var Ux = Object.defineProperty, Qx = Object.defineProperties;
var Yx = Object.getOwnPropertyDescriptors;
var Rj = Object.getOwnPropertySymbols;
var bx = Object.prototype.hasOwnProperty, Px = Object.prototype.propertyIsEnumerable;
var Hj = (e, t, r) => t in e ? Ux(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, tl = (e, t) => {
  for (var r in t || (t = {}))
    bx.call(t, r) && Hj(e, r, t[r]);
  if (Rj)
    for (var r of Rj(t))
      Px.call(t, r) && Hj(e, r, t[r]);
  return e;
}, Vj = (e, t) => Qx(e, Yx(t));
var Ce = (e, t, r) => new Promise((n, i) => {
  var M = (s) => {
    try {
      u(r.next(s));
    } catch (l) {
      i(l);
    }
  }, o = (s) => {
    try {
      u(r.throw(s));
    } catch (l) {
      i(l);
    }
  }, u = (s) => s.done ? n(s.value) : Promise.resolve(s.value).then(M, o);
  u((r = r.apply(e, t)).next());
});
var Li = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function D2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var y2 = { exports: {} }, ss = {}, T2 = { exports: {} }, V = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ba = Symbol.for("react.element"), $x = Symbol.for("react.portal"), Rx = Symbol.for("react.fragment"), Hx = Symbol.for("react.strict_mode"), Vx = Symbol.for("react.profiler"), _x = Symbol.for("react.provider"), Zx = Symbol.for("react.context"), Gx = Symbol.for("react.forward_ref"), Bx = Symbol.for("react.suspense"), Fx = Symbol.for("react.memo"), Wx = Symbol.for("react.lazy"), _j = Symbol.iterator;
function Jx(e) {
  return e === null || typeof e != "object" ? null : (e = _j && e[_j] || e["@@iterator"], typeof e == "function" ? e : null);
}
var A2 = { isMounted: function() {
  return !1;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, d2 = Object.assign, x2 = {};
function IM(e, t, r) {
  this.props = e, this.context = t, this.refs = x2, this.updater = r || A2;
}
IM.prototype.isReactComponent = {};
IM.prototype.setState = function(e, t) {
  if (typeof e != "object" && typeof e != "function" && e != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
  this.updater.enqueueSetState(this, e, t, "setState");
};
IM.prototype.forceUpdate = function(e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
};
function E2() {
}
E2.prototype = IM.prototype;
function Sg(e, t, r) {
  this.props = e, this.context = t, this.refs = x2, this.updater = r || A2;
}
var vg = Sg.prototype = new E2();
vg.constructor = Sg;
d2(vg, IM.prototype);
vg.isPureReactComponent = !0;
var Zj = Array.isArray, z2 = Object.prototype.hasOwnProperty, hg = { current: null }, f2 = { key: !0, ref: !0, __self: !0, __source: !0 };
function C2(e, t, r) {
  var n, i = {}, M = null, o = null;
  if (t != null) for (n in t.ref !== void 0 && (o = t.ref), t.key !== void 0 && (M = "" + t.key), t) z2.call(t, n) && !f2.hasOwnProperty(n) && (i[n] = t[n]);
  var u = arguments.length - 2;
  if (u === 1) i.children = r;
  else if (1 < u) {
    for (var s = Array(u), l = 0; l < u; l++) s[l] = arguments[l + 2];
    i.children = s;
  }
  if (e && e.defaultProps) for (n in u = e.defaultProps, u) i[n] === void 0 && (i[n] = u[n]);
  return { $$typeof: ba, type: e, key: M, ref: o, props: i, _owner: hg.current };
}
function Xx(e, t) {
  return { $$typeof: ba, type: e.type, key: t, ref: e.ref, props: e.props, _owner: e._owner };
}
function mg(e) {
  return typeof e == "object" && e !== null && e.$$typeof === ba;
}
function Kx(e) {
  var t = { "=": "=0", ":": "=2" };
  return "$" + e.replace(/[=:]/g, function(r) {
    return t[r];
  });
}
var Gj = /\/+/g;
function rl(e, t) {
  return typeof e == "object" && e !== null && e.key != null ? Kx("" + e.key) : t.toString(36);
}
function Ko(e, t, r, n, i) {
  var M = typeof e;
  (M === "undefined" || M === "boolean") && (e = null);
  var o = !1;
  if (e === null) o = !0;
  else switch (M) {
    case "string":
    case "number":
      o = !0;
      break;
    case "object":
      switch (e.$$typeof) {
        case ba:
        case $x:
          o = !0;
      }
  }
  if (o) return o = e, i = i(o), e = n === "" ? "." + rl(o, 0) : n, Zj(i) ? (r = "", e != null && (r = e.replace(Gj, "$&/") + "/"), Ko(i, t, r, "", function(l) {
    return l;
  })) : i != null && (mg(i) && (i = Xx(i, r + (!i.key || o && o.key === i.key ? "" : ("" + i.key).replace(Gj, "$&/") + "/") + e)), t.push(i)), 1;
  if (o = 0, n = n === "" ? "." : n + ":", Zj(e)) for (var u = 0; u < e.length; u++) {
    M = e[u];
    var s = n + rl(M, u);
    o += Ko(M, t, r, s, i);
  }
  else if (s = Jx(e), typeof s == "function") for (e = s.call(e), u = 0; !(M = e.next()).done; ) M = M.value, s = n + rl(M, u++), o += Ko(M, t, r, s, i);
  else if (M === "object") throw t = String(e), Error("Objects are not valid as a React child (found: " + (t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t) + "). If you meant to render a collection of children, use an array instead.");
  return o;
}
function io(e, t, r) {
  if (e == null) return e;
  var n = [], i = 0;
  return Ko(e, n, "", "", function(M) {
    return t.call(r, M, i++);
  }), n;
}
function qx(e) {
  if (e._status === -1) {
    var t = e._result;
    t = t(), t.then(function(r) {
      (e._status === 0 || e._status === -1) && (e._status = 1, e._result = r);
    }, function(r) {
      (e._status === 0 || e._status === -1) && (e._status = 2, e._result = r);
    }), e._status === -1 && (e._status = 0, e._result = t);
  }
  if (e._status === 1) return e._result.default;
  throw e._result;
}
var et = { current: null }, qo = { transition: null }, eE = { ReactCurrentDispatcher: et, ReactCurrentBatchConfig: qo, ReactCurrentOwner: hg };
function L2() {
  throw Error("act(...) is not supported in production builds of React.");
}
V.Children = { map: io, forEach: function(e, t, r) {
  io(e, function() {
    t.apply(this, arguments);
  }, r);
}, count: function(e) {
  var t = 0;
  return io(e, function() {
    t++;
  }), t;
}, toArray: function(e) {
  return io(e, function(t) {
    return t;
  }) || [];
}, only: function(e) {
  if (!mg(e)) throw Error("React.Children.only expected to receive a single React element child.");
  return e;
} };
V.Component = IM;
V.Fragment = Rx;
V.Profiler = Vx;
V.PureComponent = Sg;
V.StrictMode = Hx;
V.Suspense = Bx;
V.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = eE;
V.act = L2;
V.cloneElement = function(e, t, r) {
  if (e == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + e + ".");
  var n = d2({}, e.props), i = e.key, M = e.ref, o = e._owner;
  if (t != null) {
    if (t.ref !== void 0 && (M = t.ref, o = hg.current), t.key !== void 0 && (i = "" + t.key), e.type && e.type.defaultProps) var u = e.type.defaultProps;
    for (s in t) z2.call(t, s) && !f2.hasOwnProperty(s) && (n[s] = t[s] === void 0 && u !== void 0 ? u[s] : t[s]);
  }
  var s = arguments.length - 2;
  if (s === 1) n.children = r;
  else if (1 < s) {
    u = Array(s);
    for (var l = 0; l < s; l++) u[l] = arguments[l + 2];
    n.children = u;
  }
  return { $$typeof: ba, type: e.type, key: i, ref: M, props: n, _owner: o };
};
V.createContext = function(e) {
  return e = { $$typeof: Zx, _currentValue: e, _currentValue2: e, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, e.Provider = { $$typeof: _x, _context: e }, e.Consumer = e;
};
V.createElement = C2;
V.createFactory = function(e) {
  var t = C2.bind(null, e);
  return t.type = e, t;
};
V.createRef = function() {
  return { current: null };
};
V.forwardRef = function(e) {
  return { $$typeof: Gx, render: e };
};
V.isValidElement = mg;
V.lazy = function(e) {
  return { $$typeof: Wx, _payload: { _status: -1, _result: e }, _init: qx };
};
V.memo = function(e, t) {
  return { $$typeof: Fx, type: e, compare: t === void 0 ? null : t };
};
V.startTransition = function(e) {
  var t = qo.transition;
  qo.transition = {};
  try {
    e();
  } finally {
    qo.transition = t;
  }
};
V.unstable_act = L2;
V.useCallback = function(e, t) {
  return et.current.useCallback(e, t);
};
V.useContext = function(e) {
  return et.current.useContext(e);
};
V.useDebugValue = function() {
};
V.useDeferredValue = function(e) {
  return et.current.useDeferredValue(e);
};
V.useEffect = function(e, t) {
  return et.current.useEffect(e, t);
};
V.useId = function() {
  return et.current.useId();
};
V.useImperativeHandle = function(e, t, r) {
  return et.current.useImperativeHandle(e, t, r);
};
V.useInsertionEffect = function(e, t) {
  return et.current.useInsertionEffect(e, t);
};
V.useLayoutEffect = function(e, t) {
  return et.current.useLayoutEffect(e, t);
};
V.useMemo = function(e, t) {
  return et.current.useMemo(e, t);
};
V.useReducer = function(e, t, r) {
  return et.current.useReducer(e, t, r);
};
V.useRef = function(e) {
  return et.current.useRef(e);
};
V.useState = function(e) {
  return et.current.useState(e);
};
V.useSyncExternalStore = function(e, t, r) {
  return et.current.useSyncExternalStore(e, t, r);
};
V.useTransition = function() {
  return et.current.useTransition();
};
V.version = "18.3.1";
T2.exports = V;
var f = T2.exports;
const tE = /* @__PURE__ */ D2(f);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rE = f, nE = Symbol.for("react.element"), iE = Symbol.for("react.fragment"), ME = Object.prototype.hasOwnProperty, aE = rE.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, oE = { key: !0, ref: !0, __self: !0, __source: !0 };
function O2(e, t, r) {
  var n, i = {}, M = null, o = null;
  r !== void 0 && (M = "" + r), t.key !== void 0 && (M = "" + t.key), t.ref !== void 0 && (o = t.ref);
  for (n in t) ME.call(t, n) && !oE.hasOwnProperty(n) && (i[n] = t[n]);
  if (e && e.defaultProps) for (n in t = e.defaultProps, t) i[n] === void 0 && (i[n] = t[n]);
  return { $$typeof: nE, type: e, key: M, ref: o, props: i, _owner: aE.current };
}
ss.Fragment = iE;
ss.jsx = O2;
ss.jsxs = O2;
y2.exports = ss;
var a = y2.exports, CM = function(e) {
  return e && e.Math === Math && e;
}, B = (
  // eslint-disable-next-line es/no-global-this -- safe
  CM(typeof globalThis == "object" && globalThis) || CM(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  CM(typeof self == "object" && self) || CM(typeof Li == "object" && Li) || CM(typeof Li == "object" && Li) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")()
), ls = {}, X = function(e) {
  try {
    return !!e();
  } catch (t) {
    return !0;
  }
}, uE = X, ge = !uE(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), sE = X, cs = !sE(function() {
  var e = function() {
  }.bind();
  return typeof e != "function" || e.hasOwnProperty("prototype");
}), lE = cs, Mo = Function.prototype.call, Ee = lE ? Mo.bind(Mo) : function() {
  return Mo.apply(Mo, arguments);
}, wg = {}, p2 = {}.propertyIsEnumerable, S2 = Object.getOwnPropertyDescriptor, cE = S2 && !p2.call({ 1: 2 }, 1);
wg.f = cE ? function(t) {
  var r = S2(this, t);
  return !!r && r.enumerable;
} : p2;
var ui = function(e, t) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: t
  };
}, v2 = cs, h2 = Function.prototype, Vc = h2.call, IE = v2 && h2.bind.bind(Vc, Vc), G = v2 ? IE : function(e) {
  return function() {
    return Vc.apply(e, arguments);
  };
}, m2 = G, gE = m2({}.toString), jE = m2("".slice), hn = function(e) {
  return jE(gE(e), 8, -1);
}, NE = G, DE = X, yE = hn, nl = Object, TE = NE("".split), Is = DE(function() {
  return !nl("z").propertyIsEnumerable(0);
}) ? function(e) {
  return yE(e) === "String" ? TE(e, "") : nl(e);
} : nl, Pa = function(e) {
  return e == null;
}, AE = Pa, dE = TypeError, gM = function(e) {
  if (AE(e)) throw new dE("Can't call method on " + e);
  return e;
}, xE = Is, EE = gM, $a = function(e) {
  return xE(EE(e));
}, il = typeof document == "object" && document.all, je = typeof il == "undefined" && il !== void 0 ? function(e) {
  return typeof e == "function" || e === il;
} : function(e) {
  return typeof e == "function";
}, zE = je, _e = function(e) {
  return typeof e == "object" ? e !== null : zE(e);
}, Ml = B, fE = je, CE = function(e) {
  return fE(e) ? e : void 0;
}, Jr = function(e, t) {
  return arguments.length < 2 ? CE(Ml[e]) : Ml[e] && Ml[e][t];
}, LE = G, Ra = LE({}.isPrototypeOf), OE = B, Bj = OE.navigator, Fj = Bj && Bj.userAgent, Ha = Fj ? String(Fj) : "", w2 = B, al = Ha, Wj = w2.process, Jj = w2.Deno, Xj = Wj && Wj.versions || Jj && Jj.version, Kj = Xj && Xj.v8, rr, Au;
Kj && (rr = Kj.split("."), Au = rr[0] > 0 && rr[0] < 4 ? 1 : +(rr[0] + rr[1]));
!Au && al && (rr = al.match(/Edge\/(\d+)/), (!rr || rr[1] >= 74) && (rr = al.match(/Chrome\/(\d+)/), rr && (Au = +rr[1])));
var gs = Au, qj = gs, pE = X, SE = B, vE = SE.String, kg = !!Object.getOwnPropertySymbols && !pE(function() {
  var e = Symbol("symbol detection");
  return !vE(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && qj && qj < 41;
}), hE = kg, k2 = hE && !Symbol.sham && typeof Symbol.iterator == "symbol", mE = Jr, wE = je, kE = Ra, UE = k2, QE = Object, js = UE ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var t = mE("Symbol");
  return wE(t) && kE(t.prototype, QE(e));
}, YE = String, Va = function(e) {
  try {
    return YE(e);
  } catch (t) {
    return "Object";
  }
}, bE = je, PE = Va, $E = TypeError, mn = function(e) {
  if (bE(e)) return e;
  throw new $E(PE(e) + " is not a function");
}, RE = mn, HE = Pa, Ns = function(e, t) {
  var r = e[t];
  return HE(r) ? void 0 : RE(r);
}, ol = Ee, ul = je, sl = _e, VE = TypeError, _E = function(e, t) {
  var r, n;
  if (t === "string" && ul(r = e.toString) && !sl(n = ol(r, e)) || ul(r = e.valueOf) && !sl(n = ol(r, e)) || t !== "string" && ul(r = e.toString) && !sl(n = ol(r, e))) return n;
  throw new VE("Can't convert object to primitive value");
}, U2 = { exports: {} }, ZE = !1, eN = B, GE = Object.defineProperty, Ug = function(e, t) {
  try {
    GE(eN, e, { value: t, configurable: !0, writable: !0 });
  } catch (r) {
    eN[e] = t;
  }
  return t;
}, BE = B, FE = Ug, tN = "__core-js_shared__", rN = U2.exports = BE[tN] || FE(tN, {});
(rN.versions || (rN.versions = [])).push({
  version: "3.38.1",
  mode: "global",
  copyright: "© 2014-2024 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.38.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var Qg = U2.exports, nN = Qg, Yg = function(e, t) {
  return nN[e] || (nN[e] = t || {});
}, WE = gM, JE = Object, Ht = function(e) {
  return JE(WE(e));
}, XE = G, KE = Ht, qE = XE({}.hasOwnProperty), lt = Object.hasOwn || function(t, r) {
  return qE(KE(t), r);
}, ez = G, tz = 0, rz = Math.random(), nz = ez(1 .toString), bg = function(e) {
  return "Symbol(" + (e === void 0 ? "" : e) + ")_" + nz(++tz + rz, 36);
}, iz = B, Mz = Yg, iN = lt, az = bg, oz = kg, uz = k2, Oi = iz.Symbol, ll = Mz("wks"), sz = uz ? Oi.for || Oi : Oi && Oi.withoutSetter || az, ze = function(e) {
  return iN(ll, e) || (ll[e] = oz && iN(Oi, e) ? Oi[e] : sz("Symbol." + e)), ll[e];
}, lz = Ee, MN = _e, aN = js, cz = Ns, Iz = _E, gz = ze, jz = TypeError, Nz = gz("toPrimitive"), Q2 = function(e, t) {
  if (!MN(e) || aN(e)) return e;
  var r = cz(e, Nz), n;
  if (r) {
    if (t === void 0 && (t = "default"), n = lz(r, e, t), !MN(n) || aN(n)) return n;
    throw new jz("Can't convert object to primitive value");
  }
  return t === void 0 && (t = "number"), Iz(e, t);
}, Dz = Q2, yz = js, Pg = function(e) {
  var t = Dz(e, "string");
  return yz(t) ? t : t + "";
}, Tz = B, oN = _e, _c = Tz.document, Az = oN(_c) && oN(_c.createElement), $g = function(e) {
  return Az ? _c.createElement(e) : {};
}, dz = ge, xz = X, Ez = $g, Y2 = !dz && !xz(function() {
  return Object.defineProperty(Ez("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), zz = ge, fz = Ee, Cz = wg, Lz = ui, Oz = $a, pz = Pg, Sz = lt, vz = Y2, uN = Object.getOwnPropertyDescriptor;
ls.f = zz ? uN : function(t, r) {
  if (t = Oz(t), r = pz(r), vz) try {
    return uN(t, r);
  } catch (n) {
  }
  if (Sz(t, r)) return Lz(!fz(Cz.f, t, r), t[r]);
};
var Vt = {}, hz = ge, mz = X, b2 = hz && mz(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), wz = _e, kz = String, Uz = TypeError, ct = function(e) {
  if (wz(e)) return e;
  throw new Uz(kz(e) + " is not an object");
}, Qz = ge, Yz = Y2, bz = b2, ao = ct, sN = Pg, Pz = TypeError, cl = Object.defineProperty, $z = Object.getOwnPropertyDescriptor, Il = "enumerable", gl = "configurable", jl = "writable";
Vt.f = Qz ? bz ? function(t, r, n) {
  if (ao(t), r = sN(r), ao(n), typeof t == "function" && r === "prototype" && "value" in n && jl in n && !n[jl]) {
    var i = $z(t, r);
    i && i[jl] && (t[r] = n.value, n = {
      configurable: gl in n ? n[gl] : i[gl],
      enumerable: Il in n ? n[Il] : i[Il],
      writable: !1
    });
  }
  return cl(t, r, n);
} : cl : function(t, r, n) {
  if (ao(t), r = sN(r), ao(n), Yz) try {
    return cl(t, r, n);
  } catch (i) {
  }
  if ("get" in n || "set" in n) throw new Pz("Accessors not supported");
  return "value" in n && (t[r] = n.value), t;
};
var Rz = ge, Hz = Vt, Vz = ui, cr = Rz ? function(e, t, r) {
  return Hz.f(e, t, Vz(1, r));
} : function(e, t, r) {
  return e[t] = r, e;
}, P2 = { exports: {} }, Zc = ge, _z = lt, $2 = Function.prototype, Zz = Zc && Object.getOwnPropertyDescriptor, Rg = _z($2, "name"), Gz = Rg && function() {
}.name === "something", Bz = Rg && (!Zc || Zc && Zz($2, "name").configurable), Ds = {
  EXISTS: Rg,
  PROPER: Gz,
  CONFIGURABLE: Bz
}, Fz = G, Wz = je, Gc = Qg, Jz = Fz(Function.toString);
Wz(Gc.inspectSource) || (Gc.inspectSource = function(e) {
  return Jz(e);
});
var R2 = Gc.inspectSource, Xz = B, Kz = je, lN = Xz.WeakMap, qz = Kz(lN) && /native code/.test(String(lN)), ef = Yg, tf = bg, cN = ef("keys"), Hg = function(e) {
  return cN[e] || (cN[e] = tf(e));
}, Vg = {}, rf = qz, H2 = B, nf = _e, Mf = cr, Nl = lt, Dl = Qg, af = Hg, of = Vg, IN = "Object already initialized", Bc = H2.TypeError, uf = H2.WeakMap, du, Da, xu, sf = function(e) {
  return xu(e) ? Da(e) : du(e, {});
}, lf = function(e) {
  return function(t) {
    var r;
    if (!nf(t) || (r = Da(t)).type !== e)
      throw new Bc("Incompatible receiver, " + e + " required");
    return r;
  };
};
if (rf || Dl.state) {
  var Dr = Dl.state || (Dl.state = new uf());
  Dr.get = Dr.get, Dr.has = Dr.has, Dr.set = Dr.set, du = function(e, t) {
    if (Dr.has(e)) throw new Bc(IN);
    return t.facade = e, Dr.set(e, t), t;
  }, Da = function(e) {
    return Dr.get(e) || {};
  }, xu = function(e) {
    return Dr.has(e);
  };
} else {
  var Ni = af("state");
  of[Ni] = !0, du = function(e, t) {
    if (Nl(e, Ni)) throw new Bc(IN);
    return t.facade = e, Mf(e, Ni, t), t;
  }, Da = function(e) {
    return Nl(e, Ni) ? e[Ni] : {};
  }, xu = function(e) {
    return Nl(e, Ni);
  };
}
var Xr = {
  set: du,
  get: Da,
  has: xu,
  enforce: sf,
  getterFor: lf
}, _g = G, cf = X, If = je, oo = lt, Fc = ge, gf = Ds.CONFIGURABLE, jf = R2, V2 = Xr, Nf = V2.enforce, Df = V2.get, gN = String, eu = Object.defineProperty, yf = _g("".slice), Tf = _g("".replace), Af = _g([].join), df = Fc && !cf(function() {
  return eu(function() {
  }, "length", { value: 8 }).length !== 8;
}), xf = String(String).split("String"), Ef = P2.exports = function(e, t, r) {
  yf(gN(t), 0, 7) === "Symbol(" && (t = "[" + Tf(gN(t), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), r && r.getter && (t = "get " + t), r && r.setter && (t = "set " + t), (!oo(e, "name") || gf && e.name !== t) && (Fc ? eu(e, "name", { value: t, configurable: !0 }) : e.name = t), df && r && oo(r, "arity") && e.length !== r.arity && eu(e, "length", { value: r.arity });
  try {
    r && oo(r, "constructor") && r.constructor ? Fc && eu(e, "prototype", { writable: !1 }) : e.prototype && (e.prototype = void 0);
  } catch (i) {
  }
  var n = Nf(e);
  return oo(n, "source") || (n.source = Af(xf, typeof t == "string" ? t : "")), e;
};
Function.prototype.toString = Ef(function() {
  return If(this) && Df(this).source || jf(this);
}, "toString");
var _2 = P2.exports, zf = je, ff = Vt, Cf = _2, Lf = Ug, Ir = function(e, t, r, n) {
  n || (n = {});
  var i = n.enumerable, M = n.name !== void 0 ? n.name : t;
  if (zf(r) && Cf(r, M, n), n.global)
    i ? e[t] = r : Lf(t, r);
  else {
    try {
      n.unsafe ? e[t] && (i = !0) : delete e[t];
    } catch (o) {
    }
    i ? e[t] = r : ff.f(e, t, {
      value: r,
      enumerable: !1,
      configurable: !n.nonConfigurable,
      writable: !n.nonWritable
    });
  }
  return e;
}, Zg = {}, Of = Math.ceil, pf = Math.floor, Sf = Math.trunc || function(t) {
  var r = +t;
  return (r > 0 ? pf : Of)(r);
}, vf = Sf, vr = function(e) {
  var t = +e;
  return t !== t || t === 0 ? 0 : vf(t);
}, hf = vr, mf = Math.max, wf = Math.min, ys = function(e, t) {
  var r = hf(e);
  return r < 0 ? mf(r + t, 0) : wf(r, t);
}, kf = vr, Uf = Math.min, jM = function(e) {
  var t = kf(e);
  return t > 0 ? Uf(t, 9007199254740991) : 0;
}, Qf = jM, dt = function(e) {
  return Qf(e.length);
}, Yf = $a, bf = ys, Pf = dt, jN = function(e) {
  return function(t, r, n) {
    var i = Yf(t), M = Pf(i);
    if (M === 0) return !e && -1;
    var o = bf(n, M), u;
    if (e && r !== r) {
      for (; M > o; )
        if (u = i[o++], u !== u) return !0;
    } else for (; M > o; o++)
      if ((e || o in i) && i[o] === r) return e || o || 0;
    return !e && -1;
  };
}, $f = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: jN(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: jN(!1)
}, Rf = G, yl = lt, Hf = $a, Vf = $f.indexOf, _f = Vg, NN = Rf([].push), Z2 = function(e, t) {
  var r = Hf(e), n = 0, i = [], M;
  for (M in r) !yl(_f, M) && yl(r, M) && NN(i, M);
  for (; t.length > n; ) yl(r, M = t[n++]) && (~Vf(i, M) || NN(i, M));
  return i;
}, Gg = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], Zf = Z2, Gf = Gg, Bf = Gf.concat("length", "prototype");
Zg.f = Object.getOwnPropertyNames || function(t) {
  return Zf(t, Bf);
};
var Bg = {};
Bg.f = Object.getOwnPropertySymbols;
var Ff = Jr, Wf = G, Jf = Zg, Xf = Bg, Kf = ct, qf = Wf([].concat), eC = Ff("Reflect", "ownKeys") || function(t) {
  var r = Jf.f(Kf(t)), n = Xf.f;
  return n ? qf(r, n(t)) : r;
}, DN = lt, tC = eC, rC = ls, nC = Vt, Fg = function(e, t, r) {
  for (var n = tC(t), i = nC.f, M = rC.f, o = 0; o < n.length; o++) {
    var u = n[o];
    !DN(e, u) && !(r && DN(r, u)) && i(e, u, M(t, u));
  }
}, iC = X, MC = je, aC = /#|\.prototype\./, _a = function(e, t) {
  var r = uC[oC(e)];
  return r === lC ? !0 : r === sC ? !1 : MC(t) ? iC(t) : !!t;
}, oC = _a.normalize = function(e) {
  return String(e).replace(aC, ".").toLowerCase();
}, uC = _a.data = {}, sC = _a.NATIVE = "N", lC = _a.POLYFILL = "P", cC = _a, uo = B, IC = ls.f, gC = cr, jC = Ir, NC = Ug, DC = Fg, yC = cC, Qe = function(e, t) {
  var r = e.target, n = e.global, i = e.stat, M, o, u, s, l, I;
  if (n ? o = uo : i ? o = uo[r] || NC(r, {}) : o = uo[r] && uo[r].prototype, o) for (u in t) {
    if (l = t[u], e.dontCallGetSet ? (I = IC(o, u), s = I && I.value) : s = o[u], M = yC(n ? u : r + (i ? "." : "#") + u, e.forced), !M && s !== void 0) {
      if (typeof l == typeof s) continue;
      DC(l, s);
    }
    (e.sham || s && s.sham) && gC(l, "sham", !0), jC(o, u, l, e);
  }
}, TC = cs, G2 = Function.prototype, yN = G2.apply, TN = G2.call, Wg = typeof Reflect == "object" && Reflect.apply || (TC ? TN.bind(yN) : function() {
  return TN.apply(yN, arguments);
}), AC = G, dC = mn, Jg = function(e, t, r) {
  try {
    return AC(dC(Object.getOwnPropertyDescriptor(e, t)[r]));
  } catch (n) {
  }
}, xC = _e, EC = function(e) {
  return xC(e) || e === null;
}, zC = EC, fC = String, CC = TypeError, LC = function(e) {
  if (zC(e)) return e;
  throw new CC("Can't set " + fC(e) + " as a prototype");
}, OC = Jg, pC = _e, SC = gM, vC = LC, NM = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var e = !1, t = {}, r;
  try {
    r = OC(Object.prototype, "__proto__", "set"), r(t, []), e = t instanceof Array;
  } catch (n) {
  }
  return function(i, M) {
    return SC(i), vC(M), pC(i) && (e ? r(i, M) : i.__proto__ = M), i;
  };
}() : void 0), hC = Vt.f, mC = function(e, t, r) {
  r in e || hC(e, r, {
    configurable: !0,
    get: function() {
      return t[r];
    },
    set: function(n) {
      t[r] = n;
    }
  });
}, wC = je, kC = _e, AN = NM, Xg = function(e, t, r) {
  var n, i;
  return (
    // it can work only with native `setPrototypeOf`
    AN && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    wC(n = t.constructor) && n !== r && kC(i = n.prototype) && i !== r.prototype && AN(e, i), e
  );
}, UC = ze, QC = UC("toStringTag"), B2 = {};
B2[QC] = "z";
var YC = String(B2) === "[object z]", bC = YC, PC = je, tu = hn, $C = ze, RC = $C("toStringTag"), HC = Object, VC = tu(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", _C = function(e, t) {
  try {
    return e[t];
  } catch (r) {
  }
}, wn = bC ? tu : function(e) {
  var t, r, n;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (r = _C(t = HC(e), RC)) == "string" ? r : VC ? tu(t) : (n = tu(t)) === "Object" && PC(t.callee) ? "Arguments" : n;
}, ZC = wn, GC = String, _t = function(e) {
  if (ZC(e) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
  return GC(e);
}, BC = _t, FC = function(e, t) {
  return e === void 0 ? arguments.length < 2 ? "" : t : BC(e);
}, WC = _e, JC = cr, XC = function(e, t) {
  WC(t) && "cause" in t && JC(e, "cause", t.cause);
}, KC = G, F2 = Error, qC = KC("".replace), eL = function(e) {
  return String(new F2(e).stack);
}("zxcasd"), W2 = /\n\s*at [^:]*:[^\n]*/, tL = W2.test(eL), rL = function(e, t) {
  if (tL && typeof e == "string" && !F2.prepareStackTrace)
    for (; t--; ) e = qC(e, W2, "");
  return e;
}, nL = X, iL = ui, ML = !nL(function() {
  var e = new Error("a");
  return "stack" in e ? (Object.defineProperty(e, "stack", iL(1, 7)), e.stack !== 7) : !0;
}), aL = cr, oL = rL, uL = ML, dN = Error.captureStackTrace, sL = function(e, t, r, n) {
  uL && (dN ? dN(e, t) : aL(e, "stack", oL(r, n)));
}, xN = Jr, lL = lt, EN = cr, cL = Ra, zN = NM, fN = Fg, CN = mC, IL = Xg, gL = FC, jL = XC, NL = sL, DL = ge, yL = function(e, t, r, n) {
  var i = "stackTraceLimit", M = n ? 2 : 1, o = e.split("."), u = o[o.length - 1], s = xN.apply(null, o);
  if (s) {
    var l = s.prototype;
    if (lL(l, "cause") && delete l.cause, !r) return s;
    var I = xN("Error"), g = t(function(c, D) {
      var j = gL(n ? D : c, void 0), N = n ? new s(c) : new s();
      return j !== void 0 && EN(N, "message", j), NL(N, g, N.stack, 2), this && cL(l, this) && IL(N, this, g), arguments.length > M && jL(N, arguments[M]), N;
    });
    g.prototype = l, u !== "Error" ? zN ? zN(g, I) : fN(g, I, { name: !0 }) : DL && i in s && (CN(g, s, i), CN(g, s, "prepareStackTrace")), fN(g, s);
    try {
      l.name !== u && EN(l, "name", u), l.constructor = g;
    } catch (c) {
    }
    return g;
  }
}, J2 = Qe, TL = B, hr = Wg, X2 = yL, Wc = "WebAssembly", LN = TL[Wc], Eu = new Error("e", { cause: 7 }).cause !== 7, si = function(e, t) {
  var r = {};
  r[e] = X2(e, t, Eu), J2({ global: !0, constructor: !0, arity: 1, forced: Eu }, r);
}, Kg = function(e, t) {
  if (LN && LN[e]) {
    var r = {};
    r[e] = X2(Wc + "." + e, t, Eu), J2({ target: Wc, stat: !0, constructor: !0, arity: 1, forced: Eu }, r);
  }
};
si("Error", function(e) {
  return function(r) {
    return hr(e, this, arguments);
  };
});
si("EvalError", function(e) {
  return function(r) {
    return hr(e, this, arguments);
  };
});
si("RangeError", function(e) {
  return function(r) {
    return hr(e, this, arguments);
  };
});
si("ReferenceError", function(e) {
  return function(r) {
    return hr(e, this, arguments);
  };
});
si("SyntaxError", function(e) {
  return function(r) {
    return hr(e, this, arguments);
  };
});
si("TypeError", function(e) {
  return function(r) {
    return hr(e, this, arguments);
  };
});
si("URIError", function(e) {
  return function(r) {
    return hr(e, this, arguments);
  };
});
Kg("CompileError", function(e) {
  return function(r) {
    return hr(e, this, arguments);
  };
});
Kg("LinkError", function(e) {
  return function(r) {
    return hr(e, this, arguments);
  };
});
Kg("RuntimeError", function(e) {
  return function(r) {
    return hr(e, this, arguments);
  };
});
var AL = hn, qg = Array.isArray || function(t) {
  return AL(t) === "Array";
}, dL = ge, xL = qg, EL = TypeError, zL = Object.getOwnPropertyDescriptor, fL = dL && !function() {
  if (this !== void 0) return !0;
  try {
    Object.defineProperty([], "length", { writable: !1 }).length = 1;
  } catch (e) {
    return e instanceof TypeError;
  }
}(), CL = fL ? function(e, t) {
  if (xL(e) && !zL(e, "length").writable)
    throw new EL("Cannot set read only .length");
  return e.length = t;
} : function(e, t) {
  return e.length = t;
}, LL = TypeError, OL = 9007199254740991, pL = function(e) {
  if (e > OL) throw LL("Maximum allowed index exceeded");
  return e;
}, SL = Qe, vL = Ht, hL = dt, mL = CL, wL = pL, kL = X, UL = kL(function() {
  return [].push.call({ length: 4294967296 }, 1) !== 4294967297;
}), QL = function() {
  try {
    Object.defineProperty([], "length", { writable: !1 }).push();
  } catch (e) {
    return e instanceof TypeError;
  }
}, YL = UL || !QL();
SL({ target: "Array", proto: !0, arity: 1, forced: YL }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function(t) {
    var r = vL(this), n = hL(r), i = arguments.length;
    wL(n + i);
    for (var M = 0; M < i; M++)
      r[n] = arguments[M], n++;
    return mL(r, n), n;
  }
});
var bL = G, Ts = bL([].slice), PL = G, ON = qg, $L = je, pN = hn, RL = _t, SN = PL([].push), HL = function(e) {
  if ($L(e)) return e;
  if (ON(e)) {
    for (var t = e.length, r = [], n = 0; n < t; n++) {
      var i = e[n];
      typeof i == "string" ? SN(r, i) : (typeof i == "number" || pN(i) === "Number" || pN(i) === "String") && SN(r, RL(i));
    }
    var M = r.length, o = !0;
    return function(u, s) {
      if (o)
        return o = !1, s;
      if (ON(this)) return s;
      for (var l = 0; l < M; l++) if (r[l] === u) return s;
    };
  }
}, VL = Qe, K2 = Jr, q2 = Wg, _L = Ee, Za = G, e0 = X, vN = je, hN = js, t0 = Ts, ZL = HL, GL = kg, BL = String, An = K2("JSON", "stringify"), so = Za(/./.exec), mN = Za("".charAt), FL = Za("".charCodeAt), WL = Za("".replace), JL = Za(1 .toString), XL = /[\uD800-\uDFFF]/g, wN = /^[\uD800-\uDBFF]$/, kN = /^[\uDC00-\uDFFF]$/, UN = !GL || e0(function() {
  var e = K2("Symbol")("stringify detection");
  return An([e]) !== "[null]" || An({ a: e }) !== "{}" || An(Object(e)) !== "{}";
}), QN = e0(function() {
  return An("\uDF06\uD834") !== '"\\udf06\\ud834"' || An("\uDEAD") !== '"\\udead"';
}), KL = function(e, t) {
  var r = t0(arguments), n = ZL(t);
  if (!(!vN(n) && (e === void 0 || hN(e))))
    return r[1] = function(i, M) {
      if (vN(n) && (M = _L(n, this, BL(i), M)), !hN(M)) return M;
    }, q2(An, null, r);
}, qL = function(e, t, r) {
  var n = mN(r, t - 1), i = mN(r, t + 1);
  return so(wN, e) && !so(kN, i) || so(kN, e) && !so(wN, n) ? "\\u" + JL(FL(e, 0), 16) : e;
};
An && VL({ target: "JSON", stat: !0, arity: 3, forced: UN || QN }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  stringify: function(t, r, n) {
    var i = t0(arguments), M = q2(UN ? KL : An, null, i);
    return QN && typeof M == "string" ? WL(M, XL, qL) : M;
  }
});
var r0 = `	
\v\f\r                　\u2028\u2029\uFEFF`, eO = G, tO = gM, rO = _t, Jc = r0, YN = eO("".replace), nO = RegExp("^[" + Jc + "]+"), iO = RegExp("(^|[^" + Jc + "])[" + Jc + "]+$"), Tl = function(e) {
  return function(t) {
    var r = rO(tO(t));
    return e & 1 && (r = YN(r, nO, "")), e & 2 && (r = YN(r, iO, "$1")), r;
  };
}, MO = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: Tl(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: Tl(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: Tl(3)
}, aO = Ds.PROPER, oO = X, bN = r0, PN = "​᠎", uO = function(e) {
  return oO(function() {
    return !!bN[e]() || PN[e]() !== PN || aO && bN[e].name !== e;
  });
}, sO = Qe, lO = MO.trim, cO = uO;
sO({ target: "String", proto: !0, forced: cO("trim") }, {
  trim: function() {
    return lO(this);
  }
});
var IO = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, gO = $g, Al = gO("span").classList, $N = Al && Al.constructor && Al.constructor.prototype, jO = $N === Object.prototype ? void 0 : $N, n0 = {}, NO = Z2, DO = Gg, i0 = Object.keys || function(t) {
  return NO(t, DO);
}, yO = ge, TO = b2, AO = Vt, dO = ct, xO = $a, EO = i0;
n0.f = yO && !TO ? Object.defineProperties : function(t, r) {
  dO(t);
  for (var n = xO(r), i = EO(r), M = i.length, o = 0, u; M > o; ) AO.f(t, u = i[o++], n[u]);
  return t;
};
var zO = Jr, fO = zO("document", "documentElement"), CO = ct, LO = n0, RN = Gg, OO = Vg, pO = fO, SO = $g, vO = Hg, HN = ">", VN = "<", Xc = "prototype", Kc = "script", M0 = vO("IE_PROTO"), dl = function() {
}, a0 = function(e) {
  return VN + Kc + HN + e + VN + "/" + Kc + HN;
}, _N = function(e) {
  e.write(a0("")), e.close();
  var t = e.parentWindow.Object;
  return e = null, t;
}, hO = function() {
  var e = SO("iframe"), t = "java" + Kc + ":", r;
  return e.style.display = "none", pO.appendChild(e), e.src = String(t), r = e.contentWindow.document, r.open(), r.write(a0("document.F=Object")), r.close(), r.F;
}, lo, ru = function() {
  try {
    lo = new ActiveXObject("htmlfile");
  } catch (t) {
  }
  ru = typeof document != "undefined" ? document.domain && lo ? _N(lo) : hO() : _N(lo);
  for (var e = RN.length; e--; ) delete ru[Xc][RN[e]];
  return ru();
};
OO[M0] = !0;
var Ga = Object.create || function(t, r) {
  var n;
  return t !== null ? (dl[Xc] = CO(t), n = new dl(), dl[Xc] = null, n[M0] = t) : n = ru(), r === void 0 ? n : LO.f(n, r);
}, mO = ze, wO = Ga, kO = Vt.f, qc = mO("unscopables"), eI = Array.prototype;
eI[qc] === void 0 && kO(eI, qc, {
  configurable: !0,
  value: wO(null)
});
var UO = function(e) {
  eI[qc][e] = !0;
}, Ba = {}, QO = X, YO = !QO(function() {
  function e() {
  }
  return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), bO = lt, PO = je, $O = Ht, RO = Hg, HO = YO, ZN = RO("IE_PROTO"), tI = Object, VO = tI.prototype, As = HO ? tI.getPrototypeOf : function(e) {
  var t = $O(e);
  if (bO(t, ZN)) return t[ZN];
  var r = t.constructor;
  return PO(r) && t instanceof r ? r.prototype : t instanceof tI ? VO : null;
}, _O = X, ZO = je, GO = _e, GN = As, BO = Ir, FO = ze, rI = FO("iterator"), o0 = !1, ti, xl, El;
[].keys && (El = [].keys(), "next" in El ? (xl = GN(GN(El)), xl !== Object.prototype && (ti = xl)) : o0 = !0);
var WO = !GO(ti) || _O(function() {
  var e = {};
  return ti[rI].call(e) !== e;
});
WO && (ti = {});
ZO(ti[rI]) || BO(ti, rI, function() {
  return this;
});
var u0 = {
  IteratorPrototype: ti,
  BUGGY_SAFARI_ITERATORS: o0
}, JO = Vt.f, XO = lt, KO = ze, BN = KO("toStringTag"), DM = function(e, t, r) {
  e && !r && (e = e.prototype), e && !XO(e, BN) && JO(e, BN, { configurable: !0, value: t });
}, qO = u0.IteratorPrototype, ep = Ga, tp = ui, rp = DM, np = Ba, ip = function() {
  return this;
}, s0 = function(e, t, r, n) {
  var i = t + " Iterator";
  return e.prototype = ep(qO, { next: tp(+!n, r) }), rp(e, i, !1), np[i] = ip, e;
}, Mp = Qe, ap = Ee, l0 = Ds, op = je, up = s0, FN = As, WN = NM, sp = DM, lp = cr, zl = Ir, cp = ze, Ip = Ba, c0 = u0, gp = l0.PROPER, jp = l0.CONFIGURABLE, JN = c0.IteratorPrototype, co = c0.BUGGY_SAFARI_ITERATORS, LM = cp("iterator"), XN = "keys", OM = "values", KN = "entries", Np = function() {
  return this;
}, I0 = function(e, t, r, n, i, M, o) {
  up(r, t, n);
  var u = function(T) {
    if (T === i && c) return c;
    if (!co && T && T in I) return I[T];
    switch (T) {
      case XN:
        return function() {
          return new r(this, T);
        };
      case OM:
        return function() {
          return new r(this, T);
        };
      case KN:
        return function() {
          return new r(this, T);
        };
    }
    return function() {
      return new r(this);
    };
  }, s = t + " Iterator", l = !1, I = e.prototype, g = I[LM] || I["@@iterator"] || i && I[i], c = !co && g || u(i), D = t === "Array" && I.entries || g, j, N, d;
  if (D && (j = FN(D.call(new e())), j !== Object.prototype && j.next && (FN(j) !== JN && (WN ? WN(j, JN) : op(j[LM]) || zl(j, LM, Np)), sp(j, s, !0))), gp && i === OM && g && g.name !== OM && (jp ? lp(I, "name", OM) : (l = !0, c = function() {
    return ap(g, this);
  })), i)
    if (N = {
      values: u(OM),
      keys: M ? c : u(XN),
      entries: u(KN)
    }, o) for (d in N)
      (co || l || !(d in I)) && zl(I, d, N[d]);
    else Mp({ target: t, proto: !0, forced: co || l }, N);
  return I[LM] !== c && zl(I, LM, c, { name: i }), Ip[t] = c, N;
}, e4 = function(e, t) {
  return { value: e, done: t };
}, Dp = $a, t4 = UO, qN = Ba, g0 = Xr, yp = Vt.f, Tp = I0, Io = e4, Ap = ge, j0 = "Array Iterator", dp = g0.set, xp = g0.getterFor(j0), Ep = Tp(Array, "Array", function(e, t) {
  dp(this, {
    type: j0,
    target: Dp(e),
    // target
    index: 0,
    // next index
    kind: t
    // kind
  });
}, function() {
  var e = xp(this), t = e.target, r = e.index++;
  if (!t || r >= t.length)
    return e.target = null, Io(void 0, !0);
  switch (e.kind) {
    case "keys":
      return Io(r, !1);
    case "values":
      return Io(t[r], !1);
  }
  return Io([r, t[r]], !1);
}, "values"), eD = qN.Arguments = qN.Array;
t4("keys");
t4("values");
t4("entries");
if (Ap && eD.name !== "values") try {
  yp(eD, "name", { value: "values" });
} catch (e) {
}
var tD = B, N0 = IO, zp = jO, GM = Ep, rD = cr, fp = DM, Cp = ze, fl = Cp("iterator"), Cl = GM.values, D0 = function(e, t) {
  if (e) {
    if (e[fl] !== Cl) try {
      rD(e, fl, Cl);
    } catch (n) {
      e[fl] = Cl;
    }
    if (fp(e, t, !0), N0[t]) {
      for (var r in GM)
        if (e[r] !== GM[r]) try {
          rD(e, r, GM[r]);
        } catch (n) {
          e[r] = GM[r];
        }
    }
  }
};
for (var Ll in N0)
  D0(tD[Ll] && tD[Ll].prototype, Ll);
D0(zp, "DOMTokenList");
var y0 = { exports: {} }, xt = {}, T0 = { exports: {} }, A0 = {};
(function(e) {
  /**
   * @license React
   * scheduler.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  function t(S, U) {
    var k = S.length;
    S.push(U);
    e: for (; 0 < k; ) {
      var W = k - 1 >>> 1, J = S[W];
      if (0 < i(J, U)) S[W] = U, S[k] = J, k = W;
      else break e;
    }
  }
  function r(S) {
    return S.length === 0 ? null : S[0];
  }
  function n(S) {
    if (S.length === 0) return null;
    var U = S[0], k = S.pop();
    if (k !== U) {
      S[0] = k;
      e: for (var W = 0, J = S.length, Ge = J >>> 1; W < Ge; ) {
        var ve = 2 * (W + 1) - 1, Be = S[ve], he = ve + 1, It = S[he];
        if (0 > i(Be, k)) he < J && 0 > i(It, Be) ? (S[W] = It, S[he] = k, W = he) : (S[W] = Be, S[ve] = k, W = ve);
        else if (he < J && 0 > i(It, k)) S[W] = It, S[he] = k, W = he;
        else break e;
      }
    }
    return U;
  }
  function i(S, U) {
    var k = S.sortIndex - U.sortIndex;
    return k !== 0 ? k : S.id - U.id;
  }
  if (typeof performance == "object" && typeof performance.now == "function") {
    var M = performance;
    e.unstable_now = function() {
      return M.now();
    };
  } else {
    var o = Date, u = o.now();
    e.unstable_now = function() {
      return o.now() - u;
    };
  }
  var s = [], l = [], I = 1, g = null, c = 3, D = !1, j = !1, N = !1, d = typeof setTimeout == "function" ? setTimeout : null, T = typeof clearTimeout == "function" ? clearTimeout : null, y = typeof setImmediate != "undefined" ? setImmediate : null;
  typeof navigator != "undefined" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
  function A(S) {
    for (var U = r(l); U !== null; ) {
      if (U.callback === null) n(l);
      else if (U.startTime <= S) n(l), U.sortIndex = U.expirationTime, t(s, U);
      else break;
      U = r(l);
    }
  }
  function x(S) {
    if (N = !1, A(S), !j) if (r(s) !== null) j = !0, fe(E);
    else {
      var U = r(l);
      U !== null && De(x, U.startTime - S);
    }
  }
  function E(S, U) {
    j = !1, N && (N = !1, T(O), O = -1), D = !0;
    var k = c;
    try {
      for (A(U), g = r(s); g !== null && (!(g.expirationTime > U) || S && !R()); ) {
        var W = g.callback;
        if (typeof W == "function") {
          g.callback = null, c = g.priorityLevel;
          var J = W(g.expirationTime <= U);
          U = e.unstable_now(), typeof J == "function" ? g.callback = J : g === r(s) && n(s), A(U);
        } else n(s);
        g = r(s);
      }
      if (g !== null) var Ge = !0;
      else {
        var ve = r(l);
        ve !== null && De(x, ve.startTime - U), Ge = !1;
      }
      return Ge;
    } finally {
      g = null, c = k, D = !1;
    }
  }
  var C = !1, p = null, O = -1, w = 5, z = -1;
  function R() {
    return !(e.unstable_now() - z < w);
  }
  function K() {
    if (p !== null) {
      var S = e.unstable_now();
      z = S;
      var U = !0;
      try {
        U = p(!0, S);
      } finally {
        U ? P() : (C = !1, p = null);
      }
    } else C = !1;
  }
  var P;
  if (typeof y == "function") P = function() {
    y(K);
  };
  else if (typeof MessageChannel != "undefined") {
    var H = new MessageChannel(), Se = H.port2;
    H.port1.onmessage = K, P = function() {
      Se.postMessage(null);
    };
  } else P = function() {
    d(K, 0);
  };
  function fe(S) {
    p = S, C || (C = !0, P());
  }
  function De(S, U) {
    O = d(function() {
      S(e.unstable_now());
    }, U);
  }
  e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(S) {
    S.callback = null;
  }, e.unstable_continueExecution = function() {
    j || D || (j = !0, fe(E));
  }, e.unstable_forceFrameRate = function(S) {
    0 > S || 125 < S ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : w = 0 < S ? Math.floor(1e3 / S) : 5;
  }, e.unstable_getCurrentPriorityLevel = function() {
    return c;
  }, e.unstable_getFirstCallbackNode = function() {
    return r(s);
  }, e.unstable_next = function(S) {
    switch (c) {
      case 1:
      case 2:
      case 3:
        var U = 3;
        break;
      default:
        U = c;
    }
    var k = c;
    c = U;
    try {
      return S();
    } finally {
      c = k;
    }
  }, e.unstable_pauseExecution = function() {
  }, e.unstable_requestPaint = function() {
  }, e.unstable_runWithPriority = function(S, U) {
    switch (S) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        S = 3;
    }
    var k = c;
    c = S;
    try {
      return U();
    } finally {
      c = k;
    }
  }, e.unstable_scheduleCallback = function(S, U, k) {
    var W = e.unstable_now();
    switch (typeof k == "object" && k !== null ? (k = k.delay, k = typeof k == "number" && 0 < k ? W + k : W) : k = W, S) {
      case 1:
        var J = -1;
        break;
      case 2:
        J = 250;
        break;
      case 5:
        J = 1073741823;
        break;
      case 4:
        J = 1e4;
        break;
      default:
        J = 5e3;
    }
    return J = k + J, S = { id: I++, callback: U, priorityLevel: S, startTime: k, expirationTime: J, sortIndex: -1 }, k > W ? (S.sortIndex = k, t(l, S), r(s) === null && S === r(l) && (N ? (T(O), O = -1) : N = !0, De(x, k - W))) : (S.sortIndex = J, t(s, S), j || D || (j = !0, fe(E))), S;
  }, e.unstable_shouldYield = R, e.unstable_wrapCallback = function(S) {
    var U = c;
    return function() {
      var k = c;
      c = U;
      try {
        return S.apply(this, arguments);
      } finally {
        c = k;
      }
    };
  };
})(A0);
T0.exports = A0;
var Lp = T0.exports;
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Op = f, At = Lp;
function L(e) {
  for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, r = 1; r < arguments.length; r++) t += "&args[]=" + encodeURIComponent(arguments[r]);
  return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var d0 = /* @__PURE__ */ new Set(), ya = {};
function li(e, t) {
  rM(e, t), rM(e + "Capture", t);
}
function rM(e, t) {
  for (ya[e] = t, e = 0; e < t.length; e++) d0.add(t[e]);
}
var _r = !(typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined"), nI = Object.prototype.hasOwnProperty, pp = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, nD = {}, iD = {};
function Sp(e) {
  return nI.call(iD, e) ? !0 : nI.call(nD, e) ? !1 : pp.test(e) ? iD[e] = !0 : (nD[e] = !0, !1);
}
function vp(e, t, r, n) {
  if (r !== null && r.type === 0) return !1;
  switch (typeof t) {
    case "function":
    case "symbol":
      return !0;
    case "boolean":
      return n ? !1 : r !== null ? !r.acceptsBooleans : (e = e.toLowerCase().slice(0, 5), e !== "data-" && e !== "aria-");
    default:
      return !1;
  }
}
function hp(e, t, r, n) {
  if (t === null || typeof t == "undefined" || vp(e, t, r, n)) return !0;
  if (n) return !1;
  if (r !== null) switch (r.type) {
    case 3:
      return !t;
    case 4:
      return t === !1;
    case 5:
      return isNaN(t);
    case 6:
      return isNaN(t) || 1 > t;
  }
  return !1;
}
function tt(e, t, r, n, i, M, o) {
  this.acceptsBooleans = t === 2 || t === 3 || t === 4, this.attributeName = n, this.attributeNamespace = i, this.mustUseProperty = r, this.propertyName = e, this.type = t, this.sanitizeURL = M, this.removeEmptyString = o;
}
var Ue = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
  Ue[e] = new tt(e, 0, !1, e, null, !1, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
  var t = e[0];
  Ue[t] = new tt(t, 1, !1, e[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
  Ue[e] = new tt(e, 2, !1, e.toLowerCase(), null, !1, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
  Ue[e] = new tt(e, 2, !1, e, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
  Ue[e] = new tt(e, 3, !1, e.toLowerCase(), null, !1, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function(e) {
  Ue[e] = new tt(e, 3, !0, e, null, !1, !1);
});
["capture", "download"].forEach(function(e) {
  Ue[e] = new tt(e, 4, !1, e, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function(e) {
  Ue[e] = new tt(e, 6, !1, e, null, !1, !1);
});
["rowSpan", "start"].forEach(function(e) {
  Ue[e] = new tt(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var r4 = /[\-:]([a-z])/g;
function n4(e) {
  return e[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
  var t = e.replace(
    r4,
    n4
  );
  Ue[t] = new tt(t, 1, !1, e, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
  var t = e.replace(r4, n4);
  Ue[t] = new tt(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function(e) {
  var t = e.replace(r4, n4);
  Ue[t] = new tt(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function(e) {
  Ue[e] = new tt(e, 1, !1, e.toLowerCase(), null, !1, !1);
});
Ue.xlinkHref = new tt("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
["src", "href", "action", "formAction"].forEach(function(e) {
  Ue[e] = new tt(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
function i4(e, t, r, n) {
  var i = Ue.hasOwnProperty(t) ? Ue[t] : null;
  (i !== null ? i.type !== 0 : n || !(2 < t.length) || t[0] !== "o" && t[0] !== "O" || t[1] !== "n" && t[1] !== "N") && (hp(t, r, i, n) && (r = null), n || i === null ? Sp(t) && (r === null ? e.removeAttribute(t) : e.setAttribute(t, "" + r)) : i.mustUseProperty ? e[i.propertyName] = r === null ? i.type === 3 ? !1 : "" : r : (t = i.attributeName, n = i.attributeNamespace, r === null ? e.removeAttribute(t) : (i = i.type, r = i === 3 || i === 4 && r === !0 ? "" : "" + r, n ? e.setAttributeNS(n, t, r) : e.setAttribute(t, r))));
}
var Kr = Op.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, go = Symbol.for("react.element"), pi = Symbol.for("react.portal"), Si = Symbol.for("react.fragment"), M4 = Symbol.for("react.strict_mode"), iI = Symbol.for("react.profiler"), x0 = Symbol.for("react.provider"), E0 = Symbol.for("react.context"), a4 = Symbol.for("react.forward_ref"), MI = Symbol.for("react.suspense"), aI = Symbol.for("react.suspense_list"), o4 = Symbol.for("react.memo"), sn = Symbol.for("react.lazy"), z0 = Symbol.for("react.offscreen"), MD = Symbol.iterator;
function pM(e) {
  return e === null || typeof e != "object" ? null : (e = MD && e[MD] || e["@@iterator"], typeof e == "function" ? e : null);
}
var Ie = Object.assign, Ol;
function BM(e) {
  if (Ol === void 0) try {
    throw Error();
  } catch (r) {
    var t = r.stack.trim().match(/\n( *(at )?)/);
    Ol = t && t[1] || "";
  }
  return `
` + Ol + e;
}
var pl = !1;
function Sl(e, t) {
  if (!e || pl) return "";
  pl = !0;
  var r = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (t) if (t = function() {
      throw Error();
    }, Object.defineProperty(t.prototype, "props", { set: function() {
      throw Error();
    } }), typeof Reflect == "object" && Reflect.construct) {
      try {
        Reflect.construct(t, []);
      } catch (l) {
        var n = l;
      }
      Reflect.construct(e, [], t);
    } else {
      try {
        t.call();
      } catch (l) {
        n = l;
      }
      e.call(t.prototype);
    }
    else {
      try {
        throw Error();
      } catch (l) {
        n = l;
      }
      e();
    }
  } catch (l) {
    if (l && n && typeof l.stack == "string") {
      for (var i = l.stack.split(`
`), M = n.stack.split(`
`), o = i.length - 1, u = M.length - 1; 1 <= o && 0 <= u && i[o] !== M[u]; ) u--;
      for (; 1 <= o && 0 <= u; o--, u--) if (i[o] !== M[u]) {
        if (o !== 1 || u !== 1)
          do
            if (o--, u--, 0 > u || i[o] !== M[u]) {
              var s = `
` + i[o].replace(" at new ", " at ");
              return e.displayName && s.includes("<anonymous>") && (s = s.replace("<anonymous>", e.displayName)), s;
            }
          while (1 <= o && 0 <= u);
        break;
      }
    }
  } finally {
    pl = !1, Error.prepareStackTrace = r;
  }
  return (e = e ? e.displayName || e.name : "") ? BM(e) : "";
}
function mp(e) {
  switch (e.tag) {
    case 5:
      return BM(e.type);
    case 16:
      return BM("Lazy");
    case 13:
      return BM("Suspense");
    case 19:
      return BM("SuspenseList");
    case 0:
    case 2:
    case 15:
      return e = Sl(e.type, !1), e;
    case 11:
      return e = Sl(e.type.render, !1), e;
    case 1:
      return e = Sl(e.type, !0), e;
    default:
      return "";
  }
}
function oI(e) {
  if (e == null) return null;
  if (typeof e == "function") return e.displayName || e.name || null;
  if (typeof e == "string") return e;
  switch (e) {
    case Si:
      return "Fragment";
    case pi:
      return "Portal";
    case iI:
      return "Profiler";
    case M4:
      return "StrictMode";
    case MI:
      return "Suspense";
    case aI:
      return "SuspenseList";
  }
  if (typeof e == "object") switch (e.$$typeof) {
    case E0:
      return (e.displayName || "Context") + ".Consumer";
    case x0:
      return (e._context.displayName || "Context") + ".Provider";
    case a4:
      var t = e.render;
      return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
    case o4:
      return t = e.displayName || null, t !== null ? t : oI(e.type) || "Memo";
    case sn:
      t = e._payload, e = e._init;
      try {
        return oI(e(t));
      } catch (r) {
      }
  }
  return null;
}
function wp(e) {
  var t = e.type;
  switch (e.tag) {
    case 24:
      return "Cache";
    case 9:
      return (t.displayName || "Context") + ".Consumer";
    case 10:
      return (t._context.displayName || "Context") + ".Provider";
    case 18:
      return "DehydratedFragment";
    case 11:
      return e = t.render, e = e.displayName || e.name || "", t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
    case 7:
      return "Fragment";
    case 5:
      return t;
    case 4:
      return "Portal";
    case 3:
      return "Root";
    case 6:
      return "Text";
    case 16:
      return oI(t);
    case 8:
      return t === M4 ? "StrictMode" : "Mode";
    case 22:
      return "Offscreen";
    case 12:
      return "Profiler";
    case 21:
      return "Scope";
    case 13:
      return "Suspense";
    case 19:
      return "SuspenseList";
    case 25:
      return "TracingMarker";
    case 1:
    case 0:
    case 17:
    case 2:
    case 14:
    case 15:
      if (typeof t == "function") return t.displayName || t.name || null;
      if (typeof t == "string") return t;
  }
  return null;
}
function pn(e) {
  switch (typeof e) {
    case "boolean":
    case "number":
    case "string":
    case "undefined":
      return e;
    case "object":
      return e;
    default:
      return "";
  }
}
function f0(e) {
  var t = e.type;
  return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
}
function kp(e) {
  var t = f0(e) ? "checked" : "value", r = Object.getOwnPropertyDescriptor(e.constructor.prototype, t), n = "" + e[t];
  if (!e.hasOwnProperty(t) && typeof r != "undefined" && typeof r.get == "function" && typeof r.set == "function") {
    var i = r.get, M = r.set;
    return Object.defineProperty(e, t, { configurable: !0, get: function() {
      return i.call(this);
    }, set: function(o) {
      n = "" + o, M.call(this, o);
    } }), Object.defineProperty(e, t, { enumerable: r.enumerable }), { getValue: function() {
      return n;
    }, setValue: function(o) {
      n = "" + o;
    }, stopTracking: function() {
      e._valueTracker = null, delete e[t];
    } };
  }
}
function jo(e) {
  e._valueTracker || (e._valueTracker = kp(e));
}
function C0(e) {
  if (!e) return !1;
  var t = e._valueTracker;
  if (!t) return !0;
  var r = t.getValue(), n = "";
  return e && (n = f0(e) ? e.checked ? "true" : "false" : e.value), e = n, e !== r ? (t.setValue(e), !0) : !1;
}
function zu(e) {
  if (e = e || (typeof document != "undefined" ? document : void 0), typeof e == "undefined") return null;
  try {
    return e.activeElement || e.body;
  } catch (t) {
    return e.body;
  }
}
function uI(e, t) {
  var r = t.checked;
  return Ie({}, t, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: r != null ? r : e._wrapperState.initialChecked });
}
function aD(e, t) {
  var r = t.defaultValue == null ? "" : t.defaultValue, n = t.checked != null ? t.checked : t.defaultChecked;
  r = pn(t.value != null ? t.value : r), e._wrapperState = { initialChecked: n, initialValue: r, controlled: t.type === "checkbox" || t.type === "radio" ? t.checked != null : t.value != null };
}
function L0(e, t) {
  t = t.checked, t != null && i4(e, "checked", t, !1);
}
function sI(e, t) {
  L0(e, t);
  var r = pn(t.value), n = t.type;
  if (r != null) n === "number" ? (r === 0 && e.value === "" || e.value != r) && (e.value = "" + r) : e.value !== "" + r && (e.value = "" + r);
  else if (n === "submit" || n === "reset") {
    e.removeAttribute("value");
    return;
  }
  t.hasOwnProperty("value") ? lI(e, t.type, r) : t.hasOwnProperty("defaultValue") && lI(e, t.type, pn(t.defaultValue)), t.checked == null && t.defaultChecked != null && (e.defaultChecked = !!t.defaultChecked);
}
function oD(e, t, r) {
  if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
    var n = t.type;
    if (!(n !== "submit" && n !== "reset" || t.value !== void 0 && t.value !== null)) return;
    t = "" + e._wrapperState.initialValue, r || t === e.value || (e.value = t), e.defaultValue = t;
  }
  r = e.name, r !== "" && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, r !== "" && (e.name = r);
}
function lI(e, t, r) {
  (t !== "number" || zu(e.ownerDocument) !== e) && (r == null ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + r && (e.defaultValue = "" + r));
}
var FM = Array.isArray;
function _i(e, t, r, n) {
  if (e = e.options, t) {
    t = {};
    for (var i = 0; i < r.length; i++) t["$" + r[i]] = !0;
    for (r = 0; r < e.length; r++) i = t.hasOwnProperty("$" + e[r].value), e[r].selected !== i && (e[r].selected = i), i && n && (e[r].defaultSelected = !0);
  } else {
    for (r = "" + pn(r), t = null, i = 0; i < e.length; i++) {
      if (e[i].value === r) {
        e[i].selected = !0, n && (e[i].defaultSelected = !0);
        return;
      }
      t !== null || e[i].disabled || (t = e[i]);
    }
    t !== null && (t.selected = !0);
  }
}
function cI(e, t) {
  if (t.dangerouslySetInnerHTML != null) throw Error(L(91));
  return Ie({}, t, { value: void 0, defaultValue: void 0, children: "" + e._wrapperState.initialValue });
}
function uD(e, t) {
  var r = t.value;
  if (r == null) {
    if (r = t.children, t = t.defaultValue, r != null) {
      if (t != null) throw Error(L(92));
      if (FM(r)) {
        if (1 < r.length) throw Error(L(93));
        r = r[0];
      }
      t = r;
    }
    t == null && (t = ""), r = t;
  }
  e._wrapperState = { initialValue: pn(r) };
}
function O0(e, t) {
  var r = pn(t.value), n = pn(t.defaultValue);
  r != null && (r = "" + r, r !== e.value && (e.value = r), t.defaultValue == null && e.defaultValue !== r && (e.defaultValue = r)), n != null && (e.defaultValue = "" + n);
}
function sD(e) {
  var t = e.textContent;
  t === e._wrapperState.initialValue && t !== "" && t !== null && (e.value = t);
}
function p0(e) {
  switch (e) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function II(e, t) {
  return e == null || e === "http://www.w3.org/1999/xhtml" ? p0(t) : e === "http://www.w3.org/2000/svg" && t === "foreignObject" ? "http://www.w3.org/1999/xhtml" : e;
}
var No, S0 = function(e) {
  return typeof MSApp != "undefined" && MSApp.execUnsafeLocalFunction ? function(t, r, n, i) {
    MSApp.execUnsafeLocalFunction(function() {
      return e(t, r, n, i);
    });
  } : e;
}(function(e, t) {
  if (e.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e) e.innerHTML = t;
  else {
    for (No = No || document.createElement("div"), No.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = No.firstChild; e.firstChild; ) e.removeChild(e.firstChild);
    for (; t.firstChild; ) e.appendChild(t.firstChild);
  }
});
function Ta(e, t) {
  if (t) {
    var r = e.firstChild;
    if (r && r === e.lastChild && r.nodeType === 3) {
      r.nodeValue = t;
      return;
    }
  }
  e.textContent = t;
}
var qM = {
  animationIterationCount: !0,
  aspectRatio: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, Up = ["Webkit", "ms", "Moz", "O"];
Object.keys(qM).forEach(function(e) {
  Up.forEach(function(t) {
    t = t + e.charAt(0).toUpperCase() + e.substring(1), qM[t] = qM[e];
  });
});
function v0(e, t, r) {
  return t == null || typeof t == "boolean" || t === "" ? "" : r || typeof t != "number" || t === 0 || qM.hasOwnProperty(e) && qM[e] ? ("" + t).trim() : t + "px";
}
function h0(e, t) {
  e = e.style;
  for (var r in t) if (t.hasOwnProperty(r)) {
    var n = r.indexOf("--") === 0, i = v0(r, t[r], n);
    r === "float" && (r = "cssFloat"), n ? e.setProperty(r, i) : e[r] = i;
  }
}
var Qp = Ie({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
function gI(e, t) {
  if (t) {
    if (Qp[e] && (t.children != null || t.dangerouslySetInnerHTML != null)) throw Error(L(137, e));
    if (t.dangerouslySetInnerHTML != null) {
      if (t.children != null) throw Error(L(60));
      if (typeof t.dangerouslySetInnerHTML != "object" || !("__html" in t.dangerouslySetInnerHTML)) throw Error(L(61));
    }
    if (t.style != null && typeof t.style != "object") throw Error(L(62));
  }
}
function jI(e, t) {
  if (e.indexOf("-") === -1) return typeof t.is == "string";
  switch (e) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;
    default:
      return !0;
  }
}
var NI = null;
function u4(e) {
  return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
}
var DI = null, Zi = null, Gi = null;
function lD(e) {
  if (e = Ja(e)) {
    if (typeof DI != "function") throw Error(L(280));
    var t = e.stateNode;
    t && (t = fs(t), DI(e.stateNode, e.type, t));
  }
}
function m0(e) {
  Zi ? Gi ? Gi.push(e) : Gi = [e] : Zi = e;
}
function w0() {
  if (Zi) {
    var e = Zi, t = Gi;
    if (Gi = Zi = null, lD(e), t) for (e = 0; e < t.length; e++) lD(t[e]);
  }
}
function k0(e, t) {
  return e(t);
}
function U0() {
}
var vl = !1;
function Q0(e, t, r) {
  if (vl) return e(t, r);
  vl = !0;
  try {
    return k0(e, t, r);
  } finally {
    vl = !1, (Zi !== null || Gi !== null) && (U0(), w0());
  }
}
function Aa(e, t) {
  var r = e.stateNode;
  if (r === null) return null;
  var n = fs(r);
  if (n === null) return null;
  r = n[t];
  e: switch (t) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (n = !n.disabled) || (e = e.type, n = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !n;
      break e;
    default:
      e = !1;
  }
  if (e) return null;
  if (r && typeof r != "function") throw Error(L(231, t, typeof r));
  return r;
}
var yI = !1;
if (_r) try {
  var SM = {};
  Object.defineProperty(SM, "passive", { get: function() {
    yI = !0;
  } }), window.addEventListener("test", SM, SM), window.removeEventListener("test", SM, SM);
} catch (e) {
  yI = !1;
}
function Yp(e, t, r, n, i, M, o, u, s) {
  var l = Array.prototype.slice.call(arguments, 3);
  try {
    t.apply(r, l);
  } catch (I) {
    this.onError(I);
  }
}
var ea = !1, fu = null, Cu = !1, TI = null, bp = { onError: function(e) {
  ea = !0, fu = e;
} };
function Pp(e, t, r, n, i, M, o, u, s) {
  ea = !1, fu = null, Yp.apply(bp, arguments);
}
function $p(e, t, r, n, i, M, o, u, s) {
  if (Pp.apply(this, arguments), ea) {
    if (ea) {
      var l = fu;
      ea = !1, fu = null;
    } else throw Error(L(198));
    Cu || (Cu = !0, TI = l);
  }
}
function ci(e) {
  var t = e, r = e;
  if (e.alternate) for (; t.return; ) t = t.return;
  else {
    e = t;
    do
      t = e, t.flags & 4098 && (r = t.return), e = t.return;
    while (e);
  }
  return t.tag === 3 ? r : null;
}
function Y0(e) {
  if (e.tag === 13) {
    var t = e.memoizedState;
    if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
  }
  return null;
}
function cD(e) {
  if (ci(e) !== e) throw Error(L(188));
}
function Rp(e) {
  var t = e.alternate;
  if (!t) {
    if (t = ci(e), t === null) throw Error(L(188));
    return t !== e ? null : e;
  }
  for (var r = e, n = t; ; ) {
    var i = r.return;
    if (i === null) break;
    var M = i.alternate;
    if (M === null) {
      if (n = i.return, n !== null) {
        r = n;
        continue;
      }
      break;
    }
    if (i.child === M.child) {
      for (M = i.child; M; ) {
        if (M === r) return cD(i), e;
        if (M === n) return cD(i), t;
        M = M.sibling;
      }
      throw Error(L(188));
    }
    if (r.return !== n.return) r = i, n = M;
    else {
      for (var o = !1, u = i.child; u; ) {
        if (u === r) {
          o = !0, r = i, n = M;
          break;
        }
        if (u === n) {
          o = !0, n = i, r = M;
          break;
        }
        u = u.sibling;
      }
      if (!o) {
        for (u = M.child; u; ) {
          if (u === r) {
            o = !0, r = M, n = i;
            break;
          }
          if (u === n) {
            o = !0, n = M, r = i;
            break;
          }
          u = u.sibling;
        }
        if (!o) throw Error(L(189));
      }
    }
    if (r.alternate !== n) throw Error(L(190));
  }
  if (r.tag !== 3) throw Error(L(188));
  return r.stateNode.current === r ? e : t;
}
function b0(e) {
  return e = Rp(e), e !== null ? P0(e) : null;
}
function P0(e) {
  if (e.tag === 5 || e.tag === 6) return e;
  for (e = e.child; e !== null; ) {
    var t = P0(e);
    if (t !== null) return t;
    e = e.sibling;
  }
  return null;
}
var $0 = At.unstable_scheduleCallback, ID = At.unstable_cancelCallback, Hp = At.unstable_shouldYield, Vp = At.unstable_requestPaint, ye = At.unstable_now, _p = At.unstable_getCurrentPriorityLevel, s4 = At.unstable_ImmediatePriority, R0 = At.unstable_UserBlockingPriority, Lu = At.unstable_NormalPriority, Zp = At.unstable_LowPriority, H0 = At.unstable_IdlePriority, ds = null, Or = null;
function Gp(e) {
  if (Or && typeof Or.onCommitFiberRoot == "function") try {
    Or.onCommitFiberRoot(ds, e, void 0, (e.current.flags & 128) === 128);
  } catch (t) {
  }
}
var ar = Math.clz32 ? Math.clz32 : Wp, Bp = Math.log, Fp = Math.LN2;
function Wp(e) {
  return e >>>= 0, e === 0 ? 32 : 31 - (Bp(e) / Fp | 0) | 0;
}
var Do = 64, yo = 4194304;
function WM(e) {
  switch (e & -e) {
    case 1:
      return 1;
    case 2:
      return 2;
    case 4:
      return 4;
    case 8:
      return 8;
    case 16:
      return 16;
    case 32:
      return 32;
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return e & 4194240;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return e & 130023424;
    case 134217728:
      return 134217728;
    case 268435456:
      return 268435456;
    case 536870912:
      return 536870912;
    case 1073741824:
      return 1073741824;
    default:
      return e;
  }
}
function Ou(e, t) {
  var r = e.pendingLanes;
  if (r === 0) return 0;
  var n = 0, i = e.suspendedLanes, M = e.pingedLanes, o = r & 268435455;
  if (o !== 0) {
    var u = o & ~i;
    u !== 0 ? n = WM(u) : (M &= o, M !== 0 && (n = WM(M)));
  } else o = r & ~i, o !== 0 ? n = WM(o) : M !== 0 && (n = WM(M));
  if (n === 0) return 0;
  if (t !== 0 && t !== n && !(t & i) && (i = n & -n, M = t & -t, i >= M || i === 16 && (M & 4194240) !== 0)) return t;
  if (n & 4 && (n |= r & 16), t = e.entangledLanes, t !== 0) for (e = e.entanglements, t &= n; 0 < t; ) r = 31 - ar(t), i = 1 << r, n |= e[r], t &= ~i;
  return n;
}
function Jp(e, t) {
  switch (e) {
    case 1:
    case 2:
    case 4:
      return t + 250;
    case 8:
    case 16:
    case 32:
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return t + 5e3;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return -1;
    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;
    default:
      return -1;
  }
}
function Xp(e, t) {
  for (var r = e.suspendedLanes, n = e.pingedLanes, i = e.expirationTimes, M = e.pendingLanes; 0 < M; ) {
    var o = 31 - ar(M), u = 1 << o, s = i[o];
    s === -1 ? (!(u & r) || u & n) && (i[o] = Jp(u, t)) : s <= t && (e.expiredLanes |= u), M &= ~u;
  }
}
function AI(e) {
  return e = e.pendingLanes & -1073741825, e !== 0 ? e : e & 1073741824 ? 1073741824 : 0;
}
function V0() {
  var e = Do;
  return Do <<= 1, !(Do & 4194240) && (Do = 64), e;
}
function hl(e) {
  for (var t = [], r = 0; 31 > r; r++) t.push(e);
  return t;
}
function Fa(e, t, r) {
  e.pendingLanes |= t, t !== 536870912 && (e.suspendedLanes = 0, e.pingedLanes = 0), e = e.eventTimes, t = 31 - ar(t), e[t] = r;
}
function Kp(e, t) {
  var r = e.pendingLanes & ~t;
  e.pendingLanes = t, e.suspendedLanes = 0, e.pingedLanes = 0, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t, t = e.entanglements;
  var n = e.eventTimes;
  for (e = e.expirationTimes; 0 < r; ) {
    var i = 31 - ar(r), M = 1 << i;
    t[i] = 0, n[i] = -1, e[i] = -1, r &= ~M;
  }
}
function l4(e, t) {
  var r = e.entangledLanes |= t;
  for (e = e.entanglements; r; ) {
    var n = 31 - ar(r), i = 1 << n;
    i & t | e[n] & t && (e[n] |= t), r &= ~i;
  }
}
var re = 0;
function _0(e) {
  return e &= -e, 1 < e ? 4 < e ? e & 268435455 ? 16 : 536870912 : 4 : 1;
}
var Z0, c4, G0, B0, F0, dI = !1, To = [], dn = null, xn = null, En = null, da = /* @__PURE__ */ new Map(), xa = /* @__PURE__ */ new Map(), cn = [], qp = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function gD(e, t) {
  switch (e) {
    case "focusin":
    case "focusout":
      dn = null;
      break;
    case "dragenter":
    case "dragleave":
      xn = null;
      break;
    case "mouseover":
    case "mouseout":
      En = null;
      break;
    case "pointerover":
    case "pointerout":
      da.delete(t.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      xa.delete(t.pointerId);
  }
}
function vM(e, t, r, n, i, M) {
  return e === null || e.nativeEvent !== M ? (e = { blockedOn: t, domEventName: r, eventSystemFlags: n, nativeEvent: M, targetContainers: [i] }, t !== null && (t = Ja(t), t !== null && c4(t)), e) : (e.eventSystemFlags |= n, t = e.targetContainers, i !== null && t.indexOf(i) === -1 && t.push(i), e);
}
function eS(e, t, r, n, i) {
  switch (t) {
    case "focusin":
      return dn = vM(dn, e, t, r, n, i), !0;
    case "dragenter":
      return xn = vM(xn, e, t, r, n, i), !0;
    case "mouseover":
      return En = vM(En, e, t, r, n, i), !0;
    case "pointerover":
      var M = i.pointerId;
      return da.set(M, vM(da.get(M) || null, e, t, r, n, i)), !0;
    case "gotpointercapture":
      return M = i.pointerId, xa.set(M, vM(xa.get(M) || null, e, t, r, n, i)), !0;
  }
  return !1;
}
function W0(e) {
  var t = Jn(e.target);
  if (t !== null) {
    var r = ci(t);
    if (r !== null) {
      if (t = r.tag, t === 13) {
        if (t = Y0(r), t !== null) {
          e.blockedOn = t, F0(e.priority, function() {
            G0(r);
          });
          return;
        }
      } else if (t === 3 && r.stateNode.current.memoizedState.isDehydrated) {
        e.blockedOn = r.tag === 3 ? r.stateNode.containerInfo : null;
        return;
      }
    }
  }
  e.blockedOn = null;
}
function nu(e) {
  if (e.blockedOn !== null) return !1;
  for (var t = e.targetContainers; 0 < t.length; ) {
    var r = xI(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
    if (r === null) {
      r = e.nativeEvent;
      var n = new r.constructor(r.type, r);
      NI = n, r.target.dispatchEvent(n), NI = null;
    } else return t = Ja(r), t !== null && c4(t), e.blockedOn = r, !1;
    t.shift();
  }
  return !0;
}
function jD(e, t, r) {
  nu(e) && r.delete(t);
}
function tS() {
  dI = !1, dn !== null && nu(dn) && (dn = null), xn !== null && nu(xn) && (xn = null), En !== null && nu(En) && (En = null), da.forEach(jD), xa.forEach(jD);
}
function hM(e, t) {
  e.blockedOn === t && (e.blockedOn = null, dI || (dI = !0, At.unstable_scheduleCallback(At.unstable_NormalPriority, tS)));
}
function Ea(e) {
  function t(i) {
    return hM(i, e);
  }
  if (0 < To.length) {
    hM(To[0], e);
    for (var r = 1; r < To.length; r++) {
      var n = To[r];
      n.blockedOn === e && (n.blockedOn = null);
    }
  }
  for (dn !== null && hM(dn, e), xn !== null && hM(xn, e), En !== null && hM(En, e), da.forEach(t), xa.forEach(t), r = 0; r < cn.length; r++) n = cn[r], n.blockedOn === e && (n.blockedOn = null);
  for (; 0 < cn.length && (r = cn[0], r.blockedOn === null); ) W0(r), r.blockedOn === null && cn.shift();
}
var Bi = Kr.ReactCurrentBatchConfig, pu = !0;
function rS(e, t, r, n) {
  var i = re, M = Bi.transition;
  Bi.transition = null;
  try {
    re = 1, I4(e, t, r, n);
  } finally {
    re = i, Bi.transition = M;
  }
}
function nS(e, t, r, n) {
  var i = re, M = Bi.transition;
  Bi.transition = null;
  try {
    re = 4, I4(e, t, r, n);
  } finally {
    re = i, Bi.transition = M;
  }
}
function I4(e, t, r, n) {
  if (pu) {
    var i = xI(e, t, r, n);
    if (i === null) Rl(e, t, n, Su, r), gD(e, n);
    else if (eS(i, e, t, r, n)) n.stopPropagation();
    else if (gD(e, n), t & 4 && -1 < qp.indexOf(e)) {
      for (; i !== null; ) {
        var M = Ja(i);
        if (M !== null && Z0(M), M = xI(e, t, r, n), M === null && Rl(e, t, n, Su, r), M === i) break;
        i = M;
      }
      i !== null && n.stopPropagation();
    } else Rl(e, t, n, null, r);
  }
}
var Su = null;
function xI(e, t, r, n) {
  if (Su = null, e = u4(n), e = Jn(e), e !== null) if (t = ci(e), t === null) e = null;
  else if (r = t.tag, r === 13) {
    if (e = Y0(t), e !== null) return e;
    e = null;
  } else if (r === 3) {
    if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
    e = null;
  } else t !== e && (e = null);
  return Su = e, null;
}
function J0(e) {
  switch (e) {
    case "cancel":
    case "click":
    case "close":
    case "contextmenu":
    case "copy":
    case "cut":
    case "auxclick":
    case "dblclick":
    case "dragend":
    case "dragstart":
    case "drop":
    case "focusin":
    case "focusout":
    case "input":
    case "invalid":
    case "keydown":
    case "keypress":
    case "keyup":
    case "mousedown":
    case "mouseup":
    case "paste":
    case "pause":
    case "play":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
    case "ratechange":
    case "reset":
    case "resize":
    case "seeked":
    case "submit":
    case "touchcancel":
    case "touchend":
    case "touchstart":
    case "volumechange":
    case "change":
    case "selectionchange":
    case "textInput":
    case "compositionstart":
    case "compositionend":
    case "compositionupdate":
    case "beforeblur":
    case "afterblur":
    case "beforeinput":
    case "blur":
    case "fullscreenchange":
    case "focus":
    case "hashchange":
    case "popstate":
    case "select":
    case "selectstart":
      return 1;
    case "drag":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "mousemove":
    case "mouseout":
    case "mouseover":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "scroll":
    case "toggle":
    case "touchmove":
    case "wheel":
    case "mouseenter":
    case "mouseleave":
    case "pointerenter":
    case "pointerleave":
      return 4;
    case "message":
      switch (_p()) {
        case s4:
          return 1;
        case R0:
          return 4;
        case Lu:
        case Zp:
          return 16;
        case H0:
          return 536870912;
        default:
          return 16;
      }
    default:
      return 16;
  }
}
var gn = null, g4 = null, iu = null;
function X0() {
  if (iu) return iu;
  var e, t = g4, r = t.length, n, i = "value" in gn ? gn.value : gn.textContent, M = i.length;
  for (e = 0; e < r && t[e] === i[e]; e++) ;
  var o = r - e;
  for (n = 1; n <= o && t[r - n] === i[M - n]; n++) ;
  return iu = i.slice(e, 1 < n ? 1 - n : void 0);
}
function Mu(e) {
  var t = e.keyCode;
  return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
}
function Ao() {
  return !0;
}
function ND() {
  return !1;
}
function Et(e) {
  function t(r, n, i, M, o) {
    this._reactName = r, this._targetInst = i, this.type = n, this.nativeEvent = M, this.target = o, this.currentTarget = null;
    for (var u in e) e.hasOwnProperty(u) && (r = e[u], this[u] = r ? r(M) : M[u]);
    return this.isDefaultPrevented = (M.defaultPrevented != null ? M.defaultPrevented : M.returnValue === !1) ? Ao : ND, this.isPropagationStopped = ND, this;
  }
  return Ie(t.prototype, { preventDefault: function() {
    this.defaultPrevented = !0;
    var r = this.nativeEvent;
    r && (r.preventDefault ? r.preventDefault() : typeof r.returnValue != "unknown" && (r.returnValue = !1), this.isDefaultPrevented = Ao);
  }, stopPropagation: function() {
    var r = this.nativeEvent;
    r && (r.stopPropagation ? r.stopPropagation() : typeof r.cancelBubble != "unknown" && (r.cancelBubble = !0), this.isPropagationStopped = Ao);
  }, persist: function() {
  }, isPersistent: Ao }), t;
}
var yM = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(e) {
  return e.timeStamp || Date.now();
}, defaultPrevented: 0, isTrusted: 0 }, j4 = Et(yM), Wa = Ie({}, yM, { view: 0, detail: 0 }), iS = Et(Wa), ml, wl, mM, xs = Ie({}, Wa, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: N4, button: 0, buttons: 0, relatedTarget: function(e) {
  return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
}, movementX: function(e) {
  return "movementX" in e ? e.movementX : (e !== mM && (mM && e.type === "mousemove" ? (ml = e.screenX - mM.screenX, wl = e.screenY - mM.screenY) : wl = ml = 0, mM = e), ml);
}, movementY: function(e) {
  return "movementY" in e ? e.movementY : wl;
} }), DD = Et(xs), MS = Ie({}, xs, { dataTransfer: 0 }), aS = Et(MS), oS = Ie({}, Wa, { relatedTarget: 0 }), kl = Et(oS), uS = Ie({}, yM, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), sS = Et(uS), lS = Ie({}, yM, { clipboardData: function(e) {
  return "clipboardData" in e ? e.clipboardData : window.clipboardData;
} }), cS = Et(lS), IS = Ie({}, yM, { data: 0 }), yD = Et(IS), gS = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
}, jS = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
}, NS = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
function DS(e) {
  var t = this.nativeEvent;
  return t.getModifierState ? t.getModifierState(e) : (e = NS[e]) ? !!t[e] : !1;
}
function N4() {
  return DS;
}
var yS = Ie({}, Wa, { key: function(e) {
  if (e.key) {
    var t = gS[e.key] || e.key;
    if (t !== "Unidentified") return t;
  }
  return e.type === "keypress" ? (e = Mu(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? jS[e.keyCode] || "Unidentified" : "";
}, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: N4, charCode: function(e) {
  return e.type === "keypress" ? Mu(e) : 0;
}, keyCode: function(e) {
  return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
}, which: function(e) {
  return e.type === "keypress" ? Mu(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
} }), TS = Et(yS), AS = Ie({}, xs, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), TD = Et(AS), dS = Ie({}, Wa, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: N4 }), xS = Et(dS), ES = Ie({}, yM, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), zS = Et(ES), fS = Ie({}, xs, {
  deltaX: function(e) {
    return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
  },
  deltaY: function(e) {
    return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
}), CS = Et(fS), LS = [9, 13, 27, 32], D4 = _r && "CompositionEvent" in window, ta = null;
_r && "documentMode" in document && (ta = document.documentMode);
var OS = _r && "TextEvent" in window && !ta, K0 = _r && (!D4 || ta && 8 < ta && 11 >= ta), AD = " ", dD = !1;
function q0(e, t) {
  switch (e) {
    case "keyup":
      return LS.indexOf(t.keyCode) !== -1;
    case "keydown":
      return t.keyCode !== 229;
    case "keypress":
    case "mousedown":
    case "focusout":
      return !0;
    default:
      return !1;
  }
}
function e3(e) {
  return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
}
var vi = !1;
function pS(e, t) {
  switch (e) {
    case "compositionend":
      return e3(t);
    case "keypress":
      return t.which !== 32 ? null : (dD = !0, AD);
    case "textInput":
      return e = t.data, e === AD && dD ? null : e;
    default:
      return null;
  }
}
function SS(e, t) {
  if (vi) return e === "compositionend" || !D4 && q0(e, t) ? (e = X0(), iu = g4 = gn = null, vi = !1, e) : null;
  switch (e) {
    case "paste":
      return null;
    case "keypress":
      if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
        if (t.char && 1 < t.char.length) return t.char;
        if (t.which) return String.fromCharCode(t.which);
      }
      return null;
    case "compositionend":
      return K0 && t.locale !== "ko" ? null : t.data;
    default:
      return null;
  }
}
var vS = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
function xD(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t === "input" ? !!vS[e.type] : t === "textarea";
}
function t3(e, t, r, n) {
  m0(n), t = vu(t, "onChange"), 0 < t.length && (r = new j4("onChange", "change", null, r, n), e.push({ event: r, listeners: t }));
}
var ra = null, za = null;
function hS(e) {
  I3(e, 0);
}
function Es(e) {
  var t = wi(e);
  if (C0(t)) return e;
}
function mS(e, t) {
  if (e === "change") return t;
}
var r3 = !1;
if (_r) {
  var Ul;
  if (_r) {
    var Ql = "oninput" in document;
    if (!Ql) {
      var ED = document.createElement("div");
      ED.setAttribute("oninput", "return;"), Ql = typeof ED.oninput == "function";
    }
    Ul = Ql;
  } else Ul = !1;
  r3 = Ul && (!document.documentMode || 9 < document.documentMode);
}
function zD() {
  ra && (ra.detachEvent("onpropertychange", n3), za = ra = null);
}
function n3(e) {
  if (e.propertyName === "value" && Es(za)) {
    var t = [];
    t3(t, za, e, u4(e)), Q0(hS, t);
  }
}
function wS(e, t, r) {
  e === "focusin" ? (zD(), ra = t, za = r, ra.attachEvent("onpropertychange", n3)) : e === "focusout" && zD();
}
function kS(e) {
  if (e === "selectionchange" || e === "keyup" || e === "keydown") return Es(za);
}
function US(e, t) {
  if (e === "click") return Es(t);
}
function QS(e, t) {
  if (e === "input" || e === "change") return Es(t);
}
function YS(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var sr = typeof Object.is == "function" ? Object.is : YS;
function fa(e, t) {
  if (sr(e, t)) return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null) return !1;
  var r = Object.keys(e), n = Object.keys(t);
  if (r.length !== n.length) return !1;
  for (n = 0; n < r.length; n++) {
    var i = r[n];
    if (!nI.call(t, i) || !sr(e[i], t[i])) return !1;
  }
  return !0;
}
function fD(e) {
  for (; e && e.firstChild; ) e = e.firstChild;
  return e;
}
function CD(e, t) {
  var r = fD(e);
  e = 0;
  for (var n; r; ) {
    if (r.nodeType === 3) {
      if (n = e + r.textContent.length, e <= t && n >= t) return { node: r, offset: t - e };
      e = n;
    }
    e: {
      for (; r; ) {
        if (r.nextSibling) {
          r = r.nextSibling;
          break e;
        }
        r = r.parentNode;
      }
      r = void 0;
    }
    r = fD(r);
  }
}
function i3(e, t) {
  return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? i3(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
}
function M3() {
  for (var e = window, t = zu(); t instanceof e.HTMLIFrameElement; ) {
    try {
      var r = typeof t.contentWindow.location.href == "string";
    } catch (n) {
      r = !1;
    }
    if (r) e = t.contentWindow;
    else break;
    t = zu(e.document);
  }
  return t;
}
function y4(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
}
function bS(e) {
  var t = M3(), r = e.focusedElem, n = e.selectionRange;
  if (t !== r && r && r.ownerDocument && i3(r.ownerDocument.documentElement, r)) {
    if (n !== null && y4(r)) {
      if (t = n.start, e = n.end, e === void 0 && (e = t), "selectionStart" in r) r.selectionStart = t, r.selectionEnd = Math.min(e, r.value.length);
      else if (e = (t = r.ownerDocument || document) && t.defaultView || window, e.getSelection) {
        e = e.getSelection();
        var i = r.textContent.length, M = Math.min(n.start, i);
        n = n.end === void 0 ? M : Math.min(n.end, i), !e.extend && M > n && (i = n, n = M, M = i), i = CD(r, M);
        var o = CD(
          r,
          n
        );
        i && o && (e.rangeCount !== 1 || e.anchorNode !== i.node || e.anchorOffset !== i.offset || e.focusNode !== o.node || e.focusOffset !== o.offset) && (t = t.createRange(), t.setStart(i.node, i.offset), e.removeAllRanges(), M > n ? (e.addRange(t), e.extend(o.node, o.offset)) : (t.setEnd(o.node, o.offset), e.addRange(t)));
      }
    }
    for (t = [], e = r; e = e.parentNode; ) e.nodeType === 1 && t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
    for (typeof r.focus == "function" && r.focus(), r = 0; r < t.length; r++) e = t[r], e.element.scrollLeft = e.left, e.element.scrollTop = e.top;
  }
}
var PS = _r && "documentMode" in document && 11 >= document.documentMode, hi = null, EI = null, na = null, zI = !1;
function LD(e, t, r) {
  var n = r.window === r ? r.document : r.nodeType === 9 ? r : r.ownerDocument;
  zI || hi == null || hi !== zu(n) || (n = hi, "selectionStart" in n && y4(n) ? n = { start: n.selectionStart, end: n.selectionEnd } : (n = (n.ownerDocument && n.ownerDocument.defaultView || window).getSelection(), n = { anchorNode: n.anchorNode, anchorOffset: n.anchorOffset, focusNode: n.focusNode, focusOffset: n.focusOffset }), na && fa(na, n) || (na = n, n = vu(EI, "onSelect"), 0 < n.length && (t = new j4("onSelect", "select", null, t, r), e.push({ event: t, listeners: n }), t.target = hi)));
}
function xo(e, t) {
  var r = {};
  return r[e.toLowerCase()] = t.toLowerCase(), r["Webkit" + e] = "webkit" + t, r["Moz" + e] = "moz" + t, r;
}
var mi = { animationend: xo("Animation", "AnimationEnd"), animationiteration: xo("Animation", "AnimationIteration"), animationstart: xo("Animation", "AnimationStart"), transitionend: xo("Transition", "TransitionEnd") }, Yl = {}, a3 = {};
_r && (a3 = document.createElement("div").style, "AnimationEvent" in window || (delete mi.animationend.animation, delete mi.animationiteration.animation, delete mi.animationstart.animation), "TransitionEvent" in window || delete mi.transitionend.transition);
function zs(e) {
  if (Yl[e]) return Yl[e];
  if (!mi[e]) return e;
  var t = mi[e], r;
  for (r in t) if (t.hasOwnProperty(r) && r in a3) return Yl[e] = t[r];
  return e;
}
var o3 = zs("animationend"), u3 = zs("animationiteration"), s3 = zs("animationstart"), l3 = zs("transitionend"), c3 = /* @__PURE__ */ new Map(), OD = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function kn(e, t) {
  c3.set(e, t), li(t, [e]);
}
for (var bl = 0; bl < OD.length; bl++) {
  var Pl = OD[bl], $S = Pl.toLowerCase(), RS = Pl[0].toUpperCase() + Pl.slice(1);
  kn($S, "on" + RS);
}
kn(o3, "onAnimationEnd");
kn(u3, "onAnimationIteration");
kn(s3, "onAnimationStart");
kn("dblclick", "onDoubleClick");
kn("focusin", "onFocus");
kn("focusout", "onBlur");
kn(l3, "onTransitionEnd");
rM("onMouseEnter", ["mouseout", "mouseover"]);
rM("onMouseLeave", ["mouseout", "mouseover"]);
rM("onPointerEnter", ["pointerout", "pointerover"]);
rM("onPointerLeave", ["pointerout", "pointerover"]);
li("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
li("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
li("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
li("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
li("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
li("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var JM = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), HS = new Set("cancel close invalid load scroll toggle".split(" ").concat(JM));
function pD(e, t, r) {
  var n = e.type || "unknown-event";
  e.currentTarget = r, $p(n, t, void 0, e), e.currentTarget = null;
}
function I3(e, t) {
  t = (t & 4) !== 0;
  for (var r = 0; r < e.length; r++) {
    var n = e[r], i = n.event;
    n = n.listeners;
    e: {
      var M = void 0;
      if (t) for (var o = n.length - 1; 0 <= o; o--) {
        var u = n[o], s = u.instance, l = u.currentTarget;
        if (u = u.listener, s !== M && i.isPropagationStopped()) break e;
        pD(i, u, l), M = s;
      }
      else for (o = 0; o < n.length; o++) {
        if (u = n[o], s = u.instance, l = u.currentTarget, u = u.listener, s !== M && i.isPropagationStopped()) break e;
        pD(i, u, l), M = s;
      }
    }
  }
  if (Cu) throw e = TI, Cu = !1, TI = null, e;
}
function ae(e, t) {
  var r = t[pI];
  r === void 0 && (r = t[pI] = /* @__PURE__ */ new Set());
  var n = e + "__bubble";
  r.has(n) || (g3(t, e, 2, !1), r.add(n));
}
function $l(e, t, r) {
  var n = 0;
  t && (n |= 4), g3(r, e, n, t);
}
var Eo = "_reactListening" + Math.random().toString(36).slice(2);
function Ca(e) {
  if (!e[Eo]) {
    e[Eo] = !0, d0.forEach(function(r) {
      r !== "selectionchange" && (HS.has(r) || $l(r, !1, e), $l(r, !0, e));
    });
    var t = e.nodeType === 9 ? e : e.ownerDocument;
    t === null || t[Eo] || (t[Eo] = !0, $l("selectionchange", !1, t));
  }
}
function g3(e, t, r, n) {
  switch (J0(t)) {
    case 1:
      var i = rS;
      break;
    case 4:
      i = nS;
      break;
    default:
      i = I4;
  }
  r = i.bind(null, t, r, e), i = void 0, !yI || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (i = !0), n ? i !== void 0 ? e.addEventListener(t, r, { capture: !0, passive: i }) : e.addEventListener(t, r, !0) : i !== void 0 ? e.addEventListener(t, r, { passive: i }) : e.addEventListener(t, r, !1);
}
function Rl(e, t, r, n, i) {
  var M = n;
  if (!(t & 1) && !(t & 2) && n !== null) e: for (; ; ) {
    if (n === null) return;
    var o = n.tag;
    if (o === 3 || o === 4) {
      var u = n.stateNode.containerInfo;
      if (u === i || u.nodeType === 8 && u.parentNode === i) break;
      if (o === 4) for (o = n.return; o !== null; ) {
        var s = o.tag;
        if ((s === 3 || s === 4) && (s = o.stateNode.containerInfo, s === i || s.nodeType === 8 && s.parentNode === i))
          return;
        o = o.return;
      }
      for (; u !== null; ) {
        if (o = Jn(u), o === null) return;
        if (s = o.tag, s === 5 || s === 6) {
          n = M = o;
          continue e;
        }
        u = u.parentNode;
      }
    }
    n = n.return;
  }
  Q0(function() {
    var l = M, I = u4(r), g = [];
    e: {
      var c = c3.get(e);
      if (c !== void 0) {
        var D = j4, j = e;
        switch (e) {
          case "keypress":
            if (Mu(r) === 0) break e;
          case "keydown":
          case "keyup":
            D = TS;
            break;
          case "focusin":
            j = "focus", D = kl;
            break;
          case "focusout":
            j = "blur", D = kl;
            break;
          case "beforeblur":
          case "afterblur":
            D = kl;
            break;
          case "click":
            if (r.button === 2) break e;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            D = DD;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            D = aS;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            D = xS;
            break;
          case o3:
          case u3:
          case s3:
            D = sS;
            break;
          case l3:
            D = zS;
            break;
          case "scroll":
            D = iS;
            break;
          case "wheel":
            D = CS;
            break;
          case "copy":
          case "cut":
          case "paste":
            D = cS;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            D = TD;
        }
        var N = (t & 4) !== 0, d = !N && e === "scroll", T = N ? c !== null ? c + "Capture" : null : c;
        N = [];
        for (var y = l, A; y !== null; ) {
          A = y;
          var x = A.stateNode;
          if (A.tag === 5 && x !== null && (A = x, T !== null && (x = Aa(y, T), x != null && N.push(La(y, x, A)))), d) break;
          y = y.return;
        }
        0 < N.length && (c = new D(c, j, null, r, I), g.push({ event: c, listeners: N }));
      }
    }
    if (!(t & 7)) {
      e: {
        if (c = e === "mouseover" || e === "pointerover", D = e === "mouseout" || e === "pointerout", c && r !== NI && (j = r.relatedTarget || r.fromElement) && (Jn(j) || j[Zr])) break e;
        if ((D || c) && (c = I.window === I ? I : (c = I.ownerDocument) ? c.defaultView || c.parentWindow : window, D ? (j = r.relatedTarget || r.toElement, D = l, j = j ? Jn(j) : null, j !== null && (d = ci(j), j !== d || j.tag !== 5 && j.tag !== 6) && (j = null)) : (D = null, j = l), D !== j)) {
          if (N = DD, x = "onMouseLeave", T = "onMouseEnter", y = "mouse", (e === "pointerout" || e === "pointerover") && (N = TD, x = "onPointerLeave", T = "onPointerEnter", y = "pointer"), d = D == null ? c : wi(D), A = j == null ? c : wi(j), c = new N(x, y + "leave", D, r, I), c.target = d, c.relatedTarget = A, x = null, Jn(I) === l && (N = new N(T, y + "enter", j, r, I), N.target = A, N.relatedTarget = d, x = N), d = x, D && j) t: {
            for (N = D, T = j, y = 0, A = N; A; A = Di(A)) y++;
            for (A = 0, x = T; x; x = Di(x)) A++;
            for (; 0 < y - A; ) N = Di(N), y--;
            for (; 0 < A - y; ) T = Di(T), A--;
            for (; y--; ) {
              if (N === T || T !== null && N === T.alternate) break t;
              N = Di(N), T = Di(T);
            }
            N = null;
          }
          else N = null;
          D !== null && SD(g, c, D, N, !1), j !== null && d !== null && SD(g, d, j, N, !0);
        }
      }
      e: {
        if (c = l ? wi(l) : window, D = c.nodeName && c.nodeName.toLowerCase(), D === "select" || D === "input" && c.type === "file") var E = mS;
        else if (xD(c)) if (r3) E = QS;
        else {
          E = kS;
          var C = wS;
        }
        else (D = c.nodeName) && D.toLowerCase() === "input" && (c.type === "checkbox" || c.type === "radio") && (E = US);
        if (E && (E = E(e, l))) {
          t3(g, E, r, I);
          break e;
        }
        C && C(e, c, l), e === "focusout" && (C = c._wrapperState) && C.controlled && c.type === "number" && lI(c, "number", c.value);
      }
      switch (C = l ? wi(l) : window, e) {
        case "focusin":
          (xD(C) || C.contentEditable === "true") && (hi = C, EI = l, na = null);
          break;
        case "focusout":
          na = EI = hi = null;
          break;
        case "mousedown":
          zI = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          zI = !1, LD(g, r, I);
          break;
        case "selectionchange":
          if (PS) break;
        case "keydown":
        case "keyup":
          LD(g, r, I);
      }
      var p;
      if (D4) e: {
        switch (e) {
          case "compositionstart":
            var O = "onCompositionStart";
            break e;
          case "compositionend":
            O = "onCompositionEnd";
            break e;
          case "compositionupdate":
            O = "onCompositionUpdate";
            break e;
        }
        O = void 0;
      }
      else vi ? q0(e, r) && (O = "onCompositionEnd") : e === "keydown" && r.keyCode === 229 && (O = "onCompositionStart");
      O && (K0 && r.locale !== "ko" && (vi || O !== "onCompositionStart" ? O === "onCompositionEnd" && vi && (p = X0()) : (gn = I, g4 = "value" in gn ? gn.value : gn.textContent, vi = !0)), C = vu(l, O), 0 < C.length && (O = new yD(O, e, null, r, I), g.push({ event: O, listeners: C }), p ? O.data = p : (p = e3(r), p !== null && (O.data = p)))), (p = OS ? pS(e, r) : SS(e, r)) && (l = vu(l, "onBeforeInput"), 0 < l.length && (I = new yD("onBeforeInput", "beforeinput", null, r, I), g.push({ event: I, listeners: l }), I.data = p));
    }
    I3(g, t);
  });
}
function La(e, t, r) {
  return { instance: e, listener: t, currentTarget: r };
}
function vu(e, t) {
  for (var r = t + "Capture", n = []; e !== null; ) {
    var i = e, M = i.stateNode;
    i.tag === 5 && M !== null && (i = M, M = Aa(e, r), M != null && n.unshift(La(e, M, i)), M = Aa(e, t), M != null && n.push(La(e, M, i))), e = e.return;
  }
  return n;
}
function Di(e) {
  if (e === null) return null;
  do
    e = e.return;
  while (e && e.tag !== 5);
  return e || null;
}
function SD(e, t, r, n, i) {
  for (var M = t._reactName, o = []; r !== null && r !== n; ) {
    var u = r, s = u.alternate, l = u.stateNode;
    if (s !== null && s === n) break;
    u.tag === 5 && l !== null && (u = l, i ? (s = Aa(r, M), s != null && o.unshift(La(r, s, u))) : i || (s = Aa(r, M), s != null && o.push(La(r, s, u)))), r = r.return;
  }
  o.length !== 0 && e.push({ event: t, listeners: o });
}
var VS = /\r\n?/g, _S = /\u0000|\uFFFD/g;
function vD(e) {
  return (typeof e == "string" ? e : "" + e).replace(VS, `
`).replace(_S, "");
}
function zo(e, t, r) {
  if (t = vD(t), vD(e) !== t && r) throw Error(L(425));
}
function hu() {
}
var fI = null, CI = null;
function LI(e, t) {
  return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
}
var OI = typeof setTimeout == "function" ? setTimeout : void 0, ZS = typeof clearTimeout == "function" ? clearTimeout : void 0, hD = typeof Promise == "function" ? Promise : void 0, GS = typeof queueMicrotask == "function" ? queueMicrotask : typeof hD != "undefined" ? function(e) {
  return hD.resolve(null).then(e).catch(BS);
} : OI;
function BS(e) {
  setTimeout(function() {
    throw e;
  });
}
function Hl(e, t) {
  var r = t, n = 0;
  do {
    var i = r.nextSibling;
    if (e.removeChild(r), i && i.nodeType === 8) if (r = i.data, r === "/$") {
      if (n === 0) {
        e.removeChild(i), Ea(t);
        return;
      }
      n--;
    } else r !== "$" && r !== "$?" && r !== "$!" || n++;
    r = i;
  } while (r);
  Ea(t);
}
function zn(e) {
  for (; e != null; e = e.nextSibling) {
    var t = e.nodeType;
    if (t === 1 || t === 3) break;
    if (t === 8) {
      if (t = e.data, t === "$" || t === "$!" || t === "$?") break;
      if (t === "/$") return null;
    }
  }
  return e;
}
function mD(e) {
  e = e.previousSibling;
  for (var t = 0; e; ) {
    if (e.nodeType === 8) {
      var r = e.data;
      if (r === "$" || r === "$!" || r === "$?") {
        if (t === 0) return e;
        t--;
      } else r === "/$" && t++;
    }
    e = e.previousSibling;
  }
  return null;
}
var TM = Math.random().toString(36).slice(2), fr = "__reactFiber$" + TM, Oa = "__reactProps$" + TM, Zr = "__reactContainer$" + TM, pI = "__reactEvents$" + TM, FS = "__reactListeners$" + TM, WS = "__reactHandles$" + TM;
function Jn(e) {
  var t = e[fr];
  if (t) return t;
  for (var r = e.parentNode; r; ) {
    if (t = r[Zr] || r[fr]) {
      if (r = t.alternate, t.child !== null || r !== null && r.child !== null) for (e = mD(e); e !== null; ) {
        if (r = e[fr]) return r;
        e = mD(e);
      }
      return t;
    }
    e = r, r = e.parentNode;
  }
  return null;
}
function Ja(e) {
  return e = e[fr] || e[Zr], !e || e.tag !== 5 && e.tag !== 6 && e.tag !== 13 && e.tag !== 3 ? null : e;
}
function wi(e) {
  if (e.tag === 5 || e.tag === 6) return e.stateNode;
  throw Error(L(33));
}
function fs(e) {
  return e[Oa] || null;
}
var SI = [], ki = -1;
function Un(e) {
  return { current: e };
}
function oe(e) {
  0 > ki || (e.current = SI[ki], SI[ki] = null, ki--);
}
function ie(e, t) {
  ki++, SI[ki] = e.current, e.current = t;
}
var Sn = {}, Ve = Un(Sn), at = Un(!1), ri = Sn;
function nM(e, t) {
  var r = e.type.contextTypes;
  if (!r) return Sn;
  var n = e.stateNode;
  if (n && n.__reactInternalMemoizedUnmaskedChildContext === t) return n.__reactInternalMemoizedMaskedChildContext;
  var i = {}, M;
  for (M in r) i[M] = t[M];
  return n && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = i), i;
}
function ot(e) {
  return e = e.childContextTypes, e != null;
}
function mu() {
  oe(at), oe(Ve);
}
function wD(e, t, r) {
  if (Ve.current !== Sn) throw Error(L(168));
  ie(Ve, t), ie(at, r);
}
function j3(e, t, r) {
  var n = e.stateNode;
  if (t = t.childContextTypes, typeof n.getChildContext != "function") return r;
  n = n.getChildContext();
  for (var i in n) if (!(i in t)) throw Error(L(108, wp(e) || "Unknown", i));
  return Ie({}, r, n);
}
function wu(e) {
  return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || Sn, ri = Ve.current, ie(Ve, e), ie(at, at.current), !0;
}
function kD(e, t, r) {
  var n = e.stateNode;
  if (!n) throw Error(L(169));
  r ? (e = j3(e, t, ri), n.__reactInternalMemoizedMergedChildContext = e, oe(at), oe(Ve), ie(Ve, e)) : oe(at), ie(at, r);
}
var br = null, Cs = !1, Vl = !1;
function N3(e) {
  br === null ? br = [e] : br.push(e);
}
function JS(e) {
  Cs = !0, N3(e);
}
function Qn() {
  if (!Vl && br !== null) {
    Vl = !0;
    var e = 0, t = re;
    try {
      var r = br;
      for (re = 1; e < r.length; e++) {
        var n = r[e];
        do
          n = n(!0);
        while (n !== null);
      }
      br = null, Cs = !1;
    } catch (i) {
      throw br !== null && (br = br.slice(e + 1)), $0(s4, Qn), i;
    } finally {
      re = t, Vl = !1;
    }
  }
  return null;
}
var Ui = [], Qi = 0, ku = null, Uu = 0, kt = [], Ut = 0, ni = null, $r = 1, Rr = "";
function Bn(e, t) {
  Ui[Qi++] = Uu, Ui[Qi++] = ku, ku = e, Uu = t;
}
function D3(e, t, r) {
  kt[Ut++] = $r, kt[Ut++] = Rr, kt[Ut++] = ni, ni = e;
  var n = $r;
  e = Rr;
  var i = 32 - ar(n) - 1;
  n &= ~(1 << i), r += 1;
  var M = 32 - ar(t) + i;
  if (30 < M) {
    var o = i - i % 5;
    M = (n & (1 << o) - 1).toString(32), n >>= o, i -= o, $r = 1 << 32 - ar(t) + i | r << i | n, Rr = M + e;
  } else $r = 1 << M | r << i | n, Rr = e;
}
function T4(e) {
  e.return !== null && (Bn(e, 1), D3(e, 1, 0));
}
function A4(e) {
  for (; e === ku; ) ku = Ui[--Qi], Ui[Qi] = null, Uu = Ui[--Qi], Ui[Qi] = null;
  for (; e === ni; ) ni = kt[--Ut], kt[Ut] = null, Rr = kt[--Ut], kt[Ut] = null, $r = kt[--Ut], kt[Ut] = null;
}
var Tt = null, yt = null, se = !1, nr = null;
function y3(e, t) {
  var r = bt(5, null, null, 0);
  r.elementType = "DELETED", r.stateNode = t, r.return = e, t = e.deletions, t === null ? (e.deletions = [r], e.flags |= 16) : t.push(r);
}
function UD(e, t) {
  switch (e.tag) {
    case 5:
      var r = e.type;
      return t = t.nodeType !== 1 || r.toLowerCase() !== t.nodeName.toLowerCase() ? null : t, t !== null ? (e.stateNode = t, Tt = e, yt = zn(t.firstChild), !0) : !1;
    case 6:
      return t = e.pendingProps === "" || t.nodeType !== 3 ? null : t, t !== null ? (e.stateNode = t, Tt = e, yt = null, !0) : !1;
    case 13:
      return t = t.nodeType !== 8 ? null : t, t !== null ? (r = ni !== null ? { id: $r, overflow: Rr } : null, e.memoizedState = { dehydrated: t, treeContext: r, retryLane: 1073741824 }, r = bt(18, null, null, 0), r.stateNode = t, r.return = e, e.child = r, Tt = e, yt = null, !0) : !1;
    default:
      return !1;
  }
}
function vI(e) {
  return (e.mode & 1) !== 0 && (e.flags & 128) === 0;
}
function hI(e) {
  if (se) {
    var t = yt;
    if (t) {
      var r = t;
      if (!UD(e, t)) {
        if (vI(e)) throw Error(L(418));
        t = zn(r.nextSibling);
        var n = Tt;
        t && UD(e, t) ? y3(n, r) : (e.flags = e.flags & -4097 | 2, se = !1, Tt = e);
      }
    } else {
      if (vI(e)) throw Error(L(418));
      e.flags = e.flags & -4097 | 2, se = !1, Tt = e;
    }
  }
}
function QD(e) {
  for (e = e.return; e !== null && e.tag !== 5 && e.tag !== 3 && e.tag !== 13; ) e = e.return;
  Tt = e;
}
function fo(e) {
  if (e !== Tt) return !1;
  if (!se) return QD(e), se = !0, !1;
  var t;
  if ((t = e.tag !== 3) && !(t = e.tag !== 5) && (t = e.type, t = t !== "head" && t !== "body" && !LI(e.type, e.memoizedProps)), t && (t = yt)) {
    if (vI(e)) throw T3(), Error(L(418));
    for (; t; ) y3(e, t), t = zn(t.nextSibling);
  }
  if (QD(e), e.tag === 13) {
    if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(L(317));
    e: {
      for (e = e.nextSibling, t = 0; e; ) {
        if (e.nodeType === 8) {
          var r = e.data;
          if (r === "/$") {
            if (t === 0) {
              yt = zn(e.nextSibling);
              break e;
            }
            t--;
          } else r !== "$" && r !== "$!" && r !== "$?" || t++;
        }
        e = e.nextSibling;
      }
      yt = null;
    }
  } else yt = Tt ? zn(e.stateNode.nextSibling) : null;
  return !0;
}
function T3() {
  for (var e = yt; e; ) e = zn(e.nextSibling);
}
function iM() {
  yt = Tt = null, se = !1;
}
function d4(e) {
  nr === null ? nr = [e] : nr.push(e);
}
var XS = Kr.ReactCurrentBatchConfig;
function wM(e, t, r) {
  if (e = r.ref, e !== null && typeof e != "function" && typeof e != "object") {
    if (r._owner) {
      if (r = r._owner, r) {
        if (r.tag !== 1) throw Error(L(309));
        var n = r.stateNode;
      }
      if (!n) throw Error(L(147, e));
      var i = n, M = "" + e;
      return t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === M ? t.ref : (t = function(o) {
        var u = i.refs;
        o === null ? delete u[M] : u[M] = o;
      }, t._stringRef = M, t);
    }
    if (typeof e != "string") throw Error(L(284));
    if (!r._owner) throw Error(L(290, e));
  }
  return e;
}
function Co(e, t) {
  throw e = Object.prototype.toString.call(t), Error(L(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e));
}
function YD(e) {
  var t = e._init;
  return t(e._payload);
}
function A3(e) {
  function t(T, y) {
    if (e) {
      var A = T.deletions;
      A === null ? (T.deletions = [y], T.flags |= 16) : A.push(y);
    }
  }
  function r(T, y) {
    if (!e) return null;
    for (; y !== null; ) t(T, y), y = y.sibling;
    return null;
  }
  function n(T, y) {
    for (T = /* @__PURE__ */ new Map(); y !== null; ) y.key !== null ? T.set(y.key, y) : T.set(y.index, y), y = y.sibling;
    return T;
  }
  function i(T, y) {
    return T = On(T, y), T.index = 0, T.sibling = null, T;
  }
  function M(T, y, A) {
    return T.index = A, e ? (A = T.alternate, A !== null ? (A = A.index, A < y ? (T.flags |= 2, y) : A) : (T.flags |= 2, y)) : (T.flags |= 1048576, y);
  }
  function o(T) {
    return e && T.alternate === null && (T.flags |= 2), T;
  }
  function u(T, y, A, x) {
    return y === null || y.tag !== 6 ? (y = Jl(A, T.mode, x), y.return = T, y) : (y = i(y, A), y.return = T, y);
  }
  function s(T, y, A, x) {
    var E = A.type;
    return E === Si ? I(T, y, A.props.children, x, A.key) : y !== null && (y.elementType === E || typeof E == "object" && E !== null && E.$$typeof === sn && YD(E) === y.type) ? (x = i(y, A.props), x.ref = wM(T, y, A), x.return = T, x) : (x = Iu(A.type, A.key, A.props, null, T.mode, x), x.ref = wM(T, y, A), x.return = T, x);
  }
  function l(T, y, A, x) {
    return y === null || y.tag !== 4 || y.stateNode.containerInfo !== A.containerInfo || y.stateNode.implementation !== A.implementation ? (y = Xl(A, T.mode, x), y.return = T, y) : (y = i(y, A.children || []), y.return = T, y);
  }
  function I(T, y, A, x, E) {
    return y === null || y.tag !== 7 ? (y = ei(A, T.mode, x, E), y.return = T, y) : (y = i(y, A), y.return = T, y);
  }
  function g(T, y, A) {
    if (typeof y == "string" && y !== "" || typeof y == "number") return y = Jl("" + y, T.mode, A), y.return = T, y;
    if (typeof y == "object" && y !== null) {
      switch (y.$$typeof) {
        case go:
          return A = Iu(y.type, y.key, y.props, null, T.mode, A), A.ref = wM(T, null, y), A.return = T, A;
        case pi:
          return y = Xl(y, T.mode, A), y.return = T, y;
        case sn:
          var x = y._init;
          return g(T, x(y._payload), A);
      }
      if (FM(y) || pM(y)) return y = ei(y, T.mode, A, null), y.return = T, y;
      Co(T, y);
    }
    return null;
  }
  function c(T, y, A, x) {
    var E = y !== null ? y.key : null;
    if (typeof A == "string" && A !== "" || typeof A == "number") return E !== null ? null : u(T, y, "" + A, x);
    if (typeof A == "object" && A !== null) {
      switch (A.$$typeof) {
        case go:
          return A.key === E ? s(T, y, A, x) : null;
        case pi:
          return A.key === E ? l(T, y, A, x) : null;
        case sn:
          return E = A._init, c(
            T,
            y,
            E(A._payload),
            x
          );
      }
      if (FM(A) || pM(A)) return E !== null ? null : I(T, y, A, x, null);
      Co(T, A);
    }
    return null;
  }
  function D(T, y, A, x, E) {
    if (typeof x == "string" && x !== "" || typeof x == "number") return T = T.get(A) || null, u(y, T, "" + x, E);
    if (typeof x == "object" && x !== null) {
      switch (x.$$typeof) {
        case go:
          return T = T.get(x.key === null ? A : x.key) || null, s(y, T, x, E);
        case pi:
          return T = T.get(x.key === null ? A : x.key) || null, l(y, T, x, E);
        case sn:
          var C = x._init;
          return D(T, y, A, C(x._payload), E);
      }
      if (FM(x) || pM(x)) return T = T.get(A) || null, I(y, T, x, E, null);
      Co(y, x);
    }
    return null;
  }
  function j(T, y, A, x) {
    for (var E = null, C = null, p = y, O = y = 0, w = null; p !== null && O < A.length; O++) {
      p.index > O ? (w = p, p = null) : w = p.sibling;
      var z = c(T, p, A[O], x);
      if (z === null) {
        p === null && (p = w);
        break;
      }
      e && p && z.alternate === null && t(T, p), y = M(z, y, O), C === null ? E = z : C.sibling = z, C = z, p = w;
    }
    if (O === A.length) return r(T, p), se && Bn(T, O), E;
    if (p === null) {
      for (; O < A.length; O++) p = g(T, A[O], x), p !== null && (y = M(p, y, O), C === null ? E = p : C.sibling = p, C = p);
      return se && Bn(T, O), E;
    }
    for (p = n(T, p); O < A.length; O++) w = D(p, T, O, A[O], x), w !== null && (e && w.alternate !== null && p.delete(w.key === null ? O : w.key), y = M(w, y, O), C === null ? E = w : C.sibling = w, C = w);
    return e && p.forEach(function(R) {
      return t(T, R);
    }), se && Bn(T, O), E;
  }
  function N(T, y, A, x) {
    var E = pM(A);
    if (typeof E != "function") throw Error(L(150));
    if (A = E.call(A), A == null) throw Error(L(151));
    for (var C = E = null, p = y, O = y = 0, w = null, z = A.next(); p !== null && !z.done; O++, z = A.next()) {
      p.index > O ? (w = p, p = null) : w = p.sibling;
      var R = c(T, p, z.value, x);
      if (R === null) {
        p === null && (p = w);
        break;
      }
      e && p && R.alternate === null && t(T, p), y = M(R, y, O), C === null ? E = R : C.sibling = R, C = R, p = w;
    }
    if (z.done) return r(
      T,
      p
    ), se && Bn(T, O), E;
    if (p === null) {
      for (; !z.done; O++, z = A.next()) z = g(T, z.value, x), z !== null && (y = M(z, y, O), C === null ? E = z : C.sibling = z, C = z);
      return se && Bn(T, O), E;
    }
    for (p = n(T, p); !z.done; O++, z = A.next()) z = D(p, T, O, z.value, x), z !== null && (e && z.alternate !== null && p.delete(z.key === null ? O : z.key), y = M(z, y, O), C === null ? E = z : C.sibling = z, C = z);
    return e && p.forEach(function(K) {
      return t(T, K);
    }), se && Bn(T, O), E;
  }
  function d(T, y, A, x) {
    if (typeof A == "object" && A !== null && A.type === Si && A.key === null && (A = A.props.children), typeof A == "object" && A !== null) {
      switch (A.$$typeof) {
        case go:
          e: {
            for (var E = A.key, C = y; C !== null; ) {
              if (C.key === E) {
                if (E = A.type, E === Si) {
                  if (C.tag === 7) {
                    r(T, C.sibling), y = i(C, A.props.children), y.return = T, T = y;
                    break e;
                  }
                } else if (C.elementType === E || typeof E == "object" && E !== null && E.$$typeof === sn && YD(E) === C.type) {
                  r(T, C.sibling), y = i(C, A.props), y.ref = wM(T, C, A), y.return = T, T = y;
                  break e;
                }
                r(T, C);
                break;
              } else t(T, C);
              C = C.sibling;
            }
            A.type === Si ? (y = ei(A.props.children, T.mode, x, A.key), y.return = T, T = y) : (x = Iu(A.type, A.key, A.props, null, T.mode, x), x.ref = wM(T, y, A), x.return = T, T = x);
          }
          return o(T);
        case pi:
          e: {
            for (C = A.key; y !== null; ) {
              if (y.key === C) if (y.tag === 4 && y.stateNode.containerInfo === A.containerInfo && y.stateNode.implementation === A.implementation) {
                r(T, y.sibling), y = i(y, A.children || []), y.return = T, T = y;
                break e;
              } else {
                r(T, y);
                break;
              }
              else t(T, y);
              y = y.sibling;
            }
            y = Xl(A, T.mode, x), y.return = T, T = y;
          }
          return o(T);
        case sn:
          return C = A._init, d(T, y, C(A._payload), x);
      }
      if (FM(A)) return j(T, y, A, x);
      if (pM(A)) return N(T, y, A, x);
      Co(T, A);
    }
    return typeof A == "string" && A !== "" || typeof A == "number" ? (A = "" + A, y !== null && y.tag === 6 ? (r(T, y.sibling), y = i(y, A), y.return = T, T = y) : (r(T, y), y = Jl(A, T.mode, x), y.return = T, T = y), o(T)) : r(T, y);
  }
  return d;
}
var MM = A3(!0), d3 = A3(!1), Qu = Un(null), Yu = null, Yi = null, x4 = null;
function E4() {
  x4 = Yi = Yu = null;
}
function z4(e) {
  var t = Qu.current;
  oe(Qu), e._currentValue = t;
}
function mI(e, t, r) {
  for (; e !== null; ) {
    var n = e.alternate;
    if ((e.childLanes & t) !== t ? (e.childLanes |= t, n !== null && (n.childLanes |= t)) : n !== null && (n.childLanes & t) !== t && (n.childLanes |= t), e === r) break;
    e = e.return;
  }
}
function Fi(e, t) {
  Yu = e, x4 = Yi = null, e = e.dependencies, e !== null && e.firstContext !== null && (e.lanes & t && (it = !0), e.firstContext = null);
}
function $t(e) {
  var t = e._currentValue;
  if (x4 !== e) if (e = { context: e, memoizedValue: t, next: null }, Yi === null) {
    if (Yu === null) throw Error(L(308));
    Yi = e, Yu.dependencies = { lanes: 0, firstContext: e };
  } else Yi = Yi.next = e;
  return t;
}
var Xn = null;
function f4(e) {
  Xn === null ? Xn = [e] : Xn.push(e);
}
function x3(e, t, r, n) {
  var i = t.interleaved;
  return i === null ? (r.next = r, f4(t)) : (r.next = i.next, i.next = r), t.interleaved = r, Gr(e, n);
}
function Gr(e, t) {
  e.lanes |= t;
  var r = e.alternate;
  for (r !== null && (r.lanes |= t), r = e, e = e.return; e !== null; ) e.childLanes |= t, r = e.alternate, r !== null && (r.childLanes |= t), r = e, e = e.return;
  return r.tag === 3 ? r.stateNode : null;
}
var ln = !1;
function C4(e) {
  e.updateQueue = { baseState: e.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
}
function E3(e, t) {
  e = e.updateQueue, t.updateQueue === e && (t.updateQueue = { baseState: e.baseState, firstBaseUpdate: e.firstBaseUpdate, lastBaseUpdate: e.lastBaseUpdate, shared: e.shared, effects: e.effects });
}
function Hr(e, t) {
  return { eventTime: e, lane: t, tag: 0, payload: null, callback: null, next: null };
}
function fn(e, t, r) {
  var n = e.updateQueue;
  if (n === null) return null;
  if (n = n.shared, F & 2) {
    var i = n.pending;
    return i === null ? t.next = t : (t.next = i.next, i.next = t), n.pending = t, Gr(e, r);
  }
  return i = n.interleaved, i === null ? (t.next = t, f4(n)) : (t.next = i.next, i.next = t), n.interleaved = t, Gr(e, r);
}
function au(e, t, r) {
  if (t = t.updateQueue, t !== null && (t = t.shared, (r & 4194240) !== 0)) {
    var n = t.lanes;
    n &= e.pendingLanes, r |= n, t.lanes = r, l4(e, r);
  }
}
function bD(e, t) {
  var r = e.updateQueue, n = e.alternate;
  if (n !== null && (n = n.updateQueue, r === n)) {
    var i = null, M = null;
    if (r = r.firstBaseUpdate, r !== null) {
      do {
        var o = { eventTime: r.eventTime, lane: r.lane, tag: r.tag, payload: r.payload, callback: r.callback, next: null };
        M === null ? i = M = o : M = M.next = o, r = r.next;
      } while (r !== null);
      M === null ? i = M = t : M = M.next = t;
    } else i = M = t;
    r = { baseState: n.baseState, firstBaseUpdate: i, lastBaseUpdate: M, shared: n.shared, effects: n.effects }, e.updateQueue = r;
    return;
  }
  e = r.lastBaseUpdate, e === null ? r.firstBaseUpdate = t : e.next = t, r.lastBaseUpdate = t;
}
function bu(e, t, r, n) {
  var i = e.updateQueue;
  ln = !1;
  var M = i.firstBaseUpdate, o = i.lastBaseUpdate, u = i.shared.pending;
  if (u !== null) {
    i.shared.pending = null;
    var s = u, l = s.next;
    s.next = null, o === null ? M = l : o.next = l, o = s;
    var I = e.alternate;
    I !== null && (I = I.updateQueue, u = I.lastBaseUpdate, u !== o && (u === null ? I.firstBaseUpdate = l : u.next = l, I.lastBaseUpdate = s));
  }
  if (M !== null) {
    var g = i.baseState;
    o = 0, I = l = s = null, u = M;
    do {
      var c = u.lane, D = u.eventTime;
      if ((n & c) === c) {
        I !== null && (I = I.next = {
          eventTime: D,
          lane: 0,
          tag: u.tag,
          payload: u.payload,
          callback: u.callback,
          next: null
        });
        e: {
          var j = e, N = u;
          switch (c = t, D = r, N.tag) {
            case 1:
              if (j = N.payload, typeof j == "function") {
                g = j.call(D, g, c);
                break e;
              }
              g = j;
              break e;
            case 3:
              j.flags = j.flags & -65537 | 128;
            case 0:
              if (j = N.payload, c = typeof j == "function" ? j.call(D, g, c) : j, c == null) break e;
              g = Ie({}, g, c);
              break e;
            case 2:
              ln = !0;
          }
        }
        u.callback !== null && u.lane !== 0 && (e.flags |= 64, c = i.effects, c === null ? i.effects = [u] : c.push(u));
      } else D = { eventTime: D, lane: c, tag: u.tag, payload: u.payload, callback: u.callback, next: null }, I === null ? (l = I = D, s = g) : I = I.next = D, o |= c;
      if (u = u.next, u === null) {
        if (u = i.shared.pending, u === null) break;
        c = u, u = c.next, c.next = null, i.lastBaseUpdate = c, i.shared.pending = null;
      }
    } while (!0);
    if (I === null && (s = g), i.baseState = s, i.firstBaseUpdate = l, i.lastBaseUpdate = I, t = i.shared.interleaved, t !== null) {
      i = t;
      do
        o |= i.lane, i = i.next;
      while (i !== t);
    } else M === null && (i.shared.lanes = 0);
    Mi |= o, e.lanes = o, e.memoizedState = g;
  }
}
function PD(e, t, r) {
  if (e = t.effects, t.effects = null, e !== null) for (t = 0; t < e.length; t++) {
    var n = e[t], i = n.callback;
    if (i !== null) {
      if (n.callback = null, n = r, typeof i != "function") throw Error(L(191, i));
      i.call(n);
    }
  }
}
var Xa = {}, pr = Un(Xa), pa = Un(Xa), Sa = Un(Xa);
function Kn(e) {
  if (e === Xa) throw Error(L(174));
  return e;
}
function L4(e, t) {
  switch (ie(Sa, t), ie(pa, e), ie(pr, Xa), e = t.nodeType, e) {
    case 9:
    case 11:
      t = (t = t.documentElement) ? t.namespaceURI : II(null, "");
      break;
    default:
      e = e === 8 ? t.parentNode : t, t = e.namespaceURI || null, e = e.tagName, t = II(t, e);
  }
  oe(pr), ie(pr, t);
}
function aM() {
  oe(pr), oe(pa), oe(Sa);
}
function z3(e) {
  Kn(Sa.current);
  var t = Kn(pr.current), r = II(t, e.type);
  t !== r && (ie(pa, e), ie(pr, r));
}
function O4(e) {
  pa.current === e && (oe(pr), oe(pa));
}
var le = Un(0);
function Pu(e) {
  for (var t = e; t !== null; ) {
    if (t.tag === 13) {
      var r = t.memoizedState;
      if (r !== null && (r = r.dehydrated, r === null || r.data === "$?" || r.data === "$!")) return t;
    } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
      if (t.flags & 128) return t;
    } else if (t.child !== null) {
      t.child.return = t, t = t.child;
      continue;
    }
    if (t === e) break;
    for (; t.sibling === null; ) {
      if (t.return === null || t.return === e) return null;
      t = t.return;
    }
    t.sibling.return = t.return, t = t.sibling;
  }
  return null;
}
var _l = [];
function p4() {
  for (var e = 0; e < _l.length; e++) _l[e]._workInProgressVersionPrimary = null;
  _l.length = 0;
}
var ou = Kr.ReactCurrentDispatcher, Zl = Kr.ReactCurrentBatchConfig, ii = 0, ce = null, Ae = null, Oe = null, $u = !1, ia = !1, va = 0, KS = 0;
function Ye() {
  throw Error(L(321));
}
function S4(e, t) {
  if (t === null) return !1;
  for (var r = 0; r < t.length && r < e.length; r++) if (!sr(e[r], t[r])) return !1;
  return !0;
}
function v4(e, t, r, n, i, M) {
  if (ii = M, ce = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, ou.current = e === null || e.memoizedState === null ? rv : nv, e = r(n, i), ia) {
    M = 0;
    do {
      if (ia = !1, va = 0, 25 <= M) throw Error(L(301));
      M += 1, Oe = Ae = null, t.updateQueue = null, ou.current = iv, e = r(n, i);
    } while (ia);
  }
  if (ou.current = Ru, t = Ae !== null && Ae.next !== null, ii = 0, Oe = Ae = ce = null, $u = !1, t) throw Error(L(300));
  return e;
}
function h4() {
  var e = va !== 0;
  return va = 0, e;
}
function Er() {
  var e = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
  return Oe === null ? ce.memoizedState = Oe = e : Oe = Oe.next = e, Oe;
}
function Rt() {
  if (Ae === null) {
    var e = ce.alternate;
    e = e !== null ? e.memoizedState : null;
  } else e = Ae.next;
  var t = Oe === null ? ce.memoizedState : Oe.next;
  if (t !== null) Oe = t, Ae = e;
  else {
    if (e === null) throw Error(L(310));
    Ae = e, e = { memoizedState: Ae.memoizedState, baseState: Ae.baseState, baseQueue: Ae.baseQueue, queue: Ae.queue, next: null }, Oe === null ? ce.memoizedState = Oe = e : Oe = Oe.next = e;
  }
  return Oe;
}
function ha(e, t) {
  return typeof t == "function" ? t(e) : t;
}
function Gl(e) {
  var t = Rt(), r = t.queue;
  if (r === null) throw Error(L(311));
  r.lastRenderedReducer = e;
  var n = Ae, i = n.baseQueue, M = r.pending;
  if (M !== null) {
    if (i !== null) {
      var o = i.next;
      i.next = M.next, M.next = o;
    }
    n.baseQueue = i = M, r.pending = null;
  }
  if (i !== null) {
    M = i.next, n = n.baseState;
    var u = o = null, s = null, l = M;
    do {
      var I = l.lane;
      if ((ii & I) === I) s !== null && (s = s.next = { lane: 0, action: l.action, hasEagerState: l.hasEagerState, eagerState: l.eagerState, next: null }), n = l.hasEagerState ? l.eagerState : e(n, l.action);
      else {
        var g = {
          lane: I,
          action: l.action,
          hasEagerState: l.hasEagerState,
          eagerState: l.eagerState,
          next: null
        };
        s === null ? (u = s = g, o = n) : s = s.next = g, ce.lanes |= I, Mi |= I;
      }
      l = l.next;
    } while (l !== null && l !== M);
    s === null ? o = n : s.next = u, sr(n, t.memoizedState) || (it = !0), t.memoizedState = n, t.baseState = o, t.baseQueue = s, r.lastRenderedState = n;
  }
  if (e = r.interleaved, e !== null) {
    i = e;
    do
      M = i.lane, ce.lanes |= M, Mi |= M, i = i.next;
    while (i !== e);
  } else i === null && (r.lanes = 0);
  return [t.memoizedState, r.dispatch];
}
function Bl(e) {
  var t = Rt(), r = t.queue;
  if (r === null) throw Error(L(311));
  r.lastRenderedReducer = e;
  var n = r.dispatch, i = r.pending, M = t.memoizedState;
  if (i !== null) {
    r.pending = null;
    var o = i = i.next;
    do
      M = e(M, o.action), o = o.next;
    while (o !== i);
    sr(M, t.memoizedState) || (it = !0), t.memoizedState = M, t.baseQueue === null && (t.baseState = M), r.lastRenderedState = M;
  }
  return [M, n];
}
function f3() {
}
function C3(e, t) {
  var r = ce, n = Rt(), i = t(), M = !sr(n.memoizedState, i);
  if (M && (n.memoizedState = i, it = !0), n = n.queue, m4(p3.bind(null, r, n, e), [e]), n.getSnapshot !== t || M || Oe !== null && Oe.memoizedState.tag & 1) {
    if (r.flags |= 2048, ma(9, O3.bind(null, r, n, i, t), void 0, null), pe === null) throw Error(L(349));
    ii & 30 || L3(r, t, i);
  }
  return i;
}
function L3(e, t, r) {
  e.flags |= 16384, e = { getSnapshot: t, value: r }, t = ce.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, ce.updateQueue = t, t.stores = [e]) : (r = t.stores, r === null ? t.stores = [e] : r.push(e));
}
function O3(e, t, r, n) {
  t.value = r, t.getSnapshot = n, S3(t) && v3(e);
}
function p3(e, t, r) {
  return r(function() {
    S3(t) && v3(e);
  });
}
function S3(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var r = t();
    return !sr(e, r);
  } catch (n) {
    return !0;
  }
}
function v3(e) {
  var t = Gr(e, 1);
  t !== null && or(t, e, 1, -1);
}
function $D(e) {
  var t = Er();
  return typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: ha, lastRenderedState: e }, t.queue = e, e = e.dispatch = tv.bind(null, ce, e), [t.memoizedState, e];
}
function ma(e, t, r, n) {
  return e = { tag: e, create: t, destroy: r, deps: n, next: null }, t = ce.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, ce.updateQueue = t, t.lastEffect = e.next = e) : (r = t.lastEffect, r === null ? t.lastEffect = e.next = e : (n = r.next, r.next = e, e.next = n, t.lastEffect = e)), e;
}
function h3() {
  return Rt().memoizedState;
}
function uu(e, t, r, n) {
  var i = Er();
  ce.flags |= e, i.memoizedState = ma(1 | t, r, void 0, n === void 0 ? null : n);
}
function Ls(e, t, r, n) {
  var i = Rt();
  n = n === void 0 ? null : n;
  var M = void 0;
  if (Ae !== null) {
    var o = Ae.memoizedState;
    if (M = o.destroy, n !== null && S4(n, o.deps)) {
      i.memoizedState = ma(t, r, M, n);
      return;
    }
  }
  ce.flags |= e, i.memoizedState = ma(1 | t, r, M, n);
}
function RD(e, t) {
  return uu(8390656, 8, e, t);
}
function m4(e, t) {
  return Ls(2048, 8, e, t);
}
function m3(e, t) {
  return Ls(4, 2, e, t);
}
function w3(e, t) {
  return Ls(4, 4, e, t);
}
function k3(e, t) {
  if (typeof t == "function") return e = e(), t(e), function() {
    t(null);
  };
  if (t != null) return e = e(), t.current = e, function() {
    t.current = null;
  };
}
function U3(e, t, r) {
  return r = r != null ? r.concat([e]) : null, Ls(4, 4, k3.bind(null, t, e), r);
}
function w4() {
}
function Q3(e, t) {
  var r = Rt();
  t = t === void 0 ? null : t;
  var n = r.memoizedState;
  return n !== null && t !== null && S4(t, n[1]) ? n[0] : (r.memoizedState = [e, t], e);
}
function Y3(e, t) {
  var r = Rt();
  t = t === void 0 ? null : t;
  var n = r.memoizedState;
  return n !== null && t !== null && S4(t, n[1]) ? n[0] : (e = e(), r.memoizedState = [e, t], e);
}
function b3(e, t, r) {
  return ii & 21 ? (sr(r, t) || (r = V0(), ce.lanes |= r, Mi |= r, e.baseState = !0), t) : (e.baseState && (e.baseState = !1, it = !0), e.memoizedState = r);
}
function qS(e, t) {
  var r = re;
  re = r !== 0 && 4 > r ? r : 4, e(!0);
  var n = Zl.transition;
  Zl.transition = {};
  try {
    e(!1), t();
  } finally {
    re = r, Zl.transition = n;
  }
}
function P3() {
  return Rt().memoizedState;
}
function ev(e, t, r) {
  var n = Ln(e);
  if (r = { lane: n, action: r, hasEagerState: !1, eagerState: null, next: null }, $3(e)) R3(t, r);
  else if (r = x3(e, t, r, n), r !== null) {
    var i = Ke();
    or(r, e, n, i), H3(r, t, n);
  }
}
function tv(e, t, r) {
  var n = Ln(e), i = { lane: n, action: r, hasEagerState: !1, eagerState: null, next: null };
  if ($3(e)) R3(t, i);
  else {
    var M = e.alternate;
    if (e.lanes === 0 && (M === null || M.lanes === 0) && (M = t.lastRenderedReducer, M !== null)) try {
      var o = t.lastRenderedState, u = M(o, r);
      if (i.hasEagerState = !0, i.eagerState = u, sr(u, o)) {
        var s = t.interleaved;
        s === null ? (i.next = i, f4(t)) : (i.next = s.next, s.next = i), t.interleaved = i;
        return;
      }
    } catch (l) {
    } finally {
    }
    r = x3(e, t, i, n), r !== null && (i = Ke(), or(r, e, n, i), H3(r, t, n));
  }
}
function $3(e) {
  var t = e.alternate;
  return e === ce || t !== null && t === ce;
}
function R3(e, t) {
  ia = $u = !0;
  var r = e.pending;
  r === null ? t.next = t : (t.next = r.next, r.next = t), e.pending = t;
}
function H3(e, t, r) {
  if (r & 4194240) {
    var n = t.lanes;
    n &= e.pendingLanes, r |= n, t.lanes = r, l4(e, r);
  }
}
var Ru = { readContext: $t, useCallback: Ye, useContext: Ye, useEffect: Ye, useImperativeHandle: Ye, useInsertionEffect: Ye, useLayoutEffect: Ye, useMemo: Ye, useReducer: Ye, useRef: Ye, useState: Ye, useDebugValue: Ye, useDeferredValue: Ye, useTransition: Ye, useMutableSource: Ye, useSyncExternalStore: Ye, useId: Ye, unstable_isNewReconciler: !1 }, rv = { readContext: $t, useCallback: function(e, t) {
  return Er().memoizedState = [e, t === void 0 ? null : t], e;
}, useContext: $t, useEffect: RD, useImperativeHandle: function(e, t, r) {
  return r = r != null ? r.concat([e]) : null, uu(
    4194308,
    4,
    k3.bind(null, t, e),
    r
  );
}, useLayoutEffect: function(e, t) {
  return uu(4194308, 4, e, t);
}, useInsertionEffect: function(e, t) {
  return uu(4, 2, e, t);
}, useMemo: function(e, t) {
  var r = Er();
  return t = t === void 0 ? null : t, e = e(), r.memoizedState = [e, t], e;
}, useReducer: function(e, t, r) {
  var n = Er();
  return t = r !== void 0 ? r(t) : t, n.memoizedState = n.baseState = t, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: e, lastRenderedState: t }, n.queue = e, e = e.dispatch = ev.bind(null, ce, e), [n.memoizedState, e];
}, useRef: function(e) {
  var t = Er();
  return e = { current: e }, t.memoizedState = e;
}, useState: $D, useDebugValue: w4, useDeferredValue: function(e) {
  return Er().memoizedState = e;
}, useTransition: function() {
  var e = $D(!1), t = e[0];
  return e = qS.bind(null, e[1]), Er().memoizedState = e, [t, e];
}, useMutableSource: function() {
}, useSyncExternalStore: function(e, t, r) {
  var n = ce, i = Er();
  if (se) {
    if (r === void 0) throw Error(L(407));
    r = r();
  } else {
    if (r = t(), pe === null) throw Error(L(349));
    ii & 30 || L3(n, t, r);
  }
  i.memoizedState = r;
  var M = { value: r, getSnapshot: t };
  return i.queue = M, RD(p3.bind(
    null,
    n,
    M,
    e
  ), [e]), n.flags |= 2048, ma(9, O3.bind(null, n, M, r, t), void 0, null), r;
}, useId: function() {
  var e = Er(), t = pe.identifierPrefix;
  if (se) {
    var r = Rr, n = $r;
    r = (n & ~(1 << 32 - ar(n) - 1)).toString(32) + r, t = ":" + t + "R" + r, r = va++, 0 < r && (t += "H" + r.toString(32)), t += ":";
  } else r = KS++, t = ":" + t + "r" + r.toString(32) + ":";
  return e.memoizedState = t;
}, unstable_isNewReconciler: !1 }, nv = {
  readContext: $t,
  useCallback: Q3,
  useContext: $t,
  useEffect: m4,
  useImperativeHandle: U3,
  useInsertionEffect: m3,
  useLayoutEffect: w3,
  useMemo: Y3,
  useReducer: Gl,
  useRef: h3,
  useState: function() {
    return Gl(ha);
  },
  useDebugValue: w4,
  useDeferredValue: function(e) {
    var t = Rt();
    return b3(t, Ae.memoizedState, e);
  },
  useTransition: function() {
    var e = Gl(ha)[0], t = Rt().memoizedState;
    return [e, t];
  },
  useMutableSource: f3,
  useSyncExternalStore: C3,
  useId: P3,
  unstable_isNewReconciler: !1
}, iv = { readContext: $t, useCallback: Q3, useContext: $t, useEffect: m4, useImperativeHandle: U3, useInsertionEffect: m3, useLayoutEffect: w3, useMemo: Y3, useReducer: Bl, useRef: h3, useState: function() {
  return Bl(ha);
}, useDebugValue: w4, useDeferredValue: function(e) {
  var t = Rt();
  return Ae === null ? t.memoizedState = e : b3(t, Ae.memoizedState, e);
}, useTransition: function() {
  var e = Bl(ha)[0], t = Rt().memoizedState;
  return [e, t];
}, useMutableSource: f3, useSyncExternalStore: C3, useId: P3, unstable_isNewReconciler: !1 };
function er(e, t) {
  if (e && e.defaultProps) {
    t = Ie({}, t), e = e.defaultProps;
    for (var r in e) t[r] === void 0 && (t[r] = e[r]);
    return t;
  }
  return t;
}
function wI(e, t, r, n) {
  t = e.memoizedState, r = r(n, t), r = r == null ? t : Ie({}, t, r), e.memoizedState = r, e.lanes === 0 && (e.updateQueue.baseState = r);
}
var Os = { isMounted: function(e) {
  return (e = e._reactInternals) ? ci(e) === e : !1;
}, enqueueSetState: function(e, t, r) {
  e = e._reactInternals;
  var n = Ke(), i = Ln(e), M = Hr(n, i);
  M.payload = t, r != null && (M.callback = r), t = fn(e, M, i), t !== null && (or(t, e, i, n), au(t, e, i));
}, enqueueReplaceState: function(e, t, r) {
  e = e._reactInternals;
  var n = Ke(), i = Ln(e), M = Hr(n, i);
  M.tag = 1, M.payload = t, r != null && (M.callback = r), t = fn(e, M, i), t !== null && (or(t, e, i, n), au(t, e, i));
}, enqueueForceUpdate: function(e, t) {
  e = e._reactInternals;
  var r = Ke(), n = Ln(e), i = Hr(r, n);
  i.tag = 2, t != null && (i.callback = t), t = fn(e, i, n), t !== null && (or(t, e, n, r), au(t, e, n));
} };
function HD(e, t, r, n, i, M, o) {
  return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(n, M, o) : t.prototype && t.prototype.isPureReactComponent ? !fa(r, n) || !fa(i, M) : !0;
}
function V3(e, t, r) {
  var n = !1, i = Sn, M = t.contextType;
  return typeof M == "object" && M !== null ? M = $t(M) : (i = ot(t) ? ri : Ve.current, n = t.contextTypes, M = (n = n != null) ? nM(e, i) : Sn), t = new t(r, M), e.memoizedState = t.state !== null && t.state !== void 0 ? t.state : null, t.updater = Os, e.stateNode = t, t._reactInternals = e, n && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = i, e.__reactInternalMemoizedMaskedChildContext = M), t;
}
function VD(e, t, r, n) {
  e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(r, n), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(r, n), t.state !== e && Os.enqueueReplaceState(t, t.state, null);
}
function kI(e, t, r, n) {
  var i = e.stateNode;
  i.props = r, i.state = e.memoizedState, i.refs = {}, C4(e);
  var M = t.contextType;
  typeof M == "object" && M !== null ? i.context = $t(M) : (M = ot(t) ? ri : Ve.current, i.context = nM(e, M)), i.state = e.memoizedState, M = t.getDerivedStateFromProps, typeof M == "function" && (wI(e, t, M, r), i.state = e.memoizedState), typeof t.getDerivedStateFromProps == "function" || typeof i.getSnapshotBeforeUpdate == "function" || typeof i.UNSAFE_componentWillMount != "function" && typeof i.componentWillMount != "function" || (t = i.state, typeof i.componentWillMount == "function" && i.componentWillMount(), typeof i.UNSAFE_componentWillMount == "function" && i.UNSAFE_componentWillMount(), t !== i.state && Os.enqueueReplaceState(i, i.state, null), bu(e, r, i, n), i.state = e.memoizedState), typeof i.componentDidMount == "function" && (e.flags |= 4194308);
}
function oM(e, t) {
  try {
    var r = "", n = t;
    do
      r += mp(n), n = n.return;
    while (n);
    var i = r;
  } catch (M) {
    i = `
Error generating stack: ` + M.message + `
` + M.stack;
  }
  return { value: e, source: t, stack: i, digest: null };
}
function Fl(e, t, r) {
  return { value: e, source: null, stack: r != null ? r : null, digest: t != null ? t : null };
}
function UI(e, t) {
  try {
    console.error(t.value);
  } catch (r) {
    setTimeout(function() {
      throw r;
    });
  }
}
var Mv = typeof WeakMap == "function" ? WeakMap : Map;
function _3(e, t, r) {
  r = Hr(-1, r), r.tag = 3, r.payload = { element: null };
  var n = t.value;
  return r.callback = function() {
    Vu || (Vu = !0, ZI = n), UI(e, t);
  }, r;
}
function Z3(e, t, r) {
  r = Hr(-1, r), r.tag = 3;
  var n = e.type.getDerivedStateFromError;
  if (typeof n == "function") {
    var i = t.value;
    r.payload = function() {
      return n(i);
    }, r.callback = function() {
      UI(e, t);
    };
  }
  var M = e.stateNode;
  return M !== null && typeof M.componentDidCatch == "function" && (r.callback = function() {
    UI(e, t), typeof n != "function" && (Cn === null ? Cn = /* @__PURE__ */ new Set([this]) : Cn.add(this));
    var o = t.stack;
    this.componentDidCatch(t.value, { componentStack: o !== null ? o : "" });
  }), r;
}
function _D(e, t, r) {
  var n = e.pingCache;
  if (n === null) {
    n = e.pingCache = new Mv();
    var i = /* @__PURE__ */ new Set();
    n.set(t, i);
  } else i = n.get(t), i === void 0 && (i = /* @__PURE__ */ new Set(), n.set(t, i));
  i.has(r) || (i.add(r), e = Av.bind(null, e, t, r), t.then(e, e));
}
function ZD(e) {
  do {
    var t;
    if ((t = e.tag === 13) && (t = e.memoizedState, t = t !== null ? t.dehydrated !== null : !0), t) return e;
    e = e.return;
  } while (e !== null);
  return null;
}
function GD(e, t, r, n, i) {
  return e.mode & 1 ? (e.flags |= 65536, e.lanes = i, e) : (e === t ? e.flags |= 65536 : (e.flags |= 128, r.flags |= 131072, r.flags &= -52805, r.tag === 1 && (r.alternate === null ? r.tag = 17 : (t = Hr(-1, 1), t.tag = 2, fn(r, t, 1))), r.lanes |= 1), e);
}
var av = Kr.ReactCurrentOwner, it = !1;
function Xe(e, t, r, n) {
  t.child = e === null ? d3(t, null, r, n) : MM(t, e.child, r, n);
}
function BD(e, t, r, n, i) {
  r = r.render;
  var M = t.ref;
  return Fi(t, i), n = v4(e, t, r, n, M, i), r = h4(), e !== null && !it ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~i, Br(e, t, i)) : (se && r && T4(t), t.flags |= 1, Xe(e, t, n, i), t.child);
}
function FD(e, t, r, n, i) {
  if (e === null) {
    var M = r.type;
    return typeof M == "function" && !R4(M) && M.defaultProps === void 0 && r.compare === null && r.defaultProps === void 0 ? (t.tag = 15, t.type = M, G3(e, t, M, n, i)) : (e = Iu(r.type, null, n, t, t.mode, i), e.ref = t.ref, e.return = t, t.child = e);
  }
  if (M = e.child, !(e.lanes & i)) {
    var o = M.memoizedProps;
    if (r = r.compare, r = r !== null ? r : fa, r(o, n) && e.ref === t.ref) return Br(e, t, i);
  }
  return t.flags |= 1, e = On(M, n), e.ref = t.ref, e.return = t, t.child = e;
}
function G3(e, t, r, n, i) {
  if (e !== null) {
    var M = e.memoizedProps;
    if (fa(M, n) && e.ref === t.ref) if (it = !1, t.pendingProps = n = M, (e.lanes & i) !== 0) e.flags & 131072 && (it = !0);
    else return t.lanes = e.lanes, Br(e, t, i);
  }
  return QI(e, t, r, n, i);
}
function B3(e, t, r) {
  var n = t.pendingProps, i = n.children, M = e !== null ? e.memoizedState : null;
  if (n.mode === "hidden") if (!(t.mode & 1)) t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, ie(Pi, Dt), Dt |= r;
  else {
    if (!(r & 1073741824)) return e = M !== null ? M.baseLanes | r : r, t.lanes = t.childLanes = 1073741824, t.memoizedState = { baseLanes: e, cachePool: null, transitions: null }, t.updateQueue = null, ie(Pi, Dt), Dt |= e, null;
    t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, n = M !== null ? M.baseLanes : r, ie(Pi, Dt), Dt |= n;
  }
  else M !== null ? (n = M.baseLanes | r, t.memoizedState = null) : n = r, ie(Pi, Dt), Dt |= n;
  return Xe(e, t, i, r), t.child;
}
function F3(e, t) {
  var r = t.ref;
  (e === null && r !== null || e !== null && e.ref !== r) && (t.flags |= 512, t.flags |= 2097152);
}
function QI(e, t, r, n, i) {
  var M = ot(r) ? ri : Ve.current;
  return M = nM(t, M), Fi(t, i), r = v4(e, t, r, n, M, i), n = h4(), e !== null && !it ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~i, Br(e, t, i)) : (se && n && T4(t), t.flags |= 1, Xe(e, t, r, i), t.child);
}
function WD(e, t, r, n, i) {
  if (ot(r)) {
    var M = !0;
    wu(t);
  } else M = !1;
  if (Fi(t, i), t.stateNode === null) su(e, t), V3(t, r, n), kI(t, r, n, i), n = !0;
  else if (e === null) {
    var o = t.stateNode, u = t.memoizedProps;
    o.props = u;
    var s = o.context, l = r.contextType;
    typeof l == "object" && l !== null ? l = $t(l) : (l = ot(r) ? ri : Ve.current, l = nM(t, l));
    var I = r.getDerivedStateFromProps, g = typeof I == "function" || typeof o.getSnapshotBeforeUpdate == "function";
    g || typeof o.UNSAFE_componentWillReceiveProps != "function" && typeof o.componentWillReceiveProps != "function" || (u !== n || s !== l) && VD(t, o, n, l), ln = !1;
    var c = t.memoizedState;
    o.state = c, bu(t, n, o, i), s = t.memoizedState, u !== n || c !== s || at.current || ln ? (typeof I == "function" && (wI(t, r, I, n), s = t.memoizedState), (u = ln || HD(t, r, u, n, c, s, l)) ? (g || typeof o.UNSAFE_componentWillMount != "function" && typeof o.componentWillMount != "function" || (typeof o.componentWillMount == "function" && o.componentWillMount(), typeof o.UNSAFE_componentWillMount == "function" && o.UNSAFE_componentWillMount()), typeof o.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof o.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = n, t.memoizedState = s), o.props = n, o.state = s, o.context = l, n = u) : (typeof o.componentDidMount == "function" && (t.flags |= 4194308), n = !1);
  } else {
    o = t.stateNode, E3(e, t), u = t.memoizedProps, l = t.type === t.elementType ? u : er(t.type, u), o.props = l, g = t.pendingProps, c = o.context, s = r.contextType, typeof s == "object" && s !== null ? s = $t(s) : (s = ot(r) ? ri : Ve.current, s = nM(t, s));
    var D = r.getDerivedStateFromProps;
    (I = typeof D == "function" || typeof o.getSnapshotBeforeUpdate == "function") || typeof o.UNSAFE_componentWillReceiveProps != "function" && typeof o.componentWillReceiveProps != "function" || (u !== g || c !== s) && VD(t, o, n, s), ln = !1, c = t.memoizedState, o.state = c, bu(t, n, o, i);
    var j = t.memoizedState;
    u !== g || c !== j || at.current || ln ? (typeof D == "function" && (wI(t, r, D, n), j = t.memoizedState), (l = ln || HD(t, r, l, n, c, j, s) || !1) ? (I || typeof o.UNSAFE_componentWillUpdate != "function" && typeof o.componentWillUpdate != "function" || (typeof o.componentWillUpdate == "function" && o.componentWillUpdate(n, j, s), typeof o.UNSAFE_componentWillUpdate == "function" && o.UNSAFE_componentWillUpdate(n, j, s)), typeof o.componentDidUpdate == "function" && (t.flags |= 4), typeof o.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof o.componentDidUpdate != "function" || u === e.memoizedProps && c === e.memoizedState || (t.flags |= 4), typeof o.getSnapshotBeforeUpdate != "function" || u === e.memoizedProps && c === e.memoizedState || (t.flags |= 1024), t.memoizedProps = n, t.memoizedState = j), o.props = n, o.state = j, o.context = s, n = l) : (typeof o.componentDidUpdate != "function" || u === e.memoizedProps && c === e.memoizedState || (t.flags |= 4), typeof o.getSnapshotBeforeUpdate != "function" || u === e.memoizedProps && c === e.memoizedState || (t.flags |= 1024), n = !1);
  }
  return YI(e, t, r, n, M, i);
}
function YI(e, t, r, n, i, M) {
  F3(e, t);
  var o = (t.flags & 128) !== 0;
  if (!n && !o) return i && kD(t, r, !1), Br(e, t, M);
  n = t.stateNode, av.current = t;
  var u = o && typeof r.getDerivedStateFromError != "function" ? null : n.render();
  return t.flags |= 1, e !== null && o ? (t.child = MM(t, e.child, null, M), t.child = MM(t, null, u, M)) : Xe(e, t, u, M), t.memoizedState = n.state, i && kD(t, r, !0), t.child;
}
function W3(e) {
  var t = e.stateNode;
  t.pendingContext ? wD(e, t.pendingContext, t.pendingContext !== t.context) : t.context && wD(e, t.context, !1), L4(e, t.containerInfo);
}
function JD(e, t, r, n, i) {
  return iM(), d4(i), t.flags |= 256, Xe(e, t, r, n), t.child;
}
var bI = { dehydrated: null, treeContext: null, retryLane: 0 };
function PI(e) {
  return { baseLanes: e, cachePool: null, transitions: null };
}
function J3(e, t, r) {
  var n = t.pendingProps, i = le.current, M = !1, o = (t.flags & 128) !== 0, u;
  if ((u = o) || (u = e !== null && e.memoizedState === null ? !1 : (i & 2) !== 0), u ? (M = !0, t.flags &= -129) : (e === null || e.memoizedState !== null) && (i |= 1), ie(le, i & 1), e === null)
    return hI(t), e = t.memoizedState, e !== null && (e = e.dehydrated, e !== null) ? (t.mode & 1 ? e.data === "$!" ? t.lanes = 8 : t.lanes = 1073741824 : t.lanes = 1, null) : (o = n.children, e = n.fallback, M ? (n = t.mode, M = t.child, o = { mode: "hidden", children: o }, !(n & 1) && M !== null ? (M.childLanes = 0, M.pendingProps = o) : M = vs(o, n, 0, null), e = ei(e, n, r, null), M.return = t, e.return = t, M.sibling = e, t.child = M, t.child.memoizedState = PI(r), t.memoizedState = bI, e) : k4(t, o));
  if (i = e.memoizedState, i !== null && (u = i.dehydrated, u !== null)) return ov(e, t, o, n, u, i, r);
  if (M) {
    M = n.fallback, o = t.mode, i = e.child, u = i.sibling;
    var s = { mode: "hidden", children: n.children };
    return !(o & 1) && t.child !== i ? (n = t.child, n.childLanes = 0, n.pendingProps = s, t.deletions = null) : (n = On(i, s), n.subtreeFlags = i.subtreeFlags & 14680064), u !== null ? M = On(u, M) : (M = ei(M, o, r, null), M.flags |= 2), M.return = t, n.return = t, n.sibling = M, t.child = n, n = M, M = t.child, o = e.child.memoizedState, o = o === null ? PI(r) : { baseLanes: o.baseLanes | r, cachePool: null, transitions: o.transitions }, M.memoizedState = o, M.childLanes = e.childLanes & ~r, t.memoizedState = bI, n;
  }
  return M = e.child, e = M.sibling, n = On(M, { mode: "visible", children: n.children }), !(t.mode & 1) && (n.lanes = r), n.return = t, n.sibling = null, e !== null && (r = t.deletions, r === null ? (t.deletions = [e], t.flags |= 16) : r.push(e)), t.child = n, t.memoizedState = null, n;
}
function k4(e, t) {
  return t = vs({ mode: "visible", children: t }, e.mode, 0, null), t.return = e, e.child = t;
}
function Lo(e, t, r, n) {
  return n !== null && d4(n), MM(t, e.child, null, r), e = k4(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
}
function ov(e, t, r, n, i, M, o) {
  if (r)
    return t.flags & 256 ? (t.flags &= -257, n = Fl(Error(L(422))), Lo(e, t, o, n)) : t.memoizedState !== null ? (t.child = e.child, t.flags |= 128, null) : (M = n.fallback, i = t.mode, n = vs({ mode: "visible", children: n.children }, i, 0, null), M = ei(M, i, o, null), M.flags |= 2, n.return = t, M.return = t, n.sibling = M, t.child = n, t.mode & 1 && MM(t, e.child, null, o), t.child.memoizedState = PI(o), t.memoizedState = bI, M);
  if (!(t.mode & 1)) return Lo(e, t, o, null);
  if (i.data === "$!") {
    if (n = i.nextSibling && i.nextSibling.dataset, n) var u = n.dgst;
    return n = u, M = Error(L(419)), n = Fl(M, n, void 0), Lo(e, t, o, n);
  }
  if (u = (o & e.childLanes) !== 0, it || u) {
    if (n = pe, n !== null) {
      switch (o & -o) {
        case 4:
          i = 2;
          break;
        case 16:
          i = 8;
          break;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          i = 32;
          break;
        case 536870912:
          i = 268435456;
          break;
        default:
          i = 0;
      }
      i = i & (n.suspendedLanes | o) ? 0 : i, i !== 0 && i !== M.retryLane && (M.retryLane = i, Gr(e, i), or(n, e, i, -1));
    }
    return $4(), n = Fl(Error(L(421))), Lo(e, t, o, n);
  }
  return i.data === "$?" ? (t.flags |= 128, t.child = e.child, t = dv.bind(null, e), i._reactRetry = t, null) : (e = M.treeContext, yt = zn(i.nextSibling), Tt = t, se = !0, nr = null, e !== null && (kt[Ut++] = $r, kt[Ut++] = Rr, kt[Ut++] = ni, $r = e.id, Rr = e.overflow, ni = t), t = k4(t, n.children), t.flags |= 4096, t);
}
function XD(e, t, r) {
  e.lanes |= t;
  var n = e.alternate;
  n !== null && (n.lanes |= t), mI(e.return, t, r);
}
function Wl(e, t, r, n, i) {
  var M = e.memoizedState;
  M === null ? e.memoizedState = { isBackwards: t, rendering: null, renderingStartTime: 0, last: n, tail: r, tailMode: i } : (M.isBackwards = t, M.rendering = null, M.renderingStartTime = 0, M.last = n, M.tail = r, M.tailMode = i);
}
function X3(e, t, r) {
  var n = t.pendingProps, i = n.revealOrder, M = n.tail;
  if (Xe(e, t, n.children, r), n = le.current, n & 2) n = n & 1 | 2, t.flags |= 128;
  else {
    if (e !== null && e.flags & 128) e: for (e = t.child; e !== null; ) {
      if (e.tag === 13) e.memoizedState !== null && XD(e, r, t);
      else if (e.tag === 19) XD(e, r, t);
      else if (e.child !== null) {
        e.child.return = e, e = e.child;
        continue;
      }
      if (e === t) break e;
      for (; e.sibling === null; ) {
        if (e.return === null || e.return === t) break e;
        e = e.return;
      }
      e.sibling.return = e.return, e = e.sibling;
    }
    n &= 1;
  }
  if (ie(le, n), !(t.mode & 1)) t.memoizedState = null;
  else switch (i) {
    case "forwards":
      for (r = t.child, i = null; r !== null; ) e = r.alternate, e !== null && Pu(e) === null && (i = r), r = r.sibling;
      r = i, r === null ? (i = t.child, t.child = null) : (i = r.sibling, r.sibling = null), Wl(t, !1, i, r, M);
      break;
    case "backwards":
      for (r = null, i = t.child, t.child = null; i !== null; ) {
        if (e = i.alternate, e !== null && Pu(e) === null) {
          t.child = i;
          break;
        }
        e = i.sibling, i.sibling = r, r = i, i = e;
      }
      Wl(t, !0, r, null, M);
      break;
    case "together":
      Wl(t, !1, null, null, void 0);
      break;
    default:
      t.memoizedState = null;
  }
  return t.child;
}
function su(e, t) {
  !(t.mode & 1) && e !== null && (e.alternate = null, t.alternate = null, t.flags |= 2);
}
function Br(e, t, r) {
  if (e !== null && (t.dependencies = e.dependencies), Mi |= t.lanes, !(r & t.childLanes)) return null;
  if (e !== null && t.child !== e.child) throw Error(L(153));
  if (t.child !== null) {
    for (e = t.child, r = On(e, e.pendingProps), t.child = r, r.return = t; e.sibling !== null; ) e = e.sibling, r = r.sibling = On(e, e.pendingProps), r.return = t;
    r.sibling = null;
  }
  return t.child;
}
function uv(e, t, r) {
  switch (t.tag) {
    case 3:
      W3(t), iM();
      break;
    case 5:
      z3(t);
      break;
    case 1:
      ot(t.type) && wu(t);
      break;
    case 4:
      L4(t, t.stateNode.containerInfo);
      break;
    case 10:
      var n = t.type._context, i = t.memoizedProps.value;
      ie(Qu, n._currentValue), n._currentValue = i;
      break;
    case 13:
      if (n = t.memoizedState, n !== null)
        return n.dehydrated !== null ? (ie(le, le.current & 1), t.flags |= 128, null) : r & t.child.childLanes ? J3(e, t, r) : (ie(le, le.current & 1), e = Br(e, t, r), e !== null ? e.sibling : null);
      ie(le, le.current & 1);
      break;
    case 19:
      if (n = (r & t.childLanes) !== 0, e.flags & 128) {
        if (n) return X3(e, t, r);
        t.flags |= 128;
      }
      if (i = t.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), ie(le, le.current), n) break;
      return null;
    case 22:
    case 23:
      return t.lanes = 0, B3(e, t, r);
  }
  return Br(e, t, r);
}
var K3, $I, q3, eA;
K3 = function(e, t) {
  for (var r = t.child; r !== null; ) {
    if (r.tag === 5 || r.tag === 6) e.appendChild(r.stateNode);
    else if (r.tag !== 4 && r.child !== null) {
      r.child.return = r, r = r.child;
      continue;
    }
    if (r === t) break;
    for (; r.sibling === null; ) {
      if (r.return === null || r.return === t) return;
      r = r.return;
    }
    r.sibling.return = r.return, r = r.sibling;
  }
};
$I = function() {
};
q3 = function(e, t, r, n) {
  var i = e.memoizedProps;
  if (i !== n) {
    e = t.stateNode, Kn(pr.current);
    var M = null;
    switch (r) {
      case "input":
        i = uI(e, i), n = uI(e, n), M = [];
        break;
      case "select":
        i = Ie({}, i, { value: void 0 }), n = Ie({}, n, { value: void 0 }), M = [];
        break;
      case "textarea":
        i = cI(e, i), n = cI(e, n), M = [];
        break;
      default:
        typeof i.onClick != "function" && typeof n.onClick == "function" && (e.onclick = hu);
    }
    gI(r, n);
    var o;
    r = null;
    for (l in i) if (!n.hasOwnProperty(l) && i.hasOwnProperty(l) && i[l] != null) if (l === "style") {
      var u = i[l];
      for (o in u) u.hasOwnProperty(o) && (r || (r = {}), r[o] = "");
    } else l !== "dangerouslySetInnerHTML" && l !== "children" && l !== "suppressContentEditableWarning" && l !== "suppressHydrationWarning" && l !== "autoFocus" && (ya.hasOwnProperty(l) ? M || (M = []) : (M = M || []).push(l, null));
    for (l in n) {
      var s = n[l];
      if (u = i != null ? i[l] : void 0, n.hasOwnProperty(l) && s !== u && (s != null || u != null)) if (l === "style") if (u) {
        for (o in u) !u.hasOwnProperty(o) || s && s.hasOwnProperty(o) || (r || (r = {}), r[o] = "");
        for (o in s) s.hasOwnProperty(o) && u[o] !== s[o] && (r || (r = {}), r[o] = s[o]);
      } else r || (M || (M = []), M.push(
        l,
        r
      )), r = s;
      else l === "dangerouslySetInnerHTML" ? (s = s ? s.__html : void 0, u = u ? u.__html : void 0, s != null && u !== s && (M = M || []).push(l, s)) : l === "children" ? typeof s != "string" && typeof s != "number" || (M = M || []).push(l, "" + s) : l !== "suppressContentEditableWarning" && l !== "suppressHydrationWarning" && (ya.hasOwnProperty(l) ? (s != null && l === "onScroll" && ae("scroll", e), M || u === s || (M = [])) : (M = M || []).push(l, s));
    }
    r && (M = M || []).push("style", r);
    var l = M;
    (t.updateQueue = l) && (t.flags |= 4);
  }
};
eA = function(e, t, r, n) {
  r !== n && (t.flags |= 4);
};
function kM(e, t) {
  if (!se) switch (e.tailMode) {
    case "hidden":
      t = e.tail;
      for (var r = null; t !== null; ) t.alternate !== null && (r = t), t = t.sibling;
      r === null ? e.tail = null : r.sibling = null;
      break;
    case "collapsed":
      r = e.tail;
      for (var n = null; r !== null; ) r.alternate !== null && (n = r), r = r.sibling;
      n === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : n.sibling = null;
  }
}
function be(e) {
  var t = e.alternate !== null && e.alternate.child === e.child, r = 0, n = 0;
  if (t) for (var i = e.child; i !== null; ) r |= i.lanes | i.childLanes, n |= i.subtreeFlags & 14680064, n |= i.flags & 14680064, i.return = e, i = i.sibling;
  else for (i = e.child; i !== null; ) r |= i.lanes | i.childLanes, n |= i.subtreeFlags, n |= i.flags, i.return = e, i = i.sibling;
  return e.subtreeFlags |= n, e.childLanes = r, t;
}
function sv(e, t, r) {
  var n = t.pendingProps;
  switch (A4(t), t.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return be(t), null;
    case 1:
      return ot(t.type) && mu(), be(t), null;
    case 3:
      return n = t.stateNode, aM(), oe(at), oe(Ve), p4(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (e === null || e.child === null) && (fo(t) ? t.flags |= 4 : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, nr !== null && (FI(nr), nr = null))), $I(e, t), be(t), null;
    case 5:
      O4(t);
      var i = Kn(Sa.current);
      if (r = t.type, e !== null && t.stateNode != null) q3(e, t, r, n, i), e.ref !== t.ref && (t.flags |= 512, t.flags |= 2097152);
      else {
        if (!n) {
          if (t.stateNode === null) throw Error(L(166));
          return be(t), null;
        }
        if (e = Kn(pr.current), fo(t)) {
          n = t.stateNode, r = t.type;
          var M = t.memoizedProps;
          switch (n[fr] = t, n[Oa] = M, e = (t.mode & 1) !== 0, r) {
            case "dialog":
              ae("cancel", n), ae("close", n);
              break;
            case "iframe":
            case "object":
            case "embed":
              ae("load", n);
              break;
            case "video":
            case "audio":
              for (i = 0; i < JM.length; i++) ae(JM[i], n);
              break;
            case "source":
              ae("error", n);
              break;
            case "img":
            case "image":
            case "link":
              ae(
                "error",
                n
              ), ae("load", n);
              break;
            case "details":
              ae("toggle", n);
              break;
            case "input":
              aD(n, M), ae("invalid", n);
              break;
            case "select":
              n._wrapperState = { wasMultiple: !!M.multiple }, ae("invalid", n);
              break;
            case "textarea":
              uD(n, M), ae("invalid", n);
          }
          gI(r, M), i = null;
          for (var o in M) if (M.hasOwnProperty(o)) {
            var u = M[o];
            o === "children" ? typeof u == "string" ? n.textContent !== u && (M.suppressHydrationWarning !== !0 && zo(n.textContent, u, e), i = ["children", u]) : typeof u == "number" && n.textContent !== "" + u && (M.suppressHydrationWarning !== !0 && zo(
              n.textContent,
              u,
              e
            ), i = ["children", "" + u]) : ya.hasOwnProperty(o) && u != null && o === "onScroll" && ae("scroll", n);
          }
          switch (r) {
            case "input":
              jo(n), oD(n, M, !0);
              break;
            case "textarea":
              jo(n), sD(n);
              break;
            case "select":
            case "option":
              break;
            default:
              typeof M.onClick == "function" && (n.onclick = hu);
          }
          n = i, t.updateQueue = n, n !== null && (t.flags |= 4);
        } else {
          o = i.nodeType === 9 ? i : i.ownerDocument, e === "http://www.w3.org/1999/xhtml" && (e = p0(r)), e === "http://www.w3.org/1999/xhtml" ? r === "script" ? (e = o.createElement("div"), e.innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild)) : typeof n.is == "string" ? e = o.createElement(r, { is: n.is }) : (e = o.createElement(r), r === "select" && (o = e, n.multiple ? o.multiple = !0 : n.size && (o.size = n.size))) : e = o.createElementNS(e, r), e[fr] = t, e[Oa] = n, K3(e, t, !1, !1), t.stateNode = e;
          e: {
            switch (o = jI(r, n), r) {
              case "dialog":
                ae("cancel", e), ae("close", e), i = n;
                break;
              case "iframe":
              case "object":
              case "embed":
                ae("load", e), i = n;
                break;
              case "video":
              case "audio":
                for (i = 0; i < JM.length; i++) ae(JM[i], e);
                i = n;
                break;
              case "source":
                ae("error", e), i = n;
                break;
              case "img":
              case "image":
              case "link":
                ae(
                  "error",
                  e
                ), ae("load", e), i = n;
                break;
              case "details":
                ae("toggle", e), i = n;
                break;
              case "input":
                aD(e, n), i = uI(e, n), ae("invalid", e);
                break;
              case "option":
                i = n;
                break;
              case "select":
                e._wrapperState = { wasMultiple: !!n.multiple }, i = Ie({}, n, { value: void 0 }), ae("invalid", e);
                break;
              case "textarea":
                uD(e, n), i = cI(e, n), ae("invalid", e);
                break;
              default:
                i = n;
            }
            gI(r, i), u = i;
            for (M in u) if (u.hasOwnProperty(M)) {
              var s = u[M];
              M === "style" ? h0(e, s) : M === "dangerouslySetInnerHTML" ? (s = s ? s.__html : void 0, s != null && S0(e, s)) : M === "children" ? typeof s == "string" ? (r !== "textarea" || s !== "") && Ta(e, s) : typeof s == "number" && Ta(e, "" + s) : M !== "suppressContentEditableWarning" && M !== "suppressHydrationWarning" && M !== "autoFocus" && (ya.hasOwnProperty(M) ? s != null && M === "onScroll" && ae("scroll", e) : s != null && i4(e, M, s, o));
            }
            switch (r) {
              case "input":
                jo(e), oD(e, n, !1);
                break;
              case "textarea":
                jo(e), sD(e);
                break;
              case "option":
                n.value != null && e.setAttribute("value", "" + pn(n.value));
                break;
              case "select":
                e.multiple = !!n.multiple, M = n.value, M != null ? _i(e, !!n.multiple, M, !1) : n.defaultValue != null && _i(
                  e,
                  !!n.multiple,
                  n.defaultValue,
                  !0
                );
                break;
              default:
                typeof i.onClick == "function" && (e.onclick = hu);
            }
            switch (r) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                n = !!n.autoFocus;
                break e;
              case "img":
                n = !0;
                break e;
              default:
                n = !1;
            }
          }
          n && (t.flags |= 4);
        }
        t.ref !== null && (t.flags |= 512, t.flags |= 2097152);
      }
      return be(t), null;
    case 6:
      if (e && t.stateNode != null) eA(e, t, e.memoizedProps, n);
      else {
        if (typeof n != "string" && t.stateNode === null) throw Error(L(166));
        if (r = Kn(Sa.current), Kn(pr.current), fo(t)) {
          if (n = t.stateNode, r = t.memoizedProps, n[fr] = t, (M = n.nodeValue !== r) && (e = Tt, e !== null))
            switch (e.tag) {
              case 3:
                zo(n.nodeValue, r, (e.mode & 1) !== 0);
                break;
              case 5:
                e.memoizedProps.suppressHydrationWarning !== !0 && zo(n.nodeValue, r, (e.mode & 1) !== 0);
            }
          M && (t.flags |= 4);
        } else n = (r.nodeType === 9 ? r : r.ownerDocument).createTextNode(n), n[fr] = t, t.stateNode = n;
      }
      return be(t), null;
    case 13:
      if (oe(le), n = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
        if (se && yt !== null && t.mode & 1 && !(t.flags & 128)) T3(), iM(), t.flags |= 98560, M = !1;
        else if (M = fo(t), n !== null && n.dehydrated !== null) {
          if (e === null) {
            if (!M) throw Error(L(318));
            if (M = t.memoizedState, M = M !== null ? M.dehydrated : null, !M) throw Error(L(317));
            M[fr] = t;
          } else iM(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
          be(t), M = !1;
        } else nr !== null && (FI(nr), nr = null), M = !0;
        if (!M) return t.flags & 65536 ? t : null;
      }
      return t.flags & 128 ? (t.lanes = r, t) : (n = n !== null, n !== (e !== null && e.memoizedState !== null) && n && (t.child.flags |= 8192, t.mode & 1 && (e === null || le.current & 1 ? de === 0 && (de = 3) : $4())), t.updateQueue !== null && (t.flags |= 4), be(t), null);
    case 4:
      return aM(), $I(e, t), e === null && Ca(t.stateNode.containerInfo), be(t), null;
    case 10:
      return z4(t.type._context), be(t), null;
    case 17:
      return ot(t.type) && mu(), be(t), null;
    case 19:
      if (oe(le), M = t.memoizedState, M === null) return be(t), null;
      if (n = (t.flags & 128) !== 0, o = M.rendering, o === null) if (n) kM(M, !1);
      else {
        if (de !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null; ) {
          if (o = Pu(e), o !== null) {
            for (t.flags |= 128, kM(M, !1), n = o.updateQueue, n !== null && (t.updateQueue = n, t.flags |= 4), t.subtreeFlags = 0, n = r, r = t.child; r !== null; ) M = r, e = n, M.flags &= 14680066, o = M.alternate, o === null ? (M.childLanes = 0, M.lanes = e, M.child = null, M.subtreeFlags = 0, M.memoizedProps = null, M.memoizedState = null, M.updateQueue = null, M.dependencies = null, M.stateNode = null) : (M.childLanes = o.childLanes, M.lanes = o.lanes, M.child = o.child, M.subtreeFlags = 0, M.deletions = null, M.memoizedProps = o.memoizedProps, M.memoizedState = o.memoizedState, M.updateQueue = o.updateQueue, M.type = o.type, e = o.dependencies, M.dependencies = e === null ? null : { lanes: e.lanes, firstContext: e.firstContext }), r = r.sibling;
            return ie(le, le.current & 1 | 2), t.child;
          }
          e = e.sibling;
        }
        M.tail !== null && ye() > uM && (t.flags |= 128, n = !0, kM(M, !1), t.lanes = 4194304);
      }
      else {
        if (!n) if (e = Pu(o), e !== null) {
          if (t.flags |= 128, n = !0, r = e.updateQueue, r !== null && (t.updateQueue = r, t.flags |= 4), kM(M, !0), M.tail === null && M.tailMode === "hidden" && !o.alternate && !se) return be(t), null;
        } else 2 * ye() - M.renderingStartTime > uM && r !== 1073741824 && (t.flags |= 128, n = !0, kM(M, !1), t.lanes = 4194304);
        M.isBackwards ? (o.sibling = t.child, t.child = o) : (r = M.last, r !== null ? r.sibling = o : t.child = o, M.last = o);
      }
      return M.tail !== null ? (t = M.tail, M.rendering = t, M.tail = t.sibling, M.renderingStartTime = ye(), t.sibling = null, r = le.current, ie(le, n ? r & 1 | 2 : r & 1), t) : (be(t), null);
    case 22:
    case 23:
      return P4(), n = t.memoizedState !== null, e !== null && e.memoizedState !== null !== n && (t.flags |= 8192), n && t.mode & 1 ? Dt & 1073741824 && (be(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : be(t), null;
    case 24:
      return null;
    case 25:
      return null;
  }
  throw Error(L(156, t.tag));
}
function lv(e, t) {
  switch (A4(t), t.tag) {
    case 1:
      return ot(t.type) && mu(), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
    case 3:
      return aM(), oe(at), oe(Ve), p4(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
    case 5:
      return O4(t), null;
    case 13:
      if (oe(le), e = t.memoizedState, e !== null && e.dehydrated !== null) {
        if (t.alternate === null) throw Error(L(340));
        iM();
      }
      return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
    case 19:
      return oe(le), null;
    case 4:
      return aM(), null;
    case 10:
      return z4(t.type._context), null;
    case 22:
    case 23:
      return P4(), null;
    case 24:
      return null;
    default:
      return null;
  }
}
var Oo = !1, $e = !1, cv = typeof WeakSet == "function" ? WeakSet : Set, v = null;
function bi(e, t) {
  var r = e.ref;
  if (r !== null) if (typeof r == "function") try {
    r(null);
  } catch (n) {
    Ne(e, t, n);
  }
  else r.current = null;
}
function RI(e, t, r) {
  try {
    r();
  } catch (n) {
    Ne(e, t, n);
  }
}
var KD = !1;
function Iv(e, t) {
  if (fI = pu, e = M3(), y4(e)) {
    if ("selectionStart" in e) var r = { start: e.selectionStart, end: e.selectionEnd };
    else e: {
      r = (r = e.ownerDocument) && r.defaultView || window;
      var n = r.getSelection && r.getSelection();
      if (n && n.rangeCount !== 0) {
        r = n.anchorNode;
        var i = n.anchorOffset, M = n.focusNode;
        n = n.focusOffset;
        try {
          r.nodeType, M.nodeType;
        } catch (x) {
          r = null;
          break e;
        }
        var o = 0, u = -1, s = -1, l = 0, I = 0, g = e, c = null;
        t: for (; ; ) {
          for (var D; g !== r || i !== 0 && g.nodeType !== 3 || (u = o + i), g !== M || n !== 0 && g.nodeType !== 3 || (s = o + n), g.nodeType === 3 && (o += g.nodeValue.length), (D = g.firstChild) !== null; )
            c = g, g = D;
          for (; ; ) {
            if (g === e) break t;
            if (c === r && ++l === i && (u = o), c === M && ++I === n && (s = o), (D = g.nextSibling) !== null) break;
            g = c, c = g.parentNode;
          }
          g = D;
        }
        r = u === -1 || s === -1 ? null : { start: u, end: s };
      } else r = null;
    }
    r = r || { start: 0, end: 0 };
  } else r = null;
  for (CI = { focusedElem: e, selectionRange: r }, pu = !1, v = t; v !== null; ) if (t = v, e = t.child, (t.subtreeFlags & 1028) !== 0 && e !== null) e.return = t, v = e;
  else for (; v !== null; ) {
    t = v;
    try {
      var j = t.alternate;
      if (t.flags & 1024) switch (t.tag) {
        case 0:
        case 11:
        case 15:
          break;
        case 1:
          if (j !== null) {
            var N = j.memoizedProps, d = j.memoizedState, T = t.stateNode, y = T.getSnapshotBeforeUpdate(t.elementType === t.type ? N : er(t.type, N), d);
            T.__reactInternalSnapshotBeforeUpdate = y;
          }
          break;
        case 3:
          var A = t.stateNode.containerInfo;
          A.nodeType === 1 ? A.textContent = "" : A.nodeType === 9 && A.documentElement && A.removeChild(A.documentElement);
          break;
        case 5:
        case 6:
        case 4:
        case 17:
          break;
        default:
          throw Error(L(163));
      }
    } catch (x) {
      Ne(t, t.return, x);
    }
    if (e = t.sibling, e !== null) {
      e.return = t.return, v = e;
      break;
    }
    v = t.return;
  }
  return j = KD, KD = !1, j;
}
function Ma(e, t, r) {
  var n = t.updateQueue;
  if (n = n !== null ? n.lastEffect : null, n !== null) {
    var i = n = n.next;
    do {
      if ((i.tag & e) === e) {
        var M = i.destroy;
        i.destroy = void 0, M !== void 0 && RI(t, r, M);
      }
      i = i.next;
    } while (i !== n);
  }
}
function ps(e, t) {
  if (t = t.updateQueue, t = t !== null ? t.lastEffect : null, t !== null) {
    var r = t = t.next;
    do {
      if ((r.tag & e) === e) {
        var n = r.create;
        r.destroy = n();
      }
      r = r.next;
    } while (r !== t);
  }
}
function HI(e) {
  var t = e.ref;
  if (t !== null) {
    var r = e.stateNode;
    switch (e.tag) {
      case 5:
        e = r;
        break;
      default:
        e = r;
    }
    typeof t == "function" ? t(e) : t.current = e;
  }
}
function tA(e) {
  var t = e.alternate;
  t !== null && (e.alternate = null, tA(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && (delete t[fr], delete t[Oa], delete t[pI], delete t[FS], delete t[WS])), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
}
function rA(e) {
  return e.tag === 5 || e.tag === 3 || e.tag === 4;
}
function qD(e) {
  e: for (; ; ) {
    for (; e.sibling === null; ) {
      if (e.return === null || rA(e.return)) return null;
      e = e.return;
    }
    for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
      if (e.flags & 2 || e.child === null || e.tag === 4) continue e;
      e.child.return = e, e = e.child;
    }
    if (!(e.flags & 2)) return e.stateNode;
  }
}
function VI(e, t, r) {
  var n = e.tag;
  if (n === 5 || n === 6) e = e.stateNode, t ? r.nodeType === 8 ? r.parentNode.insertBefore(e, t) : r.insertBefore(e, t) : (r.nodeType === 8 ? (t = r.parentNode, t.insertBefore(e, r)) : (t = r, t.appendChild(e)), r = r._reactRootContainer, r != null || t.onclick !== null || (t.onclick = hu));
  else if (n !== 4 && (e = e.child, e !== null)) for (VI(e, t, r), e = e.sibling; e !== null; ) VI(e, t, r), e = e.sibling;
}
function _I(e, t, r) {
  var n = e.tag;
  if (n === 5 || n === 6) e = e.stateNode, t ? r.insertBefore(e, t) : r.appendChild(e);
  else if (n !== 4 && (e = e.child, e !== null)) for (_I(e, t, r), e = e.sibling; e !== null; ) _I(e, t, r), e = e.sibling;
}
var we = null, tr = !1;
function tn(e, t, r) {
  for (r = r.child; r !== null; ) nA(e, t, r), r = r.sibling;
}
function nA(e, t, r) {
  if (Or && typeof Or.onCommitFiberUnmount == "function") try {
    Or.onCommitFiberUnmount(ds, r);
  } catch (u) {
  }
  switch (r.tag) {
    case 5:
      $e || bi(r, t);
    case 6:
      var n = we, i = tr;
      we = null, tn(e, t, r), we = n, tr = i, we !== null && (tr ? (e = we, r = r.stateNode, e.nodeType === 8 ? e.parentNode.removeChild(r) : e.removeChild(r)) : we.removeChild(r.stateNode));
      break;
    case 18:
      we !== null && (tr ? (e = we, r = r.stateNode, e.nodeType === 8 ? Hl(e.parentNode, r) : e.nodeType === 1 && Hl(e, r), Ea(e)) : Hl(we, r.stateNode));
      break;
    case 4:
      n = we, i = tr, we = r.stateNode.containerInfo, tr = !0, tn(e, t, r), we = n, tr = i;
      break;
    case 0:
    case 11:
    case 14:
    case 15:
      if (!$e && (n = r.updateQueue, n !== null && (n = n.lastEffect, n !== null))) {
        i = n = n.next;
        do {
          var M = i, o = M.destroy;
          M = M.tag, o !== void 0 && (M & 2 || M & 4) && RI(r, t, o), i = i.next;
        } while (i !== n);
      }
      tn(e, t, r);
      break;
    case 1:
      if (!$e && (bi(r, t), n = r.stateNode, typeof n.componentWillUnmount == "function")) try {
        n.props = r.memoizedProps, n.state = r.memoizedState, n.componentWillUnmount();
      } catch (u) {
        Ne(r, t, u);
      }
      tn(e, t, r);
      break;
    case 21:
      tn(e, t, r);
      break;
    case 22:
      r.mode & 1 ? ($e = (n = $e) || r.memoizedState !== null, tn(e, t, r), $e = n) : tn(e, t, r);
      break;
    default:
      tn(e, t, r);
  }
}
function ey(e) {
  var t = e.updateQueue;
  if (t !== null) {
    e.updateQueue = null;
    var r = e.stateNode;
    r === null && (r = e.stateNode = new cv()), t.forEach(function(n) {
      var i = xv.bind(null, e, n);
      r.has(n) || (r.add(n), n.then(i, i));
    });
  }
}
function Xt(e, t) {
  var r = t.deletions;
  if (r !== null) for (var n = 0; n < r.length; n++) {
    var i = r[n];
    try {
      var M = e, o = t, u = o;
      e: for (; u !== null; ) {
        switch (u.tag) {
          case 5:
            we = u.stateNode, tr = !1;
            break e;
          case 3:
            we = u.stateNode.containerInfo, tr = !0;
            break e;
          case 4:
            we = u.stateNode.containerInfo, tr = !0;
            break e;
        }
        u = u.return;
      }
      if (we === null) throw Error(L(160));
      nA(M, o, i), we = null, tr = !1;
      var s = i.alternate;
      s !== null && (s.return = null), i.return = null;
    } catch (l) {
      Ne(i, t, l);
    }
  }
  if (t.subtreeFlags & 12854) for (t = t.child; t !== null; ) iA(t, e), t = t.sibling;
}
function iA(e, t) {
  var r = e.alternate, n = e.flags;
  switch (e.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      if (Xt(t, e), yr(e), n & 4) {
        try {
          Ma(3, e, e.return), ps(3, e);
        } catch (N) {
          Ne(e, e.return, N);
        }
        try {
          Ma(5, e, e.return);
        } catch (N) {
          Ne(e, e.return, N);
        }
      }
      break;
    case 1:
      Xt(t, e), yr(e), n & 512 && r !== null && bi(r, r.return);
      break;
    case 5:
      if (Xt(t, e), yr(e), n & 512 && r !== null && bi(r, r.return), e.flags & 32) {
        var i = e.stateNode;
        try {
          Ta(i, "");
        } catch (N) {
          Ne(e, e.return, N);
        }
      }
      if (n & 4 && (i = e.stateNode, i != null)) {
        var M = e.memoizedProps, o = r !== null ? r.memoizedProps : M, u = e.type, s = e.updateQueue;
        if (e.updateQueue = null, s !== null) try {
          u === "input" && M.type === "radio" && M.name != null && L0(i, M), jI(u, o);
          var l = jI(u, M);
          for (o = 0; o < s.length; o += 2) {
            var I = s[o], g = s[o + 1];
            I === "style" ? h0(i, g) : I === "dangerouslySetInnerHTML" ? S0(i, g) : I === "children" ? Ta(i, g) : i4(i, I, g, l);
          }
          switch (u) {
            case "input":
              sI(i, M);
              break;
            case "textarea":
              O0(i, M);
              break;
            case "select":
              var c = i._wrapperState.wasMultiple;
              i._wrapperState.wasMultiple = !!M.multiple;
              var D = M.value;
              D != null ? _i(i, !!M.multiple, D, !1) : c !== !!M.multiple && (M.defaultValue != null ? _i(
                i,
                !!M.multiple,
                M.defaultValue,
                !0
              ) : _i(i, !!M.multiple, M.multiple ? [] : "", !1));
          }
          i[Oa] = M;
        } catch (N) {
          Ne(e, e.return, N);
        }
      }
      break;
    case 6:
      if (Xt(t, e), yr(e), n & 4) {
        if (e.stateNode === null) throw Error(L(162));
        i = e.stateNode, M = e.memoizedProps;
        try {
          i.nodeValue = M;
        } catch (N) {
          Ne(e, e.return, N);
        }
      }
      break;
    case 3:
      if (Xt(t, e), yr(e), n & 4 && r !== null && r.memoizedState.isDehydrated) try {
        Ea(t.containerInfo);
      } catch (N) {
        Ne(e, e.return, N);
      }
      break;
    case 4:
      Xt(t, e), yr(e);
      break;
    case 13:
      Xt(t, e), yr(e), i = e.child, i.flags & 8192 && (M = i.memoizedState !== null, i.stateNode.isHidden = M, !M || i.alternate !== null && i.alternate.memoizedState !== null || (Y4 = ye())), n & 4 && ey(e);
      break;
    case 22:
      if (I = r !== null && r.memoizedState !== null, e.mode & 1 ? ($e = (l = $e) || I, Xt(t, e), $e = l) : Xt(t, e), yr(e), n & 8192) {
        if (l = e.memoizedState !== null, (e.stateNode.isHidden = l) && !I && e.mode & 1) for (v = e, I = e.child; I !== null; ) {
          for (g = v = I; v !== null; ) {
            switch (c = v, D = c.child, c.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                Ma(4, c, c.return);
                break;
              case 1:
                bi(c, c.return);
                var j = c.stateNode;
                if (typeof j.componentWillUnmount == "function") {
                  n = c, r = c.return;
                  try {
                    t = n, j.props = t.memoizedProps, j.state = t.memoizedState, j.componentWillUnmount();
                  } catch (N) {
                    Ne(n, r, N);
                  }
                }
                break;
              case 5:
                bi(c, c.return);
                break;
              case 22:
                if (c.memoizedState !== null) {
                  ry(g);
                  continue;
                }
            }
            D !== null ? (D.return = c, v = D) : ry(g);
          }
          I = I.sibling;
        }
        e: for (I = null, g = e; ; ) {
          if (g.tag === 5) {
            if (I === null) {
              I = g;
              try {
                i = g.stateNode, l ? (M = i.style, typeof M.setProperty == "function" ? M.setProperty("display", "none", "important") : M.display = "none") : (u = g.stateNode, s = g.memoizedProps.style, o = s != null && s.hasOwnProperty("display") ? s.display : null, u.style.display = v0("display", o));
              } catch (N) {
                Ne(e, e.return, N);
              }
            }
          } else if (g.tag === 6) {
            if (I === null) try {
              g.stateNode.nodeValue = l ? "" : g.memoizedProps;
            } catch (N) {
              Ne(e, e.return, N);
            }
          } else if ((g.tag !== 22 && g.tag !== 23 || g.memoizedState === null || g === e) && g.child !== null) {
            g.child.return = g, g = g.child;
            continue;
          }
          if (g === e) break e;
          for (; g.sibling === null; ) {
            if (g.return === null || g.return === e) break e;
            I === g && (I = null), g = g.return;
          }
          I === g && (I = null), g.sibling.return = g.return, g = g.sibling;
        }
      }
      break;
    case 19:
      Xt(t, e), yr(e), n & 4 && ey(e);
      break;
    case 21:
      break;
    default:
      Xt(
        t,
        e
      ), yr(e);
  }
}
function yr(e) {
  var t = e.flags;
  if (t & 2) {
    try {
      e: {
        for (var r = e.return; r !== null; ) {
          if (rA(r)) {
            var n = r;
            break e;
          }
          r = r.return;
        }
        throw Error(L(160));
      }
      switch (n.tag) {
        case 5:
          var i = n.stateNode;
          n.flags & 32 && (Ta(i, ""), n.flags &= -33);
          var M = qD(e);
          _I(e, M, i);
          break;
        case 3:
        case 4:
          var o = n.stateNode.containerInfo, u = qD(e);
          VI(e, u, o);
          break;
        default:
          throw Error(L(161));
      }
    } catch (s) {
      Ne(e, e.return, s);
    }
    e.flags &= -3;
  }
  t & 4096 && (e.flags &= -4097);
}
function gv(e, t, r) {
  v = e, MA(e);
}
function MA(e, t, r) {
  for (var n = (e.mode & 1) !== 0; v !== null; ) {
    var i = v, M = i.child;
    if (i.tag === 22 && n) {
      var o = i.memoizedState !== null || Oo;
      if (!o) {
        var u = i.alternate, s = u !== null && u.memoizedState !== null || $e;
        u = Oo;
        var l = $e;
        if (Oo = o, ($e = s) && !l) for (v = i; v !== null; ) o = v, s = o.child, o.tag === 22 && o.memoizedState !== null ? ny(i) : s !== null ? (s.return = o, v = s) : ny(i);
        for (; M !== null; ) v = M, MA(M), M = M.sibling;
        v = i, Oo = u, $e = l;
      }
      ty(e);
    } else i.subtreeFlags & 8772 && M !== null ? (M.return = i, v = M) : ty(e);
  }
}
function ty(e) {
  for (; v !== null; ) {
    var t = v;
    if (t.flags & 8772) {
      var r = t.alternate;
      try {
        if (t.flags & 8772) switch (t.tag) {
          case 0:
          case 11:
          case 15:
            $e || ps(5, t);
            break;
          case 1:
            var n = t.stateNode;
            if (t.flags & 4 && !$e) if (r === null) n.componentDidMount();
            else {
              var i = t.elementType === t.type ? r.memoizedProps : er(t.type, r.memoizedProps);
              n.componentDidUpdate(i, r.memoizedState, n.__reactInternalSnapshotBeforeUpdate);
            }
            var M = t.updateQueue;
            M !== null && PD(t, M, n);
            break;
          case 3:
            var o = t.updateQueue;
            if (o !== null) {
              if (r = null, t.child !== null) switch (t.child.tag) {
                case 5:
                  r = t.child.stateNode;
                  break;
                case 1:
                  r = t.child.stateNode;
              }
              PD(t, o, r);
            }
            break;
          case 5:
            var u = t.stateNode;
            if (r === null && t.flags & 4) {
              r = u;
              var s = t.memoizedProps;
              switch (t.type) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  s.autoFocus && r.focus();
                  break;
                case "img":
                  s.src && (r.src = s.src);
              }
            }
            break;
          case 6:
            break;
          case 4:
            break;
          case 12:
            break;
          case 13:
            if (t.memoizedState === null) {
              var l = t.alternate;
              if (l !== null) {
                var I = l.memoizedState;
                if (I !== null) {
                  var g = I.dehydrated;
                  g !== null && Ea(g);
                }
              }
            }
            break;
          case 19:
          case 17:
          case 21:
          case 22:
          case 23:
          case 25:
            break;
          default:
            throw Error(L(163));
        }
        $e || t.flags & 512 && HI(t);
      } catch (c) {
        Ne(t, t.return, c);
      }
    }
    if (t === e) {
      v = null;
      break;
    }
    if (r = t.sibling, r !== null) {
      r.return = t.return, v = r;
      break;
    }
    v = t.return;
  }
}
function ry(e) {
  for (; v !== null; ) {
    var t = v;
    if (t === e) {
      v = null;
      break;
    }
    var r = t.sibling;
    if (r !== null) {
      r.return = t.return, v = r;
      break;
    }
    v = t.return;
  }
}
function ny(e) {
  for (; v !== null; ) {
    var t = v;
    try {
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          var r = t.return;
          try {
            ps(4, t);
          } catch (s) {
            Ne(t, r, s);
          }
          break;
        case 1:
          var n = t.stateNode;
          if (typeof n.componentDidMount == "function") {
            var i = t.return;
            try {
              n.componentDidMount();
            } catch (s) {
              Ne(t, i, s);
            }
          }
          var M = t.return;
          try {
            HI(t);
          } catch (s) {
            Ne(t, M, s);
          }
          break;
        case 5:
          var o = t.return;
          try {
            HI(t);
          } catch (s) {
            Ne(t, o, s);
          }
      }
    } catch (s) {
      Ne(t, t.return, s);
    }
    if (t === e) {
      v = null;
      break;
    }
    var u = t.sibling;
    if (u !== null) {
      u.return = t.return, v = u;
      break;
    }
    v = t.return;
  }
}
var jv = Math.ceil, Hu = Kr.ReactCurrentDispatcher, U4 = Kr.ReactCurrentOwner, Pt = Kr.ReactCurrentBatchConfig, F = 0, pe = null, Te = null, ke = 0, Dt = 0, Pi = Un(0), de = 0, wa = null, Mi = 0, Ss = 0, Q4 = 0, aa = null, rt = null, Y4 = 0, uM = 1 / 0, Ur = null, Vu = !1, ZI = null, Cn = null, po = !1, jn = null, _u = 0, oa = 0, GI = null, lu = -1, cu = 0;
function Ke() {
  return F & 6 ? ye() : lu !== -1 ? lu : lu = ye();
}
function Ln(e) {
  return e.mode & 1 ? F & 2 && ke !== 0 ? ke & -ke : XS.transition !== null ? (cu === 0 && (cu = V0()), cu) : (e = re, e !== 0 || (e = window.event, e = e === void 0 ? 16 : J0(e.type)), e) : 1;
}
function or(e, t, r, n) {
  if (50 < oa) throw oa = 0, GI = null, Error(L(185));
  Fa(e, r, n), (!(F & 2) || e !== pe) && (e === pe && (!(F & 2) && (Ss |= r), de === 4 && In(e, ke)), ut(e, n), r === 1 && F === 0 && !(t.mode & 1) && (uM = ye() + 500, Cs && Qn()));
}
function ut(e, t) {
  var r = e.callbackNode;
  Xp(e, t);
  var n = Ou(e, e === pe ? ke : 0);
  if (n === 0) r !== null && ID(r), e.callbackNode = null, e.callbackPriority = 0;
  else if (t = n & -n, e.callbackPriority !== t) {
    if (r != null && ID(r), t === 1) e.tag === 0 ? JS(iy.bind(null, e)) : N3(iy.bind(null, e)), GS(function() {
      !(F & 6) && Qn();
    }), r = null;
    else {
      switch (_0(n)) {
        case 1:
          r = s4;
          break;
        case 4:
          r = R0;
          break;
        case 16:
          r = Lu;
          break;
        case 536870912:
          r = H0;
          break;
        default:
          r = Lu;
      }
      r = gA(r, aA.bind(null, e));
    }
    e.callbackPriority = t, e.callbackNode = r;
  }
}
function aA(e, t) {
  if (lu = -1, cu = 0, F & 6) throw Error(L(327));
  var r = e.callbackNode;
  if (Wi() && e.callbackNode !== r) return null;
  var n = Ou(e, e === pe ? ke : 0);
  if (n === 0) return null;
  if (n & 30 || n & e.expiredLanes || t) t = Zu(e, n);
  else {
    t = n;
    var i = F;
    F |= 2;
    var M = uA();
    (pe !== e || ke !== t) && (Ur = null, uM = ye() + 500, qn(e, t));
    do
      try {
        yv();
        break;
      } catch (u) {
        oA(e, u);
      }
    while (!0);
    E4(), Hu.current = M, F = i, Te !== null ? t = 0 : (pe = null, ke = 0, t = de);
  }
  if (t !== 0) {
    if (t === 2 && (i = AI(e), i !== 0 && (n = i, t = BI(e, i))), t === 1) throw r = wa, qn(e, 0), In(e, n), ut(e, ye()), r;
    if (t === 6) In(e, n);
    else {
      if (i = e.current.alternate, !(n & 30) && !Nv(i) && (t = Zu(e, n), t === 2 && (M = AI(e), M !== 0 && (n = M, t = BI(e, M))), t === 1)) throw r = wa, qn(e, 0), In(e, n), ut(e, ye()), r;
      switch (e.finishedWork = i, e.finishedLanes = n, t) {
        case 0:
        case 1:
          throw Error(L(345));
        case 2:
          Fn(e, rt, Ur);
          break;
        case 3:
          if (In(e, n), (n & 130023424) === n && (t = Y4 + 500 - ye(), 10 < t)) {
            if (Ou(e, 0) !== 0) break;
            if (i = e.suspendedLanes, (i & n) !== n) {
              Ke(), e.pingedLanes |= e.suspendedLanes & i;
              break;
            }
            e.timeoutHandle = OI(Fn.bind(null, e, rt, Ur), t);
            break;
          }
          Fn(e, rt, Ur);
          break;
        case 4:
          if (In(e, n), (n & 4194240) === n) break;
          for (t = e.eventTimes, i = -1; 0 < n; ) {
            var o = 31 - ar(n);
            M = 1 << o, o = t[o], o > i && (i = o), n &= ~M;
          }
          if (n = i, n = ye() - n, n = (120 > n ? 120 : 480 > n ? 480 : 1080 > n ? 1080 : 1920 > n ? 1920 : 3e3 > n ? 3e3 : 4320 > n ? 4320 : 1960 * jv(n / 1960)) - n, 10 < n) {
            e.timeoutHandle = OI(Fn.bind(null, e, rt, Ur), n);
            break;
          }
          Fn(e, rt, Ur);
          break;
        case 5:
          Fn(e, rt, Ur);
          break;
        default:
          throw Error(L(329));
      }
    }
  }
  return ut(e, ye()), e.callbackNode === r ? aA.bind(null, e) : null;
}
function BI(e, t) {
  var r = aa;
  return e.current.memoizedState.isDehydrated && (qn(e, t).flags |= 256), e = Zu(e, t), e !== 2 && (t = rt, rt = r, t !== null && FI(t)), e;
}
function FI(e) {
  rt === null ? rt = e : rt.push.apply(rt, e);
}
function Nv(e) {
  for (var t = e; ; ) {
    if (t.flags & 16384) {
      var r = t.updateQueue;
      if (r !== null && (r = r.stores, r !== null)) for (var n = 0; n < r.length; n++) {
        var i = r[n], M = i.getSnapshot;
        i = i.value;
        try {
          if (!sr(M(), i)) return !1;
        } catch (o) {
          return !1;
        }
      }
    }
    if (r = t.child, t.subtreeFlags & 16384 && r !== null) r.return = t, t = r;
    else {
      if (t === e) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e) return !0;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
  }
  return !0;
}
function In(e, t) {
  for (t &= ~Q4, t &= ~Ss, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t; ) {
    var r = 31 - ar(t), n = 1 << r;
    e[r] = -1, t &= ~n;
  }
}
function iy(e) {
  if (F & 6) throw Error(L(327));
  Wi();
  var t = Ou(e, 0);
  if (!(t & 1)) return ut(e, ye()), null;
  var r = Zu(e, t);
  if (e.tag !== 0 && r === 2) {
    var n = AI(e);
    n !== 0 && (t = n, r = BI(e, n));
  }
  if (r === 1) throw r = wa, qn(e, 0), In(e, t), ut(e, ye()), r;
  if (r === 6) throw Error(L(345));
  return e.finishedWork = e.current.alternate, e.finishedLanes = t, Fn(e, rt, Ur), ut(e, ye()), null;
}
function b4(e, t) {
  var r = F;
  F |= 1;
  try {
    return e(t);
  } finally {
    F = r, F === 0 && (uM = ye() + 500, Cs && Qn());
  }
}
function ai(e) {
  jn !== null && jn.tag === 0 && !(F & 6) && Wi();
  var t = F;
  F |= 1;
  var r = Pt.transition, n = re;
  try {
    if (Pt.transition = null, re = 1, e) return e();
  } finally {
    re = n, Pt.transition = r, F = t, !(F & 6) && Qn();
  }
}
function P4() {
  Dt = Pi.current, oe(Pi);
}
function qn(e, t) {
  e.finishedWork = null, e.finishedLanes = 0;
  var r = e.timeoutHandle;
  if (r !== -1 && (e.timeoutHandle = -1, ZS(r)), Te !== null) for (r = Te.return; r !== null; ) {
    var n = r;
    switch (A4(n), n.tag) {
      case 1:
        n = n.type.childContextTypes, n != null && mu();
        break;
      case 3:
        aM(), oe(at), oe(Ve), p4();
        break;
      case 5:
        O4(n);
        break;
      case 4:
        aM();
        break;
      case 13:
        oe(le);
        break;
      case 19:
        oe(le);
        break;
      case 10:
        z4(n.type._context);
        break;
      case 22:
      case 23:
        P4();
    }
    r = r.return;
  }
  if (pe = e, Te = e = On(e.current, null), ke = Dt = t, de = 0, wa = null, Q4 = Ss = Mi = 0, rt = aa = null, Xn !== null) {
    for (t = 0; t < Xn.length; t++) if (r = Xn[t], n = r.interleaved, n !== null) {
      r.interleaved = null;
      var i = n.next, M = r.pending;
      if (M !== null) {
        var o = M.next;
        M.next = i, n.next = o;
      }
      r.pending = n;
    }
    Xn = null;
  }
  return e;
}
function oA(e, t) {
  do {
    var r = Te;
    try {
      if (E4(), ou.current = Ru, $u) {
        for (var n = ce.memoizedState; n !== null; ) {
          var i = n.queue;
          i !== null && (i.pending = null), n = n.next;
        }
        $u = !1;
      }
      if (ii = 0, Oe = Ae = ce = null, ia = !1, va = 0, U4.current = null, r === null || r.return === null) {
        de = 1, wa = t, Te = null;
        break;
      }
      e: {
        var M = e, o = r.return, u = r, s = t;
        if (t = ke, u.flags |= 32768, s !== null && typeof s == "object" && typeof s.then == "function") {
          var l = s, I = u, g = I.tag;
          if (!(I.mode & 1) && (g === 0 || g === 11 || g === 15)) {
            var c = I.alternate;
            c ? (I.updateQueue = c.updateQueue, I.memoizedState = c.memoizedState, I.lanes = c.lanes) : (I.updateQueue = null, I.memoizedState = null);
          }
          var D = ZD(o);
          if (D !== null) {
            D.flags &= -257, GD(D, o, u, M, t), D.mode & 1 && _D(M, l, t), t = D, s = l;
            var j = t.updateQueue;
            if (j === null) {
              var N = /* @__PURE__ */ new Set();
              N.add(s), t.updateQueue = N;
            } else j.add(s);
            break e;
          } else {
            if (!(t & 1)) {
              _D(M, l, t), $4();
              break e;
            }
            s = Error(L(426));
          }
        } else if (se && u.mode & 1) {
          var d = ZD(o);
          if (d !== null) {
            !(d.flags & 65536) && (d.flags |= 256), GD(d, o, u, M, t), d4(oM(s, u));
            break e;
          }
        }
        M = s = oM(s, u), de !== 4 && (de = 2), aa === null ? aa = [M] : aa.push(M), M = o;
        do {
          switch (M.tag) {
            case 3:
              M.flags |= 65536, t &= -t, M.lanes |= t;
              var T = _3(M, s, t);
              bD(M, T);
              break e;
            case 1:
              u = s;
              var y = M.type, A = M.stateNode;
              if (!(M.flags & 128) && (typeof y.getDerivedStateFromError == "function" || A !== null && typeof A.componentDidCatch == "function" && (Cn === null || !Cn.has(A)))) {
                M.flags |= 65536, t &= -t, M.lanes |= t;
                var x = Z3(M, u, t);
                bD(M, x);
                break e;
              }
          }
          M = M.return;
        } while (M !== null);
      }
      lA(r);
    } catch (E) {
      t = E, Te === r && r !== null && (Te = r = r.return);
      continue;
    }
    break;
  } while (!0);
}
function uA() {
  var e = Hu.current;
  return Hu.current = Ru, e === null ? Ru : e;
}
function $4() {
  (de === 0 || de === 3 || de === 2) && (de = 4), pe === null || !(Mi & 268435455) && !(Ss & 268435455) || In(pe, ke);
}
function Zu(e, t) {
  var r = F;
  F |= 2;
  var n = uA();
  (pe !== e || ke !== t) && (Ur = null, qn(e, t));
  do
    try {
      Dv();
      break;
    } catch (i) {
      oA(e, i);
    }
  while (!0);
  if (E4(), F = r, Hu.current = n, Te !== null) throw Error(L(261));
  return pe = null, ke = 0, de;
}
function Dv() {
  for (; Te !== null; ) sA(Te);
}
function yv() {
  for (; Te !== null && !Hp(); ) sA(Te);
}
function sA(e) {
  var t = IA(e.alternate, e, Dt);
  e.memoizedProps = e.pendingProps, t === null ? lA(e) : Te = t, U4.current = null;
}
function lA(e) {
  var t = e;
  do {
    var r = t.alternate;
    if (e = t.return, t.flags & 32768) {
      if (r = lv(r, t), r !== null) {
        r.flags &= 32767, Te = r;
        return;
      }
      if (e !== null) e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null;
      else {
        de = 6, Te = null;
        return;
      }
    } else if (r = sv(r, t, Dt), r !== null) {
      Te = r;
      return;
    }
    if (t = t.sibling, t !== null) {
      Te = t;
      return;
    }
    Te = t = e;
  } while (t !== null);
  de === 0 && (de = 5);
}
function Fn(e, t, r) {
  var n = re, i = Pt.transition;
  try {
    Pt.transition = null, re = 1, Tv(e, t, r, n);
  } finally {
    Pt.transition = i, re = n;
  }
  return null;
}
function Tv(e, t, r, n) {
  do
    Wi();
  while (jn !== null);
  if (F & 6) throw Error(L(327));
  r = e.finishedWork;
  var i = e.finishedLanes;
  if (r === null) return null;
  if (e.finishedWork = null, e.finishedLanes = 0, r === e.current) throw Error(L(177));
  e.callbackNode = null, e.callbackPriority = 0;
  var M = r.lanes | r.childLanes;
  if (Kp(e, M), e === pe && (Te = pe = null, ke = 0), !(r.subtreeFlags & 2064) && !(r.flags & 2064) || po || (po = !0, gA(Lu, function() {
    return Wi(), null;
  })), M = (r.flags & 15990) !== 0, r.subtreeFlags & 15990 || M) {
    M = Pt.transition, Pt.transition = null;
    var o = re;
    re = 1;
    var u = F;
    F |= 4, U4.current = null, Iv(e, r), iA(r, e), bS(CI), pu = !!fI, CI = fI = null, e.current = r, gv(r), Vp(), F = u, re = o, Pt.transition = M;
  } else e.current = r;
  if (po && (po = !1, jn = e, _u = i), M = e.pendingLanes, M === 0 && (Cn = null), Gp(r.stateNode), ut(e, ye()), t !== null) for (n = e.onRecoverableError, r = 0; r < t.length; r++) i = t[r], n(i.value, { componentStack: i.stack, digest: i.digest });
  if (Vu) throw Vu = !1, e = ZI, ZI = null, e;
  return _u & 1 && e.tag !== 0 && Wi(), M = e.pendingLanes, M & 1 ? e === GI ? oa++ : (oa = 0, GI = e) : oa = 0, Qn(), null;
}
function Wi() {
  if (jn !== null) {
    var e = _0(_u), t = Pt.transition, r = re;
    try {
      if (Pt.transition = null, re = 16 > e ? 16 : e, jn === null) var n = !1;
      else {
        if (e = jn, jn = null, _u = 0, F & 6) throw Error(L(331));
        var i = F;
        for (F |= 4, v = e.current; v !== null; ) {
          var M = v, o = M.child;
          if (v.flags & 16) {
            var u = M.deletions;
            if (u !== null) {
              for (var s = 0; s < u.length; s++) {
                var l = u[s];
                for (v = l; v !== null; ) {
                  var I = v;
                  switch (I.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Ma(8, I, M);
                  }
                  var g = I.child;
                  if (g !== null) g.return = I, v = g;
                  else for (; v !== null; ) {
                    I = v;
                    var c = I.sibling, D = I.return;
                    if (tA(I), I === l) {
                      v = null;
                      break;
                    }
                    if (c !== null) {
                      c.return = D, v = c;
                      break;
                    }
                    v = D;
                  }
                }
              }
              var j = M.alternate;
              if (j !== null) {
                var N = j.child;
                if (N !== null) {
                  j.child = null;
                  do {
                    var d = N.sibling;
                    N.sibling = null, N = d;
                  } while (N !== null);
                }
              }
              v = M;
            }
          }
          if (M.subtreeFlags & 2064 && o !== null) o.return = M, v = o;
          else e: for (; v !== null; ) {
            if (M = v, M.flags & 2048) switch (M.tag) {
              case 0:
              case 11:
              case 15:
                Ma(9, M, M.return);
            }
            var T = M.sibling;
            if (T !== null) {
              T.return = M.return, v = T;
              break e;
            }
            v = M.return;
          }
        }
        var y = e.current;
        for (v = y; v !== null; ) {
          o = v;
          var A = o.child;
          if (o.subtreeFlags & 2064 && A !== null) A.return = o, v = A;
          else e: for (o = y; v !== null; ) {
            if (u = v, u.flags & 2048) try {
              switch (u.tag) {
                case 0:
                case 11:
                case 15:
                  ps(9, u);
              }
            } catch (E) {
              Ne(u, u.return, E);
            }
            if (u === o) {
              v = null;
              break e;
            }
            var x = u.sibling;
            if (x !== null) {
              x.return = u.return, v = x;
              break e;
            }
            v = u.return;
          }
        }
        if (F = i, Qn(), Or && typeof Or.onPostCommitFiberRoot == "function") try {
          Or.onPostCommitFiberRoot(ds, e);
        } catch (E) {
        }
        n = !0;
      }
      return n;
    } finally {
      re = r, Pt.transition = t;
    }
  }
  return !1;
}
function My(e, t, r) {
  t = oM(r, t), t = _3(e, t, 1), e = fn(e, t, 1), t = Ke(), e !== null && (Fa(e, 1, t), ut(e, t));
}
function Ne(e, t, r) {
  if (e.tag === 3) My(e, e, r);
  else for (; t !== null; ) {
    if (t.tag === 3) {
      My(t, e, r);
      break;
    } else if (t.tag === 1) {
      var n = t.stateNode;
      if (typeof t.type.getDerivedStateFromError == "function" || typeof n.componentDidCatch == "function" && (Cn === null || !Cn.has(n))) {
        e = oM(r, e), e = Z3(t, e, 1), t = fn(t, e, 1), e = Ke(), t !== null && (Fa(t, 1, e), ut(t, e));
        break;
      }
    }
    t = t.return;
  }
}
function Av(e, t, r) {
  var n = e.pingCache;
  n !== null && n.delete(t), t = Ke(), e.pingedLanes |= e.suspendedLanes & r, pe === e && (ke & r) === r && (de === 4 || de === 3 && (ke & 130023424) === ke && 500 > ye() - Y4 ? qn(e, 0) : Q4 |= r), ut(e, t);
}
function cA(e, t) {
  t === 0 && (e.mode & 1 ? (t = yo, yo <<= 1, !(yo & 130023424) && (yo = 4194304)) : t = 1);
  var r = Ke();
  e = Gr(e, t), e !== null && (Fa(e, t, r), ut(e, r));
}
function dv(e) {
  var t = e.memoizedState, r = 0;
  t !== null && (r = t.retryLane), cA(e, r);
}
function xv(e, t) {
  var r = 0;
  switch (e.tag) {
    case 13:
      var n = e.stateNode, i = e.memoizedState;
      i !== null && (r = i.retryLane);
      break;
    case 19:
      n = e.stateNode;
      break;
    default:
      throw Error(L(314));
  }
  n !== null && n.delete(t), cA(e, r);
}
var IA;
IA = function(e, t, r) {
  if (e !== null) if (e.memoizedProps !== t.pendingProps || at.current) it = !0;
  else {
    if (!(e.lanes & r) && !(t.flags & 128)) return it = !1, uv(e, t, r);
    it = !!(e.flags & 131072);
  }
  else it = !1, se && t.flags & 1048576 && D3(t, Uu, t.index);
  switch (t.lanes = 0, t.tag) {
    case 2:
      var n = t.type;
      su(e, t), e = t.pendingProps;
      var i = nM(t, Ve.current);
      Fi(t, r), i = v4(null, t, n, e, i, r);
      var M = h4();
      return t.flags |= 1, typeof i == "object" && i !== null && typeof i.render == "function" && i.$$typeof === void 0 ? (t.tag = 1, t.memoizedState = null, t.updateQueue = null, ot(n) ? (M = !0, wu(t)) : M = !1, t.memoizedState = i.state !== null && i.state !== void 0 ? i.state : null, C4(t), i.updater = Os, t.stateNode = i, i._reactInternals = t, kI(t, n, e, r), t = YI(null, t, n, !0, M, r)) : (t.tag = 0, se && M && T4(t), Xe(null, t, i, r), t = t.child), t;
    case 16:
      n = t.elementType;
      e: {
        switch (su(e, t), e = t.pendingProps, i = n._init, n = i(n._payload), t.type = n, i = t.tag = zv(n), e = er(n, e), i) {
          case 0:
            t = QI(null, t, n, e, r);
            break e;
          case 1:
            t = WD(null, t, n, e, r);
            break e;
          case 11:
            t = BD(null, t, n, e, r);
            break e;
          case 14:
            t = FD(null, t, n, er(n.type, e), r);
            break e;
        }
        throw Error(L(
          306,
          n,
          ""
        ));
      }
      return t;
    case 0:
      return n = t.type, i = t.pendingProps, i = t.elementType === n ? i : er(n, i), QI(e, t, n, i, r);
    case 1:
      return n = t.type, i = t.pendingProps, i = t.elementType === n ? i : er(n, i), WD(e, t, n, i, r);
    case 3:
      e: {
        if (W3(t), e === null) throw Error(L(387));
        n = t.pendingProps, M = t.memoizedState, i = M.element, E3(e, t), bu(t, n, null, r);
        var o = t.memoizedState;
        if (n = o.element, M.isDehydrated) if (M = { element: n, isDehydrated: !1, cache: o.cache, pendingSuspenseBoundaries: o.pendingSuspenseBoundaries, transitions: o.transitions }, t.updateQueue.baseState = M, t.memoizedState = M, t.flags & 256) {
          i = oM(Error(L(423)), t), t = JD(e, t, n, r, i);
          break e;
        } else if (n !== i) {
          i = oM(Error(L(424)), t), t = JD(e, t, n, r, i);
          break e;
        } else for (yt = zn(t.stateNode.containerInfo.firstChild), Tt = t, se = !0, nr = null, r = d3(t, null, n, r), t.child = r; r; ) r.flags = r.flags & -3 | 4096, r = r.sibling;
        else {
          if (iM(), n === i) {
            t = Br(e, t, r);
            break e;
          }
          Xe(e, t, n, r);
        }
        t = t.child;
      }
      return t;
    case 5:
      return z3(t), e === null && hI(t), n = t.type, i = t.pendingProps, M = e !== null ? e.memoizedProps : null, o = i.children, LI(n, i) ? o = null : M !== null && LI(n, M) && (t.flags |= 32), F3(e, t), Xe(e, t, o, r), t.child;
    case 6:
      return e === null && hI(t), null;
    case 13:
      return J3(e, t, r);
    case 4:
      return L4(t, t.stateNode.containerInfo), n = t.pendingProps, e === null ? t.child = MM(t, null, n, r) : Xe(e, t, n, r), t.child;
    case 11:
      return n = t.type, i = t.pendingProps, i = t.elementType === n ? i : er(n, i), BD(e, t, n, i, r);
    case 7:
      return Xe(e, t, t.pendingProps, r), t.child;
    case 8:
      return Xe(e, t, t.pendingProps.children, r), t.child;
    case 12:
      return Xe(e, t, t.pendingProps.children, r), t.child;
    case 10:
      e: {
        if (n = t.type._context, i = t.pendingProps, M = t.memoizedProps, o = i.value, ie(Qu, n._currentValue), n._currentValue = o, M !== null) if (sr(M.value, o)) {
          if (M.children === i.children && !at.current) {
            t = Br(e, t, r);
            break e;
          }
        } else for (M = t.child, M !== null && (M.return = t); M !== null; ) {
          var u = M.dependencies;
          if (u !== null) {
            o = M.child;
            for (var s = u.firstContext; s !== null; ) {
              if (s.context === n) {
                if (M.tag === 1) {
                  s = Hr(-1, r & -r), s.tag = 2;
                  var l = M.updateQueue;
                  if (l !== null) {
                    l = l.shared;
                    var I = l.pending;
                    I === null ? s.next = s : (s.next = I.next, I.next = s), l.pending = s;
                  }
                }
                M.lanes |= r, s = M.alternate, s !== null && (s.lanes |= r), mI(
                  M.return,
                  r,
                  t
                ), u.lanes |= r;
                break;
              }
              s = s.next;
            }
          } else if (M.tag === 10) o = M.type === t.type ? null : M.child;
          else if (M.tag === 18) {
            if (o = M.return, o === null) throw Error(L(341));
            o.lanes |= r, u = o.alternate, u !== null && (u.lanes |= r), mI(o, r, t), o = M.sibling;
          } else o = M.child;
          if (o !== null) o.return = M;
          else for (o = M; o !== null; ) {
            if (o === t) {
              o = null;
              break;
            }
            if (M = o.sibling, M !== null) {
              M.return = o.return, o = M;
              break;
            }
            o = o.return;
          }
          M = o;
        }
        Xe(e, t, i.children, r), t = t.child;
      }
      return t;
    case 9:
      return i = t.type, n = t.pendingProps.children, Fi(t, r), i = $t(i), n = n(i), t.flags |= 1, Xe(e, t, n, r), t.child;
    case 14:
      return n = t.type, i = er(n, t.pendingProps), i = er(n.type, i), FD(e, t, n, i, r);
    case 15:
      return G3(e, t, t.type, t.pendingProps, r);
    case 17:
      return n = t.type, i = t.pendingProps, i = t.elementType === n ? i : er(n, i), su(e, t), t.tag = 1, ot(n) ? (e = !0, wu(t)) : e = !1, Fi(t, r), V3(t, n, i), kI(t, n, i, r), YI(null, t, n, !0, e, r);
    case 19:
      return X3(e, t, r);
    case 22:
      return B3(e, t, r);
  }
  throw Error(L(156, t.tag));
};
function gA(e, t) {
  return $0(e, t);
}
function Ev(e, t, r, n) {
  this.tag = e, this.key = r, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = n, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
}
function bt(e, t, r, n) {
  return new Ev(e, t, r, n);
}
function R4(e) {
  return e = e.prototype, !(!e || !e.isReactComponent);
}
function zv(e) {
  if (typeof e == "function") return R4(e) ? 1 : 0;
  if (e != null) {
    if (e = e.$$typeof, e === a4) return 11;
    if (e === o4) return 14;
  }
  return 2;
}
function On(e, t) {
  var r = e.alternate;
  return r === null ? (r = bt(e.tag, t, e.key, e.mode), r.elementType = e.elementType, r.type = e.type, r.stateNode = e.stateNode, r.alternate = e, e.alternate = r) : (r.pendingProps = t, r.type = e.type, r.flags = 0, r.subtreeFlags = 0, r.deletions = null), r.flags = e.flags & 14680064, r.childLanes = e.childLanes, r.lanes = e.lanes, r.child = e.child, r.memoizedProps = e.memoizedProps, r.memoizedState = e.memoizedState, r.updateQueue = e.updateQueue, t = e.dependencies, r.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, r.sibling = e.sibling, r.index = e.index, r.ref = e.ref, r;
}
function Iu(e, t, r, n, i, M) {
  var o = 2;
  if (n = e, typeof e == "function") R4(e) && (o = 1);
  else if (typeof e == "string") o = 5;
  else e: switch (e) {
    case Si:
      return ei(r.children, i, M, t);
    case M4:
      o = 8, i |= 8;
      break;
    case iI:
      return e = bt(12, r, t, i | 2), e.elementType = iI, e.lanes = M, e;
    case MI:
      return e = bt(13, r, t, i), e.elementType = MI, e.lanes = M, e;
    case aI:
      return e = bt(19, r, t, i), e.elementType = aI, e.lanes = M, e;
    case z0:
      return vs(r, i, M, t);
    default:
      if (typeof e == "object" && e !== null) switch (e.$$typeof) {
        case x0:
          o = 10;
          break e;
        case E0:
          o = 9;
          break e;
        case a4:
          o = 11;
          break e;
        case o4:
          o = 14;
          break e;
        case sn:
          o = 16, n = null;
          break e;
      }
      throw Error(L(130, e == null ? e : typeof e, ""));
  }
  return t = bt(o, r, t, i), t.elementType = e, t.type = n, t.lanes = M, t;
}
function ei(e, t, r, n) {
  return e = bt(7, e, n, t), e.lanes = r, e;
}
function vs(e, t, r, n) {
  return e = bt(22, e, n, t), e.elementType = z0, e.lanes = r, e.stateNode = { isHidden: !1 }, e;
}
function Jl(e, t, r) {
  return e = bt(6, e, null, t), e.lanes = r, e;
}
function Xl(e, t, r) {
  return t = bt(4, e.children !== null ? e.children : [], e.key, t), t.lanes = r, t.stateNode = { containerInfo: e.containerInfo, pendingChildren: null, implementation: e.implementation }, t;
}
function fv(e, t, r, n, i) {
  this.tag = t, this.containerInfo = e, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = hl(0), this.expirationTimes = hl(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = hl(0), this.identifierPrefix = n, this.onRecoverableError = i, this.mutableSourceEagerHydrationData = null;
}
function H4(e, t, r, n, i, M, o, u, s) {
  return e = new fv(e, t, r, u, s), t === 1 ? (t = 1, M === !0 && (t |= 8)) : t = 0, M = bt(3, null, null, t), e.current = M, M.stateNode = e, M.memoizedState = { element: n, isDehydrated: r, cache: null, transitions: null, pendingSuspenseBoundaries: null }, C4(M), e;
}
function Cv(e, t, r) {
  var n = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
  return { $$typeof: pi, key: n == null ? null : "" + n, children: e, containerInfo: t, implementation: r };
}
function jA(e) {
  if (!e) return Sn;
  e = e._reactInternals;
  e: {
    if (ci(e) !== e || e.tag !== 1) throw Error(L(170));
    var t = e;
    do {
      switch (t.tag) {
        case 3:
          t = t.stateNode.context;
          break e;
        case 1:
          if (ot(t.type)) {
            t = t.stateNode.__reactInternalMemoizedMergedChildContext;
            break e;
          }
      }
      t = t.return;
    } while (t !== null);
    throw Error(L(171));
  }
  if (e.tag === 1) {
    var r = e.type;
    if (ot(r)) return j3(e, r, t);
  }
  return t;
}
function NA(e, t, r, n, i, M, o, u, s) {
  return e = H4(r, n, !0, e, i, M, o, u, s), e.context = jA(null), r = e.current, n = Ke(), i = Ln(r), M = Hr(n, i), M.callback = t != null ? t : null, fn(r, M, i), e.current.lanes = i, Fa(e, i, n), ut(e, n), e;
}
function hs(e, t, r, n) {
  var i = t.current, M = Ke(), o = Ln(i);
  return r = jA(r), t.context === null ? t.context = r : t.pendingContext = r, t = Hr(M, o), t.payload = { element: e }, n = n === void 0 ? null : n, n !== null && (t.callback = n), e = fn(i, t, o), e !== null && (or(e, i, o, M), au(e, i, o)), o;
}
function Gu(e) {
  if (e = e.current, !e.child) return null;
  switch (e.child.tag) {
    case 5:
      return e.child.stateNode;
    default:
      return e.child.stateNode;
  }
}
function ay(e, t) {
  if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
    var r = e.retryLane;
    e.retryLane = r !== 0 && r < t ? r : t;
  }
}
function V4(e, t) {
  ay(e, t), (e = e.alternate) && ay(e, t);
}
function Lv() {
  return null;
}
var DA = typeof reportError == "function" ? reportError : function(e) {
  console.error(e);
};
function _4(e) {
  this._internalRoot = e;
}
ms.prototype.render = _4.prototype.render = function(e) {
  var t = this._internalRoot;
  if (t === null) throw Error(L(409));
  hs(e, t, null, null);
};
ms.prototype.unmount = _4.prototype.unmount = function() {
  var e = this._internalRoot;
  if (e !== null) {
    this._internalRoot = null;
    var t = e.containerInfo;
    ai(function() {
      hs(null, e, null, null);
    }), t[Zr] = null;
  }
};
function ms(e) {
  this._internalRoot = e;
}
ms.prototype.unstable_scheduleHydration = function(e) {
  if (e) {
    var t = B0();
    e = { blockedOn: null, target: e, priority: t };
    for (var r = 0; r < cn.length && t !== 0 && t < cn[r].priority; r++) ;
    cn.splice(r, 0, e), r === 0 && W0(e);
  }
};
function Z4(e) {
  return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
}
function ws(e) {
  return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11 && (e.nodeType !== 8 || e.nodeValue !== " react-mount-point-unstable "));
}
function oy() {
}
function Ov(e, t, r, n, i) {
  if (i) {
    if (typeof n == "function") {
      var M = n;
      n = function() {
        var l = Gu(o);
        M.call(l);
      };
    }
    var o = NA(t, n, e, 0, null, !1, !1, "", oy);
    return e._reactRootContainer = o, e[Zr] = o.current, Ca(e.nodeType === 8 ? e.parentNode : e), ai(), o;
  }
  for (; i = e.lastChild; ) e.removeChild(i);
  if (typeof n == "function") {
    var u = n;
    n = function() {
      var l = Gu(s);
      u.call(l);
    };
  }
  var s = H4(e, 0, !1, null, null, !1, !1, "", oy);
  return e._reactRootContainer = s, e[Zr] = s.current, Ca(e.nodeType === 8 ? e.parentNode : e), ai(function() {
    hs(t, s, r, n);
  }), s;
}
function ks(e, t, r, n, i) {
  var M = r._reactRootContainer;
  if (M) {
    var o = M;
    if (typeof i == "function") {
      var u = i;
      i = function() {
        var s = Gu(o);
        u.call(s);
      };
    }
    hs(t, o, e, i);
  } else o = Ov(r, t, e, i, n);
  return Gu(o);
}
Z0 = function(e) {
  switch (e.tag) {
    case 3:
      var t = e.stateNode;
      if (t.current.memoizedState.isDehydrated) {
        var r = WM(t.pendingLanes);
        r !== 0 && (l4(t, r | 1), ut(t, ye()), !(F & 6) && (uM = ye() + 500, Qn()));
      }
      break;
    case 13:
      ai(function() {
        var n = Gr(e, 1);
        if (n !== null) {
          var i = Ke();
          or(n, e, 1, i);
        }
      }), V4(e, 1);
  }
};
c4 = function(e) {
  if (e.tag === 13) {
    var t = Gr(e, 134217728);
    if (t !== null) {
      var r = Ke();
      or(t, e, 134217728, r);
    }
    V4(e, 134217728);
  }
};
G0 = function(e) {
  if (e.tag === 13) {
    var t = Ln(e), r = Gr(e, t);
    if (r !== null) {
      var n = Ke();
      or(r, e, t, n);
    }
    V4(e, t);
  }
};
B0 = function() {
  return re;
};
F0 = function(e, t) {
  var r = re;
  try {
    return re = e, t();
  } finally {
    re = r;
  }
};
DI = function(e, t, r) {
  switch (t) {
    case "input":
      if (sI(e, r), t = r.name, r.type === "radio" && t != null) {
        for (r = e; r.parentNode; ) r = r.parentNode;
        for (r = r.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < r.length; t++) {
          var n = r[t];
          if (n !== e && n.form === e.form) {
            var i = fs(n);
            if (!i) throw Error(L(90));
            C0(n), sI(n, i);
          }
        }
      }
      break;
    case "textarea":
      O0(e, r);
      break;
    case "select":
      t = r.value, t != null && _i(e, !!r.multiple, t, !1);
  }
};
k0 = b4;
U0 = ai;
var pv = { usingClientEntryPoint: !1, Events: [Ja, wi, fs, m0, w0, b4] }, UM = { findFiberByHostInstance: Jn, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, Sv = { bundleType: UM.bundleType, version: UM.version, rendererPackageName: UM.rendererPackageName, rendererConfig: UM.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: Kr.ReactCurrentDispatcher, findHostInstanceByFiber: function(e) {
  return e = b0(e), e === null ? null : e.stateNode;
}, findFiberByHostInstance: UM.findFiberByHostInstance || Lv, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined") {
  var So = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!So.isDisabled && So.supportsFiber) try {
    ds = So.inject(Sv), Or = So;
  } catch (e) {
  }
}
xt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = pv;
xt.createPortal = function(e, t) {
  var r = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
  if (!Z4(t)) throw Error(L(200));
  return Cv(e, t, null, r);
};
xt.createRoot = function(e, t) {
  if (!Z4(e)) throw Error(L(299));
  var r = !1, n = "", i = DA;
  return t != null && (t.unstable_strictMode === !0 && (r = !0), t.identifierPrefix !== void 0 && (n = t.identifierPrefix), t.onRecoverableError !== void 0 && (i = t.onRecoverableError)), t = H4(e, 1, !1, null, null, r, !1, n, i), e[Zr] = t.current, Ca(e.nodeType === 8 ? e.parentNode : e), new _4(t);
};
xt.findDOMNode = function(e) {
  if (e == null) return null;
  if (e.nodeType === 1) return e;
  var t = e._reactInternals;
  if (t === void 0)
    throw typeof e.render == "function" ? Error(L(188)) : (e = Object.keys(e).join(","), Error(L(268, e)));
  return e = b0(t), e = e === null ? null : e.stateNode, e;
};
xt.flushSync = function(e) {
  return ai(e);
};
xt.hydrate = function(e, t, r) {
  if (!ws(t)) throw Error(L(200));
  return ks(null, e, t, !0, r);
};
xt.hydrateRoot = function(e, t, r) {
  if (!Z4(e)) throw Error(L(405));
  var n = r != null && r.hydratedSources || null, i = !1, M = "", o = DA;
  if (r != null && (r.unstable_strictMode === !0 && (i = !0), r.identifierPrefix !== void 0 && (M = r.identifierPrefix), r.onRecoverableError !== void 0 && (o = r.onRecoverableError)), t = NA(t, null, e, 1, r != null ? r : null, i, !1, M, o), e[Zr] = t.current, Ca(e), n) for (e = 0; e < n.length; e++) r = n[e], i = r._getVersion, i = i(r._source), t.mutableSourceEagerHydrationData == null ? t.mutableSourceEagerHydrationData = [r, i] : t.mutableSourceEagerHydrationData.push(
    r,
    i
  );
  return new ms(t);
};
xt.render = function(e, t, r) {
  if (!ws(t)) throw Error(L(200));
  return ks(null, e, t, !1, r);
};
xt.unmountComponentAtNode = function(e) {
  if (!ws(e)) throw Error(L(40));
  return e._reactRootContainer ? (ai(function() {
    ks(null, null, e, !1, function() {
      e._reactRootContainer = null, e[Zr] = null;
    });
  }), !0) : !1;
};
xt.unstable_batchedUpdates = b4;
xt.unstable_renderSubtreeIntoContainer = function(e, t, r, n) {
  if (!ws(r)) throw Error(L(200));
  if (e == null || e._reactInternals === void 0) throw Error(L(38));
  return ks(e, t, r, !1, n);
};
xt.version = "18.3.1-next-f1338f8080-20240426";
function yA() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ == "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(yA);
    } catch (e) {
      console.error(e);
    }
}
yA(), y0.exports = xt;
var vv = y0.exports, G4, uy = vv;
G4 = uy.createRoot, uy.hydrateRoot;
var h = {}, WI = { exports: {} };
(function(e, t) {
  (function(r, n) {
    var i = "1.0.38", M = "", o = "?", u = "function", s = "undefined", l = "object", I = "string", g = "major", c = "model", D = "name", j = "type", N = "vendor", d = "version", T = "architecture", y = "console", A = "mobile", x = "tablet", E = "smarttv", C = "wearable", p = "embedded", O = 500, w = "Amazon", z = "Apple", R = "ASUS", K = "BlackBerry", P = "Browser", H = "Chrome", Se = "Edge", fe = "Firefox", De = "Google", S = "Huawei", U = "LG", k = "Microsoft", W = "Motorola", J = "Opera", Ge = "Samsung", ve = "Sharp", Be = "Sony", he = "Xiaomi", It = "Zebra", ft = "Facebook", Wt = "Chromium OS", qr = "Mac OS", $n = function(Z, te) {
      var $ = {};
      for (var ne in Z)
        te[ne] && te[ne].length % 2 === 0 ? $[ne] = te[ne].concat(Z[ne]) : $[ne] = Z[ne];
      return $;
    }, en = function(Z) {
      for (var te = {}, $ = 0; $ < Z.length; $++)
        te[Z[$].toUpperCase()] = Z[$];
      return te;
    }, ji = function(Z, te) {
      return typeof Z === I ? gr(te).indexOf(gr(Z)) !== -1 : !1;
    }, gr = function(Z) {
      return Z.toLowerCase();
    }, zM = function(Z) {
      return typeof Z === I ? Z.replace(/[^\d\.]/g, M).split(".")[0] : n;
    }, Rn = function(Z, te) {
      if (typeof Z === I)
        return Z = Z.replace(/^\s\s*/, M), typeof te === s ? Z : Z.substring(0, O);
    }, Jt = function(Z, te) {
      for (var $ = 0, ne, mr, jr, ee, b, Nr; $ < te.length && !b; ) {
        var el = te[$], $j = te[$ + 1];
        for (ne = mr = 0; ne < el.length && !b && el[ne]; )
          if (b = el[ne++].exec(Z), b)
            for (jr = 0; jr < $j.length; jr++)
              Nr = b[++mr], ee = $j[jr], typeof ee === l && ee.length > 0 ? ee.length === 2 ? typeof ee[1] == u ? this[ee[0]] = ee[1].call(this, Nr) : this[ee[0]] = ee[1] : ee.length === 3 ? typeof ee[1] === u && !(ee[1].exec && ee[1].test) ? this[ee[0]] = Nr ? ee[1].call(this, Nr, ee[2]) : n : this[ee[0]] = Nr ? Nr.replace(ee[1], ee[2]) : n : ee.length === 4 && (this[ee[0]] = Nr ? ee[3].call(this, Nr.replace(ee[1], ee[2])) : n) : this[ee] = Nr || n;
        $ += 2;
      }
    }, fM = function(Z, te) {
      for (var $ in te)
        if (typeof te[$] === l && te[$].length > 0) {
          for (var ne = 0; ne < te[$].length; ne++)
            if (ji(te[$][ne], Z))
              return $ === o ? n : $;
        } else if (ji(te[$], Z))
          return $ === o ? n : $;
      return Z;
    }, qs = { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" }, ro = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" }, no = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [d, [D, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [d, [D, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [D, d], [/opios[\/ ]+([\w\.]+)/i], [d, [D, J + " Mini"]], [/\bop(?:rg)?x\/([\w\.]+)/i], [d, [D, J + " GX"]], [/\bopr\/([\w\.]+)/i], [d, [D, J]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [d, [D, "Baidu"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i, /(heytap|ovi)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [D, d], [/\bddg\/([\w\.]+)/i], [d, [D, "DuckDuckGo"]], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [d, [D, "UC" + P]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [d, [D, "WeChat"]], [/konqueror\/([\w\.]+)/i], [d, [D, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [d, [D, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [d, [D, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [d, [D, "Smart Lenovo " + P]], [/(avast|avg)\/([\w\.]+)/i], [[D, /(.+)/, "$1 Secure " + P], d], [/\bfocus\/([\w\.]+)/i], [d, [D, fe + " Focus"]], [/\bopt\/([\w\.]+)/i], [d, [D, J + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [d, [D, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [d, [D, "Dolphin"]], [/coast\/([\w\.]+)/i], [d, [D, J + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [d, [D, "MIUI " + P]], [/fxios\/([-\w\.]+)/i], [d, [D, fe]], [/\bqihu|(qi?ho?o?|360)browser/i], [[D, "360 " + P]], [/(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i], [[D, /(.+)/, "$1 " + P], d], [/samsungbrowser\/([\w\.]+)/i], [d, [D, Ge + " Internet"]], [/(comodo_dragon)\/([\w\.]+)/i], [[D, /_/g, " "], d], [/metasr[\/ ]?([\d\.]+)/i], [d, [D, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[D, "Sogou Mobile"], d], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i], [D, d], [/(lbbrowser)/i, /\[(linkedin)app\]/i], [D], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[D, ft], d], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(twitter)(?:and| f.+e\/([\w\.]+))/i, /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i], [D, d], [/\bgsa\/([\w\.]+) .*safari\//i], [d, [D, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [d, [D, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [d, [D, H + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[D, H + " WebView"], d], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [d, [D, "Android " + P]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [D, d], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [d, [D, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [d, D], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [D, [d, fM, qs]], [/(webkit|khtml)\/([\w\.]+)/i], [D, d], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[D, "Netscape"], d], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [d, [D, fe + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i, /panasonic;(viera)/i], [D, d], [/(cobalt)\/([\w\.]+)/i], [D, [d, /master.|lts./, ""]]], cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[T, "amd64"]], [/(ia32(?=;))/i], [[T, gr]], [/((?:i[346]|x)86)[;\)]/i], [[T, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[T, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[T, "armhf"]], [/windows (ce|mobile); ppc;/i], [[T, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[T, /ower/, M, gr]], [/(sun4\w)[;\)]/i], [[T, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[T, gr]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [c, [N, Ge], [j, x]], [/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [c, [N, Ge], [j, A]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [c, [N, z], [j, A]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [c, [N, z], [j, x]], [/(macintosh);/i], [c, [N, z]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [c, [N, ve], [j, A]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [c, [N, S], [j, x]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [c, [N, S], [j, A]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[c, /_/g, " "], [N, he], [j, A]], [/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i, /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[c, /_/g, " "], [N, he], [j, x]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [c, [N, "OPPO"], [j, A]], [/\b(opd2\d{3}a?) bui/i], [c, [N, "OPPO"], [j, x]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [c, [N, "Vivo"], [j, A]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [c, [N, "Realme"], [j, A]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [c, [N, W], [j, A]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [c, [N, W], [j, x]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [c, [N, U], [j, x]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [c, [N, U], [j, A]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [c, [N, "Lenovo"], [j, x]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[c, /_/g, " "], [N, "Nokia"], [j, A]], [/(pixel c)\b/i], [c, [N, De], [j, x]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [c, [N, De], [j, A]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [c, [N, Be], [j, A]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[c, "Xperia Tablet"], [N, Be], [j, x]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [c, [N, "OnePlus"], [j, A]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [c, [N, w], [j, x]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[c, /(.+)/g, "Fire Phone $1"], [N, w], [j, A]], [/(playbook);[-\w\),; ]+(rim)/i], [c, N, [j, x]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [c, [N, K], [j, A]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [c, [N, R], [j, x]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [c, [N, R], [j, A]], [/(nexus 9)/i], [c, [N, "HTC"], [j, x]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [N, [c, /_/g, " "], [j, A]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [c, [N, "Acer"], [j, x]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [c, [N, "Meizu"], [j, A]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [c, [N, "Ulefone"], [j, A]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [N, c, [j, A]], [/(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [N, c, [j, x]], [/(surface duo)/i], [c, [N, k], [j, x]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [c, [N, "Fairphone"], [j, A]], [/(u304aa)/i], [c, [N, "AT&T"], [j, A]], [/\bsie-(\w*)/i], [c, [N, "Siemens"], [j, A]], [/\b(rct\w+) b/i], [c, [N, "RCA"], [j, x]], [/\b(venue[\d ]{2,7}) b/i], [c, [N, "Dell"], [j, x]], [/\b(q(?:mv|ta)\w+) b/i], [c, [N, "Verizon"], [j, x]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [c, [N, "Barnes & Noble"], [j, x]], [/\b(tm\d{3}\w+) b/i], [c, [N, "NuVision"], [j, x]], [/\b(k88) b/i], [c, [N, "ZTE"], [j, x]], [/\b(nx\d{3}j) b/i], [c, [N, "ZTE"], [j, A]], [/\b(gen\d{3}) b.+49h/i], [c, [N, "Swiss"], [j, A]], [/\b(zur\d{3}) b/i], [c, [N, "Swiss"], [j, x]], [/\b((zeki)?tb.*\b) b/i], [c, [N, "Zeki"], [j, x]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[N, "Dragon Touch"], c, [j, x]], [/\b(ns-?\w{0,9}) b/i], [c, [N, "Insignia"], [j, x]], [/\b((nxa|next)-?\w{0,9}) b/i], [c, [N, "NextBook"], [j, x]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[N, "Voice"], c, [j, A]], [/\b(lvtel\-)?(v1[12]) b/i], [[N, "LvTel"], c, [j, A]], [/\b(ph-1) /i], [c, [N, "Essential"], [j, A]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [c, [N, "Envizen"], [j, x]], [/\b(trio[-\w\. ]+) b/i], [c, [N, "MachSpeed"], [j, x]], [/\btu_(1491) b/i], [c, [N, "Rotor"], [j, x]], [/(shield[\w ]+) b/i], [c, [N, "Nvidia"], [j, x]], [/(sprint) (\w+)/i], [N, c, [j, A]], [/(kin\.[onetw]{3})/i], [[c, /\./g, " "], [N, k], [j, A]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [c, [N, It], [j, x]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [c, [N, It], [j, A]], [/smart-tv.+(samsung)/i], [N, [j, E]], [/hbbtv.+maple;(\d+)/i], [[c, /^/, "SmartTV"], [N, Ge], [j, E]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[N, U], [j, E]], [/(apple) ?tv/i], [N, [c, z + " TV"], [j, E]], [/crkey/i], [[c, H + "cast"], [N, De], [j, E]], [/droid.+aft(\w+)( bui|\))/i], [c, [N, w], [j, E]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [c, [N, ve], [j, E]], [/(bravia[\w ]+)( bui|\))/i], [c, [N, Be], [j, E]], [/(mitv-\w{5}) bui/i], [c, [N, he], [j, E]], [/Hbbtv.*(technisat) (.*);/i], [N, c, [j, E]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[N, Rn], [c, Rn], [j, E]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[j, E]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [N, c, [j, y]], [/droid.+; (shield) bui/i], [c, [N, "Nvidia"], [j, y]], [/(playstation [345portablevi]+)/i], [c, [N, Be], [j, y]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [c, [N, k], [j, y]], [/((pebble))app/i], [N, c, [j, C]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [c, [N, z], [j, C]], [/droid.+; (glass) \d/i], [c, [N, De], [j, C]], [/droid.+; (wt63?0{2,3})\)/i], [c, [N, It], [j, C]], [/(quest( \d| pro)?)/i], [c, [N, ft], [j, C]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [N, [j, p]], [/(aeobc)\b/i], [c, [N, w], [j, p]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i], [c, [j, A]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [c, [j, x]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[j, x]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[j, A]], [/(android[-\w\. ]{0,9});.+buil/i], [c, [N, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [d, [D, Se + "HTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [d, [D, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [D, d], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [d, D]], os: [[/microsoft (windows) (vista|xp)/i], [D, d], [/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i], [D, [d, fM, ro]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[d, fM, ro], [D, "Windows"]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[d, /_/g, "."], [D, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[D, qr], [d, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [d, D], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [D, d], [/\(bb(10);/i], [d, [D, K]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [d, [D, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [d, [D, fe + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [d, [D, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [d, [D, "watchOS"]], [/crkey\/([\d\.]+)/i], [d, [D, H + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[D, Wt], d], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [D, d], [/(sunos) ?([\w\.\d]*)/i], [[D, "Solaris"], d], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [D, d]] }, gt = function(Z, te) {
      if (typeof Z === l && (te = Z, Z = n), !(this instanceof gt))
        return new gt(Z, te).getResult();
      var $ = typeof r !== s && r.navigator ? r.navigator : n, ne = Z || ($ && $.userAgent ? $.userAgent : M), mr = $ && $.userAgentData ? $.userAgentData : n, jr = te ? $n(no, te) : no, ee = $ && $.userAgent == ne;
      return this.getBrowser = function() {
        var b = {};
        return b[D] = n, b[d] = n, Jt.call(b, ne, jr.browser), b[g] = zM(b[d]), ee && $ && $.brave && typeof $.brave.isBrave == u && (b[D] = "Brave"), b;
      }, this.getCPU = function() {
        var b = {};
        return b[T] = n, Jt.call(b, ne, jr.cpu), b;
      }, this.getDevice = function() {
        var b = {};
        return b[N] = n, b[c] = n, b[j] = n, Jt.call(b, ne, jr.device), ee && !b[j] && mr && mr.mobile && (b[j] = A), ee && b[c] == "Macintosh" && $ && typeof $.standalone !== s && $.maxTouchPoints && $.maxTouchPoints > 2 && (b[c] = "iPad", b[j] = x), b;
      }, this.getEngine = function() {
        var b = {};
        return b[D] = n, b[d] = n, Jt.call(b, ne, jr.engine), b;
      }, this.getOS = function() {
        var b = {};
        return b[D] = n, b[d] = n, Jt.call(b, ne, jr.os), ee && !b[D] && mr && mr.platform && mr.platform != "Unknown" && (b[D] = mr.platform.replace(/chrome os/i, Wt).replace(/macos/i, qr)), b;
      }, this.getResult = function() {
        return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
      }, this.getUA = function() {
        return ne;
      }, this.setUA = function(b) {
        return ne = typeof b === I && b.length > O ? Rn(b, O) : b, this;
      }, this.setUA(ne), this;
    };
    gt.VERSION = i, gt.BROWSER = en([D, d, g]), gt.CPU = en([T]), gt.DEVICE = en([c, N, j, y, A, E, x, C, p]), gt.ENGINE = gt.OS = en([D, d]), e.exports && (t = e.exports = gt), t.UAParser = gt;
    var q = typeof r !== s && (r.jQuery || r.Zepto);
    if (q && !q.ua) {
      var Ct = new gt();
      q.ua = Ct.getResult(), q.ua.get = function() {
        return Ct.getUA();
      }, q.ua.set = function(Z) {
        Ct.setUA(Z);
        var te = Ct.getResult();
        for (var $ in te)
          q.ua[$] = te[$];
      };
    }
  })(typeof window == "object" ? window : Li);
})(WI, WI.exports);
var hv = WI.exports;
Object.defineProperty(h, "__esModule", { value: !0 });
function mv(e) {
  return e && typeof e == "object" && "default" in e ? e.default : e;
}
var He = f, Me = mv(He), TA = hv, Yn = new TA(), Ze = Yn.getBrowser(), wv = Yn.getCPU(), zt = Yn.getDevice(), B4 = Yn.getEngine(), bn = Yn.getOS(), Ka = Yn.getUA(), AA = function(t) {
  return Yn.setUA(t);
}, qa = function(t) {
  if (!t) {
    console.error("No userAgent string was provided");
    return;
  }
  var r = new TA(t);
  return {
    UA: r,
    browser: r.getBrowser(),
    cpu: r.getCPU(),
    device: r.getDevice(),
    engine: r.getEngine(),
    os: r.getOS(),
    ua: r.getUA(),
    setUserAgent: function(i) {
      return r.setUA(i);
    }
  };
}, dA = /* @__PURE__ */ Object.freeze({
  ClientUAInstance: Yn,
  browser: Ze,
  cpu: wv,
  device: zt,
  engine: B4,
  os: bn,
  ua: Ka,
  setUa: AA,
  parseUserAgent: qa
});
function sy(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function kv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? sy(Object(r), !0).forEach(function(n) {
      bv(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : sy(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ua(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ua = function(t) {
    return typeof t;
  } : ua = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ua(e);
}
function Uv(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Qv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Yv(e, t, r) {
  return t && Qv(e.prototype, t), e;
}
function bv(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function JI() {
  return JI = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, JI.apply(this, arguments);
}
function Pv(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && KI(e, t);
}
function XI(e) {
  return XI = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, XI(e);
}
function KI(e, t) {
  return KI = Object.setPrototypeOf || function(n, i) {
    return n.__proto__ = i, n;
  }, KI(e, t);
}
function $v(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, M;
  for (M = 0; M < n.length; M++)
    i = n[M], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
function Zt(e, t) {
  if (e == null) return {};
  var r = $v(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var M = Object.getOwnPropertySymbols(e);
    for (i = 0; i < M.length; i++)
      n = M[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function gu(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Rv(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return gu(e);
}
function Hv(e, t) {
  return Vv(e) || _v(e, t) || Zv(e, t) || Gv();
}
function Vv(e) {
  if (Array.isArray(e)) return e;
}
function _v(e, t) {
  var r = e == null ? null : typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], i = !0, M = !1, o, u;
    try {
      for (r = r.call(e); !(i = (o = r.next()).done) && (n.push(o.value), !(t && n.length === t)); i = !0)
        ;
    } catch (s) {
      M = !0, u = s;
    } finally {
      try {
        !i && r.return != null && r.return();
      } finally {
        if (M) throw u;
      }
    }
    return n;
  }
}
function Zv(e, t) {
  if (e) {
    if (typeof e == "string") return ly(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ly(e, t);
  }
}
function ly(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Gv() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Pe = {
  Mobile: "mobile",
  Tablet: "tablet",
  SmartTv: "smarttv",
  Console: "console",
  Wearable: "wearable",
  Embedded: "embedded",
  Browser: void 0
}, st = {
  Chrome: "Chrome",
  Firefox: "Firefox",
  Opera: "Opera",
  Yandex: "Yandex",
  Safari: "Safari",
  InternetExplorer: "Internet Explorer",
  Edge: "Edge",
  Chromium: "Chromium",
  Ie: "IE",
  MobileSafari: "Mobile Safari",
  EdgeChromium: "Edge Chromium",
  MIUI: "MIUI Browser",
  SamsungBrowser: "Samsung Browser"
}, AM = {
  IOS: "iOS",
  Android: "Android",
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MAC_OS: "Mac OS"
}, Bv = {
  isMobile: !1,
  isTablet: !1,
  isBrowser: !1,
  isSmartTV: !1,
  isConsole: !1,
  isWearable: !1
}, Fv = function(t) {
  switch (t) {
    case Pe.Mobile:
      return {
        isMobile: !0
      };
    case Pe.Tablet:
      return {
        isTablet: !0
      };
    case Pe.SmartTv:
      return {
        isSmartTV: !0
      };
    case Pe.Console:
      return {
        isConsole: !0
      };
    case Pe.Wearable:
      return {
        isWearable: !0
      };
    case Pe.Browser:
      return {
        isBrowser: !0
      };
    case Pe.Embedded:
      return {
        isEmbedded: !0
      };
    default:
      return Bv;
  }
}, Wv = function(t) {
  return AA(t);
}, Y = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
  return t || r;
}, F4 = function() {
  return typeof window != "undefined" && (window.navigator || navigator) ? window.navigator || navigator : !1;
}, W4 = function(t) {
  var r = F4();
  return r && r.platform && (r.platform.indexOf(t) !== -1 || r.platform === "MacIntel" && r.maxTouchPoints > 1 && !window.MSStream);
}, Jv = function(t, r, n, i, M) {
  return {
    isBrowser: t,
    browserMajorVersion: Y(r.major),
    browserFullVersion: Y(r.version),
    browserName: Y(r.name),
    engineName: Y(n.name),
    engineVersion: Y(n.version),
    osName: Y(i.name),
    osVersion: Y(i.version),
    userAgent: Y(M)
  };
}, cy = function(t, r, n, i) {
  return kv({}, t, {
    vendor: Y(r.vendor),
    model: Y(r.model),
    os: Y(n.name),
    osVersion: Y(n.version),
    ua: Y(i)
  });
}, Xv = function(t, r, n, i) {
  return {
    isSmartTV: t,
    engineName: Y(r.name),
    engineVersion: Y(r.version),
    osName: Y(n.name),
    osVersion: Y(n.version),
    userAgent: Y(i)
  };
}, Kv = function(t, r, n, i) {
  return {
    isConsole: t,
    engineName: Y(r.name),
    engineVersion: Y(r.version),
    osName: Y(n.name),
    osVersion: Y(n.version),
    userAgent: Y(i)
  };
}, qv = function(t, r, n, i) {
  return {
    isWearable: t,
    engineName: Y(r.name),
    engineVersion: Y(r.version),
    osName: Y(n.name),
    osVersion: Y(n.version),
    userAgent: Y(i)
  };
}, eh = function(t, r, n, i, M) {
  return {
    isEmbedded: t,
    vendor: Y(r.vendor),
    model: Y(r.model),
    engineName: Y(n.name),
    engineVersion: Y(n.version),
    osName: Y(i.name),
    osVersion: Y(i.version),
    userAgent: Y(M)
  };
};
function th(e) {
  var t = e ? qa(e) : dA, r = t.device, n = t.browser, i = t.engine, M = t.os, o = t.ua, u = Fv(r.type), s = u.isBrowser, l = u.isMobile, I = u.isTablet, g = u.isSmartTV, c = u.isConsole, D = u.isWearable, j = u.isEmbedded;
  if (s)
    return Jv(s, n, i, M, o);
  if (g)
    return Xv(g, i, M, o);
  if (c)
    return Kv(c, i, M, o);
  if (l || I)
    return cy(u, r, M, o);
  if (D)
    return qv(D, i, M, o);
  if (j)
    return eh(j, r, i, M, o);
}
var xA = function(t) {
  var r = t.type;
  return r === Pe.Mobile;
}, EA = function(t) {
  var r = t.type;
  return r === Pe.Tablet;
}, zA = function(t) {
  var r = t.type;
  return r === Pe.Mobile || r === Pe.Tablet;
}, fA = function(t) {
  var r = t.type;
  return r === Pe.SmartTv;
}, Bu = function(t) {
  var r = t.type;
  return r === Pe.Browser;
}, CA = function(t) {
  var r = t.type;
  return r === Pe.Wearable;
}, LA = function(t) {
  var r = t.type;
  return r === Pe.Console;
}, OA = function(t) {
  var r = t.type;
  return r === Pe.Embedded;
}, pA = function(t) {
  var r = t.vendor;
  return Y(r);
}, SA = function(t) {
  var r = t.model;
  return Y(r);
}, vA = function(t) {
  var r = t.type;
  return Y(r, "browser");
}, hA = function(t) {
  var r = t.name;
  return r === AM.Android;
}, mA = function(t) {
  var r = t.name;
  return r === AM.Windows;
}, wA = function(t) {
  var r = t.name;
  return r === AM.MAC_OS;
}, kA = function(t) {
  var r = t.name;
  return r === AM.WindowsPhone;
}, UA = function(t) {
  var r = t.name;
  return r === AM.IOS;
}, QA = function(t) {
  var r = t.version;
  return Y(r);
}, YA = function(t) {
  var r = t.name;
  return Y(r);
}, bA = function(t) {
  var r = t.name;
  return r === st.Chrome;
}, PA = function(t) {
  var r = t.name;
  return r === st.Firefox;
}, $A = function(t) {
  var r = t.name;
  return r === st.Chromium;
}, Fu = function(t) {
  var r = t.name;
  return r === st.Edge;
}, RA = function(t) {
  var r = t.name;
  return r === st.Yandex;
}, HA = function(t) {
  var r = t.name;
  return r === st.Safari || r === st.MobileSafari;
}, VA = function(t) {
  var r = t.name;
  return r === st.MobileSafari;
}, _A = function(t) {
  var r = t.name;
  return r === st.Opera;
}, ZA = function(t) {
  var r = t.name;
  return r === st.InternetExplorer || r === st.Ie;
}, GA = function(t) {
  var r = t.name;
  return r === st.MIUI;
}, BA = function(t) {
  var r = t.name;
  return r === st.SamsungBrowser;
}, FA = function(t) {
  var r = t.version;
  return Y(r);
}, WA = function(t) {
  var r = t.major;
  return Y(r);
}, JA = function(t) {
  var r = t.name;
  return Y(r);
}, XA = function(t) {
  var r = t.name;
  return Y(r);
}, KA = function(t) {
  var r = t.version;
  return Y(r);
}, qA = function() {
  var t = F4(), r = t && t.userAgent && t.userAgent.toLowerCase();
  return typeof r == "string" ? /electron/.test(r) : !1;
}, Ji = function(t) {
  return typeof t == "string" && t.indexOf("Edg/") !== -1;
}, ed = function() {
  var t = F4();
  return t && (/iPad|iPhone|iPod/.test(t.platform) || t.platform === "MacIntel" && t.maxTouchPoints > 1) && !window.MSStream;
}, Cr = function() {
  return W4("iPad");
}, td = function() {
  return W4("iPhone");
}, rd = function() {
  return W4("iPod");
}, nd = function(t) {
  return Y(t);
};
function id(e) {
  var t = e || dA, r = t.device, n = t.browser, i = t.os, M = t.engine, o = t.ua;
  return {
    isSmartTV: fA(r),
    isConsole: LA(r),
    isWearable: CA(r),
    isEmbedded: OA(r),
    isMobileSafari: VA(n) || Cr(),
    isChromium: $A(n),
    isMobile: zA(r) || Cr(),
    isMobileOnly: xA(r),
    isTablet: EA(r) || Cr(),
    isBrowser: Bu(r),
    isDesktop: Bu(r),
    isAndroid: hA(i),
    isWinPhone: kA(i),
    isIOS: UA(i) || Cr(),
    isChrome: bA(n),
    isFirefox: PA(n),
    isSafari: HA(n),
    isOpera: _A(n),
    isIE: ZA(n),
    osVersion: QA(i),
    osName: YA(i),
    fullBrowserVersion: FA(n),
    browserVersion: WA(n),
    browserName: JA(n),
    mobileVendor: pA(r),
    mobileModel: SA(r),
    engineName: XA(M),
    engineVersion: KA(M),
    getUA: nd(o),
    isEdge: Fu(n) || Ji(o),
    isYandex: RA(n),
    deviceType: vA(r),
    isIOS13: ed(),
    isIPad13: Cr(),
    isIPhone13: td(),
    isIPod13: rd(),
    isElectron: qA(),
    isEdgeChromium: Ji(o),
    isLegacyEdge: Fu(n) && !Ji(o),
    isWindows: mA(i),
    isMacOs: wA(i),
    isMIUI: GA(n),
    isSamsungBrowser: BA(n)
  };
}
var Md = fA(zt), ad = LA(zt), od = CA(zt), rh = OA(zt), nh = VA(Ze) || Cr(), ih = $A(Ze), Us = zA(zt) || Cr(), ud = xA(zt), sd = EA(zt) || Cr(), ld = Bu(zt), Mh = Bu(zt), cd = hA(bn), Id = kA(bn), gd = UA(bn) || Cr(), ah = bA(Ze), oh = PA(Ze), uh = HA(Ze), sh = _A(Ze), jd = ZA(Ze), lh = QA(bn), ch = YA(bn), Ih = FA(Ze), gh = WA(Ze), jh = JA(Ze), Nh = pA(zt), Dh = SA(zt), yh = XA(B4), Th = KA(B4), Ah = nd(Ka), dh = Fu(Ze) || Ji(Ka), xh = RA(Ze), Eh = vA(zt), zh = ed(), fh = Cr(), Ch = td(), Lh = rd(), Oh = qA(), ph = Ji(Ka), Sh = Fu(Ze) && !Ji(Ka), vh = mA(bn), hh = wA(bn), mh = GA(Ze), wh = BA(Ze), kh = function(t) {
  if (!t || typeof t != "string") {
    console.error("No valid user agent string was provided");
    return;
  }
  var r = qa(t), n = r.device, i = r.browser, M = r.os, o = r.engine, u = r.ua;
  return id({
    device: n,
    browser: i,
    os: M,
    engine: o,
    ua: u
  });
}, Uh = function(t) {
  var r = t.renderWithFragment, n = t.children, i = Zt(t, ["renderWithFragment", "children"]);
  return cd ? r ? Me.createElement(He.Fragment, null, n) : Me.createElement("div", i, n) : null;
}, Qh = function(t) {
  var r = t.renderWithFragment, n = t.children, i = Zt(t, ["renderWithFragment", "children"]);
  return ld ? r ? Me.createElement(He.Fragment, null, n) : Me.createElement("div", i, n) : null;
}, Yh = function(t) {
  var r = t.renderWithFragment, n = t.children, i = Zt(t, ["renderWithFragment", "children"]);
  return jd ? r ? Me.createElement(He.Fragment, null, n) : Me.createElement("div", i, n) : null;
}, bh = function(t) {
  var r = t.renderWithFragment, n = t.children, i = Zt(t, ["renderWithFragment", "children"]);
  return gd ? r ? Me.createElement(He.Fragment, null, n) : Me.createElement("div", i, n) : null;
}, Ph = function(t) {
  var r = t.renderWithFragment, n = t.children, i = Zt(t, ["renderWithFragment", "children"]);
  return Us ? r ? Me.createElement(He.Fragment, null, n) : Me.createElement("div", i, n) : null;
}, $h = function(t) {
  var r = t.renderWithFragment, n = t.children, i = Zt(t, ["renderWithFragment", "children"]);
  return sd ? r ? Me.createElement(He.Fragment, null, n) : Me.createElement("div", i, n) : null;
}, Rh = function(t) {
  var r = t.renderWithFragment, n = t.children, i = Zt(t, ["renderWithFragment", "children"]);
  return Id ? r ? Me.createElement(He.Fragment, null, n) : Me.createElement("div", i, n) : null;
}, Hh = function(t) {
  var r = t.renderWithFragment, n = t.children;
  t.viewClassName, t.style;
  var i = Zt(t, ["renderWithFragment", "children", "viewClassName", "style"]);
  return ud ? r ? Me.createElement(He.Fragment, null, n) : Me.createElement("div", i, n) : null;
}, Vh = function(t) {
  var r = t.renderWithFragment, n = t.children, i = Zt(t, ["renderWithFragment", "children"]);
  return Md ? r ? Me.createElement(He.Fragment, null, n) : Me.createElement("div", i, n) : null;
}, _h = function(t) {
  var r = t.renderWithFragment, n = t.children, i = Zt(t, ["renderWithFragment", "children"]);
  return ad ? r ? Me.createElement(He.Fragment, null, n) : Me.createElement("div", i, n) : null;
}, Zh = function(t) {
  var r = t.renderWithFragment, n = t.children, i = Zt(t, ["renderWithFragment", "children"]);
  return od ? r ? Me.createElement(He.Fragment, null, n) : Me.createElement("div", i, n) : null;
}, Gh = function(t) {
  var r = t.renderWithFragment, n = t.children;
  t.viewClassName, t.style;
  var i = t.condition, M = Zt(t, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);
  return i ? r ? Me.createElement(He.Fragment, null, n) : Me.createElement("div", M, n) : null;
};
function Bh(e) {
  return /* @__PURE__ */ function(t) {
    Pv(r, t);
    function r(n) {
      var i;
      return Uv(this, r), i = Rv(this, XI(r).call(this, n)), i.isEventListenerAdded = !1, i.handleOrientationChange = i.handleOrientationChange.bind(gu(i)), i.onOrientationChange = i.onOrientationChange.bind(gu(i)), i.onPageLoad = i.onPageLoad.bind(gu(i)), i.state = {
        isLandscape: !1,
        isPortrait: !1
      }, i;
    }
    return Yv(r, [{
      key: "handleOrientationChange",
      value: function() {
        this.isEventListenerAdded || (this.isEventListenerAdded = !0);
        var i = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: i === 0,
          isLandscape: i === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function() {
        (typeof window == "undefined" ? "undefined" : ua(window)) !== void 0 && Us && (this.isEventListenerAdded ? window.removeEventListener("load", this.onPageLoad, !1) : (this.handleOrientationChange(), window.addEventListener("load", this.onPageLoad, !1)), window.addEventListener("resize", this.onOrientationChange, !1));
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        window.removeEventListener("resize", this.onOrientationChange, !1);
      }
    }, {
      key: "render",
      value: function() {
        return Me.createElement(e, JI({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]), r;
  }(Me.Component);
}
function Fh() {
  var e = He.useState(function() {
    var M = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: M === 0,
      isLandscape: M === 90,
      orientation: M === 0 ? "portrait" : "landscape"
    };
  }), t = Hv(e, 2), r = t[0], n = t[1], i = He.useCallback(function() {
    var M = window.innerWidth > window.innerHeight ? 90 : 0, o = {
      isPortrait: M === 0,
      isLandscape: M === 90,
      orientation: M === 0 ? "portrait" : "landscape"
    };
    r.orientation !== o.orientation && n(o);
  }, [r.orientation]);
  return He.useEffect(function() {
    return (typeof window == "undefined" ? "undefined" : ua(window)) !== void 0 && Us && (i(), window.addEventListener("load", i, !1), window.addEventListener("resize", i, !1)), function() {
      window.removeEventListener("resize", i, !1), window.removeEventListener("load", i, !1);
    };
  }, [i]), r;
}
function Nd(e) {
  var t = e || window.navigator.userAgent;
  return qa(t);
}
function Wh(e) {
  var t = e || window.navigator.userAgent, r = Nd(t), n = id(r);
  return [n, r];
}
h.AndroidView = Uh;
h.BrowserTypes = st;
h.BrowserView = Qh;
h.ConsoleView = _h;
h.CustomView = Gh;
h.IEView = Yh;
h.IOSView = bh;
h.MobileOnlyView = Hh;
h.MobileView = Ph;
h.OsTypes = AM;
h.SmartTVView = Vh;
h.TabletView = $h;
h.WearableView = Zh;
h.WinPhoneView = Rh;
var sa = h.browserName = jh, Jh = h.browserVersion = gh;
h.deviceDetect = th;
h.deviceType = Eh;
h.engineName = yh;
h.engineVersion = Th;
var Kl = h.fullBrowserVersion = Ih;
h.getSelectorsByUserAgent = kh;
h.getUA = Ah;
h.isAndroid = cd;
h.isBrowser = ld;
h.isChrome = ah;
h.isChromium = ih;
h.isConsole = ad;
var eo = h.isDesktop = Mh;
h.isEdge = dh;
h.isEdgeChromium = ph;
h.isElectron = Oh;
h.isEmbedded = rh;
var Xh = h.isFirefox = oh;
h.isIE = jd;
var Dd = h.isIOS = gd;
h.isIOS13 = zh;
h.isIPad13 = fh;
h.isIPhone13 = Ch;
h.isIPod13 = Lh;
h.isLegacyEdge = Sh;
h.isMIUI = mh;
h.isMacOs = hh;
var Vr = h.isMobile = Us, ka = h.isMobileOnly = ud;
h.isMobileSafari = nh;
h.isOpera = sh;
var Kh = h.isSafari = uh;
h.isSamsungBrowser = wh;
h.isSmartTV = Md;
var yd = h.isTablet = sd;
h.isWearable = od;
h.isWinPhone = Id;
h.isWindows = vh;
h.isYandex = xh;
h.mobileModel = Dh;
h.mobileVendor = Nh;
var Wu = h.osName = ch, ql = h.osVersion = lh;
h.parseUserAgent = qa;
h.setUserAgent = Wv;
h.useDeviceData = Nd;
h.useDeviceSelectors = Wh;
h.useMobileOrientation = Fh;
h.withOrientationChange = Bh;
const qh = "_message_1n8va_9", em = "_title_1n8va_39", tm = "_subtitle_1n8va_48", rm = "_errorCode_1n8va_58", nm = "_button_1n8va_69", im = "_done_1n8va_73", Qr = {
  "process-message": "_process-message_1n8va_1",
  message: qh,
  "info-message": "_info-message_1n8va_18",
  "text-container": "_text-container_1n8va_27",
  title: em,
  subtitle: tm,
  errorCode: rm,
  button: nm,
  done: im
};
function Mm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 80, height: t || 80, viewBox: "0 0 86 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("ellipse", { cx: "43", cy: "42", rx: "40", ry: "40", transform: "rotate(90 43 42)", stroke: r || "#FF0000", strokeWidth: "3" }),
    /* @__PURE__ */ a.jsx("path", { d: "M57 28L29 56M29 28L57 56", stroke: r || "#FF0000", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
}
function am(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: t || 24, height: t || 24, fill: r || "rgba(0,0,0,0.6)", children: /* @__PURE__ */ a.jsx("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }) });
}
function om(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t ? t * 3 : 39, height: t || 13, viewBox: "0 0 39 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("path", { d: "M5.88952 5.98264C6.70681 5.48369 7.28459 4.49575 7.28459 3.40906C7.28459 1.34699 5.65607 0 3.60916 0C1.56225 0 0 1.34743 0 3.67543V5.42175H1.49815V3.675C1.49815 2.27819 2.44624 1.49642 3.61046 1.49642C4.77468 1.49642 5.60583 2.29465 5.60583 3.40906C5.60583 4.52347 4.70798 5.42132 3.54376 5.42132H1.49815V9.21326H2.995V6.75186H3.57711C5.04061 6.75186 6.00516 7.88272 6.03851 9.21326H7.60163C7.57391 7.89658 6.94373 6.56778 5.89082 5.98264", fill: r || "#8C8C8C" }),
    /* @__PURE__ */ a.jsx("path", { d: "M37.5857 2.6262V3.57429C37.1863 2.97573 36.4877 2.57812 35.4902 2.57812C33.6608 2.57812 32.2969 4.04163 32.2969 5.92092C32.2969 7.78332 33.6608 9.26371 35.4902 9.26371C36.4379 9.26371 37.1201 8.88127 37.5857 8.29916V9.21391H38.9994V2.6262H37.5857ZM35.6566 7.83183C34.592 7.83183 33.8271 7.00025 33.8271 5.91919C33.8271 4.83813 34.592 4.00654 35.6566 4.00654C36.7212 4.00654 37.5025 4.83813 37.5025 5.91919C37.5025 7.00025 36.7229 7.83183 35.6566 7.83183Z", fill: r || "#8C8C8C" }),
    /* @__PURE__ */ a.jsx("path", { d: "M27.5078 6.0384C27.5078 7.33559 26.8426 7.81808 25.9945 7.81808C25.1465 7.81808 24.4812 7.33559 24.4812 6.0384V2.62891H22.9844V5.9717C22.9844 8.16717 24.1152 9.26339 25.9945 9.26339C27.8738 9.26339 29.0047 8.16587 29.0047 5.9717V2.62891H27.5078V6.0384Z", fill: r || "#8C8C8C" }),
    /* @__PURE__ */ a.jsx("path", { d: "M11.2922 2.57812C9.44578 2.57812 8.01562 4.09143 8.01562 5.93781C8.01562 7.78419 9.44491 9.26371 11.342 9.26371C12.4893 9.26371 13.3209 8.86481 14.003 8.14974L13.1879 7.18519C12.7388 7.58409 12.1735 7.86691 11.3753 7.86691C10.5771 7.86691 9.82865 7.46758 9.59693 6.60264H14.5184C14.578 6.34086 14.6059 6.07286 14.6016 5.80441C14.6016 3.94201 13.1381 2.57812 11.2922 2.57812ZM9.51248 5.42197C9.71214 4.55574 10.4437 3.97536 11.3749 3.97536C12.3061 3.97536 12.938 4.54058 13.1212 5.42197H9.51248Z", fill: r || "#8C8C8C" }),
    /* @__PURE__ */ a.jsx("path", { d: "M31.4988 0.0664062H30.002V9.2134H31.4988V0.0664062Z", fill: r || "#8C8C8C" }),
    /* @__PURE__ */ a.jsx("path", { d: "M20.572 3.57429C20.2394 3.00864 19.4745 2.57812 18.4766 2.57812C16.7302 2.57812 15.2832 4.04163 15.2832 5.92092C15.2832 7.78332 16.7302 9.21261 18.4766 9.21261C19.4247 9.21261 20.0232 8.92978 20.4888 8.34637V8.94537C20.4888 10.2426 19.5741 10.7082 18.6927 10.7082C17.8113 10.7082 17.1127 10.275 16.9797 9.32782H15.5162C15.5829 10.991 16.913 12.0565 18.6927 12.0565C20.4724 12.0565 21.9844 11.0421 21.9844 8.84662V2.6262H20.572V3.57429ZM18.6429 7.78202C17.5783 7.78202 16.8134 7.00025 16.8134 5.91962C16.8134 4.839 17.5783 4.00698 18.6429 4.00698C19.7075 4.00698 20.4888 4.83856 20.4888 5.91962C20.4888 7.00068 19.7071 7.78202 18.6429 7.78202Z", fill: r || "#8C8C8C" })
  ] });
}
function um(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsx("svg", { width: t || 30, height: t || 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ a.jsxs("g", { opacity: "0.9", children: [
    /* @__PURE__ */ a.jsx("rect", { x: "14", y: "4", width: "2", height: "22", rx: "1", fill: r || "white" }),
    /* @__PURE__ */ a.jsx("path", { d: "M8.698 15 L1 5.762 1 24.238 Z", stroke: r || "white", strokeWidth: "2" }),
    /* @__PURE__ */ a.jsx("path", { d: "M21.302 15 L29 5.762 29 24.238 Z", fill: r || "white", stroke: r || "white", strokeWidth: "2" })
  ] }) });
}
function sm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsx("svg", { width: t || 30, height: t || 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ a.jsxs("g", { opacity: "0.9", children: [
    /* @__PURE__ */ a.jsx("rect", { x: "14", y: "4", width: "2", height: "22", rx: "1", fill: r || "white" }),
    /* @__PURE__ */ a.jsx("path", { d: "M21.302 15 L29 5.762 29 24.238 Z", stroke: r || "white", strokeWidth: "2" }),
    /* @__PURE__ */ a.jsx("path", { d: "M8.698 15 L1 5.762 1 24.238 Z", fill: r || "white", stroke: r || "white", strokeWidth: "2" })
  ] }) });
}
function lm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 80, height: t || 80, viewBox: "0 0 86 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("ellipse", { cx: "43", cy: "42", rx: "40", ry: "40", transform: "rotate(90 43 42)", stroke: r || "#E93C3C", strokeWidth: "3" }),
    /* @__PURE__ */ a.jsx("path", { d: "M41.213 32.6666H45.6663C46.3736 32.6666 47.0519 32.9476 47.552 33.4477C48.0521 33.9478 48.333 34.626 48.333 35.3333V39.7866L49.6663 41.12L57.6663 35.3333V48.6666M48.333 47.3333V48.6666C48.333 49.3739 48.0521 50.0521 47.552 50.5522C47.0519 51.0523 46.3736 51.3333 45.6663 51.3333H30.9997C30.2924 51.3333 29.6142 51.0523 29.1141 50.5522C28.614 50.0521 28.333 49.3739 28.333 48.6666V35.3333C28.333 34.626 28.614 33.9478 29.1141 33.4477C29.6142 32.9476 30.2924 32.6666 30.9997 32.6666H33.6663L48.333 47.3333Z", stroke: r || "#E93C3C", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ a.jsx("path", { d: "M28.333 27.3334L57.6663 56.6667", stroke: r || "#E93C3C", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
}
function cm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 80, height: t || 80, viewBox: "0 0 86 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("ellipse", { cx: "43", cy: "42", rx: "40", ry: "40", transform: "rotate(90 43 42)", stroke: r || "#5DA600", strokeWidth: "3" }),
    /* @__PURE__ */ a.jsx("path", { d: "M66 30L40.5069 54L28 42.2256", stroke: r || "#5DA600", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
}
function Im(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 22, height: t || 22, viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsxs("g", { clipPath: "url(#clip0_21_211)", children: [
      /* @__PURE__ */ a.jsx("path", { d: "M16.1697 5.75397L16.2882 6.08594H16.6406H19.5625C20.236 6.08594 20.7812 6.63122 20.7812 7.30469V17.1016C20.7812 17.775 20.236 18.3203 19.5625 18.3203H4.4375C3.76403 18.3203 3.21875 17.775 3.21875 17.1016V7.30469C3.21875 6.63122 3.76403 6.08594 4.4375 6.08594H7.35938H7.71147L7.83013 5.75443L8.52837 3.80365L8.52891 3.80215C8.55435 3.73034 8.6245 3.67969 8.7043 3.67969L15.2957 3.67969L15.2961 3.67969C15.3351 3.67965 15.373 3.69163 15.4049 3.714C15.4366 3.73627 15.4607 3.76776 15.474 3.80419C15.474 3.80433 15.4741 3.80448 15.4741 3.80463L16.1697 5.75397ZM8.0625 11.9453C8.0625 14.1207 9.82464 15.8828 12 15.8828C14.1754 15.8828 15.9375 14.1207 15.9375 11.9453C15.9375 9.76995 14.1754 8.00781 12 8.00781C9.82464 8.00781 8.0625 9.76995 8.0625 11.9453Z", stroke: r || "#211236" }),
      /* @__PURE__ */ a.jsx("circle", { cx: "18", cy: "9", r: "1", fill: r || "#211236" })
    ] }),
    /* @__PURE__ */ a.jsx("defs", { children: /* @__PURE__ */ a.jsx("clipPath", { id: "clip0_21_211", children: /* @__PURE__ */ a.jsx("rect", { width: "22", height: "22", fill: "white" }) }) })
  ] });
}
function gm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 22, height: t || 22, viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsxs("g", { clipPath: "url(#clip0_21_218)", children: [
      /* @__PURE__ */ a.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.782 1.0924C21 1.52022 21 2.08025 21 3.20033L21 18.8C21 19.9201 21 20.4802 20.782 20.908C20.5902 21.2843 20.2843 21.5903 19.9079 21.782C19.4801 22 18.9201 22 17.8 22H12.2C11.0799 22 10.5198 22 10.092 21.782C9.71569 21.5903 9.40973 21.2843 9.21799 20.908C9 20.4802 9 19.9201 9 18.8V3.20012C9 2.07998 9 1.51991 9.218 1.09208C9.40975 0.715752 9.71573 0.409789 10.0921 0.218047C10.5199 6.59147e-05 11.08 8.49657e-05 12.2001 0.000123068H12.2001L17.8001 0.000319782C18.9202 0.00035892 19.4802 0.000378489 19.908 0.218371C20.2843 0.410123 20.5903 0.716083 20.782 1.0924ZM10.109 1.54601C10 1.75992 10 2.03995 10 2.6V19.4C10 19.9601 10 20.2401 10.109 20.454C10.2049 20.6422 10.3578 20.7951 10.546 20.891C10.7599 21 11.0399 21 11.6 21H18.4C18.9601 21 19.2401 21 19.454 20.891C19.6422 20.7951 19.7951 20.6422 19.891 20.454C20 20.2401 20 19.9601 20 19.4V2.6C20 2.03995 20 1.75992 19.891 1.54601C19.7951 1.35785 19.6422 1.20487 19.454 1.10899C19.2401 1 18.9601 1 18.4 1H11.6C11.0399 1 10.7599 1 10.546 1.10899C10.3578 1.20487 10.2049 1.35785 10.109 1.54601Z", fill: r || "#211236" }),
      /* @__PURE__ */ a.jsx("circle", { cx: "15", cy: "19", r: "1", fill: r || "#211236" }),
      /* @__PURE__ */ a.jsx("path", { d: "M12 1H18C18 1.55228 17.5523 2 17 2H13C12.4477 2 12 1.55228 12 1Z", fill: r || "#211236" }),
      /* @__PURE__ */ a.jsx("path", { d: "M0 9.75H6V10.75H0V9.75Z", fill: r || "#211236" }),
      /* @__PURE__ */ a.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.83358 10.9314C7.199 10.5452 7.19835 9.94063 6.83211 9.55524L4.56028 7.16458C4.36668 6.96085 4.04324 6.95673 3.84451 7.15546C3.65282 7.34715 3.64888 7.6567 3.83562 7.85321L5.45448 9.55675C5.82072 9.94215 5.82137 10.5467 5.45596 10.9329L3.83418 12.6469C3.64815 12.8435 3.65242 13.1524 3.8438 13.3438C4.04282 13.5428 4.36683 13.5383 4.56027 13.3339L6.83358 10.9314Z", fill: r || "#211236" })
    ] }),
    /* @__PURE__ */ a.jsx("defs", { children: /* @__PURE__ */ a.jsx("clipPath", { id: "clip0_21_218", children: /* @__PURE__ */ a.jsx("rect", { width: "22", height: "22", fill: "white" }) }) })
  ] });
}
function jm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 22, height: t || 22, viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsxs("g", { clipPath: "url(#clip0_21_213)", children: [
      /* @__PURE__ */ a.jsx("path", { d: "M11.685 10.2487H15.4872V11.0062H11.684L11.685 10.2487Z", fill: r || "#211236" }),
      /* @__PURE__ */ a.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.3862 14.1034L9.83531 12.3636L8.00871 11.9563L6.69453 13.5517L5.37938 11.9563L3.54894 12.3636L3 14.1034V7H10.39L10.3862 14.1034ZM8.00679 8.11942V10.1613C8.00676 10.3969 7.93334 10.6274 7.79537 10.8252C7.6574 11.023 7.46075 11.1796 7.22905 11.2763C7.05875 11.348 6.87387 11.3851 6.68683 11.385C6.4998 11.3851 6.31492 11.348 6.14463 11.2763C5.91292 11.1796 5.71627 11.023 5.5783 10.8252C5.44033 10.6274 5.36691 10.3969 5.36688 10.1613V8.11942H8.00679Z", fill: r || "#211236" }),
      /* @__PURE__ */ a.jsx("path", { d: "M19 16H11.684V15.2424H19V16Z", fill: r || "#211236" }),
      /* @__PURE__ */ a.jsx("path", { d: "M19 13.5045H11.684V12.7469H19V13.5045Z", fill: r || "#211236" }),
      /* @__PURE__ */ a.jsx("path", { d: "M1.31939 4.66349C1.45107 4.5964 1.62491 4.55031 1.92748 4.52559C2.2359 4.50039 2.63205 4.50001 3.20034 4.50001L18.8 4.50004C19.3683 4.50004 19.7645 4.50043 20.0729 4.52563C20.3755 4.55035 20.5493 4.59644 20.681 4.66353C20.9632 4.80735 21.1927 5.03682 21.3365 5.31906C21.4036 5.45074 21.4497 5.62458 21.4744 5.92716C21.4996 6.23558 21.5 6.63174 21.5 7.20004L21.5 15.8C21.5 16.3683 21.4996 16.7645 21.4744 17.0729C21.4497 17.3755 21.4036 17.5493 21.3365 17.681C21.1927 17.9632 20.9632 18.1927 20.681 18.3365C20.5493 18.4036 20.3755 18.4497 20.0729 18.4744C19.7645 18.4996 19.3683 18.5 18.8 18.5L3.20009 18.5C2.63177 18.5 2.23561 18.4996 1.92718 18.4744C1.62459 18.4497 1.45074 18.4036 1.31906 18.3365C1.03681 18.1927 0.80734 17.9632 0.663533 17.681C0.596441 17.5493 0.550357 17.3754 0.525643 17.0728C0.500451 16.7644 0.500073 16.3682 0.500089 15.7999L0.500329 7.19993C0.500345 6.63164 0.500745 6.23549 0.525952 5.92708C0.550682 5.62451 0.596772 5.45067 0.663867 5.31899C0.80768 5.03676 1.03715 4.80729 1.31939 4.66349Z", stroke: r || "#211236" })
    ] }),
    /* @__PURE__ */ a.jsx("defs", { children: /* @__PURE__ */ a.jsx("clipPath", { id: "clip0_21_213", children: /* @__PURE__ */ a.jsx("rect", { width: "22", height: "22", fill: "white" }) }) })
  ] });
}
function Nm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 80, height: t || 80, viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("g", { children: /* @__PURE__ */ a.jsx("circle", { cx: "40", cy: "40", r: "40", fill: "#1B101F", fillOpacity: "0.5" }) }),
    /* @__PURE__ */ a.jsxs("g", { opacity: "0.8", children: [
      /* @__PURE__ */ a.jsx("circle", { cx: "40", cy: "40", r: "23.5", stroke: r || "white" }),
      /* @__PURE__ */ a.jsx("circle", { cx: "40", cy: "40", r: "1", fill: r || "white" })
    ] })
  ] });
}
function Dm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsx("svg", { width: t || 80, height: t || 80, viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ a.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80ZM64.0282 29.0922C64.6314 28.5243 64.66 27.575 64.0922 26.9718C63.5243 26.3686 62.575 26.34 61.9718 26.9078L37.5069 49.9399L26.0282 39.1334C25.425 38.5656 24.4757 38.5942 23.9079 39.1974C23.34 39.8006 23.3686 40.7499 23.9718 41.3177L36.4787 53.0922C37.0563 53.6359 37.9575 53.6359 38.5351 53.0922L64.0282 29.0922Z", fill: r || "white" }) });
}
function ym(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 80, height: t || 80, viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("circle", { cx: "40", cy: "40", r: "40", fill: "#E95454", fillOpacity: "0.45" }),
    /* @__PURE__ */ a.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M40 67C54.9117 67 67 54.9117 67 40C67 25.0883 54.9117 13 40 13C25.0883 13 13 25.0883 13 40C13 54.9117 25.0883 67 40 67ZM40 64C53.2548 64 64 53.2548 64 40C64 26.7452 53.2548 16 40 16C26.7452 16 16 26.7452 16 40C16 53.2548 26.7452 64 40 64Z", fill: r || "white" })
  ] });
}
function Tm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 80, height: t || 80, viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("g", { children: /* @__PURE__ */ a.jsx("circle", { cx: "40", cy: "40", r: "40", fill: "#1B101F", fillOpacity: "0.5" }) }),
    /* @__PURE__ */ a.jsx("g", { opacity: "0.8", children: /* @__PURE__ */ a.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M40 67C54.9117 67 67 54.9117 67 40C67 25.0883 54.9117 13 40 13C25.0883 13 13 25.0883 13 40C13 54.9117 25.0883 67 40 67ZM40 64C53.2548 64 64 53.2548 64 40C64 26.7452 53.2548 16 40 16C26.7452 16 16 26.7452 16 40C16 53.2548 26.7452 64 40 64Z", fill: r || "white" }) })
  ] });
}
function Am(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 80, height: t || 80, viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("g", { children: /* @__PURE__ */ a.jsx("circle", { cx: "40", cy: "40", r: "40", fill: "#1B101F", fillOpacity: "0.5" }) }),
    /* @__PURE__ */ a.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 25.2308C16 24.551 16.5373 24 17.2 24H62.8C63.4627 24 64 24.551 64 25.2308V54.7692C64 55.449 63.4627 56 62.8 56H17.2C16.5373 56 16 55.449 16 54.7692V25.2308ZM21.4 30.1538C21.4 29.814 21.6686 29.5385 22 29.5385H32.8C33.1314 29.5385 33.4 29.814 33.4 30.1538V43.6923C33.4 44.0322 33.1314 44.3077 32.8 44.3077H22C21.6686 44.3077 21.4 44.0322 21.4 43.6923V30.1538ZM39.4 29.5385C39.0686 29.5385 38.8 29.814 38.8 30.1538V30.7692C38.8 31.1091 39.0686 31.3846 39.4 31.3846H58C58.3314 31.3846 58.6 31.1091 58.6 30.7692V30.1538C58.6 29.814 58.3314 29.5385 58 29.5385H39.4ZM39.4 35.0769C39.0686 35.0769 38.8 35.3524 38.8 35.6923V36.3077C38.8 36.6476 39.0686 36.9231 39.4 36.9231H49.6C49.9314 36.9231 50.2 36.6476 50.2 36.3077V35.6923C50.2 35.3524 49.9314 35.0769 49.6 35.0769H39.4ZM38.8 41.2308C38.8 40.8909 39.0686 40.6154 39.4 40.6154H53.8C54.1314 40.6154 54.4 40.8909 54.4 41.2308V41.8462C54.4 42.186 54.1314 42.4615 53.8 42.4615H39.4C39.0686 42.4615 38.8 42.186 38.8 41.8462V41.2308ZM22 49.8462C21.6686 49.8462 21.4 50.1217 21.4 50.4615V51.0769C21.4 51.4168 21.6686 51.6923 22 51.6923H32.2C32.5314 51.6923 32.8 51.4168 32.8 51.0769V50.4615C32.8 50.1217 32.5314 49.8462 32.2 49.8462H22Z", fill: r || "white" })
  ] });
}
function dm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 80, height: t || 80, viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("circle", { cx: "40", cy: "40", r: "37", stroke: r || "#FF5E5E", strokeWidth: "3" }),
    /* @__PURE__ */ a.jsx("path", { d: "M40.213 30.6667H44.6663C45.3736 30.6667 46.0519 30.9476 46.552 31.4477C47.0521 31.9478 47.333 32.6261 47.333 33.3334V37.7867L48.6663 38.12L56.6663 33.3334V46.6667M47.333 45.3334V46.6667C47.333 47.3739 47.0521 48.0522 46.552 48.5523C46.0519 49.0524 45.3736 49.3334 44.6663 49.3334H29.9997C29.2924 49.3334 28.6142 49.0524 28.1141 48.5523C27.614 48.0522 27.333 47.3739 27.333 46.6667V33.3334C27.333 32.6261 27.614 31.9478 28.1141 31.4477C28.6142 30.9476 29.2924 30.6667 29.9997 30.6667H32.6663L47.333 45.3334Z", stroke: r || "#FF5E5E", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ a.jsx("path", { d: "M27.333 25.3333L56.6663 54.6666", stroke: r || "#FF5E5E", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
}
function xm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 80, height: t || 80, viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("g", { children: /* @__PURE__ */ a.jsx("circle", { cx: "40", cy: "40", r: "40", fill: "#1B101F", fillOpacity: "0.5" }) }),
    /* @__PURE__ */ a.jsx("path", { d: "M47.333 43L56.6663 46.6666V33.3333L47.333 37", stroke: r || "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ a.jsx("path", { d: "M47.333 43V46.6667C47.333 48.1394 46.1391 49.3334 44.6663 49.3334H29.9997C28.5269 49.3334 27.333 48.1394 27.333 46.6667V33.3334C27.333 31.8606 28.5269 30.6667 29.9997 30.6667H44.6663C46.1391 30.6667 47.333 31.8606 47.333 33.3334V43.5", stroke: r || "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
}
function Em(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 60, height: t || 60, viewBox: "0 0 60 60", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("g", { opacity: "0.6", children: /* @__PURE__ */ a.jsx("circle", { cx: "30", cy: "30", r: "29.5", stroke: r || "white" }) }),
    /* @__PURE__ */ a.jsx("circle", { cx: "30", cy: "30", r: "21", fill: r || "white" })
  ] });
}
function zm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsx("svg", { width: t || 46, height: t || 46, viewBox: "0 0 46 46", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ a.jsx("path", { d: "M45 34V41C45 43.2091 43.2091 45 41 45H34M45 12V5C45 2.79086 43.2091 1 41 1H34M12 1H5C2.79086 1 1 2.79086 1 5V12M1 34V41C1 43.2091 2.79086 45 5 45H12", stroke: r || "white", strokeWidth: "1.5" }) });
}
function fm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: t || 24, height: t || 24, viewBox: "0 0 24 24", fill: r || "rgba(0,0,0,0.6)", children: /* @__PURE__ */ a.jsx("path", { d: "M12.29,5.21l1.5,1.5a1,1,0,0,0,1.42,0,1,1,0,0,0,.13-1.21H19a1,1,0,0,0,0-2H15.34a1,1,0,0,0-.13-1.21,1,1,0,0,0-1.42,0l-1.5,1.5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76A1,1,0,0,0,12.29,5.21ZM22.92,9.12a1,1,0,0,0-.21-.33l-1.5-1.5a1,1,0,0,0-1.42,0,1,1,0,0,0-.13,1.21H16a1,1,0,0,0,0,2h3.66a1,1,0,0,0,.13,1.21,1,1,0,0,0,1.42,0l1.5-1.5a1,1,0,0,0,.21-.33A1,1,0,0,0,22.92,9.12ZM11,10a4,4,0,1,0,4,4A4,4,0,0,0,11,10Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,11,16Zm9-3a1,1,0,0,0-1,1v5a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1H6a1,1,0,0,0,1-.69l.54-1.62A1,1,0,0,1,8.44,7H10a1,1,0,0,0,0-2H8.44A3,3,0,0,0,5.59,7.06L5.28,8H4a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V14A1,1,0,0,0,20,13Z" }) });
}
function Cm(e) {
  let {
    color: t
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: "91", height: "16", viewBox: "0 0 91 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("path", { d: "M0.793307 12V4.72727H3.52058C4.07929 4.72727 4.54804 4.83144 4.92683 5.03977C5.30799 5.24811 5.59563 5.53456 5.78976 5.89915C5.98625 6.26136 6.0845 6.6733 6.0845 7.13494C6.0845 7.60133 5.98625 8.01562 5.78976 8.37784C5.59326 8.74006 5.30325 9.02533 4.91973 9.23366C4.5362 9.43963 4.0639 9.54261 3.50282 9.54261H1.6953V8.45952H3.32527C3.65197 8.45952 3.91949 8.4027 4.12782 8.28906C4.33616 8.17543 4.49004 8.01918 4.58947 7.82031C4.69127 7.62145 4.74217 7.39299 4.74217 7.13494C4.74217 6.87689 4.69127 6.64962 4.58947 6.45312C4.49004 6.25663 4.33497 6.10393 4.12427 5.99503C3.91594 5.88376 3.64724 5.82812 3.31816 5.82812H2.11078V12H0.793307ZM9.37317 12.1065C8.8405 12.1065 8.37885 11.9893 7.98823 11.755C7.5976 11.5206 7.29457 11.1927 7.07914 10.7713C6.86607 10.3499 6.75954 9.85748 6.75954 9.29403C6.75954 8.73059 6.86607 8.23698 7.07914 7.81321C7.29457 7.38944 7.5976 7.06037 7.98823 6.82599C8.37885 6.59162 8.8405 6.47443 9.37317 6.47443C9.90584 6.47443 10.3675 6.59162 10.7581 6.82599C11.1487 7.06037 11.4506 7.38944 11.6637 7.81321C11.8791 8.23698 11.9868 8.73059 11.9868 9.29403C11.9868 9.85748 11.8791 10.3499 11.6637 10.7713C11.4506 11.1927 11.1487 11.5206 10.7581 11.755C10.3675 11.9893 9.90584 12.1065 9.37317 12.1065ZM9.38027 11.0767C9.6691 11.0767 9.91058 10.9974 10.1047 10.8388C10.2988 10.6778 10.4432 10.4624 10.5379 10.1925C10.635 9.92259 10.6835 9.62192 10.6835 9.29048C10.6835 8.95668 10.635 8.65483 10.5379 8.38494C10.4432 8.11269 10.2988 7.89607 10.1047 7.73509C9.91058 7.5741 9.6691 7.49361 9.38027 7.49361C9.08435 7.49361 8.83813 7.5741 8.64164 7.73509C8.44751 7.89607 8.30191 8.11269 8.20485 8.38494C8.11015 8.65483 8.0628 8.95668 8.0628 9.29048C8.0628 9.62192 8.11015 9.92259 8.20485 10.1925C8.30191 10.4624 8.44751 10.6778 8.64164 10.8388C8.83813 10.9974 9.08435 11.0767 9.38027 11.0767ZM13.9474 12L12.4062 6.54545H13.7165L14.6753 10.3807H14.7251L15.7052 6.54545H17.0013L17.9814 10.3594H18.0347L18.9793 6.54545H20.2932L18.7485 12H17.4097L16.387 8.31392H16.3124L15.2897 12H13.9474ZM23.3493 12.1065C22.8024 12.1065 22.3301 11.9929 21.9324 11.7656C21.537 11.536 21.2328 11.2116 21.0198 10.7926C20.8067 10.3712 20.7002 9.87524 20.7002 9.30469C20.7002 8.74361 20.8067 8.25118 21.0198 7.82741C21.2352 7.40128 21.5359 7.06984 21.9218 6.8331C22.3076 6.59399 22.761 6.47443 23.2818 6.47443C23.618 6.47443 23.9352 6.52888 24.2335 6.63778C24.5342 6.74432 24.7994 6.91004 25.029 7.13494C25.261 7.35985 25.4433 7.64631 25.5759 7.99432C25.7084 8.33996 25.7747 8.75189 25.7747 9.23011V9.62429H21.3039V8.75781H24.5425C24.5401 8.5116 24.4869 8.29261 24.3827 8.10085C24.2785 7.90672 24.1329 7.75402 23.9459 7.64276C23.7612 7.53149 23.5458 7.47585 23.2996 7.47585C23.0368 7.47585 22.806 7.53977 22.6071 7.66761C22.4083 7.79309 22.2532 7.95881 22.1419 8.16477C22.033 8.36837 21.9774 8.59209 21.975 8.83594V9.59233C21.975 9.90956 22.033 10.1818 22.149 10.4091C22.265 10.634 22.4272 10.8068 22.6355 10.9276C22.8439 11.0459 23.0877 11.1051 23.3671 11.1051C23.5541 11.1051 23.7234 11.0791 23.8749 11.027C24.0264 10.9725 24.1578 10.8932 24.2691 10.7891C24.3803 10.6849 24.4644 10.5559 24.5212 10.402L25.7215 10.5369C25.6457 10.8542 25.5013 11.1312 25.2882 11.3679C25.0775 11.6023 24.8076 11.7846 24.4786 11.9148C24.1495 12.0426 23.7731 12.1065 23.3493 12.1065ZM26.7623 12V6.54545H28.0087V7.45455H28.0655C28.165 7.13968 28.3354 6.89702 28.5769 6.72656C28.8207 6.55374 29.0989 6.46733 29.4114 6.46733C29.4824 6.46733 29.5617 6.47088 29.6493 6.47798C29.7393 6.48272 29.8139 6.491 29.8731 6.50284V7.68537C29.8186 7.66643 29.7322 7.64986 29.6138 7.63565C29.4978 7.61908 29.3854 7.6108 29.2765 7.6108C29.0421 7.6108 28.8314 7.66169 28.6444 7.76349C28.4597 7.86293 28.3141 8.00142 28.2076 8.17898C28.101 8.35653 28.0478 8.56132 28.0478 8.79332V12H26.7623ZM32.8173 12.1065C32.2704 12.1065 31.7981 11.9929 31.4004 11.7656C31.005 11.536 30.7008 11.2116 30.4877 10.7926C30.2747 10.3712 30.1681 9.87524 30.1681 9.30469C30.1681 8.74361 30.2747 8.25118 30.4877 7.82741C30.7032 7.40128 31.0038 7.06984 31.3897 6.8331C31.7756 6.59399 32.229 6.47443 32.7498 6.47443C33.086 6.47443 33.4032 6.52888 33.7015 6.63778C34.0022 6.74432 34.2673 6.91004 34.497 7.13494C34.729 7.35985 34.9113 7.64631 35.0438 7.99432C35.1764 8.33996 35.2427 8.75189 35.2427 9.23011V9.62429H30.7718V8.75781H34.0105C34.0081 8.5116 33.9548 8.29261 33.8507 8.10085C33.7465 7.90672 33.6009 7.75402 33.4139 7.64276C33.2292 7.53149 33.0138 7.47585 32.7676 7.47585C32.5048 7.47585 32.274 7.53977 32.0751 7.66761C31.8762 7.79309 31.7212 7.95881 31.6099 8.16477C31.501 8.36837 31.4454 8.59209 31.443 8.83594V9.59233C31.443 9.90956 31.501 10.1818 31.617 10.4091C31.733 10.634 31.8952 10.8068 32.1035 10.9276C32.3118 11.0459 32.5557 11.1051 32.835 11.1051C33.0221 11.1051 33.1913 11.0791 33.3428 11.027C33.4944 10.9725 33.6258 10.8932 33.737 10.7891C33.8483 10.6849 33.9323 10.5559 33.9892 10.402L35.1894 10.5369C35.1137 10.8542 34.9693 11.1312 34.7562 11.3679C34.5455 11.6023 34.2756 11.7846 33.9465 11.9148C33.6175 12.0426 33.241 12.1065 32.8173 12.1065ZM38.2544 12.0959C37.8259 12.0959 37.4424 11.9858 37.1038 11.7656C36.7653 11.5455 36.4978 11.2259 36.3013 10.8068C36.1048 10.3878 36.0065 9.87879 36.0065 9.27983C36.0065 8.67377 36.106 8.16241 36.3048 7.74574C36.506 7.3267 36.7771 7.01065 37.118 6.79759C37.4589 6.58215 37.8389 6.47443 38.2579 6.47443C38.5775 6.47443 38.8403 6.52888 39.0463 6.63778C39.2523 6.74432 39.4156 6.87334 39.5363 7.02486C39.6571 7.17401 39.7506 7.31487 39.8169 7.44744H39.8702V4.72727H41.1592V12H39.895V11.1406H39.8169C39.7506 11.2732 39.6547 11.4141 39.5292 11.5632C39.4038 11.71 39.2381 11.8355 39.0321 11.9396C38.8261 12.0438 38.5669 12.0959 38.2544 12.0959ZM38.6131 11.0412C38.8853 11.0412 39.1173 10.9678 39.3091 10.821C39.5008 10.6719 39.6464 10.4647 39.7459 10.1996C39.8453 9.93442 39.895 9.62547 39.895 9.27273C39.895 8.91998 39.8453 8.6134 39.7459 8.35298C39.6488 8.09257 39.5044 7.89015 39.3126 7.74574C39.1232 7.60133 38.89 7.52912 38.6131 7.52912C38.3266 7.52912 38.0875 7.60369 37.8957 7.75284C37.704 7.90199 37.5595 8.10795 37.4625 8.37074C37.3654 8.63352 37.3169 8.93419 37.3169 9.27273C37.3169 9.61364 37.3654 9.91785 37.4625 10.1854C37.5619 10.4505 37.7075 10.66 37.8993 10.8139C38.0934 10.9654 38.3313 11.0412 38.6131 11.0412ZM44.8664 12V4.72727H46.1519V7.44744H46.2051C46.2714 7.31487 46.3649 7.17401 46.4857 7.02486C46.6064 6.87334 46.7698 6.74432 46.9757 6.63778C47.1817 6.52888 47.4445 6.47443 47.7641 6.47443C48.1855 6.47443 48.5655 6.58215 48.904 6.79759C49.2449 7.01065 49.5148 7.3267 49.7137 7.74574C49.9149 8.16241 50.0155 8.67377 50.0155 9.27983C50.0155 9.87879 49.9173 10.3878 49.7208 10.8068C49.5243 11.2259 49.2567 11.5455 48.9182 11.7656C48.5797 11.9858 48.1961 12.0959 47.7676 12.0959C47.4551 12.0959 47.1959 12.0438 46.9899 11.9396C46.784 11.8355 46.6182 11.71 46.4928 11.5632C46.3697 11.4141 46.2738 11.2732 46.2051 11.1406H46.1306V12H44.8664ZM46.127 9.27273C46.127 9.62547 46.1767 9.93442 46.2762 10.1996C46.378 10.4647 46.5236 10.6719 46.7129 10.821C46.9047 10.9678 47.1367 11.0412 47.409 11.0412C47.6931 11.0412 47.931 10.9654 48.1227 10.8139C48.3145 10.66 48.4589 10.4505 48.556 10.1854C48.6554 9.91785 48.7051 9.61364 48.7051 9.27273C48.7051 8.93419 48.6566 8.63352 48.5595 8.37074C48.4625 8.10795 48.3181 7.90199 48.1263 7.75284C47.9345 7.60369 47.6954 7.52912 47.409 7.52912C47.1343 7.52912 46.9012 7.60133 46.7094 7.74574C46.5176 7.89015 46.372 8.09257 46.2726 8.35298C46.1755 8.6134 46.127 8.91998 46.127 9.27273ZM51.6218 14.0455C51.4466 14.0455 51.2845 14.0313 51.1353 14.0028C50.9885 13.9768 50.8713 13.946 50.7838 13.9105L51.082 12.9091C51.2691 12.9635 51.436 12.9896 51.5828 12.9872C51.7295 12.9848 51.8586 12.9387 51.9698 12.8487C52.0835 12.7611 52.1793 12.6143 52.2575 12.4084L52.3676 12.1136L50.3896 6.54545H51.7532L53.0103 10.6648H53.0671L54.3278 6.54545H55.695L53.511 12.6605C53.4092 12.9493 53.2743 13.1967 53.1062 13.4027C52.9381 13.611 52.7321 13.7696 52.4883 13.8786C52.2468 13.9898 51.958 14.0455 51.6218 14.0455Z", fill: t }),
    /* @__PURE__ */ a.jsx("path", { d: "M62.9834 9.36204C63.675 8.93985 64.1639 8.1039 64.1639 7.18439C64.1639 5.43957 62.7859 4.2998 61.0539 4.2998C59.3219 4.2998 58 5.43993 58 7.40978V8.88744H59.2677V7.40942C59.2677 6.22751 60.0699 5.566 61.055 5.566C62.0401 5.566 62.7434 6.24143 62.7434 7.18439C62.7434 8.12736 61.9837 8.88708 60.9986 8.88708H59.2677V12.0956H60.5342V10.0129H61.0268C62.2651 10.0129 63.0813 10.9698 63.1095 12.0956H64.4321C64.4087 10.9815 63.8755 9.85716 62.9845 9.36204", fill: t }),
    /* @__PURE__ */ a.jsx("path", { d: "M89.8037 6.5231V7.32533C89.4658 6.81885 88.8747 6.48242 88.0307 6.48242C86.4827 6.48242 85.3286 7.72077 85.3286 9.31094C85.3286 10.8868 86.4827 12.1395 88.0307 12.1395C88.8326 12.1395 89.4098 11.8159 89.8037 11.3233V12.0973H90.9999V6.5231H89.8037ZM88.1714 10.9279C87.2706 10.9279 86.6234 10.2242 86.6234 9.30947C86.6234 8.39473 87.2706 7.69108 88.1714 7.69108C89.0722 7.69108 89.7334 8.39473 89.7334 9.30947C89.7334 10.2242 89.0737 10.9279 88.1714 10.9279Z", fill: t }),
    /* @__PURE__ */ a.jsx("path", { d: "M81.2758 9.40791C81.2758 10.5055 80.7129 10.9138 79.9953 10.9138C79.2777 10.9138 78.7148 10.5055 78.7148 9.40791V6.52295H77.4482V9.35147C77.4482 11.2092 78.4051 12.1367 79.9953 12.1367C81.5855 12.1367 82.5424 11.2081 82.5424 9.35147V6.52295H81.2758V9.40791Z", fill: t }),
    /* @__PURE__ */ a.jsx("path", { d: "M67.5552 6.48096C65.9928 6.48096 64.7827 7.76145 64.7827 9.32377C64.7827 10.8861 65.9921 12.138 67.5973 12.138C68.5681 12.138 69.2718 11.8005 69.849 11.1954L69.1593 10.3792C68.7792 10.7168 68.301 10.9561 67.6255 10.9561C66.9501 10.9561 66.3168 10.6182 66.1207 9.88632H70.2851C70.3355 9.66481 70.3591 9.43804 70.3555 9.21089C70.3555 7.63501 69.1171 6.48096 67.5552 6.48096ZM66.0493 8.88729C66.2182 8.15432 66.8372 7.66323 67.6252 7.66323C68.4131 7.66323 68.9478 8.14149 69.1028 8.88729H66.0493Z", fill: t }),
    /* @__PURE__ */ a.jsx("path", { d: "M84.6533 4.35596H83.3867V12.0957H84.6533V4.35596Z", fill: "#8C8C8C" }),
    /* @__PURE__ */ a.jsx("path", { d: "M75.4077 7.32533C75.1263 6.84671 74.4791 6.48242 73.6347 6.48242C72.157 6.48242 70.9326 7.72077 70.9326 9.31094C70.9326 10.8868 72.157 12.0962 73.6347 12.0962C74.4369 12.0962 74.9434 11.8569 75.3374 11.3632V11.8701C75.3374 12.9677 74.5634 13.3617 73.8176 13.3617C73.0718 13.3617 72.4806 12.9952 72.3681 12.1937H71.1298C71.1862 13.601 72.3117 14.5025 73.8176 14.5025C75.3235 14.5025 76.6028 13.6442 76.6028 11.7865V6.5231H75.4077V7.32533ZM73.7754 10.8857C72.8746 10.8857 72.2274 10.2242 72.2274 9.30984C72.2274 8.39547 72.8746 7.69145 73.7754 7.69145C74.6762 7.69145 75.3374 8.3951 75.3374 9.30984C75.3374 10.2246 74.6759 10.8857 73.7754 10.8857Z", fill: t })
  ] });
}
function Lm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 86, height: t || 86, viewBox: "0 0 86 86", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("path", { d: "M33.8254 7.18383L32.7648 6.12317C33.3506 5.53738 34.3003 5.53738 34.8861 6.12317L33.8254 7.18383ZM80.0417 51.9C80.0417 52.7285 79.3701 53.4 78.5417 53.4L65.0417 53.4C64.2132 53.4 63.5417 52.7285 63.5417 51.9C63.5417 51.0716 64.2132 50.4 65.0417 50.4L77.0417 50.4V38.4C77.0417 37.5716 77.7132 36.9 78.5417 36.9C79.3701 36.9 80.0417 37.5716 80.0417 38.4L80.0417 51.9ZM14.8058 28.3248C14.22 28.9106 13.2702 28.9106 12.6845 28.3248C12.0987 27.739 12.0987 26.7893 12.6845 26.2035L14.8058 28.3248ZM34.8861 6.12317L79.6023 50.8394L77.481 52.9607L32.7648 8.24449L34.8861 6.12317ZM34.8861 8.24449L14.8058 28.3248L12.6845 26.2035L32.7648 6.12317L34.8861 8.24449Z", fill: r || "#DC4343" }),
    /* @__PURE__ */ a.jsx("path", { d: "M52.0974 78.344L53.1581 79.4047C52.5723 79.9904 51.6225 79.9904 51.0367 79.4047L52.0974 78.344ZM5.88119 33.6278C5.88119 32.7994 6.55276 32.1278 7.38119 32.1278L20.8812 32.1278C21.7096 32.1278 22.3812 32.7994 22.3812 33.6278C22.3812 34.4562 21.7096 35.1278 20.8812 35.1278L8.88119 35.1278V47.1278C8.88119 47.9562 8.20961 48.6278 7.38119 48.6278C6.55276 48.6278 5.88119 47.9562 5.88119 47.1278L5.88119 33.6278ZM71.1171 57.203C71.7029 56.6172 72.6526 56.6172 73.2384 57.203C73.8242 57.7888 73.8242 58.7385 73.2384 59.3243L71.1171 57.203ZM51.0367 79.4047L6.32053 34.6884L8.44185 32.5671L53.1581 77.2833L51.0367 79.4047ZM51.0367 77.2833L71.1171 57.203L73.2384 59.3243L53.1581 79.4047L51.0367 77.2833Z", fill: r || "#DC4343" })
  ] });
}
function Om(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t ? t * 1.4 : 920, height: t || 640, viewBox: "0 0 920 640", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("path", { d: "M520 200H800V240H520V200Z", fill: r || "white" }),
    /* @__PURE__ */ a.jsx("path", { d: "M800 300H520V340H800V300Z", fill: r || "white" }),
    /* @__PURE__ */ a.jsx("path", { d: "M520 400H800V440H520V400Z", fill: r || "white" }),
    /* @__PURE__ */ a.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M274.943 123.429L274.933 123.432C266.551 126.295 258.863 130.466 251.927 135.343C243.39 140.807 235.349 147.484 228.244 155.117C216.999 166.723 206.985 181.73 202.638 200.462C201.732 203.954 201.031 207.508 200.554 211.114C198.857 223.937 199.991 237.409 204.799 251.055C201.906 250.776 199.719 251.697 198.089 253.419C191.062 260.842 194.356 283.152 195.842 288.454C202.652 312.775 208.999 319.597 213.796 319.988C216.486 337.575 230.545 358.063 243.587 375.139C243.587 405.888 203.816 413.339 170.442 419.591C162.723 421.037 155.346 422.419 148.883 424.01C114.629 432.436 110.268 472.281 110.168 504.349C110.141 513.052 117.321 520 126.023 520H473.977C482.679 520 489.859 513.052 489.839 504.349C489.769 472.142 485.483 432.464 451.117 424.01C445.211 422.556 438.486 421.191 431.39 419.752L431.388 419.751C396.76 412.725 353.321 403.912 353.321 374.203C353.664 373.739 354.01 373.272 354.358 372.804C357.463 368.617 360.701 364.25 363.825 359.791C372.128 347.938 379.624 335.429 381.652 323.912C382.709 324.634 383.91 325.123 385.24 325.123C385.796 325.123 386.374 325.037 386.972 324.849C391.593 323.394 397.418 315.772 403.633 293.568C410.9 267.609 406.477 258.905 400.199 256.714C420.616 157.928 373.971 154.617 373.971 154.617C373.971 154.617 366.934 140.939 348.397 130.606C337.66 124.183 323.287 119 304.851 119C301.953 119 298.964 119.122 295.865 119.395C288.479 119.744 281.5 121.188 274.943 123.429ZM321.183 350.388C316.077 357.278 313.321 365.627 313.321 374.203C313.321 396.791 323.959 414.183 337.296 425.916C349.473 436.63 364.134 443.009 376.199 447.154C388.689 451.445 401.819 454.454 412.943 456.796C417.197 457.692 421.006 458.464 424.494 459.171L424.495 459.171C431.031 460.495 436.443 461.592 441.555 462.85L441.562 462.852C442.371 463.051 442.688 463.234 442.718 463.251L442.719 463.252L442.723 463.254C442.746 463.267 442.79 463.292 442.907 463.412C443.207 463.723 444.371 465.103 445.684 468.766C446.817 471.928 447.691 475.687 448.338 480H151.711C152.363 475.717 153.239 471.971 154.372 468.81C155.699 465.109 156.878 463.698 157.192 463.372L157.194 463.369C157.207 463.34 157.301 463.132 158.438 462.852L158.445 462.85C163.729 461.549 169.527 460.462 176.817 459.096L176.821 459.095C179.572 458.579 182.535 458.024 185.763 457.402C196.469 455.34 209.407 452.649 221.731 448.562C233.686 444.597 248.469 438.255 260.709 426.995C274.269 414.522 283.587 396.915 283.587 375.139C283.587 366.365 280.702 357.834 275.376 350.86C269.197 342.77 263.625 334.956 259.415 327.693C254.949 319.99 253.579 315.526 253.336 313.941C251.698 303.233 245.887 294.002 237.651 287.879C236.767 285.573 235.697 282.397 234.493 278.142C234.495 278.139 234.486 278.086 234.467 277.984L234.452 277.901C235.091 277.195 235.707 276.464 236.298 275.708C244.717 264.952 247.065 250.644 242.526 237.762C239.17 228.237 239.103 219.19 241.356 210.506C241.443 210.173 241.525 209.839 241.603 209.503C243.904 199.588 249.376 190.79 256.971 182.951C257.156 182.76 257.34 182.567 257.521 182.372C262.328 177.208 267.774 172.691 273.489 169.034C273.978 168.721 274.46 168.397 274.936 168.063C279.286 165.004 283.597 162.748 287.809 161.303L287.883 161.278C291.162 160.157 294.424 159.508 297.75 159.351C298.292 159.325 298.833 159.288 299.374 159.241C301.267 159.074 303.083 159 304.851 159C315.374 159 322.72 161.857 327.864 164.933C328.213 165.142 328.565 165.345 328.92 165.543C333.473 168.081 336.341 170.874 337.886 172.659C338.515 173.386 338.906 173.925 339.077 174.173C344.22 183.353 352.722 190.05 362.636 192.979C364.507 197.532 368.476 212.578 361.027 248.618C358.865 259.075 361.005 269.523 366.336 278.005C366.023 279.378 365.623 280.965 365.114 282.784L365.113 282.786C364.533 284.861 363.983 286.685 363.469 288.283C352.34 293.961 344.445 304.559 342.258 316.974C342.258 316.974 342.208 317.246 342.023 317.818C341.833 318.406 341.53 319.218 341.065 320.269C340.111 322.423 338.685 325.105 336.678 328.368C332.654 334.911 327.684 341.617 321.853 349.483L321.183 350.388Z", fill: r || "white" }),
    /* @__PURE__ */ a.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M80 0C35.8172 0 0 35.8172 0 80V560C0 604.183 35.8172 640 80 640H840C884.183 640 920 604.183 920 560V80C920 35.8172 884.183 0 840 0H80ZM840 40H80C57.9086 40 40 57.9086 40 80V560C40 582.091 57.9086 600 80 600H840C862.091 600 880 582.091 880 560V80C880 57.9086 862.091 40 840 40Z", fill: r || "white" })
  ] });
}
function pm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t ? t * 1.4 : 920, height: t || 640, viewBox: "0 0 920 640", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("path", { d: "M460 300H140V340H460V300Z", fill: r || "white" }),
    /* @__PURE__ */ a.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M100 0C44.7715 0 0 44.7715 0 100V540C0 595.228 44.7715 640 100 640H820C875.228 640 920 595.228 920 540V100C920 44.7715 875.229 0 820 0H100ZM820 40H100C66.8629 40 40 66.8629 40 100V140H880V100C880 66.8629 853.137 40 820 40ZM40 540V240H880V540C880 573.137 853.137 600 820 600H100C66.8629 600 40 573.137 40 540Z", fill: r || "white" })
  ] });
}
function Sm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsx("svg", { width: t || 32, height: t || 32, viewBox: "0 0 32 32", fill: r || "white", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ a.jsx("path", { d: "M22,9a1,1,0,0,0,0,1.42l4.6,4.6H3.06a1,1,0,1,0,0,2H26.58L22,21.59A1,1,0,0,0,22,23a1,1,0,0,0,1.41,0l6.36-6.36a.88.88,0,0,0,0-1.27L23.42,9A1,1,0,0,0,22,9Z" }) });
}
function vm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 86, height: t || 86, viewBox: "0 0 86 86", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("ellipse", { cx: "43", cy: "43", rx: "40", ry: "40", transform: "rotate(90 43 43)", stroke: "#FCB937", strokeWidth: "3" }),
    /* @__PURE__ */ a.jsx("path", { d: "M40.8789 48.5352L40.5859 25H44.9805L44.6875 48.5352H40.8789ZM42.7832 60.4736C42.002 60.4736 41.3428 60.2051 40.8057 59.668C40.2686 59.1309 40 58.4717 40 57.6904C40 56.8929 40.2686 56.2337 40.8057 55.7129C41.3428 55.1758 42.002 54.9072 42.7832 54.9072C43.5807 54.9072 44.2399 55.1758 44.7607 55.7129C45.2979 56.2337 45.5664 56.8929 45.5664 57.6904C45.5664 58.4717 45.2979 59.1309 44.7607 59.668C44.2399 60.2051 43.5807 60.4736 42.7832 60.4736Z", fill: r || "#FCB937" })
  ] });
}
function hm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 280, height: t || 172, viewBox: "0 0 280 172", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("rect", { x: "1.45833", y: "-1.45833", width: "277.083", height: "169.083", rx: "13.125", transform: "matrix(1 0 0 -1 0 169.083)", fill: "white", fillOpacity: "0.8", stroke: "#1B1C23", strokeWidth: "2.91667" }),
    /* @__PURE__ */ a.jsx("rect", { y: "14.5762", width: "280", height: "40.8136", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "23.332", y: "69.9658", width: "37.9167", height: "11.661", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "224.582", y: "119.525", width: "23.3333", height: "34.9831", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("circle", { cx: "224.582", cy: "137.083", r: "17.5", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("circle", { cx: "247.918", cy: "137.083", r: "17.5", fill: r || "#333543" })
  ] });
}
function mm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 280, height: t || 172, viewBox: "0 0 280 172", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("rect", { x: "1.45763", y: "-1.45763", width: "277.085", height: "169.085", rx: "13.1186", transform: "matrix(1 0 0 -1 0 169.085)", fill: "white", fillOpacity: "0.8", stroke: "#1B1C23", strokeWidth: "2.91525" }),
    /* @__PURE__ */ a.jsx("rect", { x: "23.332", y: "23.3223", width: "107.917", height: "11.661", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "93.332", y: "142.848", width: "99.1667", height: "11.661", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "145.832", y: "122.44", width: "37.9167", height: "11.661", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "23.332", y: "99.1182", width: "46.6667", height: "11.661", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "84.582", y: "99.1182", width: "46.6667", height: "11.661", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "145.832", y: "99.1182", width: "46.6667", height: "11.661", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "207.082", y: "99.1182", width: "46.6667", height: "11.661", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "23.332", y: "142.848", width: "61.25", height: "11.661", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "23.3359", y: "52.4746", width: "40.8333", height: "37.8983", rx: "5.83051", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "23.3359", y: "58.3047", width: "40.8333", height: "1.45763", fill: "white" }),
    /* @__PURE__ */ a.jsx("rect", { x: "23.3359", y: "67.0508", width: "14.5833", height: "1.45763", fill: "white" }),
    /* @__PURE__ */ a.jsx("rect", { x: "49.5859", y: "67.0508", width: "14.5833", height: "1.45763", fill: "white" }),
    /* @__PURE__ */ a.jsx("rect", { x: "23.3359", y: "74.3389", width: "14.5833", height: "1.45763", fill: "white" }),
    /* @__PURE__ */ a.jsx("rect", { x: "49.5859", y: "74.3389", width: "14.5833", height: "1.45763", fill: "white" }),
    /* @__PURE__ */ a.jsx("rect", { x: "44.4805", y: "52.4746", width: "5.83051", height: "1.45833", transform: "rotate(90 44.4805 52.4746)", fill: "white" }),
    /* @__PURE__ */ a.jsx("rect", { x: "37.918", y: "58.3047", width: "26.2373", height: "1.45833", transform: "rotate(90 37.918 58.3047)", fill: "white" }),
    /* @__PURE__ */ a.jsx("rect", { x: "51.043", y: "67.0508", width: "17.4915", height: "1.45833", transform: "rotate(90 51.043 67.0508)", fill: "white" }),
    /* @__PURE__ */ a.jsx("rect", { x: "44.4805", y: "84.542", width: "5.83051", height: "1.45833", transform: "rotate(90 44.4805 84.542)", fill: "white" }),
    /* @__PURE__ */ a.jsx("rect", { x: "23.3359", y: "83.085", width: "40.8333", height: "1.45763", fill: "white" }),
    /* @__PURE__ */ a.jsx("circle", { cx: "224.476", cy: "137.017", r: "17.4915", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("circle", { cx: "247.796", cy: "137.017", r: "17.4915", fill: r || "#333543" })
  ] });
}
function wm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 270, height: t || 172, viewBox: "0 0 270 172", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("rect", { x: "1.40984", y: "-1.40984", width: "267.18", height: "169.18", rx: "12.6885", transform: "matrix(1 0 0 -1 0 169.18)", fill: "white", fillOpacity: "0.8", stroke: "#1B1C23", strokeWidth: "2.81967" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "22.5576", width: "104.062", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "171.562", y: "22.5576", width: "75.9375", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "154.688", y: "138.164", width: "92.8125", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "47.9346", width: "61.875", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "95.625", y: "47.9346", width: "61.875", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "73.3115", width: "73.125", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "112.787", width: "50.625", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "138.164", width: "87.1875", height: "11.2787", fill: r || "#333543" })
  ] });
}
function km(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 270, height: t || 172, viewBox: "0 0 270 172", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("rect", { x: "1.40625", y: "-1.40625", width: "267.188", height: "169.188", rx: "12.6562", transform: "matrix(1 0 0 -1 0 169.188)", fill: "white", fillOpacity: "0.8", stroke: "#1B1C23", strokeWidth: "2.8125" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "22.5576", width: "225", height: "33.8361", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "112.787", width: "61.875", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "95.625", y: "112.787", width: "61.875", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "138.164", width: "87.1875", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsxs("g", { clipPath: "url(#clip0_10772_56590)", children: [
      /* @__PURE__ */ a.jsx("path", { d: "M247.5 22.5576H22.5V64.8527H247.5V22.5576Z", fill: "#D6D6D6" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.4999 22.5576H22.5V27.257H37.4999V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2501 22.5576H39.375V27.257H41.2501V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.0079 22.5576H43.1328V27.257H45.0079V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7423 22.5576H46.8672V27.257H48.7423V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M63.7577 22.5576H54.3828V27.257H63.7577V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M67.4962 22.5576H65.6211V27.257H67.4962V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M71.254 22.5576H69.3789V27.257H71.254V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M82.4999 22.5576H73.125V27.257H82.4999V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M89.9921 22.5576H86.2422V27.257H89.9921V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M93.754 22.5576H91.8789V27.257H93.754V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M99.3749 22.5576H95.625V27.257H99.3749V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M110.621 22.5576H104.996V27.257H110.621V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M121.875 22.5576H118.125V27.257H121.875V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M133.125 22.5576H129.375V27.257H133.125V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M136.875 22.5576H135V27.257H136.875V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M140.633 22.5576H138.758V27.257H140.633V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M151.871 22.5576H149.996V27.257H151.871V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M159.379 22.5576H153.754V27.257H159.379V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M172.508 22.5576H166.883V27.257H172.508V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M176.25 22.5576H174.375V27.257H176.25V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M191.254 22.5576H181.879V27.257H191.254V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M195.004 22.5576H193.129V27.257H195.004V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M198.75 22.5576H196.875V27.257H198.75V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M209.996 22.5576H200.621V27.257H209.996V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.875 22.5576H213.75V27.257H226.875V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.621 22.5576H228.746V27.257H230.621V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.125 22.5576H236.25V27.257H238.125V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.883 22.5576H240.008V27.257H241.883V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.496 22.5576H245.621V27.257H247.496V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.4999 27.2578H22.5V31.9572H37.4999V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2501 27.2578H39.375V31.9572H41.2501V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.0079 27.2578H43.1328V31.9572H45.0079V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7423 27.2578H46.8672V31.9572H48.7423V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M61.8829 27.2578H54.3828V31.9572H61.8829V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M65.629 27.2578H63.7539V31.9572H65.629V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M69.3751 27.2578H67.5V31.9572H69.3751V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M78.7462 27.2578H76.8711V31.9572H78.7462V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M91.8672 27.2578H86.2422V31.9572H91.8672V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M99.379 27.2578H97.5039V31.9572H99.379V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M105 27.2578H101.25V31.9572H105V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M112.508 27.2578H110.633V31.9572H112.508V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M121.875 27.2578H118.125V31.9572H121.875V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M133.129 27.2578H125.629V31.9572H133.129V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M136.875 27.2578H135V31.9572H136.875V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M148.133 27.2578H138.758V31.9572H148.133V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M155.621 27.2578H149.996V31.9572H155.621V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M163.121 27.2578H161.246V31.9572H163.121V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M174.375 27.2578H168.75V31.9572H174.375V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M180.004 27.2578H176.254V31.9572H180.004V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M189.379 27.2578H181.879V31.9572H189.379V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M193.125 27.2578H191.25V31.9572H193.125V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M196.883 27.2578H195.008V31.9572H196.883V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M202.496 27.2578H200.621V31.9572H202.496V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.875 27.2578H213.75V31.9572H226.875V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.621 27.2578H228.746V31.9572H230.621V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.125 27.2578H236.25V31.9572H238.125V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.883 27.2578H240.008V31.9572H241.883V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.496 27.2578H245.621V31.9572H247.496V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.4999 31.9561H22.5V36.6555H37.4999V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2501 31.9561H39.375V36.6555H41.2501V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.0079 31.9561H43.1328V36.6555H45.0079V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7423 31.9561H46.8672V36.6555H48.7423V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M56.2579 31.9561H54.3828V36.6555H56.2579V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M59.9923 31.9561H58.1172V36.6555H59.9923V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M63.7501 31.9561H61.875V36.6555H63.7501V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M75.0001 31.9561H67.5V36.6555H75.0001V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M89.9921 31.9561H86.2422V36.6555H89.9921V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M103.129 31.9561H91.8789V36.6555H103.129V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M108.746 31.9561H104.996V36.6555H108.746V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M112.508 31.9561H110.633V36.6555H112.508V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M120 31.9561H118.125V36.6555H120V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M123.746 31.9561H121.871V36.6555H123.746V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M136.871 31.9561H133.121V36.6555H136.871V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M148.133 31.9561H138.758V36.6555H148.133V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M151.871 31.9561H149.996V36.6555H151.871V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M161.258 31.9561H155.633V36.6555H161.258V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M172.492 31.9561H170.617V36.6555H172.492V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M178.125 31.9561H174.375V36.6555H178.125V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M183.754 31.9561H181.879V36.6555H183.754V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M187.5 31.9561H185.625V36.6555H187.5V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M191.246 31.9561H189.371V36.6555H191.246V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M206.242 31.9561H198.742V36.6555H206.242V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.875 31.9561H213.75V36.6555H226.875V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.621 31.9561H228.746V36.6555H230.621V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.125 31.9561H236.25V36.6555H238.125V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.883 31.9561H240.008V36.6555H241.883V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.496 31.9561H245.621V36.6555H247.496V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.4999 36.6562H22.5V41.3557H37.4999V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2501 36.6562H39.375V41.3557H41.2501V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.0079 36.6562H43.1328V41.3557H45.0079V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7423 36.6562H46.8672V41.3557H48.7423V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M58.1327 36.6562H54.3828V41.3557H58.1327V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M61.8712 36.6562H59.9961V41.3557H61.8712V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M71.254 36.6562H63.7539V41.3557H71.254V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M84.3671 36.6562H74.9922V41.3557H84.3671V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M95.6171 36.6562H86.2422V41.3557H95.6171V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M99.379 36.6562H97.5039V41.3557H99.379V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M103.125 36.6562H101.25V41.3557H103.125V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M116.25 36.6562H106.875V41.3557H116.25V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M123.75 36.6562H118.125V41.3557H123.75V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M131.254 36.6562H125.629V41.3557H131.254V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M134.996 36.6562H133.121V41.3557H134.996V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M140.633 36.6562H138.758V41.3557H140.633V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M153.746 36.6562H149.996V41.3557H153.746V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M157.508 36.6562H155.633V41.3557H157.508V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M168.758 36.6562H166.883V41.3557H168.758V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M180.004 36.6562H176.254V41.3557H180.004V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M185.629 36.6562H181.879V41.3557H185.629V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M189.367 36.6562H187.492V41.3557H189.367V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M198.75 36.6562H191.25V41.3557H198.75V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M211.875 36.6562H202.5V41.3557H211.875V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.875 36.6562H213.75V41.3557H226.875V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.621 36.6562H228.746V41.3557H230.621V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.125 36.6562H236.25V41.3557H238.125V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.883 36.6562H240.008V41.3557H241.883V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.496 36.6562H245.621V41.3557H247.496V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.4999 41.3564H22.5V46.0559H37.4999V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2501 41.3564H39.375V46.0559H41.2501V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.0079 41.3564H43.1328V46.0559H45.0079V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7423 41.3564H46.8672V46.0559H48.7423V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M58.1327 41.3564H54.3828V46.0559H58.1327V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M61.8712 41.3564H59.9961V46.0559H61.8712V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M69.3789 41.3564H63.7539V46.0559H69.3789V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M80.6251 41.3564H78.75V46.0559H80.6251V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M97.4922 41.3564H86.2422V46.0559H97.4922V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M105.008 41.3564H99.3828V46.0559H105.008V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M108.75 41.3564H106.875V46.0559H108.75V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M112.508 41.3564H110.633V46.0559H112.508V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M123.75 41.3564H118.125V46.0559H123.75V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M127.504 41.3564H125.629V46.0559H127.504V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M134.992 41.3564H131.242V46.0559H134.992V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M138.754 41.3564H136.879V46.0559H138.754V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M153.746 41.3564H149.996V46.0559H153.746V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M166.879 41.3564H165.004V46.0559H166.879V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M176.242 41.3564H170.617V46.0559H176.242V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M179.996 41.3564H178.121V46.0559H179.996V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M189.379 41.3564H181.879V46.0559H189.379V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M193.125 41.3564H191.25V46.0559H193.125V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M200.633 41.3564H195.008V46.0559H200.633V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M210.004 41.3564H204.379V46.0559H210.004V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.875 41.3564H213.75V46.0559H226.875V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.621 41.3564H228.746V46.0559H230.621V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.125 41.3564H236.25V46.0559H238.125V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.883 41.3564H240.008V46.0559H241.883V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.496 41.3564H245.621V46.0559H247.496V41.3564Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.4999 46.0537H22.5V50.7531H37.4999V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2501 46.0537H39.375V50.7531H41.2501V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.0079 46.0537H43.1328V50.7531H45.0079V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7423 46.0537H46.8672V50.7531H48.7423V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M63.7577 46.0537H54.3828V50.7531H63.7577V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M67.4962 46.0537H65.6211V50.7531H67.4962V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M76.879 46.0537H69.3789V50.7531H76.879V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M82.4999 46.0537H78.75V50.7531H82.4999V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M93.7423 46.0537H86.2422V50.7531H93.7423V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M97.5001 46.0537H95.625V50.7531H97.5001V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M108.75 46.0537H101.25V50.7531H108.75V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M112.508 46.0537H110.633V50.7531H112.508V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M120 46.0537H118.125V50.7531H120V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M127.496 46.0537H121.871V50.7531H127.496V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M135 46.0537H129.375V50.7531H135V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M148.125 46.0537H140.625V50.7531H148.125V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M153.746 46.0537H149.996V50.7531H153.746V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M168.742 46.0537H159.367V50.7531H168.742V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M174.371 46.0537H172.496V50.7531H174.371V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M179.996 46.0537H178.121V50.7531H179.996V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M189.379 46.0537H181.879V50.7531H189.379V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M193.125 46.0537H191.25V50.7531H193.125V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M204.383 46.0537H195.008V50.7531H204.383V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M209.996 46.0537H206.246V50.7531H209.996V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.875 46.0537H213.75V50.7531H226.875V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.621 46.0537H228.746V50.7531H230.621V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.125 46.0537H236.25V50.7531H238.125V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.883 46.0537H240.008V50.7531H241.883V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.496 46.0537H245.621V50.7531H247.496V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.4999 50.7539H22.5V55.4533H37.4999V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2501 50.7539H39.375V55.4533H41.2501V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.0079 50.7539H43.1328V55.4533H45.0079V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7423 50.7539H46.8672V55.4533H48.7423V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M60.0078 50.7539H54.3828V55.4533H60.0078V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M63.7501 50.7539H61.875V55.4533H63.7501V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M73.125 50.7539H67.5V55.4533H73.125V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M84.3671 50.7539H74.9922V55.4533H84.3671V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M88.1173 50.7539H86.2422V55.4533H88.1173V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M99.3749 50.7539H95.625V55.4533H99.3749V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M108.746 50.7539H104.996V55.4533H108.746V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M114.375 50.7539H112.5V55.4533H114.375V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M121.875 50.7539H118.125V55.4533H121.875V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M129.379 50.7539H125.629V55.4533H129.379V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M140.629 50.7539H136.879V55.4533H140.629V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M148.121 50.7539H144.371V55.4533H148.121V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M151.871 50.7539H149.996V55.4533H151.871V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M163.121 50.7539H161.246V55.4533H163.121V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M172.5 50.7539H168.75V55.4533H172.5V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M178.125 50.7539H174.375V55.4533H178.125V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M187.504 50.7539H181.879V55.4533H187.504V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M191.246 50.7539H189.371V55.4533H191.246V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M200.633 50.7539H195.008V55.4533H200.633V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M211.875 50.7539H202.5V55.4533H211.875V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.875 50.7539H213.75V55.4533H226.875V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.621 50.7539H228.746V55.4533H230.621V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.125 50.7539H236.25V55.4533H238.125V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.883 50.7539H240.008V55.4533H241.883V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.496 50.7539H245.621V55.4533H247.496V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.4999 55.4551H22.5V60.1545H37.4999V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2501 55.4551H39.375V60.1545H41.2501V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.0079 55.4551H43.1328V60.1545H45.0079V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7423 55.4551H46.8672V60.1545H48.7423V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M65.6328 55.4551H54.3828V60.1545H65.6328V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M69.3751 55.4551H67.5V60.1545H69.3751V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M75.0001 55.4551H73.125V60.1545H75.0001V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M82.4961 55.4551H76.8711V60.1545H82.4961V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M88.1173 55.4551H86.2422V60.1545H88.1173V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M97.5001 55.4551H90V60.1545H97.5001V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M103.133 55.4551H99.3828V60.1545H103.133V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M114.371 55.4551H104.996V60.1545H114.371V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M120 55.4551H118.125V60.1545H120V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M123.746 55.4551H121.871V60.1545H123.746V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M133.129 55.4551H125.629V60.1545H133.129V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M142.5 55.4551H140.625V60.1545H142.5V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M157.496 55.4551H149.996V60.1545H157.496V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M164.996 55.4551H161.246V60.1545H164.996V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M172.5 55.4551H168.75V60.1545H172.5V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M176.25 55.4551H174.375V60.1545H176.25V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M183.754 55.4551H181.879V60.1545H183.754V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M187.5 55.4551H185.625V60.1545H187.5V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M200.621 55.4551H189.371V60.1545H200.621V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M208.125 55.4551H202.5V60.1545H208.125V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.875 55.4551H213.75V60.1545H226.875V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.621 55.4551H228.746V60.1545H230.621V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.125 55.4551H236.25V60.1545H238.125V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.883 55.4551H240.008V60.1545H241.883V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.496 55.4551H245.621V60.1545H247.496V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.4999 60.1523H22.5V64.8518H37.4999V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2501 60.1523H39.375V64.8518H41.2501V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.0079 60.1523H43.1328V64.8518H45.0079V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7423 60.1523H46.8672V64.8518H48.7423V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M65.6328 60.1523H54.3828V64.8518H65.6328V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M69.3751 60.1523H67.5V64.8518H69.3751V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M76.8749 60.1523H73.125V64.8518H76.8749V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M82.504 60.1523H80.6289V64.8518H82.504V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M88.1173 60.1523H86.2422V64.8518H88.1173V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M99.3711 60.1523H93.7461V64.8518H99.3711V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M103.125 60.1523H101.25V64.8518H103.125V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M112.504 60.1523H108.754V64.8518H112.504V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M121.875 60.1523H118.125V64.8518H121.875V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M131.258 60.1523H127.508V64.8518H131.258V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M138.754 60.1523H136.879V64.8518H138.754V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M148.125 60.1523H140.625V64.8518H148.125V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M153.746 60.1523H149.996V64.8518H153.746V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M159.383 60.1523H155.633V64.8518H159.383V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M163.121 60.1523H161.246V64.8518H163.121V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M172.504 60.1523H165.004V64.8518H172.504V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M191.254 60.1523H181.879V64.8518H191.254V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M195.004 60.1523H193.129V64.8518H195.004V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M204.367 60.1523H198.742V64.8518H204.367V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M208.121 60.1523H206.246V64.8518H208.121V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.875 60.1523H213.75V64.8518H226.875V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.621 60.1523H228.746V64.8518H230.621V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.125 60.1523H236.25V64.8518H238.125V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.883 60.1523H240.008V64.8518H241.883V60.1523Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.496 60.1523H245.621V64.8518H247.496V60.1523Z", fill: "#272833" })
    ] }),
    /* @__PURE__ */ a.jsx("defs", { children: /* @__PURE__ */ a.jsx("clipPath", { id: "clip0_10772_56590", children: /* @__PURE__ */ a.jsx("rect", { width: "225", height: "42.2951", fill: "white", transform: "translate(22.5 22.5576)" }) }) })
  ] });
}
function Um(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 270, height: t || 172, viewBox: "0 0 270 172", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("rect", { x: "1.40984", y: "-1.40984", width: "267.18", height: "169.18", rx: "12.6885", transform: "matrix(1 0 0 -1 0 169.18)", fill: "white", fillOpacity: "0.8", stroke: "#1B1C23", strokeWidth: "2.81967" }),
    /* @__PURE__ */ a.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M101.246 28.1982H22.4961V126.887C22.4962 124.482 27.1732 123.323 32.6526 121.964C39.93 120.16 48.6229 118.005 49.6542 112.116C44.6713 108.96 42.7698 104.198 40.8243 99.3255C40.4465 98.3791 40.0669 97.4286 39.6629 96.485C34.7738 101.236 32.5935 79.4764 36.9774 79.4764C28.6435 56.9793 51.4615 38.5191 72.545 51.2088C84.91 48.5382 91.7424 63.3145 84.3766 79.4768C87.4153 78.0182 87.9964 85.7946 87.4153 90.6287C87.4153 91.8706 86.1245 100.564 82.8626 97.1966C82.4668 98.1115 82.0949 99.0331 81.7247 99.9507L81.7241 99.9523L81.7239 99.9527C79.768 104.801 77.8573 109.537 72.6874 112.594C74.1725 118.123 83.0554 120.21 90.5254 121.964C96.3092 123.323 101.246 124.482 101.246 126.887V28.1982Z", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.5", y: "104.327", width: "59.0625", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "182.812", y: "104.327", width: "64.6875", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.5", y: "28.1963", width: "61.875", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.5", y: "53.5742", width: "61.875", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.5", y: "78.9512", width: "104.062", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.5", y: "129.704", width: "135", height: "11.2787", fill: r || "#333543" })
  ] });
}
function Qm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 270, height: t || 172, viewBox: "0 0 270 172", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("rect", { x: "1.40625", y: "-1.40625", width: "267.188", height: "169.188", rx: "12.6562", transform: "matrix(1 0 0 -1 0 169.188)", fill: "white", fillOpacity: "0.8", stroke: "#1B1C23", strokeWidth: "2.8125" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "124.065", width: "225", height: "8.45902", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "107.147", width: "225", height: "8.45902", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "25.377", width: "104.062", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "50.7539", width: "61.875", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "95.625", y: "50.7539", width: "61.875", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "140.983", width: "225", height: "8.45902", fill: r || "#333543" })
  ] });
}
function Ym(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 270, height: t || 172, viewBox: "0 0 270 172", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("rect", { x: "1.40984", y: "-1.40984", width: "267.18", height: "169.18", rx: "12.6885", transform: "matrix(1 0 0 -1 0 169.18)", fill: "white", fillOpacity: "0.8", stroke: "#1B1C23", strokeWidth: "2.81967" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "124.065", width: "225", height: "8.45902", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "107.147", width: "225", height: "8.45902", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "140.983", width: "225", height: "8.45902", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "76.1309", width: "61.875", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "95.625", y: "76.1309", width: "61.875", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsxs("g", { clipPath: "url(#clip0_10772_56870)", children: [
      /* @__PURE__ */ a.jsx("path", { d: "M247.496 22.5576H22.4961V64.8527H247.496V22.5576Z", fill: "#D6D6D6" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.496 22.5576H22.4961V27.257H37.496V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2462 22.5576H39.3711V27.257H41.2462V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.004 22.5576H43.1289V27.257H45.004V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7384 22.5576H46.8633V27.257H48.7384V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M63.7538 22.5576H54.3789V27.257H63.7538V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M67.4923 22.5576H65.6172V27.257H67.4923V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M71.2501 22.5576H69.375V27.257H71.2501V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M82.496 22.5576H73.1211V27.257H82.496V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M89.9882 22.5576H86.2383V27.257H89.9882V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M93.7501 22.5576H91.875V27.257H93.7501V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M99.371 22.5576H95.6211V27.257H99.371V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M110.617 22.5576H104.992V27.257H110.617V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M121.871 22.5576H118.121V27.257H121.871V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M133.121 22.5576H129.371V27.257H133.121V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M136.871 22.5576H134.996V27.257H136.871V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M140.629 22.5576H138.754V27.257H140.629V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M151.867 22.5576H149.992V27.257H151.867V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M159.375 22.5576H153.75V27.257H159.375V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M172.504 22.5576H166.879V27.257H172.504V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M176.246 22.5576H174.371V27.257H176.246V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M191.25 22.5576H181.875V27.257H191.25V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M195 22.5576H193.125V27.257H195V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M198.746 22.5576H196.871V27.257H198.746V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M209.992 22.5576H200.617V27.257H209.992V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.871 22.5576H213.746V27.257H226.871V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.617 22.5576H228.742V27.257H230.617V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.121 22.5576H236.246V27.257H238.121V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.879 22.5576H240.004V27.257H241.879V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.492 22.5576H245.617V27.257H247.492V22.5576Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.496 27.2578H22.4961V31.9572H37.496V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2462 27.2578H39.3711V31.9572H41.2462V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.004 27.2578H43.1289V31.9572H45.004V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7384 27.2578H46.8633V31.9572H48.7384V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M61.879 27.2578H54.3789V31.9572H61.879V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M65.6251 27.2578H63.75V31.9572H65.6251V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M69.3712 27.2578H67.4961V31.9572H69.3712V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M78.7423 27.2578H76.8672V31.9572H78.7423V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M91.8633 27.2578H86.2383V31.9572H91.8633V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M99.3751 27.2578H97.5V31.9572H99.3751V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M104.996 27.2578H101.246V31.9572H104.996V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M112.504 27.2578H110.629V31.9572H112.504V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M121.871 27.2578H118.121V31.9572H121.871V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M133.125 27.2578H125.625V31.9572H133.125V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M136.871 27.2578H134.996V31.9572H136.871V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M148.129 27.2578H138.754V31.9572H148.129V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M155.617 27.2578H149.992V31.9572H155.617V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M163.117 27.2578H161.242V31.9572H163.117V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M174.371 27.2578H168.746V31.9572H174.371V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M180 27.2578H176.25V31.9572H180V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M189.375 27.2578H181.875V31.9572H189.375V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M193.121 27.2578H191.246V31.9572H193.121V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M196.879 27.2578H195.004V31.9572H196.879V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M202.492 27.2578H200.617V31.9572H202.492V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.871 27.2578H213.746V31.9572H226.871V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.617 27.2578H228.742V31.9572H230.617V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.121 27.2578H236.246V31.9572H238.121V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.879 27.2578H240.004V31.9572H241.879V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.492 27.2578H245.617V31.9572H247.492V27.2578Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.496 31.9561H22.4961V36.6555H37.496V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2462 31.9561H39.3711V36.6555H41.2462V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.004 31.9561H43.1289V36.6555H45.004V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7384 31.9561H46.8633V36.6555H48.7384V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M56.254 31.9561H54.3789V36.6555H56.254V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M59.9884 31.9561H58.1133V36.6555H59.9884V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M63.7462 31.9561H61.8711V36.6555H63.7462V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M74.9962 31.9561H67.4961V36.6555H74.9962V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M89.9882 31.9561H86.2383V36.6555H89.9882V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M103.125 31.9561H91.875V36.6555H103.125V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M108.742 31.9561H104.992V36.6555H108.742V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M112.504 31.9561H110.629V36.6555H112.504V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M119.996 31.9561H118.121V36.6555H119.996V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M123.742 31.9561H121.867V36.6555H123.742V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M136.867 31.9561H133.117V36.6555H136.867V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M148.129 31.9561H138.754V36.6555H148.129V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M151.867 31.9561H149.992V36.6555H151.867V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M161.254 31.9561H155.629V36.6555H161.254V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M172.488 31.9561H170.613V36.6555H172.488V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M178.121 31.9561H174.371V36.6555H178.121V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M183.75 31.9561H181.875V36.6555H183.75V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M187.496 31.9561H185.621V36.6555H187.496V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M191.242 31.9561H189.367V36.6555H191.242V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M206.238 31.9561H198.738V36.6555H206.238V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.871 31.9561H213.746V36.6555H226.871V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.617 31.9561H228.742V36.6555H230.617V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.121 31.9561H236.246V36.6555H238.121V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.879 31.9561H240.004V36.6555H241.879V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.492 31.9561H245.617V36.6555H247.492V31.9561Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.496 36.6562H22.4961V41.3557H37.496V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2462 36.6562H39.3711V41.3557H41.2462V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.004 36.6562H43.1289V41.3557H45.004V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7384 36.6562H46.8633V41.3557H48.7384V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M58.1288 36.6562H54.3789V41.3557H58.1288V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M61.8673 36.6562H59.9922V41.3557H61.8673V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M71.2501 36.6562H63.75V41.3557H71.2501V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M84.3632 36.6562H74.9883V41.3557H84.3632V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M95.6132 36.6562H86.2383V41.3557H95.6132V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M99.3751 36.6562H97.5V41.3557H99.3751V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M103.121 36.6562H101.246V41.3557H103.121V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M116.246 36.6562H106.871V41.3557H116.246V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M123.746 36.6562H118.121V41.3557H123.746V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M131.25 36.6562H125.625V41.3557H131.25V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M134.992 36.6562H133.117V41.3557H134.992V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M140.629 36.6562H138.754V41.3557H140.629V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M153.742 36.6562H149.992V41.3557H153.742V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M157.504 36.6562H155.629V41.3557H157.504V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M168.754 36.6562H166.879V41.3557H168.754V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M180 36.6562H176.25V41.3557H180V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M185.625 36.6562H181.875V41.3557H185.625V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M189.363 36.6562H187.488V41.3557H189.363V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M198.746 36.6562H191.246V41.3557H198.746V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M211.871 36.6562H202.496V41.3557H211.871V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.871 36.6562H213.746V41.3557H226.871V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.617 36.6562H228.742V41.3557H230.617V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.121 36.6562H236.246V41.3557H238.121V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.879 36.6562H240.004V41.3557H241.879V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.492 36.6562H245.617V41.3557H247.492V36.6562Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.496 41.3555H22.4961V46.0549H37.496V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2462 41.3555H39.3711V46.0549H41.2462V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.004 41.3555H43.1289V46.0549H45.004V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7384 41.3555H46.8633V46.0549H48.7384V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M58.1288 41.3555H54.3789V46.0549H58.1288V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M61.8673 41.3555H59.9922V46.0549H61.8673V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M69.375 41.3555H63.75V46.0549H69.375V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M80.6212 41.3555H78.7461V46.0549H80.6212V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M97.4883 41.3555H86.2383V46.0549H97.4883V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M105.004 41.3555H99.3789V46.0549H105.004V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M108.746 41.3555H106.871V46.0549H108.746V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M112.504 41.3555H110.629V46.0549H112.504V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M123.746 41.3555H118.121V46.0549H123.746V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M127.5 41.3555H125.625V46.0549H127.5V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M134.988 41.3555H131.238V46.0549H134.988V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M138.75 41.3555H136.875V46.0549H138.75V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M153.742 41.3555H149.992V46.0549H153.742V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M166.875 41.3555H165V46.0549H166.875V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M176.238 41.3555H170.613V46.0549H176.238V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M179.992 41.3555H178.117V46.0549H179.992V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M189.375 41.3555H181.875V46.0549H189.375V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M193.121 41.3555H191.246V46.0549H193.121V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M200.629 41.3555H195.004V46.0549H200.629V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M210 41.3555H204.375V46.0549H210V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.871 41.3555H213.746V46.0549H226.871V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.617 41.3555H228.742V46.0549H230.617V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.121 41.3555H236.246V46.0549H238.121V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.879 41.3555H240.004V46.0549H241.879V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.492 41.3555H245.617V46.0549H247.492V41.3555Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.496 46.0537H22.4961V50.7531H37.496V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2462 46.0537H39.3711V50.7531H41.2462V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.004 46.0537H43.1289V50.7531H45.004V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7384 46.0537H46.8633V50.7531H48.7384V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M63.7538 46.0537H54.3789V50.7531H63.7538V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M67.4923 46.0537H65.6172V50.7531H67.4923V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M76.8751 46.0537H69.375V50.7531H76.8751V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M82.496 46.0537H78.7461V50.7531H82.496V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M93.7384 46.0537H86.2383V50.7531H93.7384V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M97.4962 46.0537H95.6211V50.7531H97.4962V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M108.746 46.0537H101.246V50.7531H108.746V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M112.504 46.0537H110.629V50.7531H112.504V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M119.996 46.0537H118.121V50.7531H119.996V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M127.492 46.0537H121.867V50.7531H127.492V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M134.996 46.0537H129.371V50.7531H134.996V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M148.121 46.0537H140.621V50.7531H148.121V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M153.742 46.0537H149.992V50.7531H153.742V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M168.738 46.0537H159.363V50.7531H168.738V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M174.367 46.0537H172.492V50.7531H174.367V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M179.992 46.0537H178.117V50.7531H179.992V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M189.375 46.0537H181.875V50.7531H189.375V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M193.121 46.0537H191.246V50.7531H193.121V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M204.379 46.0537H195.004V50.7531H204.379V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M209.992 46.0537H206.242V50.7531H209.992V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.871 46.0537H213.746V50.7531H226.871V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.617 46.0537H228.742V50.7531H230.617V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.121 46.0537H236.246V50.7531H238.121V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.879 46.0537H240.004V50.7531H241.879V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.492 46.0537H245.617V50.7531H247.492V46.0537Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.496 50.7539H22.4961V55.4533H37.496V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2462 50.7539H39.3711V55.4533H41.2462V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.004 50.7539H43.1289V55.4533H45.004V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7384 50.7539H46.8633V55.4533H48.7384V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M60.0039 50.7539H54.3789V55.4533H60.0039V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M63.7462 50.7539H61.8711V55.4533H63.7462V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M73.1211 50.7539H67.4961V55.4533H73.1211V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M84.3632 50.7539H74.9883V55.4533H84.3632V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M88.1134 50.7539H86.2383V55.4533H88.1134V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M99.371 50.7539H95.6211V55.4533H99.371V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M108.742 50.7539H104.992V55.4533H108.742V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M114.371 50.7539H112.496V55.4533H114.371V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M121.871 50.7539H118.121V55.4533H121.871V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M129.375 50.7539H125.625V55.4533H129.375V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M140.625 50.7539H136.875V55.4533H140.625V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M148.117 50.7539H144.367V55.4533H148.117V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M151.867 50.7539H149.992V55.4533H151.867V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M163.117 50.7539H161.242V55.4533H163.117V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M172.496 50.7539H168.746V55.4533H172.496V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M178.121 50.7539H174.371V55.4533H178.121V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M187.5 50.7539H181.875V55.4533H187.5V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M191.242 50.7539H189.367V55.4533H191.242V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M200.629 50.7539H195.004V55.4533H200.629V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M211.871 50.7539H202.496V55.4533H211.871V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.871 50.7539H213.746V55.4533H226.871V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.617 50.7539H228.742V55.4533H230.617V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.121 50.7539H236.246V55.4533H238.121V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.879 50.7539H240.004V55.4533H241.879V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.492 50.7539H245.617V55.4533H247.492V50.7539Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.496 55.4551H22.4961V60.1545H37.496V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2462 55.4551H39.3711V60.1545H41.2462V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.004 55.4551H43.1289V60.1545H45.004V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7384 55.4551H46.8633V60.1545H48.7384V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M65.6289 55.4551H54.3789V60.1545H65.6289V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M69.3712 55.4551H67.4961V60.1545H69.3712V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M74.9962 55.4551H73.1211V60.1545H74.9962V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M82.4922 55.4551H76.8672V60.1545H82.4922V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M88.1134 55.4551H86.2383V60.1545H88.1134V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M97.4962 55.4551H89.9961V60.1545H97.4962V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M103.129 55.4551H99.3789V60.1545H103.129V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M114.367 55.4551H104.992V60.1545H114.367V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M119.996 55.4551H118.121V60.1545H119.996V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M123.742 55.4551H121.867V60.1545H123.742V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M133.125 55.4551H125.625V60.1545H133.125V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M142.496 55.4551H140.621V60.1545H142.496V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M157.492 55.4551H149.992V60.1545H157.492V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M164.992 55.4551H161.242V60.1545H164.992V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M172.496 55.4551H168.746V60.1545H172.496V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M176.246 55.4551H174.371V60.1545H176.246V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M183.75 55.4551H181.875V60.1545H183.75V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M187.496 55.4551H185.621V60.1545H187.496V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M200.617 55.4551H189.367V60.1545H200.617V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M208.121 55.4551H202.496V60.1545H208.121V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.871 55.4551H213.746V60.1545H226.871V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.617 55.4551H228.742V60.1545H230.617V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.121 55.4551H236.246V60.1545H238.121V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.879 55.4551H240.004V60.1545H241.879V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.492 55.4551H245.617V60.1545H247.492V55.4551Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M37.496 60.1514H22.4961V64.8508H37.496V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M41.2462 60.1514H39.3711V64.8508H41.2462V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M45.004 60.1514H43.1289V64.8508H45.004V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M48.7384 60.1514H46.8633V64.8508H48.7384V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M65.6289 60.1514H54.3789V64.8508H65.6289V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M69.3712 60.1514H67.4961V64.8508H69.3712V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M76.871 60.1514H73.1211V64.8508H76.871V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M82.5001 60.1514H80.625V64.8508H82.5001V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M88.1134 60.1514H86.2383V64.8508H88.1134V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M99.3672 60.1514H93.7422V64.8508H99.3672V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M103.121 60.1514H101.246V64.8508H103.121V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M112.5 60.1514H108.75V64.8508H112.5V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M121.871 60.1514H118.121V64.8508H121.871V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M131.254 60.1514H127.504V64.8508H131.254V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M138.75 60.1514H136.875V64.8508H138.75V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M148.121 60.1514H140.621V64.8508H148.121V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M153.742 60.1514H149.992V64.8508H153.742V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M159.379 60.1514H155.629V64.8508H159.379V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M163.117 60.1514H161.242V64.8508H163.117V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M172.5 60.1514H165V64.8508H172.5V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M191.25 60.1514H181.875V64.8508H191.25V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M195 60.1514H193.125V64.8508H195V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M204.363 60.1514H198.738V64.8508H204.363V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M208.117 60.1514H206.242V64.8508H208.117V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M226.871 60.1514H213.746V64.8508H226.871V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M230.617 60.1514H228.742V64.8508H230.617V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M238.121 60.1514H236.246V64.8508H238.121V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M241.879 60.1514H240.004V64.8508H241.879V60.1514Z", fill: "#272833" }),
      /* @__PURE__ */ a.jsx("path", { d: "M247.492 60.1514H245.617V64.8508H247.492V60.1514Z", fill: "#272833" })
    ] }),
    /* @__PURE__ */ a.jsx("defs", { children: /* @__PURE__ */ a.jsx("clipPath", { id: "clip0_10772_56870", children: /* @__PURE__ */ a.jsx("rect", { width: "225", height: "42.2951", fill: "white", transform: "translate(22.5 22.5576)" }) }) })
  ] });
}
function bm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 270, height: t || 172, viewBox: "0 0 270 172", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("rect", { x: "1.40984", y: "-1.40984", width: "267.18", height: "169.18", rx: "12.6885", transform: "matrix(1 0 0 -1 0 169.18)", fill: "white", fillOpacity: "0.8", stroke: "#1B1C23", strokeWidth: "2.81967" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.5", y: "25.377", width: "61.875", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.5", y: "50.7539", width: "61.875", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.5", y: "76.1309", width: "104.062", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.5", y: "138.164", width: "225", height: "11.2787", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M101.25 25.377H22.5V124.065C22.5003 121.661 27.1772 120.502 32.6565 119.143C39.9339 117.339 48.6268 115.184 49.6581 109.295C44.6752 106.139 42.7737 101.377 40.8282 96.5044C40.4504 95.558 40.0708 94.6075 39.6668 93.6639C34.7777 98.4148 32.5974 76.6553 36.9813 76.6553C28.6474 54.1582 51.4654 35.698 72.5489 48.3877C84.9139 45.717 91.7464 60.4934 84.3805 76.6557C87.4192 75.1971 88.0003 82.9735 87.4192 87.8076C87.4192 89.0495 86.1284 97.7429 82.8665 94.3755C82.4704 95.2911 82.0983 96.2133 81.7279 97.1316C79.7719 101.98 77.8612 106.715 72.6914 109.773C74.1764 115.302 83.0593 117.388 90.5293 119.143C96.3129 120.502 101.25 121.661 101.25 124.065V25.377Z", fill: r || "#333543" })
  ] });
}
function Pm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 309, height: t || 438, viewBox: "0 0 309 438", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("path", { d: "M1.40455 22.4727C1.40455 18.5165 1.40564 15.6337 1.59124 13.3621C1.7755 11.1068 2.13459 9.57784 2.78232 8.3066C3.99425 5.92806 5.92806 3.99425 8.3066 2.78232C9.57784 2.13459 11.1068 1.7755 13.3621 1.59124C15.6337 1.40564 18.5165 1.40455 22.4727 1.40455H286.527C290.484 1.40455 293.366 1.40564 295.638 1.59124C297.893 1.7755 299.422 2.13459 300.693 2.78232C303.072 3.99425 305.006 5.92806 306.218 8.3066C306.865 9.57784 307.224 11.1068 307.409 13.3621C307.594 15.6337 307.595 18.5165 307.595 22.4727V217.595H1.40455V22.4727Z", fill: "white", fillOpacity: "0.8", stroke: "#1B1C23", strokeWidth: "2.80909" }),
    /* @__PURE__ */ a.jsx("path", { d: "M1.40455 415.527C1.40455 419.484 1.40564 422.366 1.59124 424.638C1.7755 426.893 2.13459 428.422 2.78232 429.693C3.99425 432.072 5.92806 434.006 8.3066 435.218C9.57784 435.865 11.1068 436.225 13.3621 436.409C15.6337 436.594 18.5165 436.595 22.4727 436.595H286.527C290.484 436.595 293.366 436.594 295.638 436.409C297.893 436.225 299.422 435.865 300.693 435.218C303.072 434.006 305.006 432.072 306.218 429.693C306.865 428.422 307.224 426.893 307.409 424.638C307.594 422.366 307.595 419.484 307.595 415.527V220.405H1.40455V415.527Z", fill: "white", fillOpacity: "0.8", stroke: "#1B1C23", strokeWidth: "2.80909" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.4727", y: "379.038", width: "264.055", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "224.727", y: "252.692", width: "61.8", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.363", y: "252.692", width: "61.8", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.363", y: "272.346", width: "61.8", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.363", y: "292", width: "103.936", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.363", y: "311.654", width: "78.6545", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.363", y: "331.308", width: "154.5", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.363", y: "350.962", width: "50.5636", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.4727", y: "404.308", width: "264.055", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M95.509 252.692H22.4727V348.154H95.509V348.154H22.4727C22.4727 345.828 26.8104 344.706 31.8923 343.392L31.8924 343.392C38.6418 341.647 46.7039 339.562 47.6604 333.866C43.039 330.813 41.2755 326.206 39.4712 321.494L39.4711 321.493C39.1207 320.578 38.7687 319.659 38.394 318.746C33.8596 323.342 31.8376 302.294 35.9034 302.294C28.1741 280.532 49.3366 262.676 68.8904 274.95C80.3582 272.367 86.695 286.66 79.8636 302.294C82.6818 300.883 83.2207 308.405 82.6818 313.081C82.6818 314.282 81.4847 322.692 78.4594 319.434C78.0921 320.32 77.747 321.212 77.4035 322.1L77.4034 322.1L77.4033 322.1C75.5893 326.79 73.8173 331.371 69.0225 334.328C70.3998 339.677 78.6382 341.695 85.5662 343.392C90.9184 344.703 95.4886 345.823 95.509 348.138V252.692Z", fill: r || "#333543" })
  ] });
}
function $m(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 309, height: t || 219, viewBox: "0 0 309 219", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("path", { d: "M1.40455 196.527C1.40455 200.484 1.40564 203.366 1.59124 205.638C1.7755 207.893 2.13459 209.422 2.78232 210.693C3.99425 213.072 5.92806 215.006 8.3066 216.218C9.57784 216.865 11.1068 217.225 13.3621 217.409C15.6337 217.594 18.5165 217.595 22.4727 217.595H286.527C290.484 217.595 293.366 217.594 295.638 217.409C297.893 217.225 299.422 216.865 300.693 216.218C303.072 215.006 305.006 213.072 306.218 210.693C306.865 209.422 307.224 207.893 307.409 205.638C307.594 203.366 307.595 200.484 307.595 196.527V1.40454H1.40455V196.527Z", fill: "white", fillOpacity: "0.8", stroke: "#1B1C23", strokeWidth: "2.80909" }),
    /* @__PURE__ */ a.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M95.509 33.6924H22.4727V129.154H22.4727C22.4729 126.828 26.8105 125.706 31.8923 124.392L31.8924 124.392C38.6418 122.647 46.7039 120.562 47.6604 114.866C43.039 111.813 41.2755 107.207 39.4712 102.494L39.4711 102.494C39.1207 101.578 38.7687 100.659 38.394 99.7463C33.8596 104.342 31.8376 83.2938 35.9034 83.2938C28.1741 61.5324 49.3366 43.6758 68.8904 55.9505C80.3582 53.3672 86.695 67.6604 79.8636 83.2943C82.6818 81.8833 83.2207 89.4054 82.6818 94.0815C82.6818 95.2828 81.4847 103.692 78.4594 100.435C78.0921 101.32 77.747 102.212 77.4035 103.1L77.4034 103.1L77.4033 103.101C75.5893 107.79 73.8173 112.371 69.0225 115.329C70.3998 120.677 78.6382 122.695 85.5662 124.392C90.9184 125.703 95.4886 126.823 95.509 129.138V33.6924Z", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.4727", y: "160.038", width: "264.055", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "224.727", y: "33.6924", width: "61.8", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.363", y: "33.6924", width: "61.8", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.363", y: "53.3457", width: "61.8", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.363", y: "73", width: "103.936", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.363", y: "92.6543", width: "78.6545", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.363", y: "112.308", width: "154.5", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "112.363", y: "131.962", width: "50.5636", height: "11.2308", fill: r || "#333543" }),
    /* @__PURE__ */ a.jsx("rect", { x: "22.4727", y: "185.308", width: "264.055", height: "11.2308", fill: r || "#333543" })
  ] });
}
function Rm(e) {
  let {
    size: t,
    color: r
  } = e;
  return /* @__PURE__ */ a.jsxs("svg", { width: t || 21, height: t || 20, viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ a.jsx("path", { d: "M15.5737 4.07891C15.4824 3.99597 15.3891 3.91522 15.2939 3.83677M15.5737 4.07891L15.2939 3.83677M15.5737 4.07891C16.2977 4.73614 16.9002 5.53165 17.3422 6.42526M15.2939 3.83677C13.9798 2.7533 12.3118 2.10522 10.4966 2.10522C8.07269 2.10522 5.91117 3.26089 4.50449 5.06575M16.9822 14.2243C15.621 16.4305 13.2251 17.8947 10.4966 17.8947C7.51384 17.8947 4.92843 16.1447 3.65796 13.5885", stroke: r || "#211236", strokeLinecap: "round" }),
    /* @__PURE__ */ a.jsx("path", { d: "M18.0873 2.58536L17.4019 6.47276L13.5145 5.7873", stroke: r || "#211236", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ a.jsx("path", { d: "M2.6126 17.2589L3.29805 13.3715L7.18545 14.0569", stroke: r || "#211236", strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
}
const Hm = {
  verified: cm,
  error: Mm,
  cross: am,
  snapshot: Em,
  square: zm,
  arrow: Sm,
  warning: vm,
  "regula-logo": om,
  "regula-logo-liveness-detection": Cm,
  "back-camera": um,
  "front-camera": sm,
  "camera-logo": lm,
  "from-camera": Im,
  "from-gallery": jm,
  "from-other-phone": gm,
  "docreader-search": Nm,
  "docreader-processing-finished": Dm,
  "docreader-processing-error": ym,
  "docreader-processing": Tm,
  "docreader-flip": Am,
  "docreader-camera-disabled": dm,
  "docreader-camera-preparing": xm,
  "camera-change": fm,
  "portrait-orientation-only": Lm,
  "document-front": Om,
  "document-back": pm,
  "bank-card-back": hm,
  "bank-card-front": mm,
  "id-back": wm,
  "id-barcode-back": km,
  "id-front": Um,
  "id-mrz-back": Qm,
  "id-mrz-barcode-back": Ym,
  "id-mrz-front": bm,
  "passport-both-pages": Pm,
  "passport-single": $m,
  "circular-arrows": Rm
};
function Ju(e) {
  let {
    type: t,
    size: r,
    color: n
  } = e;
  const i = Hm[t];
  return /* @__PURE__ */ a.jsx(i, { size: r, color: n });
}
var qI = { exports: {} };
(function(e, t) {
  (function(r, n) {
    n(t, f);
  })(Li, function(r, n) {
    var i = "default" in n ? n.default : n;
    function M(j) {
      return (M = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(N) {
        return typeof N;
      } : function(N) {
        return N && typeof Symbol == "function" && N.constructor === Symbol && N !== Symbol.prototype ? "symbol" : typeof N;
      })(j);
    }
    var o = {}, u = "[LOCALIZE-REACT]: There are no translations for specified locale", s = "[LOCALIZE-REACT] Looks like template is being used, but no value passed for ", l = /{{([^{]+[^}])}}/g;
    function I(j, N) {
      if (!N || Object.keys(N).length === 0) return j;
      var d, T, y, A = j.match(l);
      return A && A.length !== 0 ? (d = A, T = N, y = Object.keys(T), d.map(function(x) {
        var E = Array.prototype.slice.call(x, 2, -2).join(""), C = y.find(function(p) {
          return p === E;
        });
        return C ? [x, T[C]] : (console.warn(s, x), [x, x]);
      })).reduce(function(x, E) {
        var C = new RegExp(E[0], "gi");
        return x.replace(C, E[1]);
      }, j) : j;
    }
    var g = i.createContext(), c = g.Consumer;
    function D() {
      return n.useContext(g);
    }
    r.LocalizationConsumer = c, r.LocalizationContext = g, r.LocalizationProvider = function(j) {
      var N = j.children, d = j.disableCache, T = j.locale, y = j.translations, A = y === void 0 ? {} : y, x = function(w, z) {
        if (!w) return null;
        if (M(z[w]) === "object") return w;
        var R = w.toLowerCase().replace(/-/g, "_");
        if (M(z[R]) === "object") return R;
        var K = R.split("_")[0];
        return M(z[K]) === "object" ? K : (console.warn(u, w), w);
      }(T, A), E = x ? A[x] : A;
      function C(w, z, R) {
        if (!E || !w) return R || w;
        var K = typeof R == "string" ? R : w, P = E[w];
        if (typeof P == "string") return z ? I(P, z) : P;
        var H = w.split(".");
        if (H.length === 1) return I(K, z);
        for (var Se = E[H[0]], fe = 1; fe < H.length; fe++) Se = Se && Se[H[fe]];
        return I(typeof Se == "string" ? Se : K, z);
      }
      n.useEffect(function() {
        o = {};
      }, [T, A]);
      var p, O = d ? C : (p = C, function(w, z, R) {
        var K = 2 < arguments.length && R !== void 0 ? R : "", P = z ? JSON.stringify(z, null, "") + w + K : w + K;
        if (o[P]) return o[P];
        var H = p(w, z, K);
        return o[P] = H;
      });
      return i.createElement(g.Provider, { value: { locale: T, translate: O, translations: A } }, N);
    }, r.Message = function(j) {
      var N = j.defaultMessage, d = j.descriptor, T = j.values;
      return (0, D().translate)(d, T, N);
    }, r.useLocalize = D, Object.defineProperty(r, "__esModule", { value: !0 });
  });
})(qI, qI.exports);
var Ii = qI.exports;
const Vm = "_button_eou6w_1", _m = {
  button: Vm
}, Zm = ["children", "onClick"];
function Gm(e, t) {
  if (e == null) return {};
  var r, n, i = Bm(e, t);
  if (Object.getOwnPropertySymbols) {
    var M = Object.getOwnPropertySymbols(e);
    for (n = 0; n < M.length; n++) r = M[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function Bm(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.includes(n)) continue;
    r[n] = e[n];
  }
  return r;
}
function J4(e) {
  let {
    children: t,
    onClick: r
  } = e, n = Gm(e, Zm);
  return /* @__PURE__ */ a.jsx("button", Vj(tl({ className: _m.button, onClick: r }, n), { children: t }));
}
function vt(e) {
  let {
    title: t,
    type: r,
    subtitle: n,
    onReset: i,
    size: M,
    iconColor: o,
    errorCode: u
  } = e;
  const {
    translate: s
  } = Ii.useLocalize();
  return /* @__PURE__ */ a.jsx("div", { className: Qr["info-message"], children: /* @__PURE__ */ a.jsxs("div", { className: Qr["text-container"], children: [
    r === "verified" ? (
      // customized from css
      /* @__PURE__ */ a.jsx("div", { className: Qr.done })
    ) : /* @__PURE__ */ a.jsx(Ju, { type: r, size: M, color: o }),
    /* @__PURE__ */ a.jsx("p", { "data-e2e": "info-msg-title", className: Qr.title, children: t }),
    /* @__PURE__ */ a.jsx("p", { className: Qr.subtitle, children: n }),
    u && /* @__PURE__ */ a.jsxs("p", { className: Qr.errorCode, children: [
      s("errorCode"),
      " ",
      u
    ] }),
    i && /* @__PURE__ */ a.jsx("div", { className: Qr.button, children: /* @__PURE__ */ a.jsx(J4, { onClick: i, children: s("tryAgain") }) })
  ] }) });
}
function X4() {
  const e = () => window.matchMedia("(orientation: landscape)").matches ? "landscape" : "portrait", [t, r] = f.useState(() => {
    const i = e();
    return {
      isPortrait: i === "portrait",
      isLandscape: i === "landscape",
      orientation: i
    };
  }), n = f.useCallback(() => {
    const i = e();
    r((M) => M.orientation !== i ? {
      isPortrait: i === "portrait",
      isLandscape: i === "landscape",
      orientation: i
    } : M);
  }, []);
  return f.useEffect(() => (typeof window != "undefined" && (n(), window.addEventListener("load", n, !1), window.addEventListener("resize", n, !1)), () => {
    window.removeEventListener("load", n, !1), window.removeEventListener("resize", n, !1);
  }), [n]), t;
}
const Fm = "_window_10mzy_7", Wm = "_windowRotate_10mzy_26", Jm = "_header_10mzy_44", Xm = "_footer_10mzy_61", Km = "_ads_10mzy_97", qm = "_pipe_10mzy_108", QM = {
  window: Fm,
  windowRotate: Wm,
  header: Jm,
  footer: Xm,
  ads: Km,
  pipe: qm
}, ew = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 }, Iy = (e) => {
  let t;
  const r = /* @__PURE__ */ new Set(), n = (I, g) => {
    const c = typeof I == "function" ? I(t) : I;
    if (!Object.is(c, t)) {
      const D = t;
      t = (g != null ? g : typeof c != "object" || c === null) ? c : Object.assign({}, t, c), r.forEach((j) => j(t, D));
    }
  }, i = () => t, s = { setState: n, getState: i, getInitialState: () => l, subscribe: (I) => (r.add(I), () => r.delete(I)), destroy: () => {
    (ew ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), r.clear();
  } }, l = t = e(n, i, s);
  return s;
}, tw = (e) => e ? Iy(e) : Iy;
var Td = { exports: {} }, Ad = {}, dd = { exports: {} }, xd = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sM = f;
function rw(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var nw = typeof Object.is == "function" ? Object.is : rw, iw = sM.useState, Mw = sM.useEffect, aw = sM.useLayoutEffect, ow = sM.useDebugValue;
function uw(e, t) {
  var r = t(), n = iw({ inst: { value: r, getSnapshot: t } }), i = n[0].inst, M = n[1];
  return aw(function() {
    i.value = r, i.getSnapshot = t, ec(i) && M({ inst: i });
  }, [e, r, t]), Mw(function() {
    return ec(i) && M({ inst: i }), e(function() {
      ec(i) && M({ inst: i });
    });
  }, [e]), ow(r), r;
}
function ec(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var r = t();
    return !nw(e, r);
  } catch (n) {
    return !0;
  }
}
function sw(e, t) {
  return t();
}
var lw = typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined" ? sw : uw;
xd.useSyncExternalStore = sM.useSyncExternalStore !== void 0 ? sM.useSyncExternalStore : lw;
dd.exports = xd;
var cw = dd.exports;
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qs = f, Iw = cw;
function gw(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var jw = typeof Object.is == "function" ? Object.is : gw, Nw = Iw.useSyncExternalStore, Dw = Qs.useRef, yw = Qs.useEffect, Tw = Qs.useMemo, Aw = Qs.useDebugValue;
Ad.useSyncExternalStoreWithSelector = function(e, t, r, n, i) {
  var M = Dw(null);
  if (M.current === null) {
    var o = { hasValue: !1, value: null };
    M.current = o;
  } else o = M.current;
  M = Tw(function() {
    function s(D) {
      if (!l) {
        if (l = !0, I = D, D = n(D), i !== void 0 && o.hasValue) {
          var j = o.value;
          if (i(j, D)) return g = j;
        }
        return g = D;
      }
      if (j = g, jw(I, D)) return j;
      var N = n(D);
      return i !== void 0 && i(j, N) ? j : (I = D, g = N);
    }
    var l = !1, I, g, c = r === void 0 ? null : r;
    return [function() {
      return s(t());
    }, c === null ? void 0 : function() {
      return s(c());
    }];
  }, [t, r, n, i]);
  var u = Nw(e, M[0], M[1]);
  return yw(function() {
    o.hasValue = !0, o.value = u;
  }, [u]), Aw(u), u;
};
Td.exports = Ad;
var dw = Td.exports;
const xw = /* @__PURE__ */ D2(dw), Ed = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 }, { useDebugValue: Ew } = tE, { useSyncExternalStoreWithSelector: zw } = xw;
let gy = !1;
const fw = (e) => e;
function Cw(e, t = fw, r) {
  (Ed ? "production" : void 0) !== "production" && r && !gy && (console.warn(
    "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
  ), gy = !0);
  const n = zw(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    t,
    r
  );
  return Ew(n), n;
}
const jy = (e) => {
  (Ed ? "production" : void 0) !== "production" && typeof e != "function" && console.warn(
    "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
  );
  const t = typeof e == "function" ? tw(e) : e, r = (n, i) => Cw(t, n, i);
  return Object.assign(r, t), r;
}, Lw = (e) => e ? jy(e) : jy;
var K4 = G, Ow = vr, pw = _t, Sw = gM, vw = K4("".charAt), Ny = K4("".charCodeAt), hw = K4("".slice), Dy = function(e) {
  return function(t, r) {
    var n = pw(Sw(t)), i = Ow(r), M = n.length, o, u;
    return i < 0 || i >= M ? e ? "" : void 0 : (o = Ny(n, i), o < 55296 || o > 56319 || i + 1 === M || (u = Ny(n, i + 1)) < 56320 || u > 57343 ? e ? vw(n, i) : o : e ? hw(n, i, i + 2) : (o - 55296 << 10) + (u - 56320) + 65536);
  };
}, q4 = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: Dy(!1),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: Dy(!0)
}, mw = q4.charAt, ww = _t, zd = Xr, kw = I0, yy = e4, fd = "String Iterator", Uw = zd.set, Qw = zd.getterFor(fd);
kw(String, "String", function(e) {
  Uw(this, {
    type: fd,
    string: ww(e),
    index: 0
  });
}, function() {
  var t = Qw(this), r = t.string, n = t.index, i;
  return n >= r.length ? yy(void 0, !0) : (i = mw(r, n), t.index += i.length, yy(i, !1));
});
var Yw = X, bw = ze, Pw = ge, Ty = ZE, $w = bw("iterator"), Cd = !Yw(function() {
  var e = new URL("b?a=1&b=2&c=3", "https://a"), t = e.searchParams, r = new URLSearchParams("a=1&a=2&b=3"), n = "";
  return e.pathname = "c%20d", t.forEach(function(i, M) {
    t.delete("b"), n += M + i;
  }), r.delete("a", 2), r.delete("b", void 0), Ty && (!e.toJSON || !r.has("a", 1) || r.has("a", 2) || !r.has("a", void 0) || r.has("b")) || !t.size && (Ty || !Pw) || !t.sort || e.href !== "https://a/c%20d?a=1&c=3" || t.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !t[$w] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("https://тест").host !== "xn--e1aybc" || new URL("https://a#б").hash !== "#%D0%B1" || n !== "a1c3" || new URL("https://x", void 0).host !== "x";
}), Rw = hn, Hw = G, Ys = function(e) {
  if (Rw(e) === "Function") return Hw(e);
}, Ay = Ys, Vw = mn, _w = cs, Zw = Ay(Ay.bind), dM = function(e, t) {
  return Vw(e), t === void 0 ? e : _w ? Zw(e, t) : function() {
    return e.apply(t, arguments);
  };
}, dy = _2, Gw = Vt, Pn = function(e, t, r) {
  return r.get && dy(r.get, t, { getter: !0 }), r.set && dy(r.set, t, { setter: !0 }), Gw.f(e, t, r);
}, Bw = Ra, Fw = TypeError, bs = function(e, t) {
  if (Bw(t, e)) return e;
  throw new Fw("Incorrect invocation");
}, xy = ge, Ww = G, Jw = Ee, Xw = X, tc = i0, Kw = Bg, qw = wg, ek = Ht, tk = Is, yi = Object.assign, Ey = Object.defineProperty, rk = Ww([].concat), nk = !yi || Xw(function() {
  if (xy && yi({ b: 1 }, yi(Ey({}, "a", {
    enumerable: !0,
    get: function() {
      Ey(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1) return !0;
  var e = {}, t = {}, r = Symbol("assign detection"), n = "abcdefghijklmnopqrst";
  return e[r] = 7, n.split("").forEach(function(i) {
    t[i] = i;
  }), yi({}, e)[r] !== 7 || tc(yi({}, t)).join("") !== n;
}) ? function(t, r) {
  for (var n = ek(t), i = arguments.length, M = 1, o = Kw.f, u = qw.f; i > M; )
    for (var s = tk(arguments[M++]), l = o ? rk(tc(s), o(s)) : tc(s), I = l.length, g = 0, c; I > g; )
      c = l[g++], (!xy || Jw(u, s, c)) && (n[c] = s[c]);
  return n;
} : yi, ik = Ee, zy = ct, Mk = Ns, ak = function(e, t, r) {
  var n, i;
  zy(e);
  try {
    if (n = Mk(e, "return"), !n) {
      if (t === "throw") throw r;
      return r;
    }
    n = ik(n, e);
  } catch (M) {
    i = !0, n = M;
  }
  if (t === "throw") throw r;
  if (i) throw n;
  return zy(n), r;
}, ok = ct, uk = ak, sk = function(e, t, r, n) {
  try {
    return n ? t(ok(r)[0], r[1]) : t(r);
  } catch (i) {
    uk(e, "throw", i);
  }
}, lk = ze, ck = Ba, Ik = lk("iterator"), gk = Array.prototype, Ld = function(e) {
  return e !== void 0 && (ck.Array === e || gk[Ik] === e);
}, jk = G, Nk = X, Od = je, Dk = wn, yk = Jr, Tk = R2, pd = function() {
}, Sd = yk("Reflect", "construct"), ej = /^\s*(?:class|function)\b/, Ak = jk(ej.exec), dk = !ej.test(pd), YM = function(t) {
  if (!Od(t)) return !1;
  try {
    return Sd(pd, [], t), !0;
  } catch (r) {
    return !1;
  }
}, vd = function(t) {
  if (!Od(t)) return !1;
  switch (Dk(t)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return dk || !!Ak(ej, Tk(t));
  } catch (r) {
    return !0;
  }
};
vd.sham = !0;
var tj = !Sd || Nk(function() {
  var e;
  return YM(YM.call) || !YM(Object) || !YM(function() {
    e = !0;
  }) || e;
}) ? vd : YM, xk = ge, Ek = Vt, zk = ui, fk = function(e, t, r) {
  xk ? Ek.f(e, t, zk(0, r)) : e[t] = r;
}, Ck = wn, fy = Ns, Lk = Pa, Ok = Ba, pk = ze, Sk = pk("iterator"), Ps = function(e) {
  if (!Lk(e)) return fy(e, Sk) || fy(e, "@@iterator") || Ok[Ck(e)];
}, vk = Ee, hk = mn, mk = ct, wk = Va, kk = Ps, Uk = TypeError, rj = function(e, t) {
  var r = arguments.length < 2 ? kk(e) : t;
  if (hk(r)) return mk(vk(r, e));
  throw new Uk(wk(e) + " is not iterable");
}, Qk = dM, Yk = Ee, bk = Ht, Pk = sk, $k = Ld, Rk = tj, Hk = dt, Cy = fk, Vk = rj, _k = Ps, Ly = Array, Zk = function(t) {
  var r = bk(t), n = Rk(this), i = arguments.length, M = i > 1 ? arguments[1] : void 0, o = M !== void 0;
  o && (M = Qk(M, i > 2 ? arguments[2] : void 0));
  var u = _k(r), s = 0, l, I, g, c, D, j;
  if (u && !(this === Ly && $k(u)))
    for (I = n ? new this() : [], c = Vk(r, u), D = c.next; !(g = Yk(D, c)).done; s++)
      j = o ? Pk(c, M, [g.value, s], !0) : g.value, Cy(I, s, j);
  else
    for (l = Hk(r), I = n ? new this(l) : Ly(l); l > s; s++)
      j = o ? M(r[s], s) : r[s], Cy(I, s, j);
  return I.length = s, I;
}, gi = G, rc = 2147483647, la = 36, hd = 1, eg = 26, Gk = 38, Bk = 700, Fk = 72, Wk = 128, Jk = "-", Xk = /[^\0-\u007E]/, md = /[.\u3002\uFF0E\uFF61]/g, Oy = "Overflow: input needs wider integers to process", nc = la - hd, py = RangeError, Kk = gi(md.exec), $i = Math.floor, ic = String.fromCharCode, Sy = gi("".charCodeAt), wd = gi([].join), Nn = gi([].push), qk = gi("".replace), e7 = gi("".split), t7 = gi("".toLowerCase), r7 = function(e) {
  for (var t = [], r = 0, n = e.length; r < n; ) {
    var i = Sy(e, r++);
    if (i >= 55296 && i <= 56319 && r < n) {
      var M = Sy(e, r++);
      (M & 64512) === 56320 ? Nn(t, ((i & 1023) << 10) + (M & 1023) + 65536) : (Nn(t, i), r--);
    } else
      Nn(t, i);
  }
  return t;
}, vy = function(e) {
  return e + 22 + 75 * (e < 26);
}, n7 = function(e, t, r) {
  var n = 0;
  for (e = r ? $i(e / Bk) : e >> 1, e += $i(e / t); e > nc * eg >> 1; )
    e = $i(e / nc), n += la;
  return $i(n + (nc + 1) * e / (e + Gk));
}, i7 = function(e) {
  var t = [];
  e = r7(e);
  var r = e.length, n = Wk, i = 0, M = Fk, o, u;
  for (o = 0; o < e.length; o++)
    u = e[o], u < 128 && Nn(t, ic(u));
  var s = t.length, l = s;
  for (s && Nn(t, Jk); l < r; ) {
    var I = rc;
    for (o = 0; o < e.length; o++)
      u = e[o], u >= n && u < I && (I = u);
    var g = l + 1;
    if (I - n > $i((rc - i) / g))
      throw new py(Oy);
    for (i += (I - n) * g, n = I, o = 0; o < e.length; o++) {
      if (u = e[o], u < n && ++i > rc)
        throw new py(Oy);
      if (u === n) {
        for (var c = i, D = la; ; ) {
          var j = D <= M ? hd : D >= M + eg ? eg : D - M;
          if (c < j) break;
          var N = c - j, d = la - j;
          Nn(t, ic(vy(j + N % d))), c = $i(N / d), D += la;
        }
        Nn(t, ic(vy(c))), M = n7(i, g, l === s), i = 0, l++;
      }
    }
    i++, n++;
  }
  return wd(t, "");
}, M7 = function(e) {
  var t = [], r = e7(qk(t7(e), md, "."), "."), n, i;
  for (n = 0; n < r.length; n++)
    i = r[n], Nn(t, Kk(Xk, i) ? "xn--" + i7(i) : i);
  return wd(t, ".");
}, a7 = TypeError, $s = function(e, t) {
  if (e < t) throw new a7("Not enough arguments");
  return e;
}, o7 = Qe, u7 = G, s7 = ys, l7 = RangeError, hy = String.fromCharCode, my = String.fromCodePoint, c7 = u7([].join), I7 = !!my && my.length !== 1;
o7({ target: "String", stat: !0, arity: 1, forced: I7 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function(t) {
    for (var r = [], n = arguments.length, i = 0, M; n > i; ) {
      if (M = +arguments[i++], s7(M, 1114111) !== M) throw new l7(M + " is not a valid code point");
      r[i] = M < 65536 ? hy(M) : hy(((M -= 65536) >> 10) + 55296, M % 1024 + 56320);
    }
    return c7(r, "");
  }
});
var wy = B, g7 = ge, j7 = Object.getOwnPropertyDescriptor, N7 = function(e) {
  if (!g7) return wy[e];
  var t = j7(wy, e);
  return t && t.value;
}, D7 = Ir, kd = function(e, t, r) {
  for (var n in t) D7(e, n, t[n], r);
  return e;
}, ky = Ts, y7 = Math.floor, tg = function(e, t) {
  var r = e.length;
  if (r < 8)
    for (var n = 1, i, M; n < r; ) {
      for (M = n, i = e[n]; M && t(e[M - 1], i) > 0; )
        e[M] = e[--M];
      M !== n++ && (e[M] = i);
    }
  else
    for (var o = y7(r / 2), u = tg(ky(e, 0, o), t), s = tg(ky(e, o), t), l = u.length, I = s.length, g = 0, c = 0; g < l || c < I; )
      e[g + c] = g < l && c < I ? t(u[g], s[c]) <= 0 ? u[g++] : s[c++] : g < l ? u[g++] : s[c++];
  return e;
}, nj = tg, rg = Qe, Ud = B, ij = N7, T7 = Jr, vo = Ee, lr = G, ca = ge, Qd = Cd, Yd = Ir, A7 = Pn, d7 = kd, x7 = DM, E7 = s0, Mj = Xr, bd = bs, Mc = je, z7 = lt, f7 = dM, C7 = wn, L7 = ct, Pd = _e, Je = _t, O7 = Ga, Uy = ui, Qy = rj, p7 = Ps, ho = e4, Ti = $s, S7 = ze, v7 = nj, h7 = S7("iterator"), xM = "URLSearchParams", $d = xM + "Iterator", Rd = Mj.set, mt = Mj.getterFor(xM), m7 = Mj.getterFor($d), Yy = ij("fetch"), Xu = ij("Request"), Ia = ij("Headers"), ac = Xu && Xu.prototype, by = Ia && Ia.prototype, w7 = Ud.TypeError, k7 = Ud.encodeURIComponent, U7 = String.fromCharCode, Q7 = T7("String", "fromCodePoint"), Y7 = parseInt, ju = lr("".charAt), Py = lr([].join), Dn = lr([].push), Hd = lr("".replace), b7 = lr([].shift), $y = lr([].splice), Ry = lr("".split), Vd = lr("".slice), P7 = lr(/./.exec), $7 = /\+/g, oc = "�", R7 = /^[0-9a-f]+$/i, Hy = function(e, t) {
  var r = Vd(e, t, t + 2);
  return P7(R7, r) ? Y7(r, 16) : NaN;
}, H7 = function(e) {
  for (var t = 0, r = 128; r > 0 && e & r; r >>= 1)
    t++;
  return t;
}, V7 = function(e) {
  var t = null;
  switch (e.length) {
    case 1:
      t = e[0];
      break;
    case 2:
      t = (e[0] & 31) << 6 | e[1] & 63;
      break;
    case 3:
      t = (e[0] & 15) << 12 | (e[1] & 63) << 6 | e[2] & 63;
      break;
    case 4:
      t = (e[0] & 7) << 18 | (e[1] & 63) << 12 | (e[2] & 63) << 6 | e[3] & 63;
      break;
  }
  return t > 1114111 ? null : t;
}, Vy = function(e) {
  e = Hd(e, $7, " ");
  for (var t = e.length, r = "", n = 0; n < t; ) {
    var i = ju(e, n);
    if (i === "%") {
      if (ju(e, n + 1) === "%" || n + 3 > t) {
        r += "%", n++;
        continue;
      }
      var M = Hy(e, n + 1);
      if (M !== M) {
        r += i, n++;
        continue;
      }
      n += 2;
      var o = H7(M);
      if (o === 0)
        i = U7(M);
      else {
        if (o === 1 || o > 4) {
          r += oc, n++;
          continue;
        }
        for (var u = [M], s = 1; s < o && (n++, !(n + 3 > t || ju(e, n) !== "%")); ) {
          var l = Hy(e, n + 1);
          if (l !== l) {
            n += 3;
            break;
          }
          if (l > 191 || l < 128) break;
          Dn(u, l), n += 2, s++;
        }
        if (u.length !== o) {
          r += oc;
          continue;
        }
        var I = V7(u);
        I === null ? r += oc : i = Q7(I);
      }
    }
    r += i, n++;
  }
  return r;
}, _7 = /[!'()~]|%20/g, Z7 = {
  "!": "%21",
  "'": "%27",
  "(": "%28",
  ")": "%29",
  "~": "%7E",
  "%20": "+"
}, G7 = function(e) {
  return Z7[e];
}, _y = function(e) {
  return Hd(k7(e), _7, G7);
}, uc = E7(function(t, r) {
  Rd(this, {
    type: $d,
    target: mt(t).entries,
    index: 0,
    kind: r
  });
}, xM, function() {
  var t = m7(this), r = t.target, n = t.index++;
  if (!r || n >= r.length)
    return t.target = null, ho(void 0, !0);
  var i = r[n];
  switch (t.kind) {
    case "keys":
      return ho(i.key, !1);
    case "values":
      return ho(i.value, !1);
  }
  return ho([i.key, i.value], !1);
}, !0), _d = function(e) {
  this.entries = [], this.url = null, e !== void 0 && (Pd(e) ? this.parseObject(e) : this.parseQuery(typeof e == "string" ? ju(e, 0) === "?" ? Vd(e, 1) : e : Je(e)));
};
_d.prototype = {
  type: xM,
  bindURL: function(e) {
    this.url = e, this.update();
  },
  parseObject: function(e) {
    var t = this.entries, r = p7(e), n, i, M, o, u, s, l;
    if (r)
      for (n = Qy(e, r), i = n.next; !(M = vo(i, n)).done; ) {
        if (o = Qy(L7(M.value)), u = o.next, (s = vo(u, o)).done || (l = vo(u, o)).done || !vo(u, o).done) throw new w7("Expected sequence with length 2");
        Dn(t, { key: Je(s.value), value: Je(l.value) });
      }
    else for (var I in e) z7(e, I) && Dn(t, { key: I, value: Je(e[I]) });
  },
  parseQuery: function(e) {
    if (e)
      for (var t = this.entries, r = Ry(e, "&"), n = 0, i, M; n < r.length; )
        i = r[n++], i.length && (M = Ry(i, "="), Dn(t, {
          key: Vy(b7(M)),
          value: Vy(Py(M, "="))
        }));
  },
  serialize: function() {
    for (var e = this.entries, t = [], r = 0, n; r < e.length; )
      n = e[r++], Dn(t, _y(n.key) + "=" + _y(n.value));
    return Py(t, "&");
  },
  update: function() {
    this.entries.length = 0, this.parseQuery(this.url.query);
  },
  updateURL: function() {
    this.url && this.url.update();
  }
};
var Rs = function() {
  bd(this, lM);
  var t = arguments.length > 0 ? arguments[0] : void 0, r = Rd(this, new _d(t));
  ca || (this.size = r.entries.length);
}, lM = Rs.prototype;
d7(lM, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function(t, r) {
    var n = mt(this);
    Ti(arguments.length, 2), Dn(n.entries, { key: Je(t), value: Je(r) }), ca || this.length++, n.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  delete: function(e) {
    for (var t = mt(this), r = Ti(arguments.length, 1), n = t.entries, i = Je(e), M = r < 2 ? void 0 : arguments[1], o = M === void 0 ? M : Je(M), u = 0; u < n.length; ) {
      var s = n[u];
      if (s.key === i && (o === void 0 || s.value === o)) {
        if ($y(n, u, 1), o !== void 0) break;
      } else u++;
    }
    ca || (this.size = n.length), t.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function(t) {
    var r = mt(this).entries;
    Ti(arguments.length, 1);
    for (var n = Je(t), i = 0; i < r.length; i++)
      if (r[i].key === n) return r[i].value;
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function(t) {
    var r = mt(this).entries;
    Ti(arguments.length, 1);
    for (var n = Je(t), i = [], M = 0; M < r.length; M++)
      r[M].key === n && Dn(i, r[M].value);
    return i;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function(t) {
    for (var r = mt(this).entries, n = Ti(arguments.length, 1), i = Je(t), M = n < 2 ? void 0 : arguments[1], o = M === void 0 ? M : Je(M), u = 0; u < r.length; ) {
      var s = r[u++];
      if (s.key === i && (o === void 0 || s.value === o)) return !0;
    }
    return !1;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function(t, r) {
    var n = mt(this);
    Ti(arguments.length, 1);
    for (var i = n.entries, M = !1, o = Je(t), u = Je(r), s = 0, l; s < i.length; s++)
      l = i[s], l.key === o && (M ? $y(i, s--, 1) : (M = !0, l.value = u));
    M || Dn(i, { key: o, value: u }), ca || (this.size = i.length), n.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function() {
    var t = mt(this);
    v7(t.entries, function(r, n) {
      return r.key > n.key ? 1 : -1;
    }), t.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function(t) {
    for (var r = mt(this).entries, n = f7(t, arguments.length > 1 ? arguments[1] : void 0), i = 0, M; i < r.length; )
      M = r[i++], n(M.value, M.key, this);
  },
  // `URLSearchParams.prototype.keys` method
  keys: function() {
    return new uc(this, "keys");
  },
  // `URLSearchParams.prototype.values` method
  values: function() {
    return new uc(this, "values");
  },
  // `URLSearchParams.prototype.entries` method
  entries: function() {
    return new uc(this, "entries");
  }
}, { enumerable: !0 });
Yd(lM, h7, lM.entries, { name: "entries" });
Yd(lM, "toString", function() {
  return mt(this).serialize();
}, { enumerable: !0 });
ca && A7(lM, "size", {
  get: function() {
    return mt(this).entries.length;
  },
  configurable: !0,
  enumerable: !0
});
x7(Rs, xM);
rg({ global: !0, constructor: !0, forced: !Qd }, {
  URLSearchParams: Rs
});
if (!Qd && Mc(Ia)) {
  var B7 = lr(by.has), F7 = lr(by.set), Zy = function(e) {
    if (Pd(e)) {
      var t = e.body, r;
      if (C7(t) === xM)
        return r = e.headers ? new Ia(e.headers) : new Ia(), B7(r, "content-type") || F7(r, "content-type", "application/x-www-form-urlencoded;charset=UTF-8"), O7(e, {
          body: Uy(0, Je(t)),
          headers: Uy(0, r)
        });
    }
    return e;
  };
  if (Mc(Yy) && rg({ global: !0, enumerable: !0, dontCallGetSet: !0, forced: !0 }, {
    fetch: function(t) {
      return Yy(t, arguments.length > 1 ? Zy(arguments[1]) : {});
    }
  }), Mc(Xu)) {
    var sc = function(t) {
      return bd(this, ac), new Xu(t, arguments.length > 1 ? Zy(arguments[1]) : {});
    };
    ac.constructor = sc, sc.prototype = ac, rg({ global: !0, constructor: !0, dontCallGetSet: !0, forced: !0 }, {
      Request: sc
    });
  }
}
var W7 = {
  URLSearchParams: Rs,
  getState: mt
}, J7 = Qe, aj = ge, X7 = Cd, oj = B, Gy = dM, Gt = G, Ku = Ir, Lt = Pn, K7 = bs, ng = lt, uj = nk, Ai = Zk, Kt = Ts, q7 = q4.codeAt, e8 = M7, kr = _t, t8 = DM, r8 = $s, Zd = W7, Gd = Xr, n8 = Gd.set, qu = Gd.getterFor("URL"), i8 = Zd.URLSearchParams, M8 = Zd.getState, bM = oj.URL, ig = oj.TypeError, es = oj.parseInt, a8 = Math.floor, By = Math.pow, Qt = Gt("".charAt), ir = Gt(/./.exec), XM = Gt([].join), o8 = Gt(1 .toString), u8 = Gt([].pop), Ci = Gt([].push), lc = Gt("".replace), s8 = Gt([].shift), l8 = Gt("".split), ga = Gt("".slice), ts = Gt("".toLowerCase), c8 = Gt([].unshift), I8 = "Invalid authority", cc = "Invalid scheme", Hn = "Invalid host", Fy = "Invalid port", Bd = /[a-z]/i, g8 = /[\d+-.a-z]/i, Mg = /\d/, j8 = /^0x/i, N8 = /^[0-7]+$/, D8 = /^\d+$/, Fd = /^[\da-f]+$/i, y8 = /[\0\t\n\r #%/:<>?@[\\\]^|]/, T8 = /[\0\t\n\r #/:<>?@[\\\]^|]/, A8 = /^[\u0000-\u0020]+/, d8 = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/, x8 = /[\t\n\r]/g, Ot, E8 = function(e) {
  var t = l8(e, "."), r, n, i, M, o, u, s;
  if (t.length && t[t.length - 1] === "" && t.length--, r = t.length, r > 4) return e;
  for (n = [], i = 0; i < r; i++) {
    if (M = t[i], M === "") return e;
    if (o = 10, M.length > 1 && Qt(M, 0) === "0" && (o = ir(j8, M) ? 16 : 8, M = ga(M, o === 8 ? 1 : 2)), M === "")
      u = 0;
    else {
      if (!ir(o === 10 ? D8 : o === 8 ? N8 : Fd, M)) return e;
      u = es(M, o);
    }
    Ci(n, u);
  }
  for (i = 0; i < r; i++)
    if (u = n[i], i === r - 1) {
      if (u >= By(256, 5 - r)) return null;
    } else if (u > 255) return null;
  for (s = u8(n), i = 0; i < n.length; i++)
    s += n[i] * By(256, 3 - i);
  return s;
}, z8 = function(e) {
  var t = [0, 0, 0, 0, 0, 0, 0, 0], r = 0, n = null, i = 0, M, o, u, s, l, I, g, c = function() {
    return Qt(e, i);
  };
  if (c() === ":") {
    if (Qt(e, 1) !== ":") return;
    i += 2, r++, n = r;
  }
  for (; c(); ) {
    if (r === 8) return;
    if (c() === ":") {
      if (n !== null) return;
      i++, r++, n = r;
      continue;
    }
    for (M = o = 0; o < 4 && ir(Fd, c()); )
      M = M * 16 + es(c(), 16), i++, o++;
    if (c() === ".") {
      if (o === 0 || (i -= o, r > 6)) return;
      for (u = 0; c(); ) {
        if (s = null, u > 0)
          if (c() === "." && u < 4) i++;
          else return;
        if (!ir(Mg, c())) return;
        for (; ir(Mg, c()); ) {
          if (l = es(c(), 10), s === null) s = l;
          else {
            if (s === 0) return;
            s = s * 10 + l;
          }
          if (s > 255) return;
          i++;
        }
        t[r] = t[r] * 256 + s, u++, (u === 2 || u === 4) && r++;
      }
      if (u !== 4) return;
      break;
    } else if (c() === ":") {
      if (i++, !c()) return;
    } else if (c()) return;
    t[r++] = M;
  }
  if (n !== null)
    for (I = r - n, r = 7; r !== 0 && I > 0; )
      g = t[r], t[r--] = t[n + I - 1], t[n + --I] = g;
  else if (r !== 8) return;
  return t;
}, f8 = function(e) {
  for (var t = null, r = 1, n = null, i = 0, M = 0; M < 8; M++)
    e[M] !== 0 ? (i > r && (t = n, r = i), n = null, i = 0) : (n === null && (n = M), ++i);
  return i > r ? n : t;
}, PM = function(e) {
  var t, r, n, i;
  if (typeof e == "number") {
    for (t = [], r = 0; r < 4; r++)
      c8(t, e % 256), e = a8(e / 256);
    return XM(t, ".");
  }
  if (typeof e == "object") {
    for (t = "", n = f8(e), r = 0; r < 8; r++)
      i && e[r] === 0 || (i && (i = !1), n === r ? (t += r ? ":" : "::", i = !0) : (t += o8(e[r], 16), r < 7 && (t += ":")));
    return "[" + t + "]";
  }
  return e;
}, Nu = {}, Wd = uj({}, Nu, {
  " ": 1,
  '"': 1,
  "<": 1,
  ">": 1,
  "`": 1
}), Jd = uj({}, Wd, {
  "#": 1,
  "?": 1,
  "{": 1,
  "}": 1
}), Ic = uj({}, Jd, {
  "/": 1,
  ":": 1,
  ";": 1,
  "=": 1,
  "@": 1,
  "[": 1,
  "\\": 1,
  "]": 1,
  "^": 1,
  "|": 1
}), rn = function(e, t) {
  var r = q7(e, 0);
  return r > 32 && r < 127 && !ng(t, e) ? e : encodeURIComponent(e);
}, mo = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
}, KM = function(e, t) {
  var r;
  return e.length === 2 && ir(Bd, Qt(e, 0)) && ((r = Qt(e, 1)) === ":" || !t && r === "|");
}, Wy = function(e) {
  var t;
  return e.length > 1 && KM(ga(e, 0, 2)) && (e.length === 2 || (t = Qt(e, 2)) === "/" || t === "\\" || t === "?" || t === "#");
}, C8 = function(e) {
  return e === "." || ts(e) === "%2e";
}, L8 = function(e) {
  return e = ts(e), e === ".." || e === "%2e." || e === ".%2e" || e === "%2e%2e";
}, gc = {}, Jy = {}, jc = {}, Xy = {}, Ky = {}, Nc = {}, qy = {}, e1 = {}, wo = {}, ko = {}, Dc = {}, yc = {}, Tc = {}, Ac = {}, t1 = {}, dc = {}, di = {}, Tr = {}, r1 = {}, Vn = {}, wr = {}, sj = function(e, t, r) {
  var n = kr(e), i, M, o;
  if (t) {
    if (M = this.parse(n), M) throw new ig(M);
    this.searchParams = null;
  } else {
    if (r !== void 0 && (i = new sj(r, !0)), M = this.parse(n, null, i), M) throw new ig(M);
    o = M8(new i8()), o.bindURL(this), this.searchParams = o;
  }
};
sj.prototype = {
  type: "URL",
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function(e, t, r) {
    var n = this, i = t || gc, M = 0, o = "", u = !1, s = !1, l = !1, I, g, c, D;
    for (e = kr(e), t || (n.scheme = "", n.username = "", n.password = "", n.host = null, n.port = null, n.path = [], n.query = null, n.fragment = null, n.cannotBeABaseURL = !1, e = lc(e, A8, ""), e = lc(e, d8, "$1")), e = lc(e, x8, ""), I = Ai(e); M <= I.length; ) {
      switch (g = I[M], i) {
        case gc:
          if (g && ir(Bd, g))
            o += ts(g), i = Jy;
          else {
            if (t)
              return cc;
            i = jc;
            continue;
          }
          break;
        case Jy:
          if (g && (ir(g8, g) || g === "+" || g === "-" || g === "."))
            o += ts(g);
          else if (g === ":") {
            if (t && (n.isSpecial() !== ng(mo, o) || o === "file" && (n.includesCredentials() || n.port !== null) || n.scheme === "file" && !n.host)) return;
            if (n.scheme = o, t) {
              n.isSpecial() && mo[n.scheme] === n.port && (n.port = null);
              return;
            }
            o = "", n.scheme === "file" ? i = Ac : n.isSpecial() && r && r.scheme === n.scheme ? i = Xy : n.isSpecial() ? i = e1 : I[M + 1] === "/" ? (i = Ky, M++) : (n.cannotBeABaseURL = !0, Ci(n.path, ""), i = r1);
          } else {
            if (t)
              return cc;
            o = "", i = jc, M = 0;
            continue;
          }
          break;
        case jc:
          if (!r || r.cannotBeABaseURL && g !== "#") return cc;
          if (r.cannotBeABaseURL && g === "#") {
            n.scheme = r.scheme, n.path = Kt(r.path), n.query = r.query, n.fragment = "", n.cannotBeABaseURL = !0, i = wr;
            break;
          }
          i = r.scheme === "file" ? Ac : Nc;
          continue;
        case Xy:
          if (g === "/" && I[M + 1] === "/")
            i = wo, M++;
          else {
            i = Nc;
            continue;
          }
          break;
        case Ky:
          if (g === "/") {
            i = ko;
            break;
          } else {
            i = Tr;
            continue;
          }
        case Nc:
          if (n.scheme = r.scheme, g === Ot)
            n.username = r.username, n.password = r.password, n.host = r.host, n.port = r.port, n.path = Kt(r.path), n.query = r.query;
          else if (g === "/" || g === "\\" && n.isSpecial())
            i = qy;
          else if (g === "?")
            n.username = r.username, n.password = r.password, n.host = r.host, n.port = r.port, n.path = Kt(r.path), n.query = "", i = Vn;
          else if (g === "#")
            n.username = r.username, n.password = r.password, n.host = r.host, n.port = r.port, n.path = Kt(r.path), n.query = r.query, n.fragment = "", i = wr;
          else {
            n.username = r.username, n.password = r.password, n.host = r.host, n.port = r.port, n.path = Kt(r.path), n.path.length--, i = Tr;
            continue;
          }
          break;
        case qy:
          if (n.isSpecial() && (g === "/" || g === "\\"))
            i = wo;
          else if (g === "/")
            i = ko;
          else {
            n.username = r.username, n.password = r.password, n.host = r.host, n.port = r.port, i = Tr;
            continue;
          }
          break;
        case e1:
          if (i = wo, g !== "/" || Qt(o, M + 1) !== "/") continue;
          M++;
          break;
        case wo:
          if (g !== "/" && g !== "\\") {
            i = ko;
            continue;
          }
          break;
        case ko:
          if (g === "@") {
            u && (o = "%40" + o), u = !0, c = Ai(o);
            for (var j = 0; j < c.length; j++) {
              var N = c[j];
              if (N === ":" && !l) {
                l = !0;
                continue;
              }
              var d = rn(N, Ic);
              l ? n.password += d : n.username += d;
            }
            o = "";
          } else if (g === Ot || g === "/" || g === "?" || g === "#" || g === "\\" && n.isSpecial()) {
            if (u && o === "") return I8;
            M -= Ai(o).length + 1, o = "", i = Dc;
          } else o += g;
          break;
        case Dc:
        case yc:
          if (t && n.scheme === "file") {
            i = dc;
            continue;
          } else if (g === ":" && !s) {
            if (o === "") return Hn;
            if (D = n.parseHost(o), D) return D;
            if (o = "", i = Tc, t === yc) return;
          } else if (g === Ot || g === "/" || g === "?" || g === "#" || g === "\\" && n.isSpecial()) {
            if (n.isSpecial() && o === "") return Hn;
            if (t && o === "" && (n.includesCredentials() || n.port !== null)) return;
            if (D = n.parseHost(o), D) return D;
            if (o = "", i = di, t) return;
            continue;
          } else
            g === "[" ? s = !0 : g === "]" && (s = !1), o += g;
          break;
        case Tc:
          if (ir(Mg, g))
            o += g;
          else if (g === Ot || g === "/" || g === "?" || g === "#" || g === "\\" && n.isSpecial() || t) {
            if (o !== "") {
              var T = es(o, 10);
              if (T > 65535) return Fy;
              n.port = n.isSpecial() && T === mo[n.scheme] ? null : T, o = "";
            }
            if (t) return;
            i = di;
            continue;
          } else return Fy;
          break;
        case Ac:
          if (n.scheme = "file", g === "/" || g === "\\") i = t1;
          else if (r && r.scheme === "file")
            switch (g) {
              case Ot:
                n.host = r.host, n.path = Kt(r.path), n.query = r.query;
                break;
              case "?":
                n.host = r.host, n.path = Kt(r.path), n.query = "", i = Vn;
                break;
              case "#":
                n.host = r.host, n.path = Kt(r.path), n.query = r.query, n.fragment = "", i = wr;
                break;
              default:
                Wy(XM(Kt(I, M), "")) || (n.host = r.host, n.path = Kt(r.path), n.shortenPath()), i = Tr;
                continue;
            }
          else {
            i = Tr;
            continue;
          }
          break;
        case t1:
          if (g === "/" || g === "\\") {
            i = dc;
            break;
          }
          r && r.scheme === "file" && !Wy(XM(Kt(I, M), "")) && (KM(r.path[0], !0) ? Ci(n.path, r.path[0]) : n.host = r.host), i = Tr;
          continue;
        case dc:
          if (g === Ot || g === "/" || g === "\\" || g === "?" || g === "#") {
            if (!t && KM(o))
              i = Tr;
            else if (o === "") {
              if (n.host = "", t) return;
              i = di;
            } else {
              if (D = n.parseHost(o), D) return D;
              if (n.host === "localhost" && (n.host = ""), t) return;
              o = "", i = di;
            }
            continue;
          } else o += g;
          break;
        case di:
          if (n.isSpecial()) {
            if (i = Tr, g !== "/" && g !== "\\") continue;
          } else if (!t && g === "?")
            n.query = "", i = Vn;
          else if (!t && g === "#")
            n.fragment = "", i = wr;
          else if (g !== Ot && (i = Tr, g !== "/"))
            continue;
          break;
        case Tr:
          if (g === Ot || g === "/" || g === "\\" && n.isSpecial() || !t && (g === "?" || g === "#")) {
            if (L8(o) ? (n.shortenPath(), g !== "/" && !(g === "\\" && n.isSpecial()) && Ci(n.path, "")) : C8(o) ? g !== "/" && !(g === "\\" && n.isSpecial()) && Ci(n.path, "") : (n.scheme === "file" && !n.path.length && KM(o) && (n.host && (n.host = ""), o = Qt(o, 0) + ":"), Ci(n.path, o)), o = "", n.scheme === "file" && (g === Ot || g === "?" || g === "#"))
              for (; n.path.length > 1 && n.path[0] === ""; )
                s8(n.path);
            g === "?" ? (n.query = "", i = Vn) : g === "#" && (n.fragment = "", i = wr);
          } else
            o += rn(g, Jd);
          break;
        case r1:
          g === "?" ? (n.query = "", i = Vn) : g === "#" ? (n.fragment = "", i = wr) : g !== Ot && (n.path[0] += rn(g, Nu));
          break;
        case Vn:
          !t && g === "#" ? (n.fragment = "", i = wr) : g !== Ot && (g === "'" && n.isSpecial() ? n.query += "%27" : g === "#" ? n.query += "%23" : n.query += rn(g, Nu));
          break;
        case wr:
          g !== Ot && (n.fragment += rn(g, Wd));
          break;
      }
      M++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function(e) {
    var t, r, n;
    if (Qt(e, 0) === "[") {
      if (Qt(e, e.length - 1) !== "]" || (t = z8(ga(e, 1, -1)), !t)) return Hn;
      this.host = t;
    } else if (this.isSpecial()) {
      if (e = e8(e), ir(y8, e) || (t = E8(e), t === null)) return Hn;
      this.host = t;
    } else {
      if (ir(T8, e)) return Hn;
      for (t = "", r = Ai(e), n = 0; n < r.length; n++)
        t += rn(r[n], Nu);
      this.host = t;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function() {
    return !this.host || this.cannotBeABaseURL || this.scheme === "file";
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function() {
    return this.username !== "" || this.password !== "";
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function() {
    return ng(mo, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function() {
    var e = this.path, t = e.length;
    t && (this.scheme !== "file" || t !== 1 || !KM(e[0], !0)) && e.length--;
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function() {
    var e = this, t = e.scheme, r = e.username, n = e.password, i = e.host, M = e.port, o = e.path, u = e.query, s = e.fragment, l = t + ":";
    return i !== null ? (l += "//", e.includesCredentials() && (l += r + (n ? ":" + n : "") + "@"), l += PM(i), M !== null && (l += ":" + M)) : t === "file" && (l += "//"), l += e.cannotBeABaseURL ? o[0] : o.length ? "/" + XM(o, "/") : "", u !== null && (l += "?" + u), s !== null && (l += "#" + s), l;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function(e) {
    var t = this.parse(e);
    if (t) throw new ig(t);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function() {
    var e = this.scheme, t = this.port;
    if (e === "blob") try {
      return new cM(e.path[0]).origin;
    } catch (r) {
      return "null";
    }
    return e === "file" || !this.isSpecial() ? "null" : e + "://" + PM(this.host) + (t !== null ? ":" + t : "");
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function() {
    return this.scheme + ":";
  },
  setProtocol: function(e) {
    this.parse(kr(e) + ":", gc);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function() {
    return this.username;
  },
  setUsername: function(e) {
    var t = Ai(kr(e));
    if (!this.cannotHaveUsernamePasswordPort()) {
      this.username = "";
      for (var r = 0; r < t.length; r++)
        this.username += rn(t[r], Ic);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function() {
    return this.password;
  },
  setPassword: function(e) {
    var t = Ai(kr(e));
    if (!this.cannotHaveUsernamePasswordPort()) {
      this.password = "";
      for (var r = 0; r < t.length; r++)
        this.password += rn(t[r], Ic);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function() {
    var e = this.host, t = this.port;
    return e === null ? "" : t === null ? PM(e) : PM(e) + ":" + t;
  },
  setHost: function(e) {
    this.cannotBeABaseURL || this.parse(e, Dc);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function() {
    var e = this.host;
    return e === null ? "" : PM(e);
  },
  setHostname: function(e) {
    this.cannotBeABaseURL || this.parse(e, yc);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function() {
    var e = this.port;
    return e === null ? "" : kr(e);
  },
  setPort: function(e) {
    this.cannotHaveUsernamePasswordPort() || (e = kr(e), e === "" ? this.port = null : this.parse(e, Tc));
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function() {
    var e = this.path;
    return this.cannotBeABaseURL ? e[0] : e.length ? "/" + XM(e, "/") : "";
  },
  setPathname: function(e) {
    this.cannotBeABaseURL || (this.path = [], this.parse(e, di));
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function() {
    var e = this.query;
    return e ? "?" + e : "";
  },
  setSearch: function(e) {
    e = kr(e), e === "" ? this.query = null : (Qt(e, 0) === "?" && (e = ga(e, 1)), this.query = "", this.parse(e, Vn)), this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function() {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function() {
    var e = this.fragment;
    return e ? "#" + e : "";
  },
  setHash: function(e) {
    if (e = kr(e), e === "") {
      this.fragment = null;
      return;
    }
    Qt(e, 0) === "#" && (e = ga(e, 1)), this.fragment = "", this.parse(e, wr);
  },
  update: function() {
    this.query = this.searchParams.serialize() || null;
  }
};
var cM = function(t) {
  var r = K7(this, We), n = r8(arguments.length, 1) > 1 ? arguments[1] : void 0, i = n8(r, new sj(t, !1, n));
  aj || (r.href = i.serialize(), r.origin = i.getOrigin(), r.protocol = i.getProtocol(), r.username = i.getUsername(), r.password = i.getPassword(), r.host = i.getHost(), r.hostname = i.getHostname(), r.port = i.getPort(), r.pathname = i.getPathname(), r.search = i.getSearch(), r.searchParams = i.getSearchParams(), r.hash = i.getHash());
}, We = cM.prototype, pt = function(e, t) {
  return {
    get: function() {
      return qu(this)[e]();
    },
    set: t && function(r) {
      return qu(this)[t](r);
    },
    configurable: !0,
    enumerable: !0
  };
};
aj && (Lt(We, "href", pt("serialize", "setHref")), Lt(We, "origin", pt("getOrigin")), Lt(We, "protocol", pt("getProtocol", "setProtocol")), Lt(We, "username", pt("getUsername", "setUsername")), Lt(We, "password", pt("getPassword", "setPassword")), Lt(We, "host", pt("getHost", "setHost")), Lt(We, "hostname", pt("getHostname", "setHostname")), Lt(We, "port", pt("getPort", "setPort")), Lt(We, "pathname", pt("getPathname", "setPathname")), Lt(We, "search", pt("getSearch", "setSearch")), Lt(We, "searchParams", pt("getSearchParams")), Lt(We, "hash", pt("getHash", "setHash")));
Ku(We, "toJSON", function() {
  return qu(this).serialize();
}, { enumerable: !0 });
Ku(We, "toString", function() {
  return qu(this).serialize();
}, { enumerable: !0 });
if (bM) {
  var n1 = bM.createObjectURL, i1 = bM.revokeObjectURL;
  n1 && Ku(cM, "createObjectURL", Gy(n1, bM)), i1 && Ku(cM, "revokeObjectURL", Gy(i1, bM));
}
t8(cM, "URL");
J7({ global: !0, constructor: !0, forced: !X7, sham: !aj }, {
  URL: cM
});
var O8 = Qe, p8 = Ee;
O8({ target: "URL", proto: !0, enumerable: !0 }, {
  toJSON: function() {
    return p8(URL.prototype.toString, this);
  }
});
var S8 = Ir, Hs = G, M1 = _t, v8 = $s, Xd = URLSearchParams, Vs = Xd.prototype, h8 = Hs(Vs.append), a1 = Hs(Vs.delete), m8 = Hs(Vs.forEach), w8 = Hs([].push), lj = new Xd("a=1&a=2&b=3");
lj.delete("a", 1);
lj.delete("b", void 0);
lj + "" != "a=2" && S8(Vs, "delete", function(e) {
  var t = arguments.length, r = t < 2 ? void 0 : arguments[1];
  if (t && r === void 0) return a1(this, e);
  var n = [];
  m8(this, function(g, c) {
    w8(n, { key: c, value: g });
  }), v8(t, 1);
  for (var i = M1(e), M = M1(r), o = 0, u = 0, s = !1, l = n.length, I; o < l; )
    I = n[o++], s || I.key === i ? (s = !0, a1(this, I.key)) : u++;
  for (; u < l; )
    I = n[u++], I.key === i && I.value === M || h8(this, I.key, I.value);
}, { enumerable: !0, unsafe: !0 });
var k8 = Ir, Kd = G, U8 = _t, Q8 = $s, qd = URLSearchParams, cj = qd.prototype, Y8 = Kd(cj.getAll), b8 = Kd(cj.has), o1 = new qd("a=1");
(o1.has("a", 2) || !o1.has("a", void 0)) && k8(cj, "has", function(t) {
  var r = arguments.length, n = r < 2 ? void 0 : arguments[1];
  if (r && n === void 0) return b8(this, t);
  var i = Y8(this, t);
  Q8(r, 1);
  for (var M = U8(n), o = 0; o < i.length; )
    if (i[o++] === M) return !0;
  return !1;
}, { enumerable: !0, unsafe: !0 });
var P8 = ge, $8 = G, R8 = Pn, ag = URLSearchParams.prototype, H8 = $8(ag.forEach);
P8 && !("size" in ag) && R8(ag, "size", {
  get: function() {
    var t = 0;
    return H8(this, function() {
      t++;
    }), t;
  },
  configurable: !0,
  enumerable: !0
});
function $M(e, t, r) {
  return (t = V8(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function V8(e) {
  var t = _8(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function _8(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class Z8 {
  constructor() {
    $M(this, "_levels", []), $M(this, "_transports", []), $M(this, "_logs", []), $M(this, "_prevTime", 0), $M(this, "logListener", null);
    try {
      if (!window.localStorage) return;
      const t = window.localStorage.getItem("logger");
      if (!t) return;
      const [r, n] = t.split(">");
      this._levels = r.split(","), n && (this._transports = n.split(","));
    } catch (t) {
      return;
    }
  }
  create(t, r) {
    return (n) => {
      if (!this._levels.includes(t) && !this._levels.includes("all") && !this.logListener) return;
      const i = Date.now();
      let M = 0;
      if (this._prevTime && (M = i - this._prevTime), this._prevTime = i, this.logListener && this.logListener("".concat(t, ": ").concat(n, " +").concat(M, "ms")), this._transports.includes("console")) {
        const o = (r == null ? void 0 : r.color) || "blue";
        console.log("%c%s: %c%s %c+%dms", "color: ".concat(o, ";"), t, "", n, "color: ".concat(o, ";"), M);
      }
      this._transports.includes("file") && this._logs.push("".concat(t, ": ").concat(n, " +").concat(M, "ms"));
    };
  }
  saveLogs() {
    if (!this._logs.length) return;
    const t = this._logs.join(`
`), r = new Blob([t], {
      type: "text/plain"
    }), n = window.URL.createObjectURL(r), i = document.createElement("a");
    i.download = "log.txt", i.href = n, i.click(), window.URL.revokeObjectURL(n), this._logs = [];
  }
}
const Bt = new Z8();
var Sr = /* @__PURE__ */ ((e) => (e.WASM_ERROR = "WASM_ERROR", e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_SUPPORTED = "NOT_SUPPORTED", e.CAMERA_UNKNOWN_ERROR = "CAMERA_UNKNOWN_ERROR", e.CAMERA_PERMISSION_DENIED = "CAMERA_PERMISSION_DENIED", e.NO_CAMERA = "NO_CAMERA", e.INCORRECT_CAMERA_ID = "INCORRECT_CAMERA_ID", e.CONNECTION_ERROR = "CONNECTION_ERROR", e.LANDSCAPE_MODE_RESTRICTED = "LANDSCAPE_MODE_RESTRICTED", e.TIMEOUT_ERROR = "TIMEOUT_ERROR", e.CHANGE_CAMERA = "CHANGE_CAMERA", e.DEVICE_ROTATE = "DEVICE_ROTATE", e.APP_INACTIVE = "APP_INACTIVE", e.HTTP_NOT_SUPPORTED = "HTTP_NOT_SUPPORTED", e.WEBSERVICE_NOT_COMPATIBLE = "WEBSERVICE_NOT_COMPATIBLE", e))(Sr || {}), Le = /* @__PURE__ */ ((e) => (e[e.Empty = 0] = "Empty", e[e.FitFaceIntoOval = 1] = "FitFaceIntoOval", e[e.LookStraight = 2] = "LookStraight", e[e.MoveCloser = 3] = "MoveCloser", e[e.MoveAway = 4] = "MoveAway", e[e.HoldStill = 5] = "HoldStill", e[e.ShowOnlyOneFace = 6] = "ShowOnlyOneFace", e[e.TurnHead = 7] = "TurnHead", e[e.GiveMoreLight = 8] = "GiveMoreLight", e[e.RemoveOcclusion = 9] = "RemoveOcclusion", e))(Le || {}), Ij = /* @__PURE__ */ ((e) => (e[e.Far = 0] = "Far", e[e.Near = 1] = "Near", e))(Ij || {}), Re = /* @__PURE__ */ ((e) => (e[e.Finished = 0] = "Finished", e[e.InProcess = 1] = "InProcess", e[e.Timeout = 2] = "Timeout", e[e.Failed = 3] = "Failed", e[e.Stop_Session = 4] = "Stop_Session", e))(Re || {}), Ua = /* @__PURE__ */ ((e) => (e[e.ASYNCHRONOUS_UPLOAD = 0] = "ASYNCHRONOUS_UPLOAD", e[e.SYNCHRONOUS_UPLOAD = 1] = "SYNCHRONOUS_UPLOAD", e[e.NOT_UPLOAD = 2] = "NOT_UPLOAD", e))(Ua || {}), xe = /* @__PURE__ */ ((e) => (e.ELEMENT_VISIBLE = "ELEMENT_VISIBLE", e.PRESS_START_BUTTON = "PRESS_START_BUTTON", e.PRESS_RETRY_BUTTON = "PRESS_RETRY_BUTTON", e.CLOSE = "CLOSE", e.PROCESS_FINISHED = "PROCESS_FINISHED", e.SERVICE_INITIALIZED = "SERVICE_INITIALIZED", e.RETRY_COUNTER_EXCEEDED = "RETRY_COUNTER_EXCEEDED", e))(xe || {}), Yt = /* @__PURE__ */ ((e) => (e.CHANGE_CAMERA = "FaceAbortSessionStatus.CHANGE_CAMERA", e.DEVICE_ROTATE = "FaceAbortSessionStatus.DEVICE_ROTATE", e.SESSION_TIMEOUT = "FaceAbortSessionStatus.TIMEOUT", e.CLOSE_BUTTON = "FaceAbortSessionStatus.CLOSE_BUTTON", e.UNKNOWN = "FaceAbortSessionStatus.UNKNOWN", e.APP_INACTIVE = "FaceAbortSessionStatus.APP_INACTIVE", e))(Yt || {}), m = /* @__PURE__ */ ((e) => (e.RESTART = "FaceCompletionStatus.RESTART", e.ABORT_PROCESSING = "FaceCompletionStatus.ABORT_PROCESSING", e.INSTRUCTION = "FaceCompletionStatus.INSTRUCTION", e.SUCCESS = "FaceCompletionStatus.SUCCESS", e.FAILED = "FaceCompletionStatus.FAILED", e.CAPTURING = "FaceCompletionStatus.CAPTURING", e.PROCESSING_REQUEST = "FaceCompletionStatus.PROCESSING_REQUEST", e.WASM_DEFAULT_ERROR = "FaceCompletionStatus.WASM_DEFAULT_ERROR", e.NOT_SUPPORTED_ERROR = "FaceCompletionStatus.NOT_SUPPORTED_ERROR", e.UNKNOWN_ERROR = "FaceCompletionStatus.UNKNOWN_ERROR", e.NO_CAMERA_ERROR = "FaceCompletionStatus.NO_CAMERA_ERROR", e.PERMISSION_DENIED_ERROR = "FaceCompletionStatus.PERMISSION_DENIED_ERROR", e.INCORRECT_CAMERA_ID_ERROR = "FaceCompletionStatus.INCORRECT_CAMERA_ID_ERROR", e.HTTP_NOT_SUPPORTED = "HTTP_NOT_SUPPORTED", e.WEBSERVICE_NOT_COMPATIBLE = "WEBSERVICE_NOT_COMPATIBLE", e))(m || {});
const G8 = "face-liveness", B8 = "face-capture", ja = 3, Ri = "https://faceapi.regulaforensics.com", F8 = 200, u1 = {
  199: {
    name: "FACER_CONFIG_ERROR",
    type: -1
  },
  201: {
    name: "FACER_IS_NOT_INITIALIZED",
    type: -1
  },
  202: {
    name: "FACER_COMMAND_IS_NOT_SUPPORTED",
    type: -1
  },
  203: {
    name: "FACER_COMMAND_PARAMS_READ_ERROR",
    type: 1
  },
  224: {
    name: "FACER_LESS_THAN_TWO_IMAGES_IN_REQUEST",
    type: -1
  },
  227: {
    name: "FACER_VIDEO_DECODE_ERROR",
    type: -1
  },
  228: {
    name: "FACER_NOT_ENOUGH_FRAMES",
    type: -1
  },
  229: {
    name: "FACER_OUTPUT_IS_NOT_DEFINED",
    type: -1
  },
  230: {
    name: "FACER_CLOSED_EYES_DETECTED",
    type: 2
  },
  231: {
    name: "FACER_LOW_QUALITY",
    type: 1
  },
  232: {
    name: "FACER_HIGH_ASYMMETRY",
    type: 2
  },
  233: {
    name: "FACER_FACE_OVER_EMOTIONAL",
    type: 2
  },
  234: {
    name: "FACER_SUNGLASSES_DETECTED",
    type: 2
  },
  235: {
    name: "FACER_SMALL_AGE",
    type: 2
  },
  236: {
    name: "FACER_HEADDRESS_DETECTED",
    type: 2
  },
  237: {
    name: "FACER_FACES_NOT_MATCHED",
    type: -1
  },
  238: {
    name: "FACER_IMAGES_COUNT_LIMIT_EXCEEDED",
    type: -1
  },
  239: {
    name: "FACER_MEDICINE_MASK_DETECTED",
    type: 2
  },
  240: {
    name: "FACER_OCCLUSION_DETECTED",
    type: 2
  },
  242: {
    name: "FACER_FOREHEAD_GLASSES_DETECTED",
    type: 2
  },
  243: {
    name: "FACER_MOUTH_OPENED",
    type: 2
  },
  244: {
    name: "FACER_ART_MASK_DETECTED",
    type: 2
  },
  245: {
    name: "FACER_ELECTRONIC_DEVICE_DETECTED",
    type: -1
  },
  246: {
    name: "FACER_TRACK_BREAK",
    type: 1
  },
  247: {
    name: "FACER_WRONG_GEO",
    type: -1
  },
  248: {
    name: "FACER_WRONG_OF",
    type: -1
  },
  249: {
    name: "FACER_WRONG_VIEW",
    type: -1
  }
}, s1 = 200, W8 = {
  WASM_ERROR: "FaceCompletionStatus.WASM_DEFAULT_ERROR",
  NOT_SUPPORTED: "FaceCompletionStatus.NOT_SUPPORTED_ERROR",
  HTTP_NOT_SUPPORTED: "HTTP_NOT_SUPPORTED",
  WEBSERVICE_NOT_COMPATIBLE: "WEBSERVICE_NOT_COMPATIBLE"
  /* WEBSERVICE_NOT_COMPATIBLE */
}, e5 = {
  iOS: {
    Chrome: 99,
    Firefox: 99,
    Opera: 44,
    Safari: 11,
    Edge: 16,
    Chromium: 57,
    IE: 16,
    "Internet Explorer": 16,
    "Mobile Safari": 11,
    "Samsung Browser": 7
  },
  Android: {
    Chrome: 69,
    Firefox: 63,
    Opera: 44,
    Safari: 11,
    Edge: 16,
    Chromium: 57,
    IE: 16,
    "Internet Explorer": 16,
    "Mobile Safari": 11,
    "Samsung Browser": 7
  },
  desktop: {
    Chrome: 66,
    Firefox: 69,
    Opera: 44,
    Safari: 11,
    Edge: 16,
    Chromium: 57,
    IE: 16,
    "Internet Explorer": 16,
    "Mobile Safari": 11,
    "Samsung Browser": 7
  }
}, l1 = 22.5, J8 = [3, 4, 5], X8 = 1e3, K8 = 1500, q8 = [
  1,
  4,
  3,
  7,
  2,
  9
  /* RemoveOcclusion */
], e6 = [
  4,
  3,
  1
  /* FitFaceIntoOval */
];
var Du = /* @__PURE__ */ ((e) => (e.aborted = "liveness_aborted", e.timeout = "liveness_timeout", e.default = "liveness_default", e.inactive = "liveness_inactive", e))(Du || {}), _s = /* @__PURE__ */ ((e) => (e[e.ACTIVE = 0] = "ACTIVE", e[e.PASSIVE = 1] = "PASSIVE", e))(_s || {}), og = /* @__PURE__ */ ((e) => (e[e.FACE_LIVENESS = 0] = "FACE_LIVENESS", e[e.FACE_CAPTURE = 1] = "FACE_CAPTURE", e[e.FACE_PASSIVE_LIVENESS = 2] = "FACE_PASSIVE_LIVENESS", e))(og || {});
function c1(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function xc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? c1(Object(r), !0).forEach(function(n) {
      t6(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c1(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function t6(e, t, r) {
  return (t = r6(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function r6(e) {
  var t = n6(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function n6(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const i6 = Bt.create("main"), I1 = {
  locale: void 0,
  url: void 0,
  debug: void 0,
  headers: void 0,
  tag: "",
  copyright: void 0,
  cameraId: void 0,
  changeCamera: !0,
  startScreen: void 0,
  deviceOrientation: void 0,
  closeDisabled: void 0,
  finishScreen: void 0,
  retryCount: -1,
  customization: {},
  metadata: {},
  nonce: void 0,
  rotationAngle: void 0,
  recordingProcess: Ua.ASYNCHRONOUS_UPLOAD,
  livenessType: _s.ACTIVE,
  holdStillDuration: void 0,
  timeoutInterval: void 0,
  workerPath: "https://wasm.regulaforensics.com/face/release/6.4/b5a9def0-bc5346988",
  detectOcclusion: !0
}, M6 = (e) => xc(xc({}, I1), {}, {
  onEvent: () => i6('Function "onEvent" not defined.'),
  setTag: (t) => e(() => ({
    tag: t
  })),
  setUserCameraId: (t) => e(() => ({
    cameraId: t
  })),
  setRetryCount: (t) => e(() => ({
    retryCount: t
  })),
  decreaseRetryCount: () => e((t) => {
    const r = t.retryCount;
    return {
      retryCount: r < 0 ? t.retryCount : r - 1
    };
  }),
  resetAttributes: () => e(() => xc({}, I1))
});
var rs = /* @__PURE__ */ ((e) => (e.UINT = "UINT", e.BASE64 = "BASE64", e.UINT_AND_BASE64 = "UINT_AND_BASE64", e))(rs || {}), nt = /* @__PURE__ */ ((e) => (e[e.EMPTY = -1] = "EMPTY", e[e.ERROR = 0] = "ERROR", e[e.OK = 1] = "OK", e[e.TIMEOUT = 2] = "TIMEOUT", e))(nt || {}), _ = /* @__PURE__ */ ((e) => (e.PREPARING = "StreamStatus.PREPARING", e.REQUESTING = "StreamStatus.REQUESTING", e.READY = "StreamStatus.READY", e.PLAY = "StreamStatus.PLAY", e.UNKNOWN_ERROR = "StreamStatus.UNKNOWN_ERROR", e.NOT_SUPPORTED = "StreamStatus.NOT_SUPPORTED", e.HTTP_NOT_SUPPORTED = "StreamStatus.HTTP_NOT_SUPPORTED", e.INSECURE_PAGE_CONTEXT = "StreamStatus.INSECURE_PAGE_CONTEXT", e.PERMISSION_DENIED = "StreamStatus.PERMISSION_DENIED", e.NO_CAMERA = "StreamStatus.NO_CAMERA", e.INCORRECT_CAMERA_ID = "StreamStatus.INCORRECT_CAMERA_ID", e))(_ || {}), ur = /* @__PURE__ */ ((e) => (e.user = "user", e.environment = "environment", e))(ur || {}), Pr = /* @__PURE__ */ ((e) => (e.contain = "contain", e.cover = "cover", e))(Pr || {}), t5 = /* @__PURE__ */ ((e) => (e[e.HAVE_NOTHING = 0] = "HAVE_NOTHING", e[e.HAVE_METADATA = 1] = "HAVE_METADATA", e[e.HAVE_CURRENT_DATA = 2] = "HAVE_CURRENT_DATA", e[e.HAVE_FUTURE_DATA = 3] = "HAVE_FUTURE_DATA", e[e.HAVE_ENOUGH_DATA = 4] = "HAVE_ENOUGH_DATA", e))(t5 || {}), ug = /* @__PURE__ */ ((e) => (e.Rtl = "rtl", e.Ltr = "ltr", e))(ug || {}), r5 = /* @__PURE__ */ ((e) => (e.mirror = "mirror", e.noMirror = "noMirror", e))(r5 || {});
const a6 = "NotAllowedError", g1 = "en", o6 = ["ar", "he"], u6 = 1, s6 = 500, l6 = 1500, j1 = 1e4, Qa = {
  VGA: {
    width: 640,
    height: 480
  },
  HD: {
    width: 1280,
    height: 720
  },
  FULL_HD: {
    width: 1920,
    height: 1080
  },
  SQUARE: {
    width: 720,
    height: 720
  }
}, c6 = ["rear", "back", "rück", "arrière", "trasera", "trás", "traseira", "posteriore", "posterior", "后面", "後面", "背面", "后置", "後置", "背置", "задней", "الخلفية", "خلفية", "후", "arka", "achterzijde", "หลัง", "baksidan", "bagside", "sau", "bak", "tylny", "takakamera", "belakang", "אחורית", "πίσω", "spate", "hátsó", "zadní", "darrere", "zadná", "задня", "задна", "birou", "артқы", "stražnja", "belakang", "बैक"], I6 = {
  "StreamStatus.UNKNOWN_ERROR": "CAMERA_UNKNOWN_ERROR",
  "StreamStatus.PERMISSION_DENIED": "CAMERA_PERMISSION_DENIED",
  "StreamStatus.NO_CAMERA": "NO_CAMERA",
  "StreamStatus.INCORRECT_CAMERA_ID": "INCORRECT_CAMERA_ID",
  "StreamStatus.NOT_SUPPORTED": "NOT_SUPPORTED",
  "StreamStatus.HTTP_NOT_SUPPORTED": "HTTP_NOT_SUPPORTED",
  "StreamStatus.INSECURE_PAGE_CONTEXT": "INSECURE_PAGE_CONTEXT"
  /* INSECURE_PAGE_CONTEXT */
}, g6 = "rgl-uid";
function N1(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ec(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? N1(Object(r), !0).forEach(function(n) {
      j6(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : N1(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function j6(e, t, r) {
  return (t = N6(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function N6(e) {
  var t = D6(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function D6(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const D1 = {
  publicKey: void 0,
  transactionId: "",
  images: [],
  abortProcess: !1,
  abortSessionStatus: null,
  faceSnapshot: !1,
  response: {
    code: nt.EMPTY
  },
  request: null,
  completionStatus: m.INSTRUCTION
}, y6 = (e, t) => Ec(Ec({}, D1), {}, {
  setRequest: (r) => e(() => ({
    request: r
  })),
  setResponse: (r) => e(() => ({
    response: r
  })),
  setAbortSessionStatus: (r) => e(() => ({
    abortSessionStatus: r
  })),
  setAbortProcess: (r) => e(() => ({
    abortProcess: r
  })),
  setImages: (r) => e(() => ({
    images: r
  })),
  setPublicKey: (r) => e(() => ({
    publicKey: r
  })),
  setTransactionId: (r) => e(() => ({
    transactionId: r
  })),
  setCompletionStatus: (r) => e(() => ({
    completionStatus: r
  })),
  onRestart: (r) => Ce(void 0, null, function* () {
    const n = t().abortSessionStatus, i = n === Yt.CHANGE_CAMERA, M = n === Yt.DEVICE_ROTATE, o = n === Yt.SESSION_TIMEOUT || n === Yt.APP_INACTIVE;
    if (r) {
      e(() => ({
        completionStatus: m.RESTART,
        request: null,
        response: {
          code: nt.EMPTY
        },
        images: []
      }));
      return;
    }
    o ? e(() => ({
      completionStatus: m.FAILED,
      request: null,
      response: {
        code: nt.EMPTY
      },
      images: []
    })) : (yield e(() => ({
      completionStatus: m.RESTART
    })), e((u) => ({
      completionStatus: u.startScreen && !i && !M ? m.INSTRUCTION : m.CAPTURING,
      request: null,
      response: {
        code: nt.EMPTY
      },
      images: []
    })));
  }),
  onStart: () => {
    e((r) => (r.onEvent({
      action: xe.PRESS_START_BUTTON,
      data: null
    }), {
      completionStatus: m.CAPTURING
    }));
  },
  onRotateDevice: (r, n) => {
    const i = t().completionStatus;
    i === m.RESTART && e((M) => ({
      completionStatus: M.startScreen ? m.INSTRUCTION : m.CAPTURING
    })), i === m.CAPTURING && (r || n) && e((M) => (M.onEvent({
      action: xe.PROCESS_FINISHED,
      data: {
        status: nt.ERROR,
        reason: r ? Sr.LANDSCAPE_MODE_RESTRICTED : Sr.DEVICE_ROTATE
      }
    }), {
      abortProcess: !0,
      abortSessionStatus: Yt.DEVICE_ROTATE
    }));
  },
  onError: (r) => {
    const n = W8[r.type] || m.UNKNOWN_ERROR;
    e((i) => (i.onEvent({
      action: xe.PROCESS_FINISHED,
      data: {
        status: nt.ERROR,
        reason: r.type
      }
    }), {
      completionStatus: n
    }));
  },
  resetProps: () => e(() => Ec({}, D1))
});
function y1(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function T1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? y1(Object(r), !0).forEach(function(n) {
      T6(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : y1(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function T6(e, t, r) {
  return (t = A6(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function A6(e) {
  var t = d6(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function d6(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const Q = Lw(function() {
  return T1(T1({}, M6(...arguments)), y6(...arguments));
}), x6 = 18, E6 = "#8C8C8C";
function n5(e) {
  let {
    onClose: t,
    children: r,
    direction: n
  } = e;
  const {
    isPortrait: i,
    isLandscape: M
  } = X4(), {
    translate: o,
    locale: u
  } = Ii.useLocalize(), {
    copyright: s,
    closeDisabled: l,
    rotationAngle: I
  } = Q();
  f.useEffect(() => {
    const c = document.getElementsByTagName("body")[0];
    return c.style.overflow = "hidden", () => {
      c.style.overflow = "";
    };
  });
  const g = f.useMemo(() => eo && I && I !== 0 && I !== 180, [I]);
  return /* @__PURE__ */ a.jsxs("div", { className: "".concat(QM.window, " ").concat(g ? QM.windowRotate : ""), "data-device": Vr && i || g ? "mobile" : "desktop", "data-direction": n, "data-locale": u, children: [
    ka && M && /* @__PURE__ */ a.jsx(vt, { type: "portrait-orientation-only", title: o("onlyPortraitOrientation"), subtitle: o("turnDeviceIntoPortrait"), iconColor: "#DC4343" }),
    r,
    /* @__PURE__ */ a.jsx("header", { className: QM.header, children: !l && /* @__PURE__ */ a.jsx("button", { "data-e2e": "cross", onClick: t, children: /* @__PURE__ */ a.jsx(Ju, { type: "cross", color: "rgba(0, 0, 0, 0.6)" }) }) }),
    !!s && /* @__PURE__ */ a.jsx("footer", { className: QM.footer, children: /* @__PURE__ */ a.jsx("div", { className: QM.ads, children: /* @__PURE__ */ a.jsx(Ju, { color: E6, type: "regula-logo-liveness-detection", size: x6 }) }) })
  ] });
}
var A1 = Va, z6 = TypeError, f6 = function(e, t) {
  if (!delete e[t]) throw new z6("Cannot delete property " + A1(t) + " of " + A1(e));
}, C6 = X, L6 = function(e, t) {
  var r = [][e];
  return !!r && C6(function() {
    r.call(null, t || function() {
      return 1;
    }, 1);
  });
}, O6 = Ha, d1 = O6.match(/firefox\/(\d+)/i), i5 = !!d1 && +d1[1], p6 = Ha, M5 = /MSIE|Trident/.test(p6), S6 = Ha, x1 = S6.match(/AppleWebKit\/(\d+)\./), a5 = !!x1 && +x1[1], v6 = Qe, o5 = G, h6 = mn, m6 = Ht, E1 = dt, w6 = f6, z1 = _t, gj = X, k6 = nj, U6 = L6, f1 = i5, Q6 = M5, C1 = gs, L1 = a5, yn = [], O1 = o5(yn.sort), Y6 = o5(yn.push), b6 = gj(function() {
  yn.sort(void 0);
}), P6 = gj(function() {
  yn.sort(null);
}), $6 = U6("sort"), u5 = !gj(function() {
  if (C1) return C1 < 70;
  if (!(f1 && f1 > 3)) {
    if (Q6) return !0;
    if (L1) return L1 < 603;
    var e = "", t, r, n, i;
    for (t = 65; t < 76; t++) {
      switch (r = String.fromCharCode(t), t) {
        case 66:
        case 69:
        case 70:
        case 72:
          n = 3;
          break;
        case 68:
        case 71:
          n = 4;
          break;
        default:
          n = 2;
      }
      for (i = 0; i < 47; i++)
        yn.push({ k: r + i, v: n });
    }
    for (yn.sort(function(M, o) {
      return o.v - M.v;
    }), i = 0; i < yn.length; i++)
      r = yn[i].k.charAt(0), e.charAt(e.length - 1) !== r && (e += r);
    return e !== "DGBEFHACIJK";
  }
}), R6 = b6 || !P6 || !$6 || !u5, H6 = function(e) {
  return function(t, r) {
    return r === void 0 ? -1 : t === void 0 ? 1 : e !== void 0 ? +e(t, r) || 0 : z1(t) > z1(r) ? 1 : -1;
  };
};
v6({ target: "Array", proto: !0, forced: R6 }, {
  sort: function(t) {
    t !== void 0 && h6(t);
    var r = m6(this);
    if (u5) return t === void 0 ? O1(r) : O1(r, t);
    var n = [], i = E1(r), M, o;
    for (o = 0; o < i; o++)
      o in r && Y6(n, r[o]);
    for (k6(n, H6(t)), M = E1(n), o = 0; o < M; ) r[o] = n[o++];
    for (; o < i; ) w6(r, o++);
    return r;
  }
});
var s5 = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined", V6 = vr, _6 = jM, Z6 = RangeError, jj = function(e) {
  if (e === void 0) return 0;
  var t = V6(e), r = _6(t);
  if (t !== r) throw new Z6("Wrong length or index");
  return r;
}, G6 = Math.sign || function(t) {
  var r = +t;
  return r === 0 || r !== r ? r : r < 0 ? -1 : 1;
}, B6 = G6, F6 = Math.abs, l5 = 2220446049250313e-31, p1 = 1 / l5, W6 = function(e) {
  return e + p1 - p1;
}, J6 = function(e, t, r, n) {
  var i = +e, M = F6(i), o = B6(i);
  if (M < n) return o * W6(M / n / t) * n * t;
  var u = (1 + t / l5) * M, s = u - (u - M);
  return s > r || s !== s ? o * (1 / 0) : o * s;
}, X6 = J6, K6 = 11920928955078125e-23, q6 = 34028234663852886e22, e9 = 11754943508222875e-54, t9 = Math.fround || function(t) {
  return X6(t, K6, q6, e9);
}, r9 = Array, n9 = Math.abs, Yr = Math.pow, i9 = Math.floor, M9 = Math.log, a9 = Math.LN2, o9 = function(e, t, r) {
  var n = r9(r), i = r * 8 - t - 1, M = (1 << i) - 1, o = M >> 1, u = t === 23 ? Yr(2, -24) - Yr(2, -77) : 0, s = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0, l = 0, I, g, c;
  for (e = n9(e), e !== e || e === 1 / 0 ? (g = e !== e ? 1 : 0, I = M) : (I = i9(M9(e) / a9), c = Yr(2, -I), e * c < 1 && (I--, c *= 2), I + o >= 1 ? e += u / c : e += u * Yr(2, 1 - o), e * c >= 2 && (I++, c /= 2), I + o >= M ? (g = 0, I = M) : I + o >= 1 ? (g = (e * c - 1) * Yr(2, t), I += o) : (g = e * Yr(2, o - 1) * Yr(2, t), I = 0)); t >= 8; )
    n[l++] = g & 255, g /= 256, t -= 8;
  for (I = I << t | g, i += t; i > 0; )
    n[l++] = I & 255, I /= 256, i -= 8;
  return n[l - 1] |= s * 128, n;
}, u9 = function(e, t) {
  var r = e.length, n = r * 8 - t - 1, i = (1 << n) - 1, M = i >> 1, o = n - 7, u = r - 1, s = e[u--], l = s & 127, I;
  for (s >>= 7; o > 0; )
    l = l * 256 + e[u--], o -= 8;
  for (I = l & (1 << -o) - 1, l >>= -o, o += t; o > 0; )
    I = I * 256 + e[u--], o -= 8;
  if (l === 0)
    l = 1 - M;
  else {
    if (l === i)
      return I ? NaN : s ? -1 / 0 : 1 / 0;
    I += Yr(2, t), l -= M;
  }
  return (s ? -1 : 1) * I * Yr(2, l - t);
}, s9 = {
  pack: o9,
  unpack: u9
}, l9 = Ht, S1 = ys, c9 = dt, c5 = function(t) {
  for (var r = l9(this), n = c9(r), i = arguments.length, M = S1(i > 1 ? arguments[1] : void 0, n), o = i > 2 ? arguments[2] : void 0, u = o === void 0 ? n : S1(o, n); u > M; ) r[M++] = t;
  return r;
}, Zs = B, Nj = G, zc = ge, I9 = s5, I5 = Ds, g9 = cr, j9 = Pn, v1 = kd, fc = X, Uo = bs, N9 = vr, D9 = jM, ns = jj, y9 = t9, g5 = s9, T9 = As, h1 = NM, A9 = c5, d9 = Ts, x9 = Xg, E9 = Fg, j5 = DM, Dj = Xr, z9 = I5.PROPER, m1 = I5.CONFIGURABLE, Xi = "ArrayBuffer", Gs = "DataView", Ki = "prototype", f9 = "Wrong length", N5 = "Wrong index", w1 = Dj.getterFor(Xi), Na = Dj.getterFor(Gs), k1 = Dj.set, qt = Zs[Xi], Nt = qt, xi = Nt && Nt[Ki], zr = Zs[Gs], _n = zr && zr[Ki], U1 = Object.prototype, C9 = Zs.Array, is = Zs.RangeError, L9 = Nj(A9), O9 = Nj([].reverse), D5 = g5.pack, Q1 = g5.unpack, Y1 = function(e) {
  return [e & 255];
}, b1 = function(e) {
  return [e & 255, e >> 8 & 255];
}, P1 = function(e) {
  return [e & 255, e >> 8 & 255, e >> 16 & 255, e >> 24 & 255];
}, $1 = function(e) {
  return e[3] << 24 | e[2] << 16 | e[1] << 8 | e[0];
}, p9 = function(e) {
  return D5(y9(e), 23, 4);
}, S9 = function(e) {
  return D5(e, 52, 8);
}, Qo = function(e, t, r) {
  j9(e[Ki], t, {
    configurable: !0,
    get: function() {
      return r(this)[t];
    }
  });
}, nn = function(e, t, r, n) {
  var i = Na(e), M = ns(r), o = !!n;
  if (M + t > i.byteLength) throw new is(N5);
  var u = i.bytes, s = M + i.byteOffset, l = d9(u, s, s + t);
  return o ? l : O9(l);
}, Mn = function(e, t, r, n, i, M) {
  var o = Na(e), u = ns(r), s = n(+i), l = !!M;
  if (u + t > o.byteLength) throw new is(N5);
  for (var I = o.bytes, g = u + o.byteOffset, c = 0; c < t; c++) I[g + c] = s[l ? c : t - c - 1];
};
if (!I9)
  Nt = function(t) {
    Uo(this, xi);
    var r = ns(t);
    k1(this, {
      type: Xi,
      bytes: L9(C9(r), 0),
      byteLength: r
    }), zc || (this.byteLength = r, this.detached = !1);
  }, xi = Nt[Ki], zr = function(t, r, n) {
    Uo(this, _n), Uo(t, xi);
    var i = w1(t), M = i.byteLength, o = N9(r);
    if (o < 0 || o > M) throw new is("Wrong offset");
    if (n = n === void 0 ? M - o : D9(n), o + n > M) throw new is(f9);
    k1(this, {
      type: Gs,
      buffer: t,
      byteLength: n,
      byteOffset: o,
      bytes: i.bytes
    }), zc || (this.buffer = t, this.byteLength = n, this.byteOffset = o);
  }, _n = zr[Ki], zc && (Qo(Nt, "byteLength", w1), Qo(zr, "buffer", Na), Qo(zr, "byteLength", Na), Qo(zr, "byteOffset", Na)), v1(_n, {
    getInt8: function(t) {
      return nn(this, 1, t)[0] << 24 >> 24;
    },
    getUint8: function(t) {
      return nn(this, 1, t)[0];
    },
    getInt16: function(t) {
      var r = nn(this, 2, t, arguments.length > 1 ? arguments[1] : !1);
      return (r[1] << 8 | r[0]) << 16 >> 16;
    },
    getUint16: function(t) {
      var r = nn(this, 2, t, arguments.length > 1 ? arguments[1] : !1);
      return r[1] << 8 | r[0];
    },
    getInt32: function(t) {
      return $1(nn(this, 4, t, arguments.length > 1 ? arguments[1] : !1));
    },
    getUint32: function(t) {
      return $1(nn(this, 4, t, arguments.length > 1 ? arguments[1] : !1)) >>> 0;
    },
    getFloat32: function(t) {
      return Q1(nn(this, 4, t, arguments.length > 1 ? arguments[1] : !1), 23);
    },
    getFloat64: function(t) {
      return Q1(nn(this, 8, t, arguments.length > 1 ? arguments[1] : !1), 52);
    },
    setInt8: function(t, r) {
      Mn(this, 1, t, Y1, r);
    },
    setUint8: function(t, r) {
      Mn(this, 1, t, Y1, r);
    },
    setInt16: function(t, r) {
      Mn(this, 2, t, b1, r, arguments.length > 2 ? arguments[2] : !1);
    },
    setUint16: function(t, r) {
      Mn(this, 2, t, b1, r, arguments.length > 2 ? arguments[2] : !1);
    },
    setInt32: function(t, r) {
      Mn(this, 4, t, P1, r, arguments.length > 2 ? arguments[2] : !1);
    },
    setUint32: function(t, r) {
      Mn(this, 4, t, P1, r, arguments.length > 2 ? arguments[2] : !1);
    },
    setFloat32: function(t, r) {
      Mn(this, 4, t, p9, r, arguments.length > 2 ? arguments[2] : !1);
    },
    setFloat64: function(t, r) {
      Mn(this, 8, t, S9, r, arguments.length > 2 ? arguments[2] : !1);
    }
  });
else {
  var R1 = z9 && qt.name !== Xi;
  !fc(function() {
    qt(1);
  }) || !fc(function() {
    new qt(-1);
  }) || fc(function() {
    return new qt(), new qt(1.5), new qt(NaN), qt.length !== 1 || R1 && !m1;
  }) ? (Nt = function(t) {
    return Uo(this, xi), x9(new qt(ns(t)), this, Nt);
  }, Nt[Ki] = xi, xi.constructor = Nt, E9(Nt, qt)) : R1 && m1 && g9(qt, "name", Xi), h1 && T9(_n) !== U1 && h1(_n, U1);
  var Yo = new zr(new Nt(2)), H1 = Nj(_n.setInt8);
  Yo.setInt8(0, 2147483648), Yo.setInt8(1, 2147483649), (Yo.getInt8(0) || !Yo.getInt8(1)) && v1(_n, {
    setInt8: function(t, r) {
      H1(this, t, r << 24 >> 24);
    },
    setUint8: function(t, r) {
      H1(this, t, r << 24 >> 24);
    }
  }, { unsafe: !0 });
}
j5(Nt, Xi);
j5(zr, Gs);
var yj = {
  ArrayBuffer: Nt,
  DataView: zr
}, v9 = Jr, h9 = Pn, m9 = ze, w9 = ge, V1 = m9("species"), y5 = function(e) {
  var t = v9(e);
  w9 && t && !t[V1] && h9(t, V1, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, k9 = Qe, U9 = B, Q9 = yj, Y9 = y5, Tj = "ArrayBuffer", _1 = Q9[Tj], b9 = U9[Tj];
k9({ global: !0, constructor: !0, forced: b9 !== _1 }, {
  ArrayBuffer: _1
});
Y9(Tj);
var P9 = tj, $9 = Va, R9 = TypeError, T5 = function(e) {
  if (P9(e)) return e;
  throw new R9($9(e) + " is not a constructor");
}, Z1 = ct, H9 = T5, V9 = Pa, _9 = ze, Z9 = _9("species"), A5 = function(e, t) {
  var r = Z1(e).constructor, n;
  return r === void 0 || V9(n = Z1(r)[Z9]) ? t : H9(n);
}, G9 = Qe, Aj = Ys, B9 = X, d5 = yj, G1 = ct, B1 = ys, F9 = jM, W9 = A5, dj = d5.ArrayBuffer, sg = d5.DataView, x5 = sg.prototype, F1 = Aj(dj.prototype.slice), J9 = Aj(x5.getUint8), X9 = Aj(x5.setUint8), K9 = B9(function() {
  return !new dj(2).slice(1, void 0).byteLength;
});
G9({ target: "ArrayBuffer", proto: !0, unsafe: !0, forced: K9 }, {
  slice: function(t, r) {
    if (F1 && r === void 0)
      return F1(G1(this), t);
    for (var n = G1(this).byteLength, i = B1(t, n), M = B1(r === void 0 ? n : r, n), o = new (W9(this, dj))(F9(M - i)), u = new sg(this), s = new sg(o), l = 0; i < M; )
      X9(s, l++, J9(u, i++));
    return o;
  }
});
var E5 = B, q9 = Jg, eU = hn, W1 = E5.ArrayBuffer, tU = E5.TypeError, z5 = W1 && q9(W1.prototype, "byteLength", "get") || function(e) {
  if (eU(e) !== "ArrayBuffer") throw new tU("ArrayBuffer expected");
  return e.byteLength;
}, rU = B, nU = Ys, iU = z5, J1 = rU.ArrayBuffer, X1 = J1 && J1.prototype, K1 = X1 && nU(X1.slice), f5 = function(e) {
  if (iU(e) !== 0 || !K1) return !1;
  try {
    return K1(e, 0, 0), !1;
  } catch (t) {
    return !0;
  }
}, MU = ge, aU = Pn, oU = f5, q1 = ArrayBuffer.prototype;
MU && !("detached" in q1) && aU(q1, "detached", {
  configurable: !0,
  get: function() {
    return oU(this);
  }
});
var uU = f5, sU = TypeError, lU = function(e) {
  if (uU(e)) throw new sU("ArrayBuffer is detached");
  return e;
}, RM = B, cU = Ha, IU = hn, bo = function(e) {
  return cU.slice(0, e.length) === e;
}, C5 = function() {
  return bo("Bun/") ? "BUN" : bo("Cloudflare-Workers") ? "CLOUDFLARE" : bo("Deno/") ? "DENO" : bo("Node.js/") ? "NODE" : RM.Bun && typeof Bun.version == "string" ? "BUN" : RM.Deno && typeof Deno.version == "object" ? "DENO" : IU(RM.process) === "process" ? "NODE" : RM.window && RM.document ? "BROWSER" : "REST";
}(), gU = C5, jU = gU === "NODE", NU = B, DU = jU, yU = function(e) {
  if (DU) {
    try {
      return NU.process.getBuiltinModule(e);
    } catch (t) {
    }
    try {
      return Function('return require("' + e + '")')();
    } catch (t) {
    }
  }
}, TU = B, AU = X, Cc = gs, Lc = C5, eT = TU.structuredClone, L5 = !!eT && !AU(function() {
  if (Lc === "DENO" && Cc > 92 || Lc === "NODE" && Cc > 94 || Lc === "BROWSER" && Cc > 97) return !1;
  var e = new ArrayBuffer(8), t = eT(e, { transfer: [e] });
  return e.byteLength !== 0 || t.byteLength !== 8;
}), xj = B, dU = yU, xU = L5, EU = xj.structuredClone, tT = xj.ArrayBuffer, Po = xj.MessageChannel, lg = !1, Oc, rT, $o, pc;
if (xU)
  lg = function(e) {
    EU(e, { transfer: [e] });
  };
else if (tT) try {
  Po || (Oc = dU("worker_threads"), Oc && (Po = Oc.MessageChannel)), Po && (rT = new Po(), $o = new tT(2), pc = function(e) {
    rT.port1.postMessage(null, [e]);
  }, $o.byteLength === 2 && (pc($o), $o.byteLength === 0 && (lg = pc)));
} catch (e) {
}
var zU = lg, Ej = B, zj = G, O5 = Jg, fU = jj, CU = lU, LU = z5, nT = zU, Sc = L5, OU = Ej.structuredClone, p5 = Ej.ArrayBuffer, cg = Ej.DataView, pU = Math.min, fj = p5.prototype, S5 = cg.prototype, SU = zj(fj.slice), iT = O5(fj, "resizable", "get"), MT = O5(fj, "maxByteLength", "get"), vU = zj(S5.getInt8), hU = zj(S5.setInt8), v5 = (Sc || nT) && function(e, t, r) {
  var n = LU(e), i = t === void 0 ? n : fU(t), M = !iT || !iT(e), o;
  if (CU(e), Sc && (e = OU(e, { transfer: [e] }), n === i && (r || M)))
    return e;
  if (n >= i && (!r || M))
    o = SU(e, 0, i);
  else {
    var u = r && !M && MT ? { maxByteLength: MT(e) } : void 0;
    o = new p5(i, u);
    for (var s = new cg(e), l = new cg(o), I = pU(i, n), g = 0; g < I; g++) hU(l, g, vU(s, g));
  }
  return Sc || nT(e), o;
}, mU = Qe, aT = v5;
aT && mU({ target: "ArrayBuffer", proto: !0 }, {
  transfer: function() {
    return aT(this, arguments.length ? arguments[0] : void 0, !0);
  }
});
var wU = Qe, oT = v5;
oT && wU({ target: "ArrayBuffer", proto: !0 }, {
  transferToFixedLength: function() {
    return oT(this, arguments.length ? arguments[0] : void 0, !1);
  }
});
var kU = ct, UU = function() {
  var e = kU(this), t = "";
  return e.hasIndices && (t += "d"), e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.unicodeSets && (t += "v"), e.sticky && (t += "y"), t;
}, Cj = X, QU = B, Lj = QU.RegExp, Oj = Cj(function() {
  var e = Lj("a", "y");
  return e.lastIndex = 2, e.exec("abcd") !== null;
}), YU = Oj || Cj(function() {
  return !Lj("a", "y").sticky;
}), bU = Oj || Cj(function() {
  var e = Lj("^r", "gy");
  return e.lastIndex = 2, e.exec("str") !== null;
}), PU = {
  BROKEN_CARET: bU,
  MISSED_STICKY: YU,
  UNSUPPORTED_Y: Oj
}, $U = X, RU = B, HU = RU.RegExp, VU = $U(function() {
  var e = HU(".", "s");
  return !(e.dotAll && e.test(`
`) && e.flags === "s");
}), _U = X, ZU = B, GU = ZU.RegExp, BU = _U(function() {
  var e = GU("(?<a>b)", "g");
  return e.exec("b").groups.a !== "b" || "b".replace(e, "$<a>c") !== "bc";
}), Hi = Ee, Bs = G, FU = _t, WU = UU, JU = PU, XU = Yg, KU = Ga, qU = Xr.get, eQ = VU, tQ = BU, rQ = XU("native-string-replace", String.prototype.replace), Ms = RegExp.prototype.exec, Ig = Ms, nQ = Bs("".charAt), iQ = Bs("".indexOf), MQ = Bs("".replace), vc = Bs("".slice), gg = function() {
  var e = /a/, t = /b*/g;
  return Hi(Ms, e, "a"), Hi(Ms, t, "a"), e.lastIndex !== 0 || t.lastIndex !== 0;
}(), h5 = JU.BROKEN_CARET, jg = /()??/.exec("")[1] !== void 0, aQ = gg || jg || h5 || eQ || tQ;
aQ && (Ig = function(t) {
  var r = this, n = qU(r), i = FU(t), M = n.raw, o, u, s, l, I, g, c;
  if (M)
    return M.lastIndex = r.lastIndex, o = Hi(Ig, M, i), r.lastIndex = M.lastIndex, o;
  var D = n.groups, j = h5 && r.sticky, N = Hi(WU, r), d = r.source, T = 0, y = i;
  if (j && (N = MQ(N, "y", ""), iQ(N, "g") === -1 && (N += "g"), y = vc(i, r.lastIndex), r.lastIndex > 0 && (!r.multiline || r.multiline && nQ(i, r.lastIndex - 1) !== `
`) && (d = "(?: " + d + ")", y = " " + y, T++), u = new RegExp("^(?:" + d + ")", N)), jg && (u = new RegExp("^" + d + "$(?!\\s)", N)), gg && (s = r.lastIndex), l = Hi(Ms, j ? u : r, y), j ? l ? (l.input = vc(l.input, T), l[0] = vc(l[0], T), l.index = r.lastIndex, r.lastIndex += l[0].length) : r.lastIndex = 0 : gg && l && (r.lastIndex = r.global ? l.index + l[0].length : s), jg && l && l.length > 1 && Hi(rQ, l[0], u, function() {
    for (I = 1; I < arguments.length - 2; I++)
      arguments[I] === void 0 && (l[I] = void 0);
  }), l && D)
    for (l.groups = g = KU(null), I = 0; I < D.length; I++)
      c = D[I], g[c[0]] = l[c[1]];
  return l;
});
var pj = Ig, oQ = Qe, uT = pj;
oQ({ target: "RegExp", proto: !0, forced: /./.exec !== uT }, {
  exec: uT
});
var sT = Ee, lT = Ir, uQ = pj, cT = X, m5 = ze, sQ = cr, lQ = m5("species"), hc = RegExp.prototype, cQ = function(e, t, r, n) {
  var i = m5(e), M = !cT(function() {
    var l = {};
    return l[i] = function() {
      return 7;
    }, ""[e](l) !== 7;
  }), o = M && !cT(function() {
    var l = !1, I = /a/;
    return e === "split" && (I = {}, I.constructor = {}, I.constructor[lQ] = function() {
      return I;
    }, I.flags = "", I[i] = /./[i]), I.exec = function() {
      return l = !0, null;
    }, I[i](""), !l;
  });
  if (!M || !o || r) {
    var u = /./[i], s = t(i, ""[e], function(l, I, g, c, D) {
      var j = I.exec;
      return j === uQ || j === hc.exec ? M && !D ? { done: !0, value: sT(u, I, g, c) } : { done: !0, value: sT(l, g, I, c) } : { done: !1 };
    });
    lT(String.prototype, e, s[0]), lT(hc, i, s[1]);
  }
  n && sQ(hc[i], "sham", !0);
}, IQ = q4.charAt, gQ = function(e, t, r) {
  return t + (r ? IQ(e, t).length : 1);
}, Sj = G, jQ = Ht, NQ = Math.floor, mc = Sj("".charAt), DQ = Sj("".replace), wc = Sj("".slice), yQ = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, TQ = /\$([$&'`]|\d{1,2})/g, AQ = function(e, t, r, n, i, M) {
  var o = r + e.length, u = n.length, s = TQ;
  return i !== void 0 && (i = jQ(i), s = yQ), DQ(M, s, function(l, I) {
    var g;
    switch (mc(I, 0)) {
      case "$":
        return "$";
      case "&":
        return e;
      case "`":
        return wc(t, 0, r);
      case "'":
        return wc(t, o);
      case "<":
        g = i[wc(I, 1, -1)];
        break;
      default:
        var c = +I;
        if (c === 0) return l;
        if (c > u) {
          var D = NQ(c / 10);
          return D === 0 ? l : D <= u ? n[D - 1] === void 0 ? mc(I, 1) : n[D - 1] + mc(I, 1) : l;
        }
        g = n[c - 1];
    }
    return g === void 0 ? "" : g;
  });
}, IT = Ee, dQ = ct, xQ = je, EQ = hn, zQ = pj, fQ = TypeError, CQ = function(e, t) {
  var r = e.exec;
  if (xQ(r)) {
    var n = IT(r, e, t);
    return n !== null && dQ(n), n;
  }
  if (EQ(e) === "RegExp") return IT(zQ, e, t);
  throw new fQ("RegExp#exec called on incompatible receiver");
}, LQ = Wg, gT = Ee, Fs = G, OQ = cQ, pQ = X, SQ = ct, vQ = je, hQ = Pa, mQ = vr, wQ = jM, Ei = _t, kQ = gM, UQ = gQ, QQ = Ns, YQ = AQ, bQ = CQ, PQ = ze, Ng = PQ("replace"), $Q = Math.max, RQ = Math.min, HQ = Fs([].concat), kc = Fs([].push), jT = Fs("".indexOf), NT = Fs("".slice), VQ = function(e) {
  return e === void 0 ? e : String(e);
}, _Q = function() {
  return "a".replace(/./, "$0") === "$0";
}(), DT = function() {
  return /./[Ng] ? /./[Ng]("a", "$0") === "" : !1;
}(), ZQ = !pQ(function() {
  var e = /./;
  return e.exec = function() {
    var t = [];
    return t.groups = { a: "7" }, t;
  }, "".replace(e, "$<a>") !== "7";
});
OQ("replace", function(e, t, r) {
  var n = DT ? "$" : "$0";
  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function(M, o) {
      var u = kQ(this), s = hQ(M) ? void 0 : QQ(M, Ng);
      return s ? gT(s, M, u, o) : gT(t, Ei(u), M, o);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function(i, M) {
      var o = SQ(this), u = Ei(i);
      if (typeof M == "string" && jT(M, n) === -1 && jT(M, "$<") === -1) {
        var s = r(t, o, u, M);
        if (s.done) return s.value;
      }
      var l = vQ(M);
      l || (M = Ei(M));
      var I = o.global, g;
      I && (g = o.unicode, o.lastIndex = 0);
      for (var c = [], D; D = bQ(o, u), !(D === null || (kc(c, D), !I)); ) {
        var j = Ei(D[0]);
        j === "" && (o.lastIndex = UQ(u, wQ(o.lastIndex), g));
      }
      for (var N = "", d = 0, T = 0; T < c.length; T++) {
        D = c[T];
        for (var y = Ei(D[0]), A = $Q(RQ(mQ(D.index), u.length), 0), x = [], E, C = 1; C < D.length; C++) kc(x, VQ(D[C]));
        var p = D.groups;
        if (l) {
          var O = HQ([y], x, A, u);
          p !== void 0 && kc(O, p), E = Ei(LQ(M, void 0, O));
        } else
          E = YQ(y, u, A, x, p, M);
        A >= d && (N += NT(u, d, A) + E, d = A + y.length);
      }
      return N + NT(u, d);
    }
  ];
}, !ZQ || !_Q || DT);
var Dg = { exports: {} }, GQ = ze, w5 = GQ("iterator"), k5 = !1;
try {
  var BQ = 0, yT = {
    next: function() {
      return { done: !!BQ++ };
    },
    return: function() {
      k5 = !0;
    }
  };
  yT[w5] = function() {
    return this;
  }, Array.from(yT, function() {
    throw 2;
  });
} catch (e) {
}
var FQ = function(e, t) {
  try {
    if (!t && !k5) return !1;
  } catch (i) {
    return !1;
  }
  var r = !1;
  try {
    var n = {};
    n[w5] = function() {
      return {
        next: function() {
          return { done: r = !0 };
        }
      };
    }, e(n);
  } catch (i) {
  }
  return r;
}, WQ = s5, vj = ge, qe = B, U5 = je, Ws = _e, vn = lt, hj = wn, JQ = Va, XQ = cr, yg = Ir, KQ = Pn, qQ = Ra, Js = As, EM = NM, eY = ze, tY = bg, Q5 = Xr, Y5 = Q5.enforce, rY = Q5.get, as = qe.Int8Array, Tg = as && as.prototype, TT = qe.Uint8ClampedArray, AT = TT && TT.prototype, Lr = as && Js(as), Mr = Tg && Js(Tg), nY = Object.prototype, mj = qe.TypeError, dT = eY("toStringTag"), Ag = tY("TYPED_ARRAY_TAG"), os = "TypedArrayConstructor", Fr = WQ && !!EM && hj(qe.opera) !== "Opera", b5 = !1, Mt, Tn, qi, Wr = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
}, wj = {
  BigInt64Array: 8,
  BigUint64Array: 8
}, iY = function(t) {
  if (!Ws(t)) return !1;
  var r = hj(t);
  return r === "DataView" || vn(Wr, r) || vn(wj, r);
}, P5 = function(e) {
  var t = Js(e);
  if (Ws(t)) {
    var r = rY(t);
    return r && vn(r, os) ? r[os] : P5(t);
  }
}, $5 = function(e) {
  if (!Ws(e)) return !1;
  var t = hj(e);
  return vn(Wr, t) || vn(wj, t);
}, MY = function(e) {
  if ($5(e)) return e;
  throw new mj("Target is not a typed array");
}, aY = function(e) {
  if (U5(e) && (!EM || qQ(Lr, e))) return e;
  throw new mj(JQ(e) + " is not a typed array constructor");
}, oY = function(e, t, r, n) {
  if (vj) {
    if (r) for (var i in Wr) {
      var M = qe[i];
      if (M && vn(M.prototype, e)) try {
        delete M.prototype[e];
      } catch (o) {
        try {
          M.prototype[e] = t;
        } catch (u) {
        }
      }
    }
    (!Mr[e] || r) && yg(Mr, e, r ? t : Fr && Tg[e] || t, n);
  }
}, uY = function(e, t, r) {
  var n, i;
  if (vj) {
    if (EM) {
      if (r) {
        for (n in Wr)
          if (i = qe[n], i && vn(i, e)) try {
            delete i[e];
          } catch (M) {
          }
      }
      if (!Lr[e] || r)
        try {
          return yg(Lr, e, r ? t : Fr && Lr[e] || t);
        } catch (M) {
        }
      else return;
    }
    for (n in Wr)
      i = qe[n], i && (!i[e] || r) && yg(i, e, t);
  }
};
for (Mt in Wr)
  Tn = qe[Mt], qi = Tn && Tn.prototype, qi ? Y5(qi)[os] = Tn : Fr = !1;
for (Mt in wj)
  Tn = qe[Mt], qi = Tn && Tn.prototype, qi && (Y5(qi)[os] = Tn);
if ((!Fr || !U5(Lr) || Lr === Function.prototype) && (Lr = function() {
  throw new mj("Incorrect invocation");
}, Fr))
  for (Mt in Wr)
    qe[Mt] && EM(qe[Mt], Lr);
if ((!Fr || !Mr || Mr === nY) && (Mr = Lr.prototype, Fr))
  for (Mt in Wr)
    qe[Mt] && EM(qe[Mt].prototype, Mr);
Fr && Js(AT) !== Mr && EM(AT, Mr);
if (vj && !vn(Mr, dT)) {
  b5 = !0, KQ(Mr, dT, {
    configurable: !0,
    get: function() {
      return Ws(this) ? this[Ag] : void 0;
    }
  });
  for (Mt in Wr) qe[Mt] && XQ(qe[Mt], Ag, Mt);
}
var Ft = {
  NATIVE_ARRAY_BUFFER_VIEWS: Fr,
  TYPED_ARRAY_TAG: b5 && Ag,
  aTypedArray: MY,
  aTypedArrayConstructor: aY,
  exportTypedArrayMethod: oY,
  exportTypedArrayStaticMethod: uY,
  getTypedArrayConstructor: P5,
  isView: iY,
  isTypedArray: $5,
  TypedArray: Lr,
  TypedArrayPrototype: Mr
}, R5 = B, Uc = X, sY = FQ, lY = Ft.NATIVE_ARRAY_BUFFER_VIEWS, cY = R5.ArrayBuffer, Zn = R5.Int8Array, IY = !lY || !Uc(function() {
  Zn(1);
}) || !Uc(function() {
  new Zn(-1);
}) || !sY(function(e) {
  new Zn(), new Zn(null), new Zn(1.5), new Zn(e);
}, !0) || Uc(function() {
  return new Zn(new cY(2), 1, void 0).length !== 1;
}), gY = _e, jY = Math.floor, NY = Number.isInteger || function(t) {
  return !gY(t) && isFinite(t) && jY(t) === t;
}, DY = vr, yY = RangeError, TY = function(e) {
  var t = DY(e);
  if (t < 0) throw new yY("The argument can't be less than 0");
  return t;
}, AY = TY, dY = RangeError, H5 = function(e, t) {
  var r = AY(e);
  if (r % t) throw new dY("Wrong offset");
  return r;
}, xY = Math.round, EY = function(e) {
  var t = xY(e);
  return t < 0 ? 0 : t > 255 ? 255 : t & 255;
}, zY = wn, V5 = function(e) {
  var t = zY(e);
  return t === "BigInt64Array" || t === "BigUint64Array";
}, fY = Q2, CY = TypeError, kj = function(e) {
  var t = fY(e, "number");
  if (typeof t == "number") throw new CY("Can't convert number to bigint");
  return BigInt(t);
}, LY = dM, OY = Ee, pY = T5, SY = Ht, vY = dt, hY = rj, mY = Ps, wY = Ld, kY = V5, UY = Ft.aTypedArrayConstructor, QY = kj, YY = function(t) {
  var r = pY(this), n = SY(t), i = arguments.length, M = i > 1 ? arguments[1] : void 0, o = M !== void 0, u = mY(n), s, l, I, g, c, D, j, N;
  if (u && !wY(u))
    for (j = hY(n, u), N = j.next, n = []; !(D = OY(N, j)).done; )
      n.push(D.value);
  for (o && i > 2 && (M = LY(M, arguments[2])), l = vY(n), I = new (UY(r))(l), g = kY(I), s = 0; l > s; s++)
    c = o ? M(n[s], s) : n[s], I[s] = g ? QY(c) : +c;
  return I;
}, xT = qg, bY = tj, PY = _e, $Y = ze, RY = $Y("species"), ET = Array, HY = function(e) {
  var t;
  return xT(e) && (t = e.constructor, bY(t) && (t === ET || xT(t.prototype)) ? t = void 0 : PY(t) && (t = t[RY], t === null && (t = void 0))), t === void 0 ? ET : t;
}, VY = HY, _Y = function(e, t) {
  return new (VY(e))(t === 0 ? 0 : t);
}, ZY = dM, GY = G, BY = Is, FY = Ht, WY = dt, JY = _Y, zT = GY([].push), an = function(e) {
  var t = e === 1, r = e === 2, n = e === 3, i = e === 4, M = e === 6, o = e === 7, u = e === 5 || M;
  return function(s, l, I, g) {
    for (var c = FY(s), D = BY(c), j = WY(D), N = ZY(l, I), d = 0, T = g || JY, y = t ? T(s, j) : r || o ? T(s, 0) : void 0, A, x; j > d; d++) if ((u || d in D) && (A = D[d], x = N(A, d, c), e))
      if (t) y[d] = x;
      else if (x) switch (e) {
        case 3:
          return !0;
        case 5:
          return A;
        case 6:
          return d;
        case 2:
          zT(y, A);
      }
      else switch (e) {
        case 4:
          return !1;
        case 7:
          zT(y, A);
      }
    return M ? -1 : n || i ? i : y;
  };
}, XY = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: an(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: an(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: an(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: an(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: an(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: an(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: an(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: an(7)
}, KY = dt, _5 = function(e, t, r) {
  for (var n = 0, i = arguments.length > 2 ? r : KY(t), M = new e(i); i > n; ) M[n] = t[n++];
  return M;
}, fT = Qe, Z5 = B, CT = Ee, qY = ge, eb = IY, to = Ft, G5 = yj, LT = bs, tb = ui, HM = cr, rb = NY, nb = jM, OT = jj, Qc = H5, ib = EY, B5 = Pg, VM = lt, Mb = wn, dg = _e, ab = js, ob = Ga, ub = Ra, Ro = NM, sb = Zg.f, pT = YY, lb = XY.forEach, cb = y5, Ib = Pn, F5 = Vt, W5 = ls, ST = _5, Uj = Xr, gb = Xg, xg = Uj.get, jb = Uj.set, Nb = Uj.enforce, J5 = F5.f, Db = W5.f, Yc = Z5.RangeError, X5 = G5.ArrayBuffer, yb = X5.prototype, Tb = G5.DataView, Ho = to.NATIVE_ARRAY_BUFFER_VIEWS, vT = to.TYPED_ARRAY_TAG, hT = to.TypedArray, _M = to.TypedArrayPrototype, Eg = to.isTypedArray, Vo = "BYTES_PER_ELEMENT", bc = "Wrong length", _o = function(e, t) {
  Ib(e, t, {
    configurable: !0,
    get: function() {
      return xg(this)[t];
    }
  });
}, mT = function(e) {
  var t;
  return ub(yb, e) || (t = Mb(e)) === "ArrayBuffer" || t === "SharedArrayBuffer";
}, K5 = function(e, t) {
  return Eg(e) && !ab(t) && t in e && rb(+t) && t >= 0;
}, wT = function(t, r) {
  return r = B5(r), K5(t, r) ? tb(2, t[r]) : Db(t, r);
}, kT = function(t, r, n) {
  return r = B5(r), K5(t, r) && dg(n) && VM(n, "value") && !VM(n, "get") && !VM(n, "set") && !n.configurable && (!VM(n, "writable") || n.writable) && (!VM(n, "enumerable") || n.enumerable) ? (t[r] = n.value, t) : J5(t, r, n);
};
qY ? (Ho || (W5.f = wT, F5.f = kT, _o(_M, "buffer"), _o(_M, "byteOffset"), _o(_M, "byteLength"), _o(_M, "length")), fT({ target: "Object", stat: !0, forced: !Ho }, {
  getOwnPropertyDescriptor: wT,
  defineProperty: kT
}), Dg.exports = function(e, t, r) {
  var n = e.match(/\d+/)[0] / 8, i = e + (r ? "Clamped" : "") + "Array", M = "get" + e, o = "set" + e, u = Z5[i], s = u, l = s && s.prototype, I = {}, g = function(N, d) {
    var T = xg(N);
    return T.view[M](d * n + T.byteOffset, !0);
  }, c = function(N, d, T) {
    var y = xg(N);
    y.view[o](d * n + y.byteOffset, r ? ib(T) : T, !0);
  }, D = function(N, d) {
    J5(N, d, {
      get: function() {
        return g(this, d);
      },
      set: function(T) {
        return c(this, d, T);
      },
      enumerable: !0
    });
  };
  Ho ? eb && (s = t(function(N, d, T, y) {
    return LT(N, l), gb(function() {
      return dg(d) ? mT(d) ? y !== void 0 ? new u(d, Qc(T, n), y) : T !== void 0 ? new u(d, Qc(T, n)) : new u(d) : Eg(d) ? ST(s, d) : CT(pT, s, d) : new u(OT(d));
    }(), N, s);
  }), Ro && Ro(s, hT), lb(sb(u), function(N) {
    N in s || HM(s, N, u[N]);
  }), s.prototype = l) : (s = t(function(N, d, T, y) {
    LT(N, l);
    var A = 0, x = 0, E, C, p;
    if (!dg(d))
      p = OT(d), C = p * n, E = new X5(C);
    else if (mT(d)) {
      E = d, x = Qc(T, n);
      var O = d.byteLength;
      if (y === void 0) {
        if (O % n) throw new Yc(bc);
        if (C = O - x, C < 0) throw new Yc(bc);
      } else if (C = nb(y) * n, C + x > O) throw new Yc(bc);
      p = C / n;
    } else return Eg(d) ? ST(s, d) : CT(pT, s, d);
    for (jb(N, {
      buffer: E,
      byteOffset: x,
      byteLength: C,
      length: p,
      view: new Tb(E)
    }); A < p; ) D(N, A++);
  }), Ro && Ro(s, hT), l = s.prototype = ob(_M)), l.constructor !== s && HM(l, "constructor", s), Nb(l).TypedArrayConstructor = s, vT && HM(l, vT, i);
  var j = s !== u;
  I[i] = s, fT({ global: !0, constructor: !0, forced: j, sham: !Ho }, I), Vo in s || HM(s, Vo, n), Vo in l || HM(l, Vo, n), cb(i);
}) : Dg.exports = function() {
};
var q5 = Dg.exports, Ab = q5;
Ab("Uint8", function(e) {
  return function(r, n, i) {
    return e(this, r, n, i);
  };
}, !0);
var ex = Ft, db = dt, xb = vr, Eb = ex.aTypedArray, zb = ex.exportTypedArrayMethod;
zb("at", function(t) {
  var r = Eb(this), n = db(r), i = xb(t), M = i >= 0 ? i : n + i;
  return M < 0 || M >= n ? void 0 : r[M];
});
var tx = Ft, fb = c5, Cb = kj, Lb = wn, Ob = Ee, pb = G, Sb = X, vb = tx.aTypedArray, hb = tx.exportTypedArrayMethod, mb = pb("".slice), wb = Sb(function() {
  var e = 0;
  return new Int8Array(2).fill({ valueOf: function() {
    return e++;
  } }), e !== 1;
});
hb("fill", function(t) {
  var r = arguments.length;
  vb(this);
  var n = mb(Lb(this), 0, 3) === "Big" ? Cb(t) : +t;
  return Ob(fb, this, n, r > 1 ? arguments[1] : void 0, r > 2 ? arguments[2] : void 0);
}, wb);
var kb = dM, Ub = Is, Qb = Ht, Yb = dt, UT = function(e) {
  var t = e === 1;
  return function(r, n, i) {
    for (var M = Qb(r), o = Ub(M), u = Yb(o), s = kb(n, i), l, I; u-- > 0; )
      if (l = o[u], I = s(l, u, M), I) switch (e) {
        case 0:
          return l;
        case 1:
          return u;
      }
    return t ? -1 : void 0;
  };
}, rx = {
  // `Array.prototype.findLast` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLast: UT(0),
  // `Array.prototype.findLastIndex` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLastIndex: UT(1)
}, nx = Ft, bb = rx.findLast, Pb = nx.aTypedArray, $b = nx.exportTypedArrayMethod;
$b("findLast", function(t) {
  return bb(Pb(this), t, arguments.length > 1 ? arguments[1] : void 0);
});
var ix = Ft, Rb = rx.findLastIndex, Hb = ix.aTypedArray, Vb = ix.exportTypedArrayMethod;
Vb("findLastIndex", function(t) {
  return Rb(Hb(this), t, arguments.length > 1 ? arguments[1] : void 0);
});
var Mx = B, ax = Ee, Qj = Ft, _b = dt, Zb = H5, Gb = Ht, ox = X, Bb = Mx.RangeError, zg = Mx.Int8Array, QT = zg && zg.prototype, ux = QT && QT.set, Fb = Qj.aTypedArray, Wb = Qj.exportTypedArrayMethod, fg = !ox(function() {
  var e = new Uint8ClampedArray(2);
  return ax(ux, e, { length: 1, 0: 3 }, 1), e[1] !== 3;
}), Jb = fg && Qj.NATIVE_ARRAY_BUFFER_VIEWS && ox(function() {
  var e = new zg(2);
  return e.set(1), e.set("2", 1), e[0] !== 0 || e[1] !== 2;
});
Wb("set", function(t) {
  Fb(this);
  var r = Zb(arguments.length > 1 ? arguments[1] : void 0, 1), n = Gb(t);
  if (fg) return ax(ux, this, n, r);
  var i = this.length, M = _b(n), o = 0;
  if (M + r > i) throw new Bb("Wrong length");
  for (; o < M; ) this[r + o] = n[o++];
}, !fg || Jb);
var Xb = B, Kb = Ys, Cg = X, qb = mn, eP = nj, sx = Ft, YT = i5, tP = M5, bT = gs, PT = a5, rP = sx.aTypedArray, nP = sx.exportTypedArrayMethod, Ya = Xb.Uint16Array, eM = Ya && Kb(Ya.prototype.sort), iP = !!eM && !(Cg(function() {
  eM(new Ya(2), null);
}) && Cg(function() {
  eM(new Ya(2), {});
})), $T = !!eM && !Cg(function() {
  if (bT) return bT < 74;
  if (YT) return YT < 67;
  if (tP) return !0;
  if (PT) return PT < 602;
  var e = new Ya(516), t = Array(516), r, n;
  for (r = 0; r < 516; r++)
    n = r % 4, e[r] = 515 - r, t[r] = r - 2 * n + 3;
  for (eM(e, function(i, M) {
    return (i / 4 | 0) - (M / 4 | 0);
  }), r = 0; r < 516; r++)
    if (e[r] !== t[r]) return !0;
}), MP = function(e) {
  return function(t, r) {
    return e !== void 0 ? +e(t, r) || 0 : r !== r ? -1 : t !== t ? 1 : t === 0 && r === 0 ? 1 / t > 0 && 1 / r < 0 ? 1 : -1 : t > r;
  };
};
nP("sort", function(t) {
  return t !== void 0 && qb(t), $T ? eM(this, t) : eP(rP(this), MP(t));
}, !$T || iP);
var aP = dt, oP = function(e, t) {
  for (var r = aP(e), n = new t(r), i = 0; i < r; i++) n[i] = e[r - i - 1];
  return n;
}, uP = oP, Yj = Ft, sP = Yj.aTypedArray, lP = Yj.exportTypedArrayMethod, cP = Yj.getTypedArrayConstructor;
lP("toReversed", function() {
  return uP(sP(this), cP(this));
});
var Xs = Ft, IP = G, gP = mn, jP = _5, NP = Xs.aTypedArray, DP = Xs.getTypedArrayConstructor, yP = Xs.exportTypedArrayMethod, TP = IP(Xs.TypedArrayPrototype.sort);
yP("toSorted", function(t) {
  t !== void 0 && gP(t);
  var r = NP(this), n = jP(DP(r), r);
  return TP(n, t);
});
var AP = dt, dP = vr, xP = RangeError, EP = function(e, t, r, n) {
  var i = AP(e), M = dP(r), o = M < 0 ? i + M : M;
  if (o >= i || o < 0) throw new xP("Incorrect index");
  for (var u = new t(i), s = 0; s < i; s++) u[s] = s === o ? n : e[s];
  return u;
}, zP = EP, bj = Ft, fP = V5, CP = vr, LP = kj, OP = bj.aTypedArray, pP = bj.getTypedArrayConstructor, SP = bj.exportTypedArrayMethod, vP = !!function() {
  try {
    new Int8Array(1).with(2, { valueOf: function() {
      throw 8;
    } });
  } catch (e) {
    return e === 8;
  }
}();
SP("with", function(e, t) {
  var r = OP(this), n = CP(e), i = fP(r) ? LP(t) : +t;
  return zP(r, pP(r), n, i);
}, !vP);
var RT = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", hP = typeof Uint8Array == "undefined" ? [] : new Uint8Array(256);
for (var Zo = 0; Zo < RT.length; Zo++)
  hP[RT.charCodeAt(Zo)] = Zo;
function Go(e, t, r) {
  return (t = mP(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function mP(e) {
  var t = wP(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function wP(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class HT {
  constructor(t, r) {
    Go(this, "deviceId", void 0), Go(this, "facing", void 0), Go(this, "groupId", void 0), Go(this, "label", void 0), this.deviceId = t.deviceId, this.facing = r, this.groupId = t.groupId, this.label = t.label;
  }
}
var me = [];
for (var Pc = 0; Pc < 256; ++Pc)
  me.push((Pc + 256).toString(16).slice(1));
function kP(e, t = 0) {
  return (me[e[t + 0]] + me[e[t + 1]] + me[e[t + 2]] + me[e[t + 3]] + "-" + me[e[t + 4]] + me[e[t + 5]] + "-" + me[e[t + 6]] + me[e[t + 7]] + "-" + me[e[t + 8]] + me[e[t + 9]] + "-" + me[e[t + 10]] + me[e[t + 11]] + me[e[t + 12]] + me[e[t + 13]] + me[e[t + 14]] + me[e[t + 15]]).toLowerCase();
}
var Bo, UP = new Uint8Array(16);
function QP() {
  if (!Bo && (Bo = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Bo))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Bo(UP);
}
var YP = typeof crypto != "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const VT = {
  randomUUID: YP
};
function _T(e, t, r) {
  if (VT.randomUUID && !t && !e)
    return VT.randomUUID();
  e = e || {};
  var n = e.random || (e.rng || QP)();
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, kP(n);
}
const wt = (e) => {
  switch (e) {
    case "":
    case "true":
      return !0;
    case "false":
      return !1;
    case null:
    default:
      return;
  }
};
function lx() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  const n = [...t];
  return n.length === 0 ? function(i) {
    return i;
  } : n.length === 1 ? n[0] : n.reduce(function(i, M) {
    return function() {
      return i(M(...arguments));
    };
  });
}
function Lg(e, t, r, n, i, M, o, u, s) {
  const l = e / t, I = r / n, c = (s === Pr.contain ? I < l : I > l) ? e / r : t / n, D = (e / c - r) / 2, j = (t / c - n) / 2;
  return {
    width: i / c,
    height: M / c,
    left: o / c - D,
    top: u / c - j
  };
}
function cx(e, t) {
  return new CustomEvent(e, {
    bubbles: !0,
    composed: !0,
    detail: t
  });
}
function bP() {
  return Ce(this, null, function* () {
    const t = (yield navigator.mediaDevices.enumerateDevices()).filter((n) => n.kind === "videoinput"), r = t.every((n) => n.label !== "");
    return {
      videoDevices: t,
      isCameraAllowed: r
    };
  });
}
function PP(e, t) {
  const r = e.toLowerCase();
  return t.some((n) => r.includes(n));
}
function $P(e) {
  return Ce(this, null, function* () {
    const t = {
      frontCameras: [],
      backCameras: []
    };
    let r = e.videoDevices;
    if (!e.isCameraAllowed) {
      const n = yield navigator.mediaDevices.getUserMedia({
        video: !0,
        audio: !1
      });
      r = (yield navigator.mediaDevices.enumerateDevices()).filter((M) => M.kind === "videoinput"), n.getTracks().forEach((M) => M.stop());
    }
    for (const n of r)
      PP(n.label, c6) ? t.backCameras.push(new HT(n, ur.environment)) : t.frontCameras.push(new HT(n, ur.user));
    return t;
  });
}
function RP(e, t, r) {
  const n = [...t.frontCameras, ...t.backCameras];
  if (!n.length)
    return {
      deviceId: "",
      facing: void 0,
      groupId: "",
      label: ""
    };
  if (r)
    return n.find((M) => M.deviceId === r) || {
      deviceId: "",
      facing: void 0,
      groupId: "",
      label: ""
    };
  if (e === ur.environment && t.backCameras.length) {
    const M = t.backCameras.map((o) => {
      const u = /\b([0-9]+)MP?\b/i, s = o.label.match(u);
      return s !== null ? parseInt(s[1], 10) : NaN;
    });
    if (M.every((o) => !isNaN(o))) {
      const o = M.lastIndexOf(Math.max(...M));
      return t.backCameras[o];
    } else
      return Dd ? {
        deviceId: "",
        facing: ur.environment,
        groupId: "",
        label: ""
      } : t.backCameras.sort((o, u) => o.label.localeCompare(u.label))[0];
  } else
    return {
      deviceId: "",
      facing: ur.user,
      groupId: "",
      label: ""
    };
}
const ZT = (e) => {
  e.getTracks().forEach((t) => t.stop());
};
function HP(e, t, r) {
  return Ce(this, null, function* () {
    const n = {
      status: _.PREPARING,
      stream: null,
      camera: {
        deviceId: "",
        facing: void 0,
        groupId: "",
        label: ""
      }
    };
    if (navigator.mediaDevices) {
      if (!t.deviceId && !t.facing)
        return r ? (n.status = _.INCORRECT_CAMERA_ID, n) : (n.status = _.NO_CAMERA, n);
      const i = {
        height: {
          ideal: e.height > j1 ? Qa.FULL_HD.height : e.height
        },
        width: {
          ideal: e.width > j1 ? Qa.FULL_HD.width : e.width
        },
        frameRate: {
          ideal: 30
        }
      };
      t.deviceId ? i.deviceId = {
        exact: t.deviceId
      } : i.facingMode = {
        ideal: t.facing
      };
      const M = yield navigator.mediaDevices.getUserMedia({
        video: i,
        audio: !1
      }), o = M.getVideoTracks()[0], {
        deviceId: u,
        groupId: s,
        facingMode: l
      } = o.getSettings(), I = {
        deviceId: u || t.deviceId,
        label: o.label || t.label,
        groupId: s || t.groupId,
        facing: l || t.facing
      };
      return {
        status: _.READY,
        stream: M,
        camera: I
      };
    } else
      return n.status = _.NOT_SUPPORTED, n;
  });
}
function VP(e, t) {
  const r = {
    imageData: [],
    raw: "",
    mimeType: ""
  }, {
    videoHeight: n,
    videoWidth: i,
    readyState: M
  } = e;
  if (n && i && M === t5.HAVE_ENOUGH_DATA) {
    const o = document.createElement("canvas");
    o.width = i, o.height = n;
    const u = o.getContext("2d", {
      willReadFrequently: !0
    });
    if (u == null || u.drawImage(e, 0, 0), t !== rs.UINT) {
      const s = "image/jpeg";
      r.raw = o.toDataURL(s, 0.8).replace("data:".concat(s, ";base64,"), ""), r.mimeType = s;
    }
    if (t !== rs.BASE64) {
      const s = u == null ? void 0 : u.getImageData(0, 0, i, n);
      s && (r.imageData = [s]);
    }
  }
  return r;
}
function _P(e, t) {
  const r = [...e.frontCameras, ...e.backCameras], i = (r.findIndex((M) => M.deviceId === t) + 1) % r.length;
  return r[i].deviceId;
}
function tM(e, t) {
  const r = (i) => i !== null && typeof i == "object" && !Array.isArray(i), n = Object.assign({}, e);
  if (r(e) && r(t))
    for (const i of Object.keys(t)) {
      const M = e[i], o = t[i];
      r(o) ? M === void 0 ? n[i] = o : n[i] = tM(M, o) : n[i] = o;
    }
  return n;
}
function ZP(e) {
  return Ce(this, null, function* () {
    return new Promise((t) => setTimeout(t, e));
  });
}
const GP = (e) => {
  let t;
  try {
    var r;
    t = (r = window.localStorage.getItem(e)) !== null && r !== void 0 ? r : _T(), window.localStorage.setItem(e, t);
  } catch (n) {
    t = _T();
  }
  return t;
}, BP = () => ["localhost", "127.0.0.1", "", "::1"].includes(window.location.hostname), FP = () => !BP() && window.location.protocol === "http:";
function GT(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function BT(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? GT(Object(r), !0).forEach(function(n) {
      WP(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : GT(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function WP(e, t, r) {
  return (t = JP(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function JP(e) {
  var t = XP(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function XP(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ix(e) {
  function t(r) {
    const {
      locale: n,
      translations: i,
      dictionaries: M
    } = r;
    let o = M;
    if (i)
      for (const D in i)
        if (Object.prototype.hasOwnProperty.call(M, D))
          o = tM(o, {
            [D]: i[D]
          });
        else {
          const j = tM(M.en, i[D]);
          o = tM(o, {
            [D]: j
          });
        }
    const s = (window.navigator ? window.navigator.language : g1).substring(0, 2).toLowerCase(), l = Object.prototype.hasOwnProperty.call(o, s) ? s : g1, I = n && Object.prototype.hasOwnProperty.call(o, n) ? n : l, g = o6.includes(I) ? ug.Rtl : ug.Ltr, c = BT(BT({}, r), {}, {
      direction: g
    });
    return /* @__PURE__ */ a.jsx(Ii.LocalizationProvider, { disableCache: !0, locale: I, translations: o, children: /* @__PURE__ */ a.jsx(e, tl({}, c)) });
  }
  return t;
}
function FT(e, t, r) {
  return (t = KP(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function KP(e) {
  var t = qP(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function qP(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class oi {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    FT(this, "type", void 0), FT(this, "details", void 0), this.type = t, this.details = r;
  }
}
function WT(e, t, r) {
  return (t = e$(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function e$(e) {
  var t = t$(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function t$(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class gx extends f.Component {
  constructor(t) {
    super(t), WT(this, "onError", void 0), WT(this, "supportedBrowserVersions", void 0), this.supportedBrowserVersions = t.supportedBrowserVersions, this.onError = t.onError;
  }
  componentDidCatch(t) {
    this.onError(new oi("UNKNOWN_ERROR", t));
  }
  componentDidMount() {
    if (this.supportedBrowserVersions) {
      let t = null;
      if (Vr && Wu in this.supportedBrowserVersions && (t = this.supportedBrowserVersions[Wu]), eo && (t = this.supportedBrowserVersions.desktop), t && sa in t) {
        const r = t[sa];
        r !== void 0 && Number(Jh) < r && this.onError(new oi("NOT_SUPPORTED"));
      }
    }
  }
  render() {
    return this.props.children;
  }
}
function r$(e, t, r) {
  var n;
  const i = e.getContext("2d");
  if (!i || (i.clearRect(0, 0, t.videoContainerParams.width, t.videoContainerParams.height), !(r != null && (n = r.frameResult) !== null && n !== void 0 && (n = n.faces) !== null && n !== void 0 && n.length))) return;
  const M = r.frameResult.faces[0], o = M.landmarks[0], u = M.landmarks[1], s = M.landmarks[3], l = M.landmarks[4], I = Lg.bind(null, t.videoParams.width, t.videoParams.height, t.videoContainerParams.width, t.videoContainerParams.height), g = I.bind(null, 0, 0), c = g(o.x, o.y, Pr.contain), D = g(u.x, u.y, Pr.contain), j = g(s.x, s.y, Pr.contain), N = g(l.x, l.y, Pr.contain), {
    width: d,
    height: T,
    left: y,
    top: A
  } = I(M == null ? void 0 : M.position.width, M == null ? void 0 : M.position.height, M == null ? void 0 : M.position.x, M == null ? void 0 : M.position.y, Pr.contain);
  i.beginPath(), i.rect(y, A, d, T), i.moveTo(c.left, c.top), i.lineTo(D.left, D.top), i.lineTo(N.left, N.top), i.lineTo(j.left, j.top), i.closePath(), i.strokeStyle = "rebeccapurple", i.stroke();
}
const jx = (e, t) => e === m.ABORT_PROCESSING || e === m.FAILED && t === Yt.SESSION_TIMEOUT;
function JT(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = arguments.length > 2 ? arguments[2] : void 0, n = arguments.length > 3 ? arguments[3] : void 0, i = arguments.length > 4 ? arguments[4] : void 0;
  const M = e === Re.Finished;
  return t && M && n ? m.SUCCESS : t && (e === Re.Timeout || e === Re.Failed) ? m.FAILED : M && i && r || e === Re.Stop_Session ? m.ABORT_PROCESSING : M && n && i ? m.PROCESSING_REQUEST : (e === Re.Timeout || e === Re.Failed) && i ? m.FAILED : m.CAPTURING;
}
const Ks = (e, t) => {
  const r = n$(e);
  return [...t, r].reduce((n, i) => n + i, "");
}, n$ = (e) => `
        :host {
        display: block;
        width: 100%;
        height: 100%;
        background-color: #fff;
        --font-family: `.concat(e.fontFamily || "Noto Sans, sans-serif", `;
        --font-size: `).concat(e.fontSize || "16px", `;
        --onboarding-screen-start-button-background: `).concat(e.onboardingScreenStartButtonBackground || "#7E57C5", `;
        --onboarding-screen-start-button-background-hover: `).concat(e.onboardingScreenStartButtonBackgroundHover || "#7c45b4", `;
        --onboarding-screen-start-button-title: `).concat(e.onboardingScreenStartButtonTitle || "#FFFFFF", `;
        --onboarding-screen-start-button-title-hover: `).concat(e.onboardingScreenStartButtonTitleHover || "#FFFFFF", `;
        --onboarding-screen-illumination: url(`).concat(e.onboardingScreenIllumination || "data:image/svg+xml;base64,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", `);
        --onboarding-screen-accessories: url(`).concat(e.onboardingScreenAccessories || "data:image/svg+xml;base64,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", `);
        --onboarding-screen-camera-level: url(`).concat(e.onboardingScreenCameraLevel || "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMiIGhlaWdodD0iNDMiIHZpZXdCb3g9IjAgMCA0MyA0MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgICAgICAgICAgPHBhdGgKICAgICAgICAgICAgICAgIGQ9Ik00LjkzOTQ4IDEwLjg0NDVDNC45NDMyMSA2LjA0NTI3IDguODM2NzggMi4xNTc3NSAxMy42MzYgMi4xNjE0OEwxNi4xMTMxIDIuMTYzNDFDMjAuOTEyMyAyLjE2NzE0IDI0Ljc5OTggNi4wNjA3MSAyNC43OTYxIDEwLjg1OTlMMjQuNzg5OCAxOC45MzY2QzI0Ljc4NTYgMjQuNDE5OSAyMC4zMzcgMjguODYxNSAxNC44NTM4IDI4Ljg1NzJDOS4zNzA1MyAyOC44NTI5IDQuOTI4OTMgMjQuNDA0NCA0LjkzMzIgMTguOTIxMkw0LjkzOTQ4IDEwLjg0NDVaIgogICAgICAgICAgICAgICAgZmlsbD0iI0U4RThFOCIKICAgICAgICAgICAgICAgIHN0cm9rZT0iIzI2MjYyNiIKICAgICAgICAgICAgICAgIHN0cm9rZVdpZHRoPSIxLjI1MDg2IgogICAgICAgICAgICAvPgogICAgICAgICAgICA8cGF0aAogICAgICAgICAgICAgICAgZD0iTTE5LjA3MzIgMjIuMzQ4NkMxNS44NzcgMjIuODYwMiAxNC4wOTQ0IDIyLjg4NTggMTAuOTUwNSAyMS45MzY0TTE1LjYyNzIgOS44ODE4NkMxNS43MTc1IDEwLjIyODIgMTcuNjUxNiAxNy40NzM1IDE3LjQzNjcgMTguMzczMkMxNy4yMjE3IDE5LjI3MjggMTMuOTI3IDE4LjI2NzMgMTMuOTI3IDE4LjI2NzMiCiAgICAgICAgICAgICAgICBzdHJva2U9IiMyNjI2MjYiCiAgICAgICAgICAgICAgICBzdHJva2VXaWR0aD0iMS4yNTA4NiIKICAgICAgICAgICAgLz4KICAgICAgICAgICAgPGNpcmNsZQogICAgICAgICAgICAgICAgY3g9IjIwLjQxODEiCiAgICAgICAgICAgICAgICBjeT0iMTEuMTg2MyIKICAgICAgICAgICAgICAgIHI9IjAuNjI1NDMxIgogICAgICAgICAgICAgICAgdHJhbnNmb3JtPSJyb3RhdGUoLTUuNjA1NTcgMjAuNDE4MSAxMS4xODYzKSIKICAgICAgICAgICAgICAgIGZpbGw9IiMyNjI2MjYiCiAgICAgICAgICAgICAgICBzdHJva2U9IiMyNjI2MjYiCiAgICAgICAgICAgICAgICBzdHJva2VXaWR0aD0iMC41OTcxODQiCiAgICAgICAgICAgIC8+CiAgICAgICAgICAgIDxjaXJjbGUKICAgICAgICAgICAgICAgIGN4PSIxMC42NzY1IgogICAgICAgICAgICAgICAgY3k9IjExLjM5OCIKICAgICAgICAgICAgICAgIHI9IjAuNjI1NDMyIgogICAgICAgICAgICAgICAgdHJhbnNmb3JtPSJyb3RhdGUoLTEzLjEwNDIgMTAuNjc2NSAxMS4zOTgpIgogICAgICAgICAgICAgICAgZmlsbD0iIzI2MjYyNiIKICAgICAgICAgICAgICAgIHN0cm9rZT0iIzI2MjYyNiIKICAgICAgICAgICAgICAgIHN0cm9rZVdpZHRoPSIwLjU5NzE4NCIKICAgICAgICAgICAgLz4KICAgICAgICAgICAgPHJlY3QKICAgICAgICAgICAgICAgIHg9IjE5LjA2NCIKICAgICAgICAgICAgICAgIHk9IjE0LjUxNDYiCiAgICAgICAgICAgICAgICB3aWR0aD0iMTMuOTYzOCIKICAgICAgICAgICAgICAgIGhlaWdodD0iMjUuMzc0OCIKICAgICAgICAgICAgICAgIHJ4PSIzLjE3ODIzIgogICAgICAgICAgICAgICAgZmlsbD0iI0ZCRkJGQiIKICAgICAgICAgICAgICAgIHN0cm9rZT0iIzI2MjYyNiIKICAgICAgICAgICAgICAgIHN0cm9rZVdpZHRoPSIxLjI1MDg2IgogICAgICAgICAgICAvPgogICAgICAgICAgICA8cmVjdAogICAgICAgICAgICAgICAgeD0iMjEuMTk1NiIKICAgICAgICAgICAgICAgIHk9IjE2LjYzMTMiCiAgICAgICAgICAgICAgICB3aWR0aD0iNS44MzczNiIKICAgICAgICAgICAgICAgIGhlaWdodD0iNS44MzczNiIKICAgICAgICAgICAgICAgIHJ4PSIxLjQ4NDg4IgogICAgICAgICAgICAgICAgZmlsbD0iI0U4RThFOCIKICAgICAgICAgICAgICAgIHN0cm9rZT0iIzI2MjYyNiIKICAgICAgICAgICAgICAgIHN0cm9rZVdpZHRoPSIwLjgzMzkwOSIKICAgICAgICAgICAgLz4KICAgICAgICAgICAgPGNpcmNsZSBjeD0iMjIuODYzNyIgY3k9IjIwLjgwMDEiIHI9IjAuODM0MzI0IiBmaWxsPSIjMjYyNjI2IiAvPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSIyNS4zNjYxIiBjeT0iMTguMjk4NyIgcj0iMC44MzQzMjQiIGZpbGw9IiMyNjI2MjYiIC8+CiAgICAgICAgICAgIDxwYXRoCiAgICAgICAgICAgICAgICBkPSJNMjIuNzA0MiAzMi43Nzc4QzIyLjcwNDIgMzEuMDA2MiAyNS4zNDYxIDMxLjA2OCAyMy4yODExIDMxLjA2OEMyMS45ODggMzEuMDY4IDIxLjI5MTcgMzAuNDUgMjEuMjkxNyAyOS4zMzc2QzIxLjI5MTcgMjguMjI1MiAyMS45ODggMjcuNjI3OCAyMy4yODExIDI3LjYyNzhDMjUuNTI1MSAyNy42Mjc4IDIzLjEwMjEgMjcuNzEwMiAyMy4xMDIxIDI1Ljg5NzRDMjMuMTAyMSAyNC43ODUgMjMuNzk4MyAyNC4xODc2IDI1LjA5MTQgMjQuMTg3NkgzNC4xMzUxVjE5LjA5NjFDMzQuMTM1MSAxNy43NTcgMzQuNzMxOSAxNy4wMzYgMzUuODA2MSAxNy4wMzZDMzcuMDc5MyAxNy4wMzYgMzcuNDU3MyAxNi45MTI0IDM3LjQ1NzMgMTcuNjU0VjM0LjIzNzFDMzcuNDU3MyAzNy4xMDM5IDM2LjQ2MjYgMzcuOTQ4NSAzMy43NDEyIDM3Ljk0ODVIMjcuMDU2OUMyNS43NjM4IDM3Ljk0ODUgMjUuMDY3NiAzNy4zMzA1IDI1LjA2NzYgMzYuMjE4MUMyNS4wNjc2IDM0LjQ0NjUgMjcuNzA5NCAzNC41MDgzIDI0LjY5MzYgMzQuNTA4M0MyMy40MDA1IDM0LjUwODMgMjIuNzA0MiAzMy44OTAzIDIyLjcwNDIgMzIuNzc3OFoiCiAgICAgICAgICAgICAgICBmaWxsPSIjRThFOEU4IgogICAgICAgICAgICAgICAgc3Ryb2tlPSIjMjYyNjI2IgogICAgICAgICAgICAgICAgc3Ryb2tlV2lkdGg9IjEuMjUwODYiCiAgICAgICAgICAgICAgICBzdHJva2VMaW5lam9pbj0icm91bmQiCiAgICAgICAgICAgIC8+CiAgICAgICAgICAgIDxyZWN0IHg9IjMyLjMzNTkiIHk9IjAuNTE2IiB3aWR0aD0iMTAuMTQ4IiBoZWlnaHQ9IjEwLjE0OCIgcng9IjUuMDc0IiBmaWxsPSIjMjM3ODA0IiAvPgogICAgICAgICAgICA8cmVjdAogICAgICAgICAgICAgICAgeD0iMzMuOTExNiIKICAgICAgICAgICAgICAgIHk9IjUuNDE1NTMiCiAgICAgICAgICAgICAgICB3aWR0aD0iMS4yOTg1IgogICAgICAgICAgICAgICAgaGVpZ2h0PSIzLjg5NTUxIgogICAgICAgICAgICAgICAgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDMzLjkxMTYgNS40MTU1MykiCiAgICAgICAgICAgICAgICBmaWxsPSIjRkJGQkZCIgogICAgICAgICAgICAvPgogICAgICAgICAgICA8cmVjdAogICAgICAgICAgICAgICAgeD0iMzkuOTkwMiIKICAgICAgICAgICAgICAgIHk9IjMuMDEwMjUiCiAgICAgICAgICAgICAgICB3aWR0aD0iMS4yOTg1IgogICAgICAgICAgICAgICAgaGVpZ2h0PSI0LjcwMDM3IgogICAgICAgICAgICAgICAgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMzkuOTkwMiAzLjAxMDI1KSIKICAgICAgICAgICAgICAgIGZpbGw9IiNGQkZCRkIiCiAgICAgICAgICAgIC8+CiAgICAgICAgICAgIDxyZWN0CiAgICAgICAgICAgICAgICB4PSIzMi4zMzU5IgogICAgICAgICAgICAgICAgeT0iMC41MTYiCiAgICAgICAgICAgICAgICB3aWR0aD0iMTAuMTQ4IgogICAgICAgICAgICAgICAgaGVpZ2h0PSIxMC4xNDgiCiAgICAgICAgICAgICAgICByeD0iNS4wNzQiCiAgICAgICAgICAgICAgICBzdHJva2U9IiMyMzc4MDQiCiAgICAgICAgICAgICAgICBzdHJva2VXaWR0aD0iMS4wMzIiCiAgICAgICAgICAgIC8+CiAgICAgICAgPC9zdmc+", `);
        --camera-screen-sector-target: `).concat(e.cameraScreenSectorTarget || "#BEABE2", `;
        --camera-screen-sector-active: `).concat(e.cameraScreenSectorActive || "#7E57C5", `;
        --camera-screen-stroke-normal: `).concat(e.cameraScreenStrokeNormal || "#7E57C5", `;
        --processing-screen-progress: `).concat(e.processingScreenProgress || "#7E57C5", `;
        --camera-screen-front-hint-label-background: `).concat(e.cameraScreenFrontHintLabelBackground || "#E8E8E8", `;
        --camera-screen-front-hint-label-text: `).concat(e.cameraScreenFrontHintLabelText || "#000000", `;
        --success-screen-image: url(`).concat(e.successScreenImage || "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODYiIGhlaWdodD0iODYiIHZpZXdCb3g9IjAgMCA4NiA4NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGVsbGlwc2UgY3g9IjQzIiBjeT0iNDMiIHJ4PSI0MCIgcnk9IjQwIiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA0MyA0MykiIHN0cm9rZT0iIzVEQTYwMCIgc3Ryb2tlLXdpZHRoPSIzIi8+CjxwYXRoIGQ9Ik02NiAzMUw0MC41MDY5IDU1TDI4IDQzLjIyNTYiIHN0cm9rZT0iIzVEQTYwMCIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+CgoKCgo=", `);
        --retry-screen-environment-image: url(`).concat(e.retryScreenEnvironmentImage || "data:image/svg+xml;base64,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", `);
        --retry-screen-person-image: url(`).concat(e.retryScreenPersonImage || "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDE0MCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxNDAiIGhlaWdodD0iMTAwIiByeD0iMyIgZmlsbD0iI0Y0RjRGNCIvPgo8Y2lyY2xlIGN4PSIxMjQiIGN5PSIxNiIgcj0iMTAiIGZpbGw9IiNEQzQzNDMiLz4KPHJlY3Qgd2lkdGg9IjkuMTk2MjgiIGhlaWdodD0iMS44MzkyNiIgdHJhbnNmb3JtPSJtYXRyaXgoLTAuNzA3MTA3IC0wLjcwNzEwNyAtMC43MDcxMDcgMC43MDcxMDcgMTI4LjA1MyAxOC43NTI5KSIgZmlsbD0id2hpdGUiLz4KPHJlY3QgeD0iMTIwLjI1IiB5PSIxOC43NTI5IiB3aWR0aD0iOS4xOTYyOCIgaGVpZ2h0PSIxLjgzOTI2IiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgMTIwLjI1IDE4Ljc1MjkpIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNNjcuMjMzIDI1LjM3MTdMNzIuNjA5NyAyNS4zNzU5QzgzLjIyNDQgMjUuMzg0MSA5MS44MjI2IDMzLjk5NTcgOTEuODE0NCA0NC42MTA0TDkxLjgwMDggNjIuMTQxNkM5MS43OTE0IDc0LjI0MTEgODEuOTc1MiA4NC4wNDIgNjkuODc1NyA4NC4wMzI2QzU3Ljc3NjMgODQuMDIzMSA0Ny45NzU0IDc0LjIwNyA0Ny45ODQ4IDYyLjEwNzVMNDcuOTk4NCA0NC41NzYzQzQ4LjAwNjcgMzMuOTYxNiA1Ni42MTgzIDI1LjM2MzQgNjcuMjMzIDI1LjM3MTdaIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik03OS4wMzU5IDY5LjU0N0M3NS4wMDA1IDc2IDY1LjUwMDUgNzUuNSA2MS40MDQ4IDY4LjY1MjRNNzEuNTU2IDQyLjQ4NjdDNzEuNzUyMSA0My4yMzg1IDc1Ljk1MDMgNTguOTY1MiA3NS40ODM3IDYwLjkxOEM3NS4wMTcgNjIuODcwOCA2Ny44NjU1IDYwLjY4ODEgNjcuODY1NSA2MC42ODgxIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiLz4KPGVsbGlwc2UgY3g9IjgxLjUiIGN5PSI0NiIgcng9IjIuNSIgcnk9IjEiIGZpbGw9IiMwQzBDMEMiLz4KPGVsbGlwc2UgY3g9IjYwLjUiIGN5PSI0NiIgcng9IjIuNSIgcnk9IjEiIGZpbGw9IiMwQzBDMEMiLz4KPC9zdmc+CgoK", `);
        --retry-screen-retry-button-background: `).concat(e.retryScreenRetryButtonBackground || "#7E57C5", `;
        --retry-screen-retry-button-background-hover: `).concat(e.retryScreenRetryButtonBackgroundHover || "#7c45b4", `;
        --retry-screen-retry-button-title: `).concat(e.retryScreenRetryButtonTitle || "#FFFFFF", `;
        --retry-screen-retry-button-title-hover: `).concat(e.retryScreenRetryButtonTitleHover || "#FFFFFF", `;
    }`), Nx = (e) => {
  if (typeof e != "number") return 0;
  if (e === 180) return e;
  const t = e % 360;
  return t === 90 || t === -270 ? 90 : t === -90 || t === 270 ? -90 : 0;
}, i$ = (e) => {
  let t = Du.default;
  return e === Re.Timeout && (t = Du.timeout), e === Re.Stop_Session && (t = Du.aborted), t;
}, Dx = (e) => e === Re.Finished || e === Re.Stop_Session || e === Re.Timeout, M$ = location.hostname === "localhost" || location.hostname === "127.0.0.1", yx = location.protocol === "http:" && !M$, XT = (e) => {
  const t = /(?:^|\D)(\d+\.\d+).*$/, r = e.match(t);
  return r && r[1] ? r[1] : "6.1";
}, a$ = (e) => {
  try {
    const t = JSON.parse(e);
    return typeof t == "object" && t !== null;
  } catch (t) {
    return !1;
  }
}, o$ = (e, t) => e.replace(/https:\/\/wasm\.regulaforensics\.com\/face\/\w+\/\d+\.\d+\/[a-f0-9-]+/, t), u$ = "_text_wzfb4_15", s$ = "_title_wzfb4_28", l$ = "_subtitle_wzfb4_43", c$ = "_container_wzfb4_55", I$ = "_icon_wzfb4_88", g$ = "_illumination_wzfb4_132", j$ = "_buttonAnimation_wzfb4_1", Fe = {
  "instruction-window": "_instruction-window_wzfb4_1",
  text: u$,
  title: s$,
  subtitle: l$,
  container: c$,
  "icon-block": "_icon-block_wzfb4_88",
  "icon-container": "_icon-container_wzfb4_111",
  icon: I$,
  illumination: g$,
  "no-accessories": "_no-accessories_wzfb4_136",
  "camera-on-eye": "_camera-on-eye_wzfb4_140",
  buttonAnimation: j$
};
function N$(e) {
  let {
    title: t,
    subtitle: r,
    btnText: n
  } = e;
  const {
    onStart: i
  } = Q((o) => ({
    onStart: o.onStart
  })), {
    translate: M
  } = Ii.useLocalize();
  return /* @__PURE__ */ a.jsx("div", { className: Fe["instruction-window"], children: /* @__PURE__ */ a.jsxs("div", { className: Fe.container, children: [
    /* @__PURE__ */ a.jsxs("div", { className: Fe.text, children: [
      /* @__PURE__ */ a.jsx("div", { className: Fe.title, children: t }),
      /* @__PURE__ */ a.jsx("div", { className: Fe.subtitle, children: r })
    ] }),
    /* @__PURE__ */ a.jsxs("div", { className: Fe["icon-container"], children: [
      /* @__PURE__ */ a.jsxs("div", { className: Fe["icon-block"], children: [
        /* @__PURE__ */ a.jsx("div", { className: "".concat(Fe.icon, " ").concat(Fe.illumination) }),
        M("illumination")
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: Fe["icon-block"], children: [
        /* @__PURE__ */ a.jsx("div", { className: "".concat(Fe.icon, " ").concat(Fe["no-accessories"]) }),
        M("noAccessories")
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: Fe["icon-block"], children: [
        /* @__PURE__ */ a.jsx("div", { className: "".concat(Fe.icon, " ").concat(Fe["camera-on-eye"]) }),
        M("cameraLevel")
      ] })
    ] }),
    /* @__PURE__ */ a.jsx(J4, { "data-e2e": "get-ready", onClick: i, children: n })
  ] }) });
}
function KT(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function St(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? KT(Object(r), !0).forEach(function(n) {
      D$(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : KT(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function D$(e, t, r) {
  return (t = y$(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function y$(e) {
  var t = T$(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function T$(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const zi = Bt.create("main");
function A$() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ur.environment, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Qa.VGA, r = arguments.length > 2 ? arguments[2] : void 0;
  const [{
    status: n,
    stream: i,
    camera: M
  }, o] = f.useState({
    status: _.PREPARING,
    stream: null,
    camera: {
      deviceId: "",
      facing: void 0,
      groupId: "",
      label: ""
    }
  }), [u, s] = f.useState(null), [l, I] = f.useState(null), g = f.useRef(""), c = f.useCallback(() => {
    o((D) => St(St({}, D), {}, {
      status: _.PLAY
    }));
  }, []);
  return f.useEffect(() => {
    let D = !0;
    return bP().then((j) => {
      zi("Video devices: ".concat(JSON.stringify(j))), D && (o((N) => St(St({}, N), {}, {
        status: j.isCameraAllowed ? _.PREPARING : _.REQUESTING
      })), s(j));
    }).catch((j) => {
      zi("Error in receiving media devices: ".concat(j)), D && o((N) => St(St({}, N), {}, {
        status: FP() ? _.HTTP_NOT_SUPPORTED : window.isSecureContext ? _.NOT_SUPPORTED : _.INSECURE_PAGE_CONTEXT
      }));
    }), () => {
      D = !1;
    };
  }, []), f.useEffect(() => {
    let D = !0;
    if (!(!u || l))
      return $P(u).then((j) => {
        zi("Sorted cameras: ".concat(JSON.stringify(j))), D && I(j);
      }).catch((j) => {
        if (zi("Error sorting cameras: ".concat(j)), !!D) {
          if (j instanceof Error && j.name === a6)
            return o((N) => St(St({}, N), {}, {
              status: _.PERMISSION_DENIED
            }));
          o((N) => St(St({}, N), {}, {
            status: _.UNKNOWN_ERROR
          }));
        }
      }), () => {
        D = !1;
      };
  }, [u]), f.useEffect(() => {
    let D = !0;
    const j = n === _.PREPARING || n === _.REQUESTING;
    if (!l || i !== null || !j) return;
    const N = RP(e, l, r);
    return zi("Selected camera: ".concat(JSON.stringify(N))), Ce(this, null, function* () {
      try {
        yield ZP(Xh ? s6 : 0);
        const y = yield HP(t, N, r);
        if (D)
          g.current = y.camera.deviceId, o(y);
        else {
          if (!y.stream) return;
          ZT(y.stream);
        }
      } catch (T) {
        if (zi("Get video error: ".concat(T)), !D) return;
        o((y) => St(St({}, y), {}, {
          status: _.UNKNOWN_ERROR
        }));
      }
    }), () => {
      D = !1;
    };
  }, [l, i, e, r, n, t]), f.useEffect(() => () => {
    i && ZT(i);
  }, [i]), f.useEffect(() => {
    if (!r || !g.current) return;
    const D = r !== g.current;
    n !== _.PLAY || !D || o({
      status: _.PREPARING,
      stream: null,
      camera: {
        deviceId: "",
        facing: void 0,
        groupId: "",
        label: ""
      }
    });
  }, [r, n]), {
    status: n,
    stream: i,
    camera: M,
    sortedDevices: l,
    onPlay: c
  };
}
const d$ = "_container_1hyic_1", x$ = "_video_1hyic_6", qT = {
  container: d$,
  video: x$
};
function Ar(e, t, r) {
  return (t = E$(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function E$(e) {
  var t = z$(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function z$(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const fi = Bt.create("main"), f$ = 12e5;
class C$ {
  constructor() {
    Ar(this, "chunks", []), Ar(this, "recorder", null), Ar(
      this,
      "mimeType",
      "video/webm"
      /* WEBM */
    ), Ar(this, "record", null), Ar(this, "delayTimeout", null), Ar(this, "durationTimeout", null), Ar(this, "isRecording", !1), Ar(this, "debug", !1), Ar(this, "delay", 0), Ar(this, "duration", void 0);
  }
  init(t) {
    if (!("MediaRecorder" in window)) {
      fi("MediaRecorder is missing");
      return;
    }
    this.mimeType = MediaRecorder.isTypeSupported(
      "video/webm"
      /* WEBM */
    ) ? "video/webm" : "video/mp4;codecs=avc1", this.recorder = new MediaRecorder(t, {
      mimeType: this.mimeType,
      videoBitsPerSecond: f$
    }), this.recorder.addEventListener("dataavailable", this.setChunk.bind(this)), this.recorder.addEventListener("error", this.errorHandle.bind(this)), this.delay ? this.delayTimeout = setTimeout(() => {
      this.delayTimeout = null, this.startRecording();
    }, this.delay) : this.startRecording(), this.duration && (this.durationTimeout = setTimeout(() => Ce(this, null, function* () {
      this.durationTimeout = null, this.record = yield this.getRecord();
    }), this.delay + this.duration)), fi("MediaRecorder initialized: { duration: ".concat(this.duration, ", delay: ").concat(this.delay, ", mimeType: ").concat(this.mimeType, " }"));
  }
  startRecording() {
    this.recorder && (this.recorder.start(), this.isRecording = !0, fi("Recording has started"));
  }
  clearTimeouts() {
    this.delayTimeout && clearTimeout(this.delayTimeout), this.durationTimeout && clearTimeout(this.durationTimeout);
  }
  getRecord() {
    return Ce(this, null, function* () {
      if (this.record) {
        const t = this.record;
        return this.record = null, t;
      }
      return !this.recorder || this.recorder.state === "inactive" ? null : (this.stopRecord(), new Promise((t) => {
        if (!this.recorder)
          return t(null);
        this.recorder.onstop = () => Ce(this, null, function* () {
          const r = yield this.getVideoData();
          fi("Video record resolved"), t(r);
        });
      }));
    });
  }
  stopRecord() {
    var t, r, n;
    if (!this.recorder || this.recorder.state === "inactive") {
      this.clearTimeouts();
      return;
    }
    (t = this.recorder) === null || t === void 0 || t.stop(), (r = this.recorder) === null || r === void 0 || r.removeEventListener("dataavailable", this.setChunk), (n = this.recorder) === null || n === void 0 || n.removeEventListener("error", this.errorHandle), this.clearTimeouts(), this.isRecording = !1, fi("Recording stopped");
  }
  errorHandle(t) {
    fi("Stream recorder service error: ".concat(JSON.stringify(t)));
  }
  setChunk(t) {
    this.chunks.push(t.data);
  }
  getVideoData() {
    return Ce(this, null, function* () {
      const t = new Blob(this.chunks, {
        type: this.mimeType
      });
      if (this.debug) {
        const r = document.createElement("a"), n = URL.createObjectURL(t);
        r.href = n, r.download = "video", r.click(), URL.revokeObjectURL(n);
      }
      return new Promise((r) => {
        r({
          data: t,
          mimeType: t.type
        });
      });
    });
  }
}
function L$(e) {
  let {
    onVideoStatusChange: t,
    onVideoSizeChange: r,
    mode: n,
    resolution: i,
    mirroring: M,
    onFailStatus: o,
    cameraId: u,
    onRecordService: s,
    videoRecord: l,
    onVideoStarted: I,
    onVideoStopped: g,
    mirrorType: c
  } = e;
  const D = f.useRef(null), {
    status: j,
    stream: N,
    camera: d,
    sortedDevices: T,
    onPlay: y
  } = A$(n, i, u), A = f.useRef(null), x = f.useRef(null), E = (d == null ? void 0 : d.facing) === ur.environment || c === r5.noMirror ? 1 : -1, C = M ? -E : E, p = () => {
    y(), I == null || I();
  };
  return f.useEffect(() => {
    const O = A.current, w = x.current, z = () => {
      !O || !w || r == null || r({
        videoElement: O,
        videoParams: {
          width: O.videoWidth,
          height: O.videoHeight
        },
        videoContainerParams: {
          width: w.clientWidth,
          height: w.clientHeight
        }
      });
    };
    return O && (window.addEventListener("resize", z), O.addEventListener("resize", z)), () => {
      var R;
      O && (window.removeEventListener("resize", z), O.removeEventListener("resize", z)), (R = D.current) === null || R === void 0 || R.stopRecord();
    };
  }, []), f.useEffect(() => {
    const O = A.current;
    if (j === _.READY && O && N && (O.srcObject = N, Dd ? setTimeout(() => O.play(), l6) : O.play(), l)) {
      if (D.current) {
        var z;
        (z = D.current) === null || z === void 0 || z.stopRecord();
      } else {
        const K = new C$();
        typeof l != "boolean" && (K.delay = l.delay || 0, K.duration = l.duration, K.debug = !!l.debug), D.current = K, s == null || s(K);
      }
      D.current.init(N);
    }
    const R = I6[j];
    o && R && o(R), t({
      videoStatus: j,
      camera: d,
      sortedDevices: T
    });
  }, [j, d, N, T, l]), /* @__PURE__ */ a.jsx("div", { ref: x, className: qT.container, children: /* @__PURE__ */ a.jsx("video", { onAbort: g, onLoadedData: p, className: qT.video, style: {
    transform: "scaleX(".concat(C, ")")
  }, ref: A, playsInline: !0 }) });
}
const O$ = "_container_1dlmk_14", p$ = "_translateY_1dlmk_31", S$ = "_videoContainer_1dlmk_39", v$ = "_videoContainerRotation_1dlmk_44", h$ = "_videoContainerBlur_1dlmk_64", m$ = "_backgroundSvg_1dlmk_72", w$ = "_hide_1dlmk_80", k$ = "_frame_1dlmk_84", U$ = "_dash_1dlmk_1", Q$ = "_done_1dlmk_90", Y$ = "_pulse_1dlmk_1", b$ = "_hintArrowAnimation_1dlmk_106", P$ = "_pulseHintArrow_1dlmk_1", $$ = "_primaryMessage_1dlmk_125", R$ = "_secondaryMessage_1dlmk_134", H$ = "_centreMessage_1dlmk_146", V$ = "_functionalButtons_1dlmk_163", _$ = "_targetSector_1dlmk_212", Z$ = "_currentSector_1dlmk_217", G$ = "_firstStepAnimation_1dlmk_222", B$ = "_targetSectorFirstStepAnimation_1dlmk_1", F$ = "_currentSectorFirstStepAnimation_1dlmk_1", W$ = "_ellipseFirstStepAnimation_1dlmk_1", J$ = "_spriteAnimation_1dlmk_1", X$ = "_moveCloser_1dlmk_1", K$ = "_moveAway_1dlmk_1", q$ = "_fitYourFace_1dlmk_1", ue = {
  "message-container": "_message-container_1dlmk_2",
  container: O$,
  translateY: p$,
  videoContainer: S$,
  videoContainerRotation: v$,
  "videoContainerRotation-90-rev": "_videoContainerRotation-90-rev_1dlmk_52",
  "videoContainerRotation-90": "_videoContainerRotation-90_1dlmk_52",
  "videoContainerRotation-180": "_videoContainerRotation-180_1dlmk_60",
  videoContainerBlur: h$,
  backgroundSvg: m$,
  hide: w$,
  frame: k$,
  dash: U$,
  done: Q$,
  pulse: Y$,
  hintArrowAnimation: b$,
  pulseHintArrow: P$,
  primaryMessage: $$,
  secondaryMessage: R$,
  centreMessage: H$,
  functionalButtons: V$,
  targetSector: _$,
  currentSector: Z$,
  firstStepAnimation: G$,
  targetSectorFirstStepAnimation: B$,
  currentSectorFirstStepAnimation: F$,
  ellipseFirstStepAnimation: W$,
  "face-hint": "_face-hint_1dlmk_247",
  "face-hint-container": "_face-hint-container_1dlmk_252",
  "face-hint-round": "_face-hint-round_1dlmk_264",
  "face-hint-target": "_face-hint-target_1dlmk_273",
  spriteAnimation: J$,
  "face-hint-animation-9": "_face-hint-animation-9_1dlmk_280",
  "face-hint-animation-2": "_face-hint-animation-2_1dlmk_285",
  "face-hint-animation-3": "_face-hint-animation-3_1dlmk_290",
  moveCloser: X$,
  "face-hint-animation-4": "_face-hint-animation-4_1dlmk_295",
  moveAway: K$,
  "face-hint-animation-1": "_face-hint-animation-1_1dlmk_300",
  fitYourFace: q$
}, Tx = f.memo((e) => {
  let {
    numSectors: t,
    targetSector: r,
    currSector: n,
    centerX: i,
    centerY: M,
    sectorRadius: o
  } = e;
  const u = 360 / t, [s, l] = f.useState({
    targetSectorAngle: 0,
    targetSector: 0
  }), [I, g] = f.useState({
    strokeDashArrayFill: 0,
    strokeOffset: 0,
    sectorRadius: 0
  }), c = f.useRef(0);
  f.useEffect(() => {
    const d = 2 * Math.PI * o, T = 100 / t, y = d / 100 * T;
    g({
      strokeDashArrayFill: d,
      strokeOffset: d - y,
      sectorRadius: o
    });
  }, [o]), f.useEffect(() => {
    l((d) => {
      const T = r - d.targetSector;
      let y = d.targetSectorAngle - T * u;
      return T * u > 180 && (y = d.targetSectorAngle + (t - T) * u), c.current = c.current + 1, {
        targetSectorAngle: y,
        targetSector: r
      };
    });
  }, [r]);
  const D = f.useMemo(() => {
    if (n === r)
      return /* @__PURE__ */ a.jsx("circle", { className: ue.currentSector, strokeWidth: I.sectorRadius / 3, transform: "rotate(".concat(-r * u - l1, " ").concat(i, " ").concat(M, ")"), strokeDasharray: I.strokeDashArrayFill, strokeDashoffset: I.strokeOffset, fill: "none", stroke: "var(--camera-screen-sector-active)", r: I.sectorRadius, cx: i, cy: M, mask: "url(#readinessMask)" });
  }, [r, n]), j = () => {
    if (eo && Kh) {
      const d = window.parent.innerWidth / window.parent.outerWidth;
      return "".concat(i / d, "px ").concat(M / d, "px");
    }
    return "center center";
  }, N = f.useMemo(() => /* @__PURE__ */ a.jsx("circle", { className: ue.targetSector, strokeWidth: I.sectorRadius / 3, style: {
    "--sector-rotate": "rotate(".concat(s.targetSectorAngle - l1, "deg)"),
    transformOrigin: j(),
    WebkitTransformOrigin: j(),
    transition: c.current > 1 ? ".5s linear" : "",
    WebkitTransition: c.current > 1 ? ".5s linear" : ""
  }, strokeDasharray: I.strokeDashArrayFill, strokeDashoffset: I.strokeOffset, fill: "none", stroke: "var(--camera-screen-sector-target)", r: I.sectorRadius, cx: i, cy: M, mask: "url(#targetSectorMask)" }), [r, c.current, s.targetSectorAngle]);
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx("defs", { children: /* @__PURE__ */ a.jsxs("mask", { id: "targetSectorMask", x: "0", y: "0", children: [
      /* @__PURE__ */ a.jsx("circle", { strokeWidth: I.sectorRadius / 2, r: I.sectorRadius, cx: i, cy: M, fill: "black", stroke: "white" }),
      /* @__PURE__ */ a.jsx("ellipse", { cx: i, cy: M, rx: o - ja, ry: o - ja })
    ] }) }),
    N,
    D
  ] });
});
Tx.displayName = "SectorAnimationSvg";
const eR = "data:image/svg+xml;base64,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", tR = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjI0MDAiIHZpZXdCb3g9IjAgMCAzMDAgMjQwMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTY3Ljc0MDIgMTQ2LjM3QzY3Ljc0MDIgMTM0LjcgNjcuODQwMiAxMjMuMDMgNjguMDgwMiAxMTEuMzdDNjguNjAwMiA4NS45ODk3IDc5Ljk4MDIgNjYuMzg5NyAxMDAuNTggNTIuMTQ5N0MxMTIuMTkgNDQuMTE5NyAxMjUuMjggNDAuMDc5NyAxMzkuNDUgMzkuOTY5N0MxNDcuNzUgMzkuODk5NyAxNTYuMDYgMzkuODI5NyAxNjQuMzYgNDAuMDI5N0MxOTYuNzMgNDAuNzg5NyAyMjYuMDcgNjMuNTQ5NyAyMzMuNzkgOTguMjg5N0MyMzQuNCAxMDEuMDQgMjM0Ljg4IDEwMy44OSAyMzQuOSAxMDYuNjlDMjM1LjA0IDEzMS42OSAyMzUuNzEgMTU2LjcxIDIzNC45NCAxODEuNjhDMjM0LjAxIDIxMS44OSAyMTkuOTEgMjM1LjI4IDE5NC4xOSAyNTAuOEMxNDkuMjggMjc3LjkxIDkxLjE4MDIgMjU3LjA2IDcyLjgyMDIgMjA3LjczQzY5LjEyMDIgMTk3Ljc5IDY3LjU4MDIgMTg3LjQ4IDY3LjcxMDIgMTc2Ljg3QzY3LjgzMDIgMTY2LjcxIDY3Ljc0MDIgMTU2LjU0IDY3Ljc0MDIgMTQ2LjM3Wk03NC42MDAyIDE0Ni4xNUM3NC42MDAyIDE1Ny45OCA3NC40MDAyIDE2OS44MSA3NC42NTAyIDE4MS42NEM3NC45NDAyIDE5NS40MyA3OC44MzAyIDIwOC4zMSA4Ni40NjAyIDIxOS43OEMxMDMuNTkgMjQ1LjUyIDEyNy42NiAyNTcuNjYgMTU4LjUzIDI1NS4zMUMxNzkuMDQgMjUzLjc1IDE5NiAyNDQuNjYgMjA5LjUgMjI5LjE5QzIyMi4yOCAyMTQuNTUgMjI4LjQyIDE5Ny4zMSAyMjguNDMgMTc3LjlDMjI4LjQzIDE1NS4wNyAyMjguMzEgMTMyLjI0IDIyOC4yMyAxMDkuNDJDMjI4LjIzIDEwOC4yNSAyMjguMjUgMTA3LjA4IDIyOC4xMiAxMDUuOTNDMjI0LjQgNzIuODM5NyAxOTYuNjIgNDcuNDQ5NyAxNjMuMzUgNDYuNzk5N0MxNTUuODggNDYuNjQ5NyAxNDguNCA0Ni43ODk3IDE0MC45MyA0Ni43NDk3QzEzMy4wNCA0Ni43MDk3IDEyNS40MyA0OC4xMjk3IDExOC4wMyA1MC44NTk3QzkxLjE2MDIgNjAuNzY5NyA3NC43MTAyIDg2LjY0OTcgNzQuODIwMiAxMTEuNjhDNzQuODcwMiAxMjMuMTggNzQuNjAwMiAxMzQuNjUgNzQuNjAwMiAxNDYuMTVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjM0LjAxIDQ0Ny4zOUMyMzQuMDEgNDU5LjM4IDIzNC42NCA0NzEuMzkgMjM0LjE4IDQ4My4zNkMyMzMuMjggNTA2Ljg3IDIyMy40MyA1MjYuMzYgMjA2LjE3IDU0Mi4wM0MxOTMuNTIgNTUzLjUyIDE3OC41MyA1NjAuNjUgMTYxLjYxIDU2Mi40N0MxMjguNzUgNTY2IDEwMS45NCA1NTQuNTMgODIuMzAwMiA1MjcuNjRDNzEuNjkwMiA1MTMuMTEgNjYuNzkwMiA0OTYuNDggNjYuOTMwMiA0NzguNDdDNjcuMTEwMiA0NTQuNDkgNjcuMTYwMiA0MzAuNSA2Ny44NTAyIDQwNi41NEM2OC4yODAyIDM5MS41NyA3NC4zNDAyIDM3OC40MSA4My44MDAyIDM2Ni45OEM5Ny4zMjAyIDM1MC42NCAxMTQuODUgMzQxLjU3IDEzNS45NyAzNDAuNTZDMTQ3LjU0IDM0MC4wMSAxNTkuMjggMzQwLjExIDE3MC43NyAzNDEuNDRDMTg5Ljg1IDM0My42NSAyMDUuNTYgMzUyLjkxIDIxNy43OSAzNjcuODNDMjI2Ljc2IDM3OC43OCAyMzEuODMgMzkxLjQ3IDIzMy44NSA0MDUuNDNDMjM0LjA2IDQwNi45IDIzNC4wMSA0MDguNDIgMjM0LjAxIDQwOS45MkMyMzQuMDIgNDIyLjQxIDIzNC4wMSA0MzQuOSAyMzQuMDEgNDQ3LjM5Wk0yMjcuMzEgNDQ3LjM5QzIyNy4zMSA0MzUuMjIgMjI3LjM2IDQyMy4wNiAyMjcuMjcgNDEwLjg5QzIyNy4yNSA0MDguMDggMjI2Ljk3IDQwNS4yNCAyMjYuNDkgNDAyLjQ2QzIyMS43MSAzNzUuMDcgMjAwLjM2IDM1My4zMSAxNzMuMDkgMzQ4LjYzQzE1OS42MyAzNDYuMzIgMTQ1Ljk1IDM0Ni4yNCAxMzIuMzcgMzQ3LjY5QzExNC42OSAzNDkuNTggMTAwLjIyIDM1Ny44NCA4OC45NzAyIDM3MS41NUM4MC40MjAyIDM4MS45NyA3NS4wNDAyIDM5My45OSA3NC42NjAyIDQwNy41N0M3NC4wMjAyIDQzMC41NiA3My44MTAyIDQ1My41NiA3My44NzAyIDQ3Ni41NUM3My44OTAyIDQ4My42NSA3NC42MjAyIDQ5MC45MyA3Ni4zNDAyIDQ5Ny44Qzg4LjE1MDIgNTQ0Ljk2IDEzOC42NyA1NjkuNTkgMTgyLjY0IDU0OS4xM0MyMTAuMTkgNTM2LjMxIDIyNS4zNyA1MTMuOTEgMjI3LjQ1IDQ4My4zNUMyMjguMjYgNDcxLjQxIDIyNy4zMSA0NTkuMzggMjI3LjMxIDQ0Ny4zOVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik02Ni40NCA3NDcuMzhDNjYuNDQgNzM1LjM5IDY2Ljc3IDcyMy40MSA2Ny4wOCA3MTEuNDNDNjcuODQgNjgyLjQ3IDgxLjY5IDY2MS41OSAxMDcuMDIgNjQ4LjNDMTE2LjU0IDY0My4zMSAxMjYuODggNjQwLjgzIDEzNy43MiA2NDEuMDlDMTQ3LjE3IDY0MS4zMiAxNTYuNjkgNjQxLjA0IDE2Ni4wNiA2NDIuMTFDMTk2LjM4IDY0NS41OCAyMTYuOTYgNjYyLjExIDIyOC4xOCA2OTAuNDVDMjMxLjAyIDY5Ny42MiAyMzIuMTkgNzA1LjEyIDIzMi4yOCA3MTIuODlDMjMyLjUxIDczMy41NCAyMzMgNzU0LjE4IDIzMy40OCA3NzQuODJDMjMzLjggNzg4LjUgMjMxLjkxIDgwMS43OCAyMjYuMDIgODE0LjE5QzIxMy4yMyA4NDEuMTggMTkyLjIyIDg1Ny44NCAxNjIuNzUgODYyLjgxQzEyNi43OSA4NjguODggOTEuNjcgODUwLjA3IDc1LjQ2IDgxNy44NkM2OC45NiA4MDQuOTUgNjYuMjEgNzkxLjI2IDY2LjQxIDc3Ni44NkM2Ni41NSA3NjcuMDQgNjYuNDQgNzU3LjIxIDY2LjQ0IDc0Ny4zOFpNNzMuNTkgNzQ2LjE0QzczLjU5IDc1OC4xMyA3My4zMSA3NzAuMTMgNzMuNzEgNzgyLjExQzczLjkxIDc4OC4wNCA3NC44MSA3OTQuMDcgNzYuMzEgNzk5LjgxQzg1Ljk0IDgzNi42MSAxMjEuNjkgODYwLjk2IDE1OC44MiA4NTYuMzRDMTc4LjgzIDg1My44NSAxOTUuNCA4NDQuOTcgMjA4LjQ4IDgyOS42NkMyMjEuNDcgODE0LjQ2IDIyNy4zMyA3OTYuNTkgMjI3LjE0IDc3Ni43MkMyMjYuOTUgNzU3LjA3IDIyNi40NyA3MzcuNDMgMjI2LjA0IDcxNy43OEMyMjUuOTMgNzEyLjk2IDIyNiA3MDguMDUgMjI1LjEyIDcwMy4zNEMyMTkuMzEgNjcyLjIgMTkzLjkzIDY1MS4wMyAxNjYuMjkgNjQ4LjdDMTU2LjcyIDY0Ny44OSAxNDcuMDYgNjQ3LjcyIDEzNy40NSA2NDcuODFDMTAyLjgxIDY0OC4xMyA3NC42IDY3Ni4zOSA3NC4wOSA3MTEuMTZDNzMuOTIgNzIyLjgxIDczLjU5IDczNC40OCA3My41OSA3NDYuMTRaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNNjYuMjQwMSAxMDQ2LjcyQzY2LjI0MDEgMTAzNC4zOSA2Ni41MzAxIDEwMjIuMDcgNjYuOTQwMSAxMDA5Ljc1QzY3LjkwMDEgOTgxLjA3IDgyLjAwMDEgOTYwLjc3IDEwNy4zMiA5NDguMTJDMTE3LjQ2IDk0My4wNSAxMjguNDIgOTQxLjI2IDEzOS43MSA5NDEuNzJDMTQ3LjUxIDk0Mi4wNCAxNTUuMyA5NDIuNDYgMTYzLjA4IDk0Mi45OEMxOTQuNzQgOTQ1LjExIDIyMi4zMSA5NjkuNTYgMjI4Ljk2IDEwMDEuNzhDMjI5LjcgMTAwNS4zNCAyMjkuOTkgMTAwOS4wMyAyMzAuMTIgMTAxMi42N0MyMzAuODcgMTAzMy45OCAyMzEuNDkgMTA1NS4zIDIzMi4xOCAxMDc2LjYxQzIzMi42IDEwODkuNjMgMjMwLjU1IDExMDIuMjIgMjI1LjE3IDExMTQuMDlDMjEyLjcxIDExNDEuNTcgMTkxLjY4IDExNTguODMgMTYxLjk5IDExNjMuNDlDMTE2LjA4IDExNzAuNyA3Ny4wMzAxIDExMzkuNTMgNjguMTEwMSAxMDk3LjU2QzY2LjA4MDEgMTA4OC4wMyA2Ni4xMzAxIDEwNzguMzggNjYuMjMwMSAxMDY4LjcxQzY2LjMwMDEgMTA2MS4zOCA2Ni4yNDAxIDEwNTQuMDUgNjYuMjQwMSAxMDQ2LjcyWk03My41NjAxIDEwNDYuMkM3My41NjAxIDEwNTcuNjkgNzMuNTAwMSAxMDY5LjE4IDczLjU3MDEgMTA4MC42N0M3My42NTAxIDEwOTQuMSA3Ny4xODAxIDExMDYuNjMgODMuNzEwMSAxMTE4LjMyQzEwOC4wNyAxMTYxLjkgMTY2LjM0IDExNzAuNyAyMDIuMTQgMTEzNi4xQzIxNS45MyAxMTIyLjc4IDIyNCAxMTA2LjQ3IDIyNS4zOSAxMDg3LjIzQzIyNS45OSAxMDc4Ljk2IDIyNS42MiAxMDcwLjYxIDIyNS40NCAxMDYyLjNDMjI1LjA5IDEwNDYuMTUgMjI0LjYxIDEwMzAuMDEgMjI0LjEgMTAxMy44N0MyMjMuOTkgMTAxMC4zOCAyMjMuODMgMTAwNi44MyAyMjMuMTEgMTAwMy40NEMyMTcuMjIgOTc1LjUzIDE5Ni4yOSA5NTYuMDkgMTcxLjg2IDk1MC43QzE2MC43NSA5NDguMjUgMTQ5LjQxIDk0OC42NSAxMzguMTYgOTQ4LjI3QzEzMy4wOSA5NDguMSAxMjcuODUgOTQ4LjggMTIyLjg5IDk0OS45NEM5Mi4zNzAxIDk1NyA3My44NTAxIDk4My45OSA3My44NTAxIDEwMTAuNzJDNzMuODUwMSAxMDIyLjU0IDczLjU2MDEgMTAzNC4zOCA3My41NjAxIDEwNDYuMloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik02Ni44Mjk4IDEzNDUuNTlDNjYuODI5OCAxMzMzLjU5IDY3LjAwOTggMTMyMS41OSA2Ni43ODk4IDEzMDkuNTlDNjYuMjg5OCAxMjgxLjQzIDg2LjQwOTggMTI1Mi43MyAxMTYuNTQgMTI0NC44MkMxMjUgMTI0Mi42IDEzMy41IDEyNDEuODggMTQyLjE5IDEyNDIuNjdDMTQ4LjY0IDEyNDMuMjYgMTU1LjEzIDEyNDMuMzcgMTYxLjU2IDEyNDQuMDZDMTg1LjA0IDEyNDYuNTcgMjAzLjAxIDEyNTguMjYgMjE1Ljk4IDEyNzcuNzlDMjIzLjcgMTI4OS40MiAyMjcuNDggMTMwMi4zNiAyMjguMDEgMTMxNi4zOEMyMjguNzcgMTMzNi41MyAyMzAuMzEgMTM1Ni42NSAyMzAuNjggMTM3Ni44QzIzMS4zNCAxNDEyLjE3IDIxNi45IDE0MzkuNTIgMTg1LjQxIDE0NTYuMzVDMTU1LjggMTQ3Mi4xNyAxMTguMzIgMTQ2Ni4yIDkzLjkxOTggMTQ0Mi45MUM3OC42Mjk4IDE0MjguMzIgNjkuODc5OCAxNDEwLjQ1IDY3LjE2OTggMTM4OS41N0M2Ni42Mzk4IDEzODUuNDYgNjYuNzI5OCAxMzgxLjI1IDY2LjcwOTggMTM3Ny4wOUM2Ni42NDk4IDEzNjYuNTkgNjYuNjg5OCAxMzU2LjA5IDY2LjY4OTggMTM0NS41OUg2Ni44Mzk4SDY2LjgyOThaTTIyNC4xMyAxMzYyLjI4QzIyMy40OSAxMzQ4LjEzIDIyMi44OCAxMzMzLjk5IDIyMi4xOSAxMzE5Ljg0QzIyMS43NiAxMzExLjAyIDIyMS4xNyAxMzAyLjI2IDIxNy43MiAxMjkzLjkxQzIwOC41OCAxMjcxLjc5IDE5Mi44NSAxMjU3LjMgMTY5LjQ4IDEyNTEuN0MxNTguNTkgMTI0OS4wOSAxNDcuMzkgMTI0OS4yMyAxMzYuMjkgMTI0OC45QzEyMi4xOSAxMjQ4LjQ4IDEwOS4zOCAxMjUyLjc5IDk4LjIyOTggMTI2MS4zOEM4My4xNTk4IDEyNzIuOTkgNzQuNTU5OCAxMjg4LjUxIDc0LjAxOTggMTMwNy41NUM3My4zNTk4IDEzMzEuMDMgNzMuNjQ5OCAxMzU0LjU0IDczLjg1OTggMTM3OC4wNEM3NC4wNjk4IDE0MDEuMjcgODEuOTQ5OCAxNDIxLjQ5IDk5LjEyOTggMTQzNy40QzExNy4zNSAxNDU0LjI4IDEzOS4wMiAxNDYxLjE3IDE2My40NSAxNDU2LjUyQzE5OS4wNSAxNDQ5Ljc2IDIyNC4zMSAxNDE4LjY0IDIyNC42MiAxMzgyLjI1QzIyNC42OCAxMzc1LjU5IDIyNC4xMyAxMzY4Ljk0IDIyNC4xMyAxMzYyLjI4WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTY2LjkzOTkgMTY0NS45NEM2Ni45Mzk5IDE2MzMuNzcgNjcuMTY5OSAxNjIxLjYgNjYuODg5OSAxNjA5LjQ0QzY2LjIwOTkgMTU3OS44MSA4Ny4zOTk5IDE1NDguMjMgMTI0LjgyIDE1NDMuNDJDMTI4LjQyIDE1NDIuOTYgMTMyLjE1IDE1NDIuOSAxMzUuNzYgMTU0My4yM0MxNDYuNDkgMTU0NC4yIDE1Ny40MSAxNTQ0LjQ2IDE2Ny44NiAxNTQ2Ljc5QzE5MC4wNyAxNTUxLjc1IDIwNi4wMSAxNTY1LjUzIDIxNi42OSAxNTg1LjQ2QzIyMi4wMyAxNTk1LjQyIDIyNC42MyAxNjA2LjE1IDIyNS4xOCAxNjE3LjUyQzIyNi4wNCAxNjM1LjE1IDIyNy4yNSAxNjUyLjc4IDIyOC42OSAxNjcwLjM3QzIzMC4zIDE2ODkuOTYgMjI3LjgyIDE3MDguNjcgMjE3LjYxIDE3MjUuNzZDMjAyLjc2IDE3NTAuNjEgMTgwLjg1IDE3NjQuMjkgMTUxLjkzIDE3NjUuNDlDMTMzLjQxIDE3NjYuMjYgMTE2LjU4IDE3NjAuMzcgMTAxLjg0IDE3NDkuMDNDODIuNTY5OSAxNzM0LjIgNzEuNTE5OSAxNzE0LjQgNjguMjc5OSAxNjkwLjRDNjcuMTQ5OSAxNjgyLjAyIDY3LjQyOTkgMTY3My40NCA2Ny4yMzk5IDE2NjQuOTRDNjcuMDg5OSAxNjU4LjYxIDY2LjkzOTkgMTY1Mi4yNyA2Ni45Mzk5IDE2NDUuOTRaTTc0LjA5OTkgMTY0My4yMkM3NC4wOTk5IDE2NTQuMzggNzQuNjY5OSAxNjY1LjU0IDc0LjgxOTkgMTY3Ni43Qzc0Ljg3OTkgMTY4MS41MiA3NS4wMjk5IDE2ODYuNCA3NS44NDk5IDE2OTEuMTRDNzkuOTc5OSAxNzE0Ljk5IDkxLjc4OTkgMTczMy45NyAxMTIuMjkgMTc0Ny4wN0MxNDQuMzIgMTc2Ny41NCAxODYuOCAxNzU5LjAxIDIwOC43NyAxNzI3LjkzQzIyMC44NyAxNzEwLjggMjI0LjcxIDE2OTEuNzEgMjIzLjEgMTY3MS4wOUMyMjEuNjcgMTY1Mi44MyAyMjAuMzMgMTYzNC41NiAyMTkuNDcgMTYxNi4yN0MyMTguMDggMTU4Ni41OCAxOTYuOTIgMTU2MC4wMSAxNjguMTcgMTU1Mi45M0MxNTcuMTcgMTU1MC4yMiAxNDUuODMgMTU0OS45OCAxMzQuNTUgMTU0OS42NEMxMjEuMTEgMTU0OS4yMyAxMDguOTIgMTU1My4wNSA5OC4yMjk5IDE1NjEuMTJDODIuNjY5OSAxNTcyLjg3IDc0LjYyOTkgMTU4OC43NCA3NC4xNDk5IDE2MDguMjVDNzMuODU5OSAxNjE5LjkgNzQuMDk5OSAxNjMxLjU3IDc0LjA5OTkgMTY0My4yM1YxNjQzLjIyWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTY4LjA0OTkgMTk0NC4zNkM2Ny43MTk5IDE5MzIuMiA2Ny4zODk5IDE5MjAuMDMgNjcuMjQ5OSAxOTA3Ljg3QzY2LjkwOTkgMTg3OC41OSA4Ni43Njk5IDE4NTAuNjkgMTE3Ljk4IDE4NDUuMTFDMTIzLjQ4IDE4NDQuMTMgMTI5LjI1IDE4NDMuOCAxMzQuODEgMTg0NC4yMkMxNDQuODggMTg0NC45NyAxNTUuMTQgMTg0NS40OSAxNjQuODggMTg0Ny45MUMxODkuNDMgMTg1NCAyMDYgMTg2OS45MyAyMTYuMjEgMTg5Mi44NUMyMTkuNzEgMTkwMC43IDIyMS4zMSAxOTA4Ljk4IDIyMiAxOTE3LjUxQzIyMy4wNCAxOTMwLjI5IDIyNC4yMyAxOTQzLjA2IDIyNS4yOCAxOTU1Ljg0QzIyNi4wMSAxOTY0LjYzIDIyNi45MiAxOTczLjQzIDIyNy4yMiAxOTgyLjI0QzIyNy44OSAyMDAyLjI2IDIyMi4zMyAyMDIwLjUyIDIxMC4wMSAyMDM2LjMxQzE5My4zMyAyMDU3LjY4IDE3MS4xNyAyMDY3Ljc2IDE0NC4yMSAyMDY1LjU1QzEyMy40OSAyMDYzLjg1IDEwNi4xNyAyMDU0LjM0IDkyLjI1OTkgMjAzOC45Qzc3LjA2OTkgMjAyMi4wMyA2OS40Nzk5IDIwMDIuMDMgNjguODU5OSAxOTc5LjM0QzY4LjUzOTkgMTk2Ny42OCA2OC4zMTk5IDE5NTYuMDIgNjguMDQ5OSAxOTQ0LjM2QzY3Ljk4OTkgMTk0NC4zNiA2OC4xMDk5IDE5NDQuMzYgNjguMDQ5OSAxOTQ0LjM2Wk0yMjEuODEgMTk4MS4xNEMyMjEuNTUgMTk3Ni42NSAyMjEuNDEgMTk3Mi4xNSAyMjEuMDIgMTk2Ny42OEMyMTkuNTUgMTk1MC42IDIxNy44MyAxOTMzLjU1IDIxNi41NCAxOTE2LjQ2QzIxNS45NyAxOTA4Ljg4IDIxNC40MyAxOTAxLjYyIDIxMS4zNyAxODk0LjczQzIwMS44OCAxODczLjM5IDE4Ni4zNSAxODU4LjkyIDE2My4zNiAxODUzLjUxQzE1Ny4xIDE4NTIuMDQgMTUwLjU4IDE4NTEuNjEgMTQ0LjE1IDE4NTEuMDJDMTM2LjkgMTg1MC4zNiAxMjkuNjYgMTg0OS41NyAxMjIuMzIgMTg1MC44QzkyLjEyOTkgMTg1NS44NyA3NC40Njk5IDE4ODEuNzYgNzQuNTk5OSAxOTA3LjAzQzc0LjY3OTkgMTkyMS42OCA3NS4xOTk5IDE5MzYuMzMgNzUuNTc5OSAxOTUwLjk4Qzc1Ljg0OTkgMTk2MS40NyA3NS44OTk5IDE5NzEuOTcgNzYuNTk5OSAxOTgyLjQzQzc4LjQ2OTkgMjAxMC41NSA5MC44NDk5IDIwMzIuOTUgMTE0Ljg4IDIwNDcuN0MxMzguMjcgMjA2Mi4wNiAxNjIuODYgMjA2Mi45MiAxODYuNTQgMjA0OC41NEMyMTEuNDYgMjAzMy40IDIyMS42OCAyMDA5Ljc1IDIyMS44IDE5ODEuMTRIMjIxLjgxWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTIyNS40NSAyMjgxLjQ3QzIyNS41IDIzMDYuOTcgMjE5LjI4IDIzMjUuOTEgMjA1LjI3IDIzNDEuODVDMTkxLjQ5IDIzNTcuNTIgMTc0LjA5IDIzNjUuOCAxNTMuMTMgMjM2NS45NEMxMjkuOTcgMjM2Ni4wOSAxMTAuOTcgMjM1Ni41NSA5NS40NCAyMzM5Ljg3QzgwLjI3IDIzMjMuNTcgNzIuMSAyMzAzLjk3IDcwLjk2IDIyODEuNzNDNjkuNjcgMjI1Ni42MiA2OC43MiAyMjMxLjQ4IDY4IDIyMDYuMzRDNjcuMTQgMjE3Ni40MiA4Ny40MiAyMTUwLjk0IDExNi41NiAyMTQ1LjZDMTIzLjE1IDIxNDQuMzkgMTMwLjEzIDIxNDQuOTUgMTM2LjkgMjE0NS4zMUMxNDMuMTggMjE0NS42NCAxNDkuNDYgMjE0Ni41MiAxNTUuNjYgMjE0Ny42QzE3Ny4zNyAyMTUxLjM4IDE5My42NyAyMTYzLjQyIDIwNS44MSAyMTgxLjQ3QzIxMy45OSAyMTkzLjYzIDIxNy44OCAyMjA3LjIzIDIxOS4xMyAyMjIxLjc3QzIyMC4wMyAyMjMyLjIxIDIyMS40NyAyMjQyLjYxIDIyMi41OCAyMjUzLjAzQzIyMy43NCAyMjYzLjk1IDIyNC43OSAyMjc0Ljg4IDIyNS40NSAyMjgxLjQ3Wk03Ni43MyAyMjQ0LjgyQzc2LjY3IDIyNDQuODIgNzYuNjIgMjI0NC44MiA3Ni41NiAyMjQ0LjgyQzc3LjIgMjI1Ny40NyA3Ny41OCAyMjcwLjEzIDc4LjU1IDIyODIuNzVDODAuNTIgMjMwOC4yMiA5MS41MiAyMzI5LjEgMTExLjkzIDIzNDQuNEMxMjkuNjkgMjM1Ny43MSAxNDkuNzMgMjM2Mi4yIDE3MS4yNyAyMzU1LjlDMTkyLjI2IDIzNDkuNzYgMjA2LjE3IDIzMzUuNDEgMjE0LjUzIDIzMTUuNDNDMjIwLjkgMjMwMC4yMSAyMjEuMTMgMjI4NC4zNiAyMTkuMTggMjI2OC4yNkMyMTcuMTYgMjI1MS41NiAyMTUuMTQgMjIzNC44NiAyMTMuNTggMjIxOC4xMkMyMTIgMjIwMS4xOSAyMDUuNDIgMjE4Ni42NCAxOTMuOTcgMjE3NC4zMUMxODMuNiAyMTYzLjE0IDE3MS4wOCAyMTU1LjcgMTU1Ljc2IDIxNTMuNjVDMTQ5LjY4IDIxNTIuODQgMTQzLjU2IDIxNTIuMzEgMTM3LjQ4IDIxNTEuNDVDMTI5LjY0IDIxNTAuMzQgMTIxLjkyIDIxNTAuNzIgMTE0LjMgMjE1Mi44NkM4OS4xMiAyMTU5LjkxIDc1LjAxIDIxODIuOTcgNzUuMTEgMjIwNS44N0M3NS4xNyAyMjE4Ljg1IDc2LjE2IDIyMzEuODQgNzYuNzMgMjI0NC44MloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xNTkgMTc3Ljk2SDE1Mi41N0MxNTEuNTggMTczLjc0IDE1MS4zOSAxMTAuMjQgMTUyLjM0IDEwNC4yNkgxNTguNTFDMTU5LjM4IDEwNy42OCAxNTkuODcgMTcxLjg5IDE1OSAxNzcuOTZaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTg0Ljg5IDIwMy44M0MxODUuMDYgMjA1LjcyIDE4NS4yMiAyMDcuNSAxODUuMzcgMjA5LjE2QzE3My42NiAyMTUuMTcgMTM1LjExIDIxMy40OCAxMTkuNzQgMjA2LjMxQzExOS44NCAyMDUuNDUgMTE5Ljg4IDIwNC40OSAxMjAuMDkgMjAzLjU2QzEyMC4zMSAyMDIuNiAxMjAuNyAyMDEuNjggMTIxLjE5IDIwMC4yMUMxMzEuNTQgMjAyLjk0IDE0MS45NCAyMDUuOTUgMTUyLjY1IDIwNS44OEMxNjMuMTkgMjA1LjgxIDE3My43MiAyMDQuNTkgMTg0Ljg3IDIwMy44M0gxODQuODlaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTI0LjI1IDExNy4xNEMxMjQuMyAxMjEuMDYgMTIwLjk1IDEyNC41NiAxMTcuMDYgMTI0LjYzQzExMy4xNCAxMjQuNyAxMDkuNzUgMTIxLjM3IDEwOS43IDExNy4zN0MxMDkuNjUgMTEzLjI0IDExMi43MiAxMTAuMDcgMTE2LjgzIDExMC4wMkMxMjAuOTIgMTA5Ljk3IDEyNC4yIDExMy4xMiAxMjQuMjUgMTE3LjE0WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTIwNC4zNCAxMTUuMzZDMjA0LjQyIDExOS41NSAyMDEuNDUgMTIyLjc1IDE5Ny4zOSAxMjIuODVDMTkzLjQyIDEyMi45NCAxODkuOTggMTE5LjcyIDE4OS44MyAxMTUuNzdDMTg5LjY4IDExMS45OCAxOTMuMTIgMTA4LjM3IDE5Ni45OSAxMDguMjVDMjAxIDEwOC4xMiAyMDQuMjcgMTExLjI5IDIwNC4zNSAxMTUuMzdMMjA0LjM0IDExNS4zNloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xNTMuNTQgNDAzLjU0SDE2MC4zOEMxNjEuMSA0MjcuOTUgMTYxLjgxIDQ1Mi4xMiAxNjIuNTQgNDc2Ljg3QzE1OS41MiA0NzcuMTMgMTU3LjAzIDQ3Ny4zNCAxNTQuMjEgNDc3LjU3QzE1NS4zMSA0NTIuNjYgMTUzLjAxIDQyOC4zOSAxNTMuNTQgNDAzLjUzVjQwMy41NFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xODQuNzYgNTAzLjFDMTg1LjA3IDUwNC4yIDE4NS4yNSA1MDQuNjYgMTg1LjMyIDUwNS4xNEMxODUuNSA1MDYuNDUgMTg1LjY0IDUwNy43NyAxODUuODUgNTA5LjUxQzE2My41OSA1MTQuNDMgMTQxLjcxIDUxNC4yNyAxMTkuNzQgNTA2LjczQzEyMC4yNCA1MDQuNjQgMTIwLjY5IDUwMi43NyAxMjEuMjIgNTAwLjU0QzEyOC4zMiA1MDIuMDEgMTM1LjE1IDUwMy44OSAxNDIuMTIgNTA0Ljc1QzE0OS4xNSA1MDUuNjIgMTU2LjMyIDUwNS45NyAxNjMuMzkgNTA1LjY4QzE3MC40NSA1MDUuMzkgMTc3LjQ3IDUwNC4wMyAxODQuNzggNTAzLjFIMTg0Ljc2WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTEyNS4xMSA0MTYuODVDMTI1LjExIDQyMC44MSAxMjEuNzUgNDI0LjAzIDExNy42NyA0MjMuOTlDMTEzLjQ2IDQyMy45NSAxMTAuNDYgNDIwLjkxIDExMC41IDQxNi43QzExMC41MyA0MTIuNjMgMTEzLjgyIDQwOS4zNCAxMTcuOCA0MDkuNEMxMjEuNjQgNDA5LjQ2IDEyNS4xMiA0MTMgMTI1LjEyIDQxNi44NUgxMjUuMTFaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjA0Ljc1IDQxNS41QzIwNC43NiA0MTkuNTIgMjAxLjQ0IDQyMi44MyAxOTcuNDYgNDIyLjc1QzE5My41MyA0MjIuNjggMTkwLjM0IDQxOS4yNiAxOTAuNDQgNDE1LjIzQzE5MC41NCA0MTEuMzcgMTkzLjY0IDQwOC4yNyAxOTcuNDEgNDA4LjI0QzIwMS4zNyA0MDguMjEgMjA0LjczIDQxMS41NCAyMDQuNzQgNDE1LjVIMjA0Ljc1WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTE1NC43NCA3MDMuMjhIMTYxLjA3QzE2Mi44NiA3MDkuMTMgMTY2LjA1IDc3MC4zIDE2NC44IDc3NS42OUMxNjIuMDQgNzc1Ljk2IDE1OS4yIDc3Ni42MyAxNTUuODQgNzc1LjIyQzE1Ni42MyA3NzQuMTQgMTU3LjI0IDc3My4zMSAxNTguMjQgNzcxLjk1QzE1Ny4xIDc0OS41OSAxNTUuOTMgNzI2LjcxIDE1NC43MyA3MDMuMjhIMTU0Ljc0WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTE4NS41NiA4MDMuM0MxODUuODIgODA1LjIxIDE4Ni4wOCA4MDcuMTEgMTg2LjM2IDgwOS4xOEMxNjQuMTYgODE0LjM3IDE0Mi40NiA4MTQuMjkgMTIwLjQ5IDgwNi45N0MxMjAuOTMgODA0Ljg5IDEyMS4zNSA4MDIuODYgMTIxLjcxIDgwMS4xNUMxMzIuNTYgODAyLjc4IDE0Mi45NyA4MDUuMjkgMTUzLjQ1IDgwNS42NUMxNjMuOTUgODA2IDE3NC41MiA4MDQuMiAxODUuNTYgODAzLjNaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTExLjQ1IDcxNi4xOUMxMTEuNDUgNzEyLjAzIDExNC40NyA3MDkuMDMgMTE4LjYyIDcwOS4wNEMxMjIuNjggNzA5LjA1IDEyNS44NiA3MTIuMTEgMTI1Ljk5IDcxNi4xNEMxMjYuMTIgNzIwLjMgMTIyLjY2IDcyMy43NiAxMTguNSA3MjMuNjJDMTE0LjUyIDcyMy40OSAxMTEuNDYgNzIwLjI1IDExMS40NiA3MTYuMThMMTExLjQ1IDcxNi4xOVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yMDQuNzUgNzE1LjM3QzIwNC44NiA3MTkuMTIgMjAxLjc5IDcyMi40OCAxOTguMSA3MjIuNjRDMTk0LjM4IDcyMi44IDE5MC44MiA3MTkuMzggMTkwLjY2IDcxNS40OUMxOTAuNTEgNzExLjc2IDE5My42MiA3MDguMzkgMTk3LjMyIDcwOC4yN0MyMDEuMjEgNzA4LjE0IDIwNC42MyA3MTEuNDIgMjA0Ljc0IDcxNS4zN0gyMDQuNzVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTY4LjA2IDEwNzQuNDFDMTY0Ljk0IDEwNzQuODYgMTYxLjc0IDEwNzUuNTQgMTU3LjggMTA3My44NEMxNTkuMjIgMTA3My4xNSAxNjAuMSAxMDcyLjcyIDE2MS40OSAxMDcyLjA0QzE2MS40OSAxMDY5LjAyIDE2MS43NCAxMDY1LjcxIDE2MS40NSAxMDYyLjQ2QzE2MC4wMiAxMDQ2LjIyIDE1OC40MyAxMDMwIDE1Ni45NSAxMDEzLjc2QzE1Ni42MiAxMDEwLjE3IDE1Ni41MyAxMDA2LjU2IDE1Ni4zMSAxMDAyLjcxSDE2Mi40OUMxNjUuNzggMTAxNi4xNiAxNjkuOTIgMTA2OS4xMyAxNjguMDYgMTA3NC40MVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMjEuNDEgMTEwNy4wOEMxMjEuOTIgMTEwNC45MSAxMjIuMzkgMTEwMi44OCAxMjMuMDIgMTEwMC4xOEMxNDMuODggMTEwNy4wOCAxNjQuNzEgMTEwNi44NiAxODUuNjggMTEwMi4xMUMxODYuMDIgMTEwMy4zIDE4Ni4yNCAxMTAzLjkxIDE4Ni4zNiAxMTA0LjU0QzE4Ni41OSAxMTA1LjgzIDE4Ni43NyAxMTA3LjEzIDE4Ny4wMiAxMTA4LjczQzE2NSAxMTE0LjExIDE0My4zNSAxMTE0LjM3IDEyMS40MSAxMTA3LjA3VjExMDcuMDhaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTI3LjA5IDEwMTUuOTZDMTI3LjA5IDEwMTkuOTcgMTIzLjc3IDEwMjMuMSAxMTkuNjEgMTAyMy4wMUMxMTUuNDcgMTAyMi45MiAxMTIuNDYgMTAxOS44MSAxMTIuNDcgMTAxNS42MkMxMTIuNDcgMTAxMS42NCAxMTUuMzggMTAwOC42IDExOS4zIDEwMDguNDZDMTIzLjM3IDEwMDguMzEgMTI3LjEgMTAxMS45IDEyNy4xIDEwMTUuOTZIMTI3LjA5WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTIwNC4zIDEwMTUuODZDMjA0LjIxIDEwMTkuNjUgMjAxLjM1IDEwMjIuNTQgMTk3Ljc1IDEwMjIuNDhDMTkzLjk4IDEwMjIuNDIgMTkwLjYxIDEwMTguNzggMTkwLjczIDEwMTQuOTFDMTkwLjg0IDEwMTEuMzEgMTkzLjk2IDEwMDguMjYgMTk3LjQ1IDEwMDguMzNDMjAxLjM1IDEwMDguNCAyMDQuNDEgMTAxMS43NyAyMDQuMzEgMTAxNS44N0wyMDQuMyAxMDE1Ljg2WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTE1Ny40NSAxMzAyLjM1SDE2My45NUMxNjUuMDQgMTMwOS45IDE2Ni4xMSAxMzE3LjI3IDE2Ny4xNiAxMzI0LjY0QzE2OC43NiAxMzM1Ljg0IDE3MC40IDEzNDcuMDMgMTcxLjkxIDEzNTguMjRDMTcyLjU1IDEzNjMgMTczLjAyIDEzNjcuNzkgMTcxLjk1IDEzNzIuNjZDMTY4LjI3IDEzNzQuMDcgMTY0LjgzIDEzNzQuMjIgMTYwLjI3IDEzNzIuOEMxNjIuMzQgMTM3Mi4yIDE2My40NiAxMzcxLjg3IDE2NS4xNiAxMzcxLjM4QzE2NS4xNiAxMzY4LjYyIDE2NS40NiAxMzY1LjgxIDE2NS4xMSAxMzYzLjA5QzE2Mi44MyAxMzQ1LjExIDE2MC40MSAxMzI3LjE0IDE1OC4wNiAxMzA5LjE2QzE1Ny43OCAxMzA3LjA1IDE1Ny42OCAxMzA0LjkyIDE1Ny40NSAxMzAyLjM2VjEzMDIuMzVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTIyLjU0IDE0MDcuMDNDMTIzLjEzIDE0MDQuODcgMTIzLjYzIDE0MDMgMTI0LjI2IDE0MDAuN0MxMzQuNzggMTQwMi43NyAxNDQuODggMTQwNS44NiAxNTUuMzQgMTQwNS4zQzE2NS43IDE0MDQuNzQgMTc2LjAyIDE0MDMuNTEgMTg2Ljg0IDE0MDIuNTNDMTg3LjAyIDE0MDQuMzQgMTg3LjIxIDE0MDYuMjQgMTg3LjQgMTQwOC4wOUMxNjcuNDcgMTQxMy42NCAxNDYuMTggMTQxNC43MiAxMjIuNTQgMTQwNy4wNFYxNDA3LjAzWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTEyOC4wOCAxMzE1LjUzQzEyOC4xNCAxMzE5LjI3IDEyNC45OSAxMzIyLjU1IDEyMS4xOSAxMzIyLjY4QzExNy4xMyAxMzIyLjgzIDExMy42IDEzMTkuMzQgMTEzLjU1IDEzMTUuMTVDMTEzLjUgMTMxMS4xMSAxMTYuMyAxMzA4LjE4IDEyMC4yOSAxMzA4LjFDMTI0LjQ2IDEzMDguMDEgMTI4LjAxIDEzMTEuMzkgMTI4LjA4IDEzMTUuNTNaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjAzLjk4IDEzMTUuNzRDMjAyLjM0IDEzMjEuMDEgMjAwLjM1IDEzMjIuNjUgMTk2LjQ5IDEzMjIuMDlDMTkzLjEzIDEzMjEuNiAxOTAuNjcgMTMxOC43NSAxOTAuNTUgMTMxNS4yMUMxOTAuNDQgMTMxMS44OCAxOTIuNzUgMTMwOC45OCAxOTUuOSAxMzA4LjQ5QzE5OS42MyAxMzA3LjkxIDIwMi4yNSAxMzEwLjIxIDIwMy45OCAxMzE1Ljc0WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTE3NC4zNyAxNjcxLjg5SDE2My44QzE2My43NyAxNjcxLjcxIDE2My43MyAxNjcxLjUyIDE2My43IDE2NzEuMzRDMTY0LjM0IDE2NzEuMjcgMTY0Ljk5IDE2NzEuMjIgMTY1LjYyIDE2NzEuMTFDMTY2LjQxIDE2NzAuOTggMTY3LjE5IDE2NzAuODEgMTY4LjE5IDE2NzAuNjFDMTY5LjM1IDE2NjYuNTUgMTY4Ljk4IDE2NjIuNTYgMTY4LjMgMTY1OC42OEMxNjUuMjQgMTY0MS4xOCAxNjIgMTYyMy43MSAxNTguODYgMTYwNi4yMkMxNTguNjMgMTYwNC45MyAxNTguNjMgMTYwMy42MSAxNTguNDcgMTYwMS42OUMxNjAuNiAxNjAxLjggMTYyLjQ5IDE2MDEuOSAxNjQuNjggMTYwMi4wMUMxNjUuODEgMTYwNy43NSAxNjYuOTQgMTYxMy4yNSAxNjcuOTcgMTYxOC43NkMxNzAuNTcgMTYzMi42NCAxNzMuMTggMTY0Ni41MSAxNzUuNjcgMTY2MC40MUMxNzYuMzQgMTY2NC4xMyAxNzcuMDQgMTY2Ny45NyAxNzQuMzcgMTY3MS44OVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMjUuOTQgMTcwMS40QzEzNi4zNiAxNzAyLjY5IDE0Ni40NyAxNzA0LjgyIDE1Ni42MSAxNzA0LjkzQzE2Ni42MSAxNzA1LjA1IDE3Ni42NCAxNzAzLjEzIDE4Ny4xOCAxNzAyLjA1QzE4Ny40OCAxNzAzLjU3IDE4Ny44OSAxNzA1LjU5IDE4OC4zNCAxNzA3Ljg0QzE2Ny4wMiAxNzEzLjQ1IDE0Ni4xOCAxNzEzLjkzIDEyNS4xMSAxNzA3LjQ3QzEyNC4xMSAxNzA1LjIgMTI1LjA5IDE3MDMuMTkgMTI1Ljk0IDE3MDEuMzlWMTcwMS40WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTEyOS4yMiAxNjE1LjQyQzEyOC41IDE2MjEgMTI0Ljk2IDE2MjIuNzIgMTIwLjY0IDE2MjEuODdDMTE3LjA5IDE2MjEuMTggMTE0LjY0IDE2MTguMDYgMTE0LjcxIDE2MTQuMzJDMTE0Ljc3IDE2MTAuODYgMTE2Ljk1IDE2MDguMjkgMTIwLjMyIDE2MDcuNzNDMTI0LjU0IDE2MDcuMDIgMTI5LjUgMTYwOS41IDEyOS4yMyAxNjE1LjQzTDEyOS4yMiAxNjE1LjQyWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTIwMi44NCAxNjE2LjE0QzIwMi43NCAxNjE5LjY0IDIwMC4yMiAxNjIyLjEyIDE5Ni44MyAxNjIyLjA4QzE5Mi45IDE2MjIuMDMgMTg5Ljg4IDE2MTguNTYgMTkwLjEyIDE2MTQuMzlDMTkwLjMzIDE2MTAuODYgMTkyLjk0IDE2MDguNDIgMTk2LjI4IDE2MDguNjVDMTk5Ljg5IDE2MDguOSAyMDIuOTUgMTYxMi40IDIwMi44NCAxNjE2LjE0WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTE1OC45MSAxOTAxLjQzSDE2NC43M0MxNjUuMjEgMTkwMi42NSAxNjUuODQgMTkwMy44MSAxNjYuMTQgMTkwNS4wNUMxNzAuMzQgMTkyMi42OSAxNzQuNTUgMTk0MC4zMiAxNzguNjMgMTk1Ny45OUMxNzkuNTYgMTk2Mi4wMSAxODAuMzEgMTk2Ni4xNiAxNzcuODYgMTk3MC4wMkMxNzQuMTYgMTk3MS40MyAxNzAuNTIgMTk3MC44MSAxNjYuODggMTk3MC40M0MxNjguMjEgMTk3MC4yOCAxNjkuNTUgMTk3MC4xMyAxNzAuOSAxOTY5Ljk3QzE3MS4yMyAxOTY5LjU0IDE3MS43NiAxOTY5LjE2IDE3MS43OCAxOTY4Ljc2QzE3MS45IDE5NjUuNDggMTcyLjUgMTk2Mi4wOCAxNzEuODcgMTk1OC45M0MxNjkuNTcgMTk0Ny41MiAxNjYuODUgMTkzNi4xOSAxNjQuMjcgMTkyNC44NEMxNjIuNTQgMTkxNy4yMyAxNjAuNzkgMTkwOS42MiAxNTguOTIgMTkwMS40M0gxNTguOTFaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTg3LjgzIDIwMDEuNDRDMTg4LjI0IDIwMDMuMzcgMTg4LjY0IDIwMDUuMjcgMTg5LjA2IDIwMDcuMjRDMTY4LjI1IDIwMTMuMjcgMTQ3LjcyIDIwMTMuNjkgMTI2LjU5IDIwMDcuMjhDMTI2Ljk3IDIwMDUuMDggMTI3LjM0IDIwMDIuOTIgMTI3LjYzIDIwMDEuMjRDMTM4LjE4IDIwMDIuNTMgMTQ4LjE3IDIwMDQuNjggMTU4LjE2IDIwMDQuNzJDMTY3Ljk2IDIwMDQuNzYgMTc3Ljc4IDIwMDIuNjQgMTg3LjgzIDIwMDEuNDVWMjAwMS40NFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMjIuNDkgMTkwNy4yQzEyNi4zOSAxOTA3LjI4IDEyOS45NyAxOTEwLjk3IDEzMCAxOTE0Ljk2QzEzMC4wMyAxOTE4LjcxIDEyNy4yMiAxOTIxLjY2IDEyMy41NyAxOTIxLjcxQzExOS4zOSAxOTIxLjc2IDExNS43IDE5MTcuOTYgMTE1LjgyIDE5MTMuNzJDMTE1LjkyIDE5MTAuMDIgMTE4Ljg4IDE5MDcuMTMgMTIyLjQ5IDE5MDcuMloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xOTQuNjggMTkwOC44OEMxOTguMzkgMTkwOC44OSAyMDEuMzEgMTkxMS45OSAyMDEuMzggMTkxNS45OUMyMDEuNDUgMTkxOS43OCAxOTkuMjYgMTkyMi4xNCAxOTUuOCAxOTIyLjAxQzE5Mi4xMSAxOTIxLjg3IDE4OS4zNCAxOTE4LjY5IDE4OS4zNyAxOTE0LjY1QzE4OS40IDE5MTEuMDQgMTkxLjQgMTkwOC44NyAxOTQuNjggMTkwOC44OFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xODEuNDcgMjI2OC4wMUMxNzcuNDUgMjI3MC41NyAxNzMuNTQgMjI2OS4yNCAxNjkuODEgMjI2OS40MUMxNzEuMjQgMjI2OS4zMyAxNzIuNjcgMjI2OS4yNiAxNzQuMTUgMjI2OS4xN0MxNzYuODEgMjI2NC43OCAxNzYuMDUgMjI2MC4zMyAxNzQuOTIgMjI1Ni4wMUMxNzIuNzkgMjI0Ny44MSAxNzAuMzkgMjIzOS42OSAxNjguMDggMjIzMS41NEMxNjUuMjggMjIyMS42NSAxNjIuNDYgMjIxMS43NiAxNTkuNTQgMjIwMS40OEgxNjUuNDlDMTY2Ljk1IDIyMDYuMjkgMTY4LjQ2IDIyMTEuMTcgMTY5LjkxIDIyMTYuMDdDMTczLjYzIDIyMjguNjUgMTc3LjQgMjI0MS4yMSAxODAuOTcgMjI1My44NEMxODEuODIgMjI1Ni44NCAxODIuMTYgMjI2MC4wMyAxODIuMzUgMjI2My4xNkMxODIuNDUgMjI2NC44NyAxODEuNzMgMjI2Ni42MiAxODEuNDUgMjI2OC4wMkwxODEuNDcgMjI2OC4wMVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMjguNjggMjMwNy4wNkMxMjkuMTEgMjMwNC45MSAxMjkuNTMgMjMwMi44NSAxMzAuMDYgMjMwMC4yNkMxMzkuNzQgMjMwMi40OCAxNDkuMjIgMjMwNC40MSAxNTkuMDEgMjMwNC40OUMxNjguODYgMjMwNC41NyAxNzguMjggMjMwMi4wMyAxODguNCAyMzAwLjM3QzE4OC44IDIzMDIuNSAxODkuMTUgMjMwNC4zNiAxODkuNTYgMjMwNi41NEMxNjkuMjMgMjMxMy4wOSAxNDkuMiAyMzEzLjM5IDEyOC42OCAyMzA3LjA2WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTEzMS4wMSAyMjE0LjczQzEzMS4wOSAyMjE4LjM0IDEyOC40NSAyMjIxLjEgMTI0Ljg1IDIyMjEuMTZDMTIwLjg0IDIyMjEuMjIgMTE3LjIxIDIyMTcuNzcgMTE2Ljk4IDIyMTMuNjhDMTE2Ljc4IDIyMTAuMTIgMTE5LjM2IDIyMDcuMjEgMTIyLjg4IDIyMDcuMDJDMTI3LjA4IDIyMDYuOCAxMzAuOTEgMjIxMC40MyAxMzEuMDEgMjIxNC43M1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xOTQuNjMgMjIyMS45N0MxOTIuMTYgMjIyMS45MiAxOTAuMjYgMjIyMC40OSAxODkuMSAyMjE4LjFDMTg3Ljk3IDIyMTUuNzcgMTg3Ljg2IDIyMTMuMzYgMTg5LjIyIDIyMTEuMDJDMTg5LjMgMjIxMC44OCAxODkuNDEgMjIxMC43NSAxODkuNTIgMjIxMC42M0MxOTAuOTUgMjIwOC45MyAxOTMuNTkgMjIwOC40OSAxOTUuODIgMjIwOS41OEMxOTguNjMgMjIxMC45NSAyMDAuNTcgMjIxNC45OSAxOTkuODIgMjIxNy45QzE5OS4xNyAyMjIwLjQ0IDE5Ny4zNyAyMjIxLjkzIDE5NC42MyAyMjIxLjk2VjIyMjEuOTdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K", rR = "data:image/svg+xml;base64,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", nR = "data:image/svg+xml;base64,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", iR = "data:image/svg+xml;base64,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", MR = "data:image/svg+xml;base64,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", Gn = [eR, tR, rR, nR, iR, MR], on = {
  TARGET_0_DEG: Gn[0],
  TARGET_45_DEG: Gn[1],
  TARGET_90_DEG: Gn[2],
  TARGET_135_DEG: Gn[3],
  TARGET_180_DEG: Gn[4],
  STATIC_FACE: Gn[0],
  OCCLUSION_HINT: Gn[5]
}, Ax = f.memo((e) => {
  let {
    targetSector: t,
    roundRadiusY: r,
    setCameraBlur: n,
    isSectorMode: i,
    message: M,
    facePosition: o,
    centerX: u,
    centerY: s
  } = e;
  const l = M === Le.TurnHead, I = M === Le.RemoveOcclusion, [g, c] = f.useState(on.TARGET_0_DEG), [D, j] = f.useState(1), N = f.useRef(void 0), [d, T] = f.useState(!1), [y, A] = f.useState(!1), [x, E] = f.useState(null);
  return f.useEffect(() => {
    q8.includes(M) && (y && !i || M === Le.FitFaceIntoOval && o.x === 0 || (N.current && clearTimeout(N.current), E(M), n(!0), T(e6.includes(M)), A(!0), N.current = setTimeout(() => {
      n(!1), A(!1);
    }, I ? K8 : X8), i && (n(!1), A(!1), clearTimeout(N.current))));
  }, [M, i, o.x]), f.useEffect(() => () => {
    clearTimeout(N.current);
  }, []), f.useEffect(() => {
    n(l);
  }, [l]), f.useEffect(() => {
    if (y) return;
    if (d && c(on.STATIC_FACE), I) {
      c(on.OCCLUSION_HINT), j(1);
      return;
    }
    t === 2 && c(on.TARGET_0_DEG), (t === 1 || t === 3) && c(on.TARGET_45_DEG), (t === 0 || t === 4) && c(on.TARGET_90_DEG), (t === 5 || t === 7) && c(on.TARGET_135_DEG), t === 6 && c(on.TARGET_180_DEG);
    const C = typeof t == "number" && J8.includes(t) && M !== Le.FitFaceIntoOval;
    j(C ? -1 : 1);
  }, [t, y, M]), /* @__PURE__ */ a.jsx("div", { className: ue["face-hint-container"], style: {
    opacity: l || y ? 1 : 0,
    transform: "scale(".concat(D, ",1)")
  }, children: /* @__PURE__ */ a.jsxs("div", { className: ue["face-hint-round"], style: {
    width: r * 2,
    height: r * 2,
    borderRadius: "".concat(r, "px")
  }, children: [
    l ? (
      // control from WASM
      /* @__PURE__ */ a.jsx("div", { className: ue["face-hint-target"], style: {
        width: r * 2 + "px",
        height: r * 2 + "px",
        backgroundImage: "url('".concat(g, "')")
      } })
    ) : null,
    y ? (
      // control from state & timeout (move closer, center face, etc)
      /* @__PURE__ */ a.jsx("div", { className: "".concat(ue["face-hint"], " ").concat(ue["face-hint-animation-" + x]), style: {
        position: "absolute",
        "--from-left": "".concat(o.x + o.width / 2 - u, "px"),
        "--from-top": "".concat(o.y + o.height / 2 - s, "px"),
        width: r * 2 + "px",
        height: r * 2 + "px",
        backgroundImage: "url('".concat(g, "')"),
        backgroundRepeat: "no-repeat",
        backgroundPosition: "0 0%",
        backgroundSize: "100%"
      } })
    ) : null
  ] }) });
});
Ax.displayName = "FaceHintAnimation";
function aR(e) {
  let {
    children: t
  } = e;
  return /* @__PURE__ */ a.jsx(a.Fragment, { children: t && /* @__PURE__ */ a.jsx("div", { className: ue["message-container"], children: /* @__PURE__ */ a.jsx("span", { "data-e2e": "message-text", children: t }) }) });
}
const oR = f.memo(aR), uR = {
  [_.PREPARING]: "preparingCamera",
  [_.READY]: "preparingCamera",
  [_.REQUESTING]: "allowAccessCamera",
  [_.UNKNOWN_ERROR]: "somethingWentWrong",
  [_.INCORRECT_CAMERA_ID]: "incorrectCameraId"
}, sR = {
  [Le.LookStraight]: "lookStraight",
  [Le.FitFaceIntoOval]: "fitYourFace",
  [Le.MoveCloser]: "moveCloser",
  [Le.MoveAway]: "moveAway",
  [Le.HoldStill]: "holdSteady",
  [Le.ShowOnlyOneFace]: "showOnlyOneFace",
  [Le.TurnHead]: "turnHead",
  [Le.GiveMoreLight]: "",
  // not used in web component
  [Le.RemoveOcclusion]: "removeOcclusion",
  [Le.Empty]: ""
}, lR = (e, t, r) => e.videoStatus === _.PLAY ? t ? sR[r] : "preparingService" : uR[e.videoStatus] || "", cR = (e) => {
  let {
    isMobile: t,
    faceSnapshot: r,
    livenessType: n,
    videoStatusParams: i,
    showChangeCameraButton: M
  } = e;
  const o = t && !r && n === _s.ACTIVE;
  return !M || o ? !1 : !!(i.sortedDevices && i.sortedDevices.frontCameras.length + i.sortedDevices.backCameras.length > u6);
};
function IR(e) {
  let {
    children: t,
    captureFrame: r,
    videoStatusParams: n,
    message: i,
    prepared: M,
    onChangeCamera: o,
    readiness: u,
    numSectors: s,
    currSector: l,
    targetSector: I,
    step: g,
    showChangeCameraButton: c,
    facePosition: D,
    faceSnapshot: j
  } = e;
  const {
    abortProcess: N
  } = Q((k) => ({
    abortProcess: k.abortProcess
  })), {
    rotationAngle: d
  } = Q((k) => ({
    rotationAngle: k.rotationAngle
  })), {
    livenessType: T
  } = Q((k) => ({
    livenessType: k.livenessType
  })), {
    translate: y
  } = Ii.useLocalize(), A = f.useRef(null), x = i === Le.HoldStill, E = g > 0 && typeof I == "number", C = M && n.videoStatus === _.PLAY, p = y(lR(n, M, i)), O = {
    transition: "".concat(F8, "ms")
  }, w = cR({
    isMobile: Vr,
    faceSnapshot: j,
    livenessType: T,
    videoStatusParams: n,
    showChangeCameraButton: c
  }), [z, R] = f.useState({
    viewBoxWidth: 0,
    viewBoxHeight: 0,
    maskCX: 0,
    maskCY: 0,
    maskRX: 0,
    maskRY: 0,
    frameRX: 0,
    frameRY: 0,
    frameClipWidth: 0,
    frameClipX: 0,
    frameClipY: 0,
    steadyStrokeWidth: 0,
    strokeWidth: 0
  });
  f.useEffect(() => {
    const k = A.current;
    if (k) {
      const {
        width: W,
        height: J
      } = k.getBoundingClientRect(), Ge = W, ve = J, Be = r.left, he = r.top, It = r.width, ft = r.height, Wt = It + ja, qr = ft + ja, $n = Math.round(Wt * 2 / 2 * (1 - u)), en = Math.round(Be - $n / 2), ji = Math.round(he - $n / 2), gr = ja, zM = Math.round(gr * 1.5);
      R({
        viewBoxWidth: Ge,
        viewBoxHeight: ve,
        maskCX: Be,
        maskCY: he,
        maskRX: It,
        maskRY: ft,
        frameRX: Wt,
        frameRY: qr,
        frameClipWidth: $n,
        frameClipX: en,
        frameClipY: ji,
        steadyStrokeWidth: zM,
        strokeWidth: gr
      });
    }
  }, [r, u]);
  const K = () => E || C && !E ? "url(#bgClip)" : "", P = () => E || x ? "" : "url(#ovalClip)", H = () => g === 1 ? "".concat(ue.backgroundSvg, " ").concat(ue.firstStepAnimation) : ue.backgroundSvg, Se = () => E ? 1 : x ? z.steadyStrokeWidth : z.strokeWidth, [fe, De] = f.useState(!1), S = f.useCallback((k) => {
    De(k);
  }, []), U = f.useMemo(() => {
    if (!d || d === 0 || !eo) return "";
    if (d === 180) return ue["videoContainerRotation-180"];
    const k = ue.videoContainerRotation, W = d === 90 ? ue["videoContainerRotation-90"] : ue["videoContainerRotation-90-rev"];
    return "".concat(k, " ").concat(W);
  }, [d]);
  return /* @__PURE__ */ a.jsxs("div", { ref: A, className: "".concat(ue.container, " ").concat(ue.translateY), style: {
    opacity: N ? 0 : 1
  }, children: [
    /* @__PURE__ */ a.jsx("div", { className: "".concat(ue.videoContainer, " ").concat(U), children: /* @__PURE__ */ a.jsx("div", { className: ue.videoContainerBlur, style: {
      filter: "blur(".concat(fe ? "20px" : 0, ")")
    }, children: t }) }),
    /* @__PURE__ */ a.jsxs("svg", { className: H(), xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "xMidYMid slice", viewBox: "0 0 ".concat(z.viewBoxWidth, " ").concat(z.viewBoxHeight), children: [
      /* @__PURE__ */ a.jsxs("defs", { children: [
        /* @__PURE__ */ a.jsxs("mask", { id: "bgClip", children: [
          /* @__PURE__ */ a.jsx("rect", { x: "0", y: "0", width: z.viewBoxWidth, height: z.viewBoxHeight, fill: "#fff" }),
          /* @__PURE__ */ a.jsx("ellipse", { cx: z.maskCX, cy: z.maskCY, rx: z.maskRX, ry: z.maskRY })
        ] }),
        E && /* @__PURE__ */ a.jsxs("mask", { id: "readinessMask", x: "0", y: "0", children: [
          /* @__PURE__ */ a.jsx(
            "circle",
            {
              fill: "white",
              r: (z.frameRX + z.frameRX / 6) * u,
              cx: z.maskCX,
              cy: z.maskCY
            }
          ),
          /* @__PURE__ */ a.jsx("ellipse", { cx: z.maskCX, cy: z.maskCY, rx: z.maskRX, ry: z.maskRY })
        ] }),
        /* @__PURE__ */ a.jsxs("mask", { id: "ovalClip", children: [
          /* @__PURE__ */ a.jsx("rect", { x: "0", y: "0", width: z.viewBoxWidth, height: z.viewBoxHeight, fill: "#fff" }),
          /* @__PURE__ */ a.jsx("rect", { style: O, x: z.frameClipX, y: "0", width: Math.max(z.frameClipWidth, 0), height: z.viewBoxHeight }),
          /* @__PURE__ */ a.jsx("rect", { style: O, x: "0", y: z.frameClipY, width: z.viewBoxWidth, height: Math.max(z.frameClipWidth, 0) })
        ] })
      ] }),
      /* @__PURE__ */ a.jsx("rect", { mask: K(), x: "0", y: "0", width: z.viewBoxWidth, height: z.viewBoxHeight, fill: "white" }),
      E && typeof I == "number" && /* @__PURE__ */ a.jsx(Tx, { numSectors: s, targetSector: I, currSector: l, centerX: z.viewBoxWidth / 2, centerY: z.viewBoxHeight / 2, sectorRadius: z.frameRX }),
      /* @__PURE__ */ a.jsx("ellipse", { mask: P(), className: "".concat(x ? ue.done : "", " ").concat(M ? "" : ue.hide), cx: z.maskCX, cy: z.maskCY, rx: E ? z.maskRX : z.frameRX, ry: E ? z.maskRX : z.frameRY, fill: "none", stroke: C ? "var(--camera-screen-stroke-normal)" : "", strokeWidth: Se() })
    ] }),
    /* @__PURE__ */ a.jsx(Ax, { roundRadiusY: z.maskRY, targetSector: E ? I : l, setCameraBlur: S, isSectorMode: E, message: i, facePosition: D, centerX: z.viewBoxWidth / 2, centerY: z.viewBoxHeight / 2 }),
    /* @__PURE__ */ a.jsx("div", { className: "".concat(ue.secondaryMessage, " ").concat(M ? "" : ue.centreMessage), children: /* @__PURE__ */ a.jsx(oR, { children: p }) }),
    w && /* @__PURE__ */ a.jsx("div", { className: ue.functionalButtons, children: /* @__PURE__ */ a.jsx("button", { disabled: n.videoStatus !== _.PLAY, onClick: o, children: /* @__PURE__ */ a.jsx(Ju, { size: 30, type: "camera-change" }) }) })
  ] });
}
const gR = f.memo(IR), jR = "_container_ctl1v_1", NR = "_translateY_ctl1v_24", Fo = {
  container: jR,
  "debug-canvas": "_debug-canvas_ctl1v_14",
  "mirror-x": "_mirror-x_ctl1v_20",
  translateY: NR
};
var DR = q5;
DR("Uint8", function(e) {
  return function(r, n, i) {
    return e(this, r, n, i);
  };
});
function ZM(e, t, r) {
  return (t = yR(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function yR(e) {
  var t = TR(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function TR(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const $c = Bt.create("wasm");
class AR {
  constructor() {
    ZM(this, "initialized", !1), ZM(this, "processing", !1), ZM(this, "prepared", !1), ZM(this, "worker", void 0), ZM(this, "listenerCallback", null), this.worker = null;
  }
  prepare(t) {
    return Ce(this, null, function* () {
      const r = "Liveness.worker.js", n = Q.getState().workerPath, i = Q.getState().workerPath === "https://wasm.regulaforensics.com/face/release/6.4/b5a9def0-bc5346988";
      try {
        let o = yield (yield fetch(n + "/" + r)).text();
        i || (o = o$(o, n));
        const u = new Blob([o], {
          type: "text/plain"
        }), s = URL.createObjectURL(u);
        this.worker = new Worker(s);
      } catch (M) {
        $c("Creating worker error: ".concat(JSON.stringify(M)));
      }
      this.listenerCallback = t, this.worker && (this.worker.onmessage = (M) => this.onWorkerMessage(M), this.worker.postMessage({
        target: "gl",
        op: "setPrefetched",
        preMain: !0
      }), this.worker.postMessage({
        target: "worker-init",
        URL: document.URL,
        currentScriptUrl: "https://wasm.regulaforensics.com/face/release/6.4/b5a9def0-bc5346988",
        preMain: !0
      }));
    });
  }
  initialize(t) {
    this.postCustomMessage({
      event: "initializeService",
      initializedData: t
    }, !0);
  }
  addDataToPackage(t, r) {
    t && this.postCustomMessage({
      event: "addDataToPackage",
      videoUInt8Array: t,
      processData: r
    }, !0);
  }
  finalizePackage() {
    this.postCustomMessage({
      event: "finalizePackage"
      /* finalizePackage */
    }, !0);
  }
  postCustomMessage(t, r) {
    this.worker && this.worker.postMessage({
      target: "custom",
      userData: t,
      preMain: r
    });
  }
  triggerListenerCallback(t) {
    this.listenerCallback && this.listenerCallback({
      initialized: this.initialized,
      prepared: this.prepared,
      data: t
    });
  }
  onWorkerMessage(t) {
    const r = t.data;
    if (r.target === "stdout") return $c(JSON.stringify(r.content));
    if (r.target === "stderr") {
      $c(JSON.stringify(r.content));
      const n = typeof r.content == "object" ? {
        error: r.content
      } : {
        error: new oi(Sr.WASM_ERROR, r.content)
      };
      this.triggerListenerCallback(n);
      return;
    }
    if (r.target === "custom") {
      const n = r.method !== "onRuntimeInitialized" && r.method !== "initializeService";
      r.method === "onRuntimeInitialized" && (this.prepared = !0), r.method === "initializeService" && (this.initialized = !0), n && (this.processing = !1), this.triggerListenerCallback(r.data);
      return;
    }
  }
  shutdown() {
    this.worker && this.worker.terminate();
  }
  processImage(t, r) {
    t && this.postCustomMessage({
      event: "processImage",
      imageUInt8Array: t,
      processData: r
    }, !0);
  }
}
function e2(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function un(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? e2(Object(r), !0).forEach(function(n) {
      Og(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : e2(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Og(e, t, r) {
  return (t = dR(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function dR(e) {
  var t = xR(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function xR(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class ER {
  constructor() {
    Og(this, "headers", void 0), Og(this, "controller", void 0), this.controller = null, this.headers = {};
  }
  abortLivenessRequest() {
    this.controller && (this.controller.abort(), this.controller = null);
  }
  provideHeaders(t) {
    t && (this.headers = t);
  }
  getLivenessDetectionResult(t, r) {
    return Ce(this, null, function* () {
      let {
        transactionId: n,
        backendURL: i = Ri,
        publicKey: M
      } = r;
      this.controller = new AbortController();
      const {
        signal: o
      } = this.controller, u = "".concat(i, "/api/v2/liveness?transactionId=").concat(n), s = {
        method: "POST",
        body: t,
        headers: un(un({}, this.headers), {}, {
          "X-CLIENT-KEY": M
        }),
        signal: o
      };
      return yield (yield fetch(u, s)).json();
    });
  }
  sendLivenessAbortedResult(t, r) {
    return Ce(this, null, function* () {
      let {
        transactionId: n,
        backendURL: i = Ri,
        publicKey: M
      } = r;
      const o = "".concat(i, "/api/v2/liveness?transactionId=").concat(n), u = {
        method: "POST",
        body: t,
        headers: un(un({}, this.headers), {}, {
          "X-CLIENT-KEY": M
        })
      };
      yield fetch(o, u);
    });
  }
  sendVideoData(n, i) {
    return Ce(this, arguments, function* (t, r) {
      let M = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ri, o = arguments.length > 3 ? arguments[3] : void 0;
      const u = "".concat(M, "/api/v2/liveness/video?transactionId=").concat(r, "&tag=").concat(o), s = {
        method: "POST",
        body: t,
        headers: un({}, this.headers)
      };
      yield fetch(u, s);
    });
  }
  getInitialisingData(n, i) {
    return Ce(this, arguments, function* (t, r) {
      let M = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ri, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
      const u = "".concat(M, "/api/v2/liveness/start"), s = {
        method: "POST",
        body: JSON.stringify({
          type: o,
          tag: r,
          metadata: un({}, t)
        }),
        headers: un(un({}, this.headers), {}, {
          "Content-Type": "application/json"
        })
      };
      return yield (yield fetch(u, s)).json();
    });
  }
}
const Wn = new ER(), zR = ["data"];
function fR(e, t) {
  if (e == null) return {};
  var r, n, i = CR(e, t);
  if (Object.getOwnPropertySymbols) {
    var M = Object.getOwnPropertySymbols(e);
    for (n = 0; n < M.length; n++) r = M[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function CR(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.includes(n)) continue;
    r[n] = e[n];
  }
  return r;
}
const LR = (e, t, r) => {
  const {
    transactionId: n
  } = Q((i) => ({
    transactionId: i.transactionId
  }));
  f.useEffect(() => {
    if (Dx(e)) {
      if (!t.recordService) return r.finalizePackage();
      t.recordService.getRecord().then((i) => Ce(void 0, null, function* () {
        if (!i) return;
        const {
          data: M
        } = i, o = fR(i, zR), u = yield M.arrayBuffer(), s = new Uint8Array(u);
        if (t.recordingProcess === Ua.SYNCHRONOUS_UPLOAD) {
          const l = {
            dataName: "processingVideo",
            sizeBytes: M.size,
            metaData: o
          };
          r.addDataToPackage(s, l);
        }
        if (t.recordingProcess === Ua.ASYNCHRONOUS_UPLOAD) {
          const l = i$(e);
          Wn.sendVideoData(s, n, t.url, l);
        }
        r.finalizePackage();
      }));
    }
  }, [e, t.recordService]);
};
function OR() {
  const [e, t] = f.useState(null);
  return f.useEffect(() => {
    const {
      navigator: r
    } = window;
    if (r) {
      const {
        appCodeName: n,
        appName: i,
        appVersion: M,
        language: o,
        languages: u,
        platform: s,
        product: l,
        productSub: I,
        userAgent: g,
        vendor: c,
        vendorSub: D
      } = r;
      t({
        appCodeName: n,
        appName: i,
        appVersion: M,
        language: o,
        languages: u,
        platform: s,
        product: l,
        productSub: I,
        userAgent: g,
        vendor: c,
        vendorSub: D
      });
    }
  }, []), e;
}
function t2(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function dr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? t2(Object(r), !0).forEach(function(n) {
      pR(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : t2(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function pR(e, t, r) {
  return (t = SR(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function SR(e) {
  var t = vR(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function vR(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const hR = 1500, r2 = (e) => e * 1e3, Rc = Bt.create("main"), mR = (e, t, r, n, i) => {
  var M;
  const o = OR(), {
    onEvent: u
  } = Q((I) => ({
    onEvent: I.onEvent
  })), {
    setTransactionId: s
  } = Q((I) => ({
    setTransactionId: I.setTransactionId
  })), {
    metadata: l
  } = Q((I) => ({
    metadata: I.metadata
  }));
  f.useEffect(() => {
    if (!t.initialized && t.prepared && e.videoElementParams.videoParams.width && e.videoElementParams.videoParams.height && e.videoStatusParams.sortedDevices && o)
      if (e.faceSnapshot) {
        var I, g;
        const c = e.holdStillDuration && r2(e.holdStillDuration) || hR, D = {
          rotationAngle: e.rotationAngle,
          scenario: 1,
          frameWidth: e.videoElementParams.videoParams.width,
          frameHeight: e.videoElementParams.videoParams.height,
          debugOutput: (I = e.debug) === null || I === void 0 ? void 0 : I.faceDebugOutputCanvasFromWasm,
          numChannels: 3,
          holdStillNormalTimeoutMs: c,
          minHoldStillFraction: 2,
          messageQueueSize: 1,
          detectOcclusion: e.detectOcclusion
        };
        e.timeoutInterval && (D.normalTimeoutMs = r2(e.timeoutInterval));
        const j = {
          config: D,
          metadata: {
            hostAppId: e.url || Ri,
            sdkVersion: XT("6.4.1506"),
            deviceModel: "".concat(Wu, "/").concat(ql, " ").concat(sa, "/").concat(Kl),
            camera: e.videoStatusParams.camera
          }
        };
        (g = e.debug) !== null && g !== void 0 && g.extendedWasmResponse && (j.enableLog = !0), r.initialize(j), u({
          action: xe.SERVICE_INITIALIZED,
          data: null
        }), Rc("Service initialized");
      } else {
        const c = GP(g6), D = [...e.videoStatusParams.sortedDevices.frontCameras, ...e.videoStatusParams.sortedDevices.backCameras].map((N) => {
          const d = N.facing === ur.user ? "front" : "back";
          return {
            cameraID: N.deviceId,
            label: N.label,
            groupId: N.groupId,
            facing: d
          };
        }), j = {
          platform: "Web",
          osVersion: "".concat(ql),
          sdkVersion: XT("6.4.1506"),
          hostAppId: e.url || Ri,
          userID: c,
          deviceModel: "".concat(Wu, "/").concat(ql, " ").concat(sa, "/").concat(Kl),
          hostAppVersion: "".concat(sa, "/").concat(Kl),
          currentCameraInfo: {
            cameraID: e.videoStatusParams.camera.deviceId
          },
          cameraState: D
        };
        l && l instanceof Object && Object.keys(l).length > 0 && (j.customMetadata = l), Wn.getInitialisingData(j, e.tag, e.url, e.livenessType).then((N) => {
          var d, T;
          if (!a$(N.publicKey))
            return i((A) => dr(dr({}, A), {}, {
              error: new oi(Sr.WEBSERVICE_NOT_COMPATIBLE)
            }));
          const y = dr(dr({}, N), {}, {
            tag: String(N.tag || N.sessionId),
            metadata: dr(dr({}, N.metadata), j),
            config: dr(dr({}, N.config), {}, {
              rotationAngle: e.rotationAngle,
              scenario: e.livenessType === _s.PASSIVE ? og.FACE_PASSIVE_LIVENESS : og.FACE_LIVENESS,
              frameWidth: e.videoElementParams.videoParams.width,
              frameHeight: e.videoElementParams.videoParams.height,
              numChannels: 3,
              debugOutput: (d = e.debug) === null || d === void 0 ? void 0 : d.faceDebugOutputCanvasFromWasm
            })
          });
          (T = e.debug) !== null && T !== void 0 && T.extendedWasmResponse && (y.enableLog = !0), r.initialize(y), u({
            action: xe.SERVICE_INITIALIZED,
            data: null
          }), Rc("Service initialized"), e.setTransactionId(y.transactionId), s(y.transactionId), e.tag || e.setTag(y.tag);
        }).catch((N) => {
          r.shutdown(), i((d) => dr(dr({}, d), {}, {
            error: new oi(Sr.UNKNOWN_ERROR, "initialized request failed with: ".concat(N))
          }));
        });
      }
    !t.prepared && o && n && r.prepare(n).then(() => {
      Rc("Service prepared");
    });
  }, [t.prepared, t.initialized, e.videoElementParams.videoParams.width, e.videoElementParams.videoParams.height, e.videoStatusParams.sortedDevices, e.videoStatusParams.camera, (M = e.debug) === null || M === void 0 ? void 0 : M.faceDebugOutputCanvasFromWasm, e.url, o]);
};
function Wo(e, t, r) {
  return (t = wR(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function wR(e) {
  var t = kR(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function kR(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const n2 = Bt.create("main");
class UR {
  constructor() {
    Wo(this, "angles", void 0), Wo(this, "initialized", void 0), Wo(this, "debugPlate", void 0), Wo(this, "setAngleLink", this.setAngle.bind(this)), this.debugPlate = !1, this.angles = null, this.initialized = !1;
  }
  setAngle(t) {
    if (this.angles = {
      alpha: t.alpha,
      beta: t.beta,
      gamma: t.gamma
    }, this.debugPlate) {
      const r = document.querySelector(".angle-debug-plate");
      if (!r || !t.alpha || !t.beta || !t.gamma) return;
      r.innerHTML = "";
      const n = document.createElement("div");
      n.textContent = "Roll: ".concat(Math.floor(t.alpha)), r.appendChild(n);
      const i = document.createElement("div");
      i.textContent = "Pitch: ".concat(Math.floor(t.beta)), r.appendChild(i);
      const M = document.createElement("div");
      M.textContent = "YAW: ".concat(Math.floor(t.gamma)), r.appendChild(M);
    }
  }
  setListeners() {
    window.DeviceOrientationEvent && typeof window.DeviceOrientationEvent.requestPermission == "function" ? Ce(this, null, function* () {
      yield window.DeviceOrientationEvent.requestPermission().then((t) => {
        t === "granted" && (this.initialized = !0, window.addEventListener("deviceorientation", this.setAngleLink)), t === "denied" && n2("Device orientation service permission denied");
      }).catch((t) => {
        if (this.initialized = !1, this.debugPlate) {
          const r = document.querySelector(".angle-debug-plate");
          if (!r) return;
          r.innerHTML = "Err. Permission denied";
        }
        n2("Device orientation service error: ".concat(t));
      });
    }) : (this.initialized = !0, window.addEventListener("deviceorientation", this.setAngleLink));
  }
  init(t) {
    if (t) {
      var r;
      if (this.debugPlate = !0, document.querySelector(".angle-debug-plate")) return;
      const n = document.createElement("div");
      n.setAttribute("class", "angle-debug-plate"), n.setAttribute("style", "position: fixed; top: 30px;left: 20px; box-shadow: 0 0 5px rgba(0,0,0,0.2); border-radius: 5px; background: white; height: 50px; width: 100px;z-index: 9999;overflow: hidden; padding: 5px; font-size: 12px;"), (r = document.querySelector("body")) === null || r === void 0 || r.append(n);
    }
    this.setListeners();
  }
  getAngle() {
    return this.angles;
  }
  shutdown() {
    if (window.removeEventListener("deviceorientation", this.setAngleLink), this.initialized = !1, this.debugPlate) {
      const t = document.querySelector(".angle-debug-plate");
      if (!t) return;
      t.remove();
    }
  }
}
const Vi = new UR();
function i2(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function M2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? i2(Object(r), !0).forEach(function(n) {
      QR(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i2(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function QR(e, t, r) {
  return (t = YR(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function YR(e) {
  var t = bR(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function bR(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const PR = Bt.create("main"), $R = (e, t, r, n, i) => {
  f.useLayoutEffect(() => {
    const M = e.videoStatusParams.videoStatus === _.PLAY;
    if (!e.videoElementParams.videoElement || t || !r.initialized || !M)
      return;
    n(!0), PR("Image processing started");
    let o = {};
    if (Vr && Vi.initialized) {
      const s = Vi.getAngle();
      o = {
        deviceOrientation: {
          yaw: s == null ? void 0 : s.gamma,
          pitch: s == null ? void 0 : s.beta,
          roll: s == null ? void 0 : s.alpha
        }
      };
    }
    e.abortProcess && (o = M2(M2({}, o), {}, {
      abortSession: !0
    }));
    const {
      imageData: u
    } = VP(e.videoElementParams.videoElement, rs.UINT);
    i.processImage(u[0].data, o);
  }, [r.initialized, e.videoElementParams.videoElement, t, e.videoStatusParams.videoStatus, e.abortProcess]);
};
function a2(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Hc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? a2(Object(r), !0).forEach(function(n) {
      RR(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : a2(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function RR(e, t, r) {
  return (t = HR(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function HR(e) {
  var t = VR(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function VR(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const _R = Bt.create("main"), ZR = {
  initialized: !1,
  numSectors: 0,
  step: 0,
  message: Le.Empty,
  prepared: !1,
  processingStage: Ij.Far,
  status: Re.InProcess,
  request: null,
  requestSize: null,
  debugOutput: null,
  images: [],
  ovals: [],
  targetSector: void 0,
  currSector: 0,
  readiness: 0,
  publicKey: null,
  error: null,
  facePosition: {
    width: 0,
    height: 0,
    x: 0,
    y: 0
  }
};
function GR(e) {
  const t = f.useMemo(() => new AR(), []), [r, n] = f.useState(!1), [i, M] = f.useState(ZR), o = (u) => {
    let {
      data: s,
      initialized: l,
      prepared: I
    } = u;
    (s == null ? void 0 : s.status) === Re.InProcess && n(!1), M((g) => Hc(Hc(Hc({}, g), {}, {
      initialized: l,
      prepared: I
    }, s), {}, {
      request: Dx(s == null ? void 0 : s.status) || !(s != null && s.request) ? null : s.request
    })), _R("Worker response");
  };
  return LR(i.status, e, t), mR(e, i, t, o, M), $R(e, r, i, n, t), f.useEffect(() => () => {
    t.shutdown();
  }, []), i;
}
function BR(e, t) {
  f.useEffect(() => {
    function r() {
      t && t();
    }
    if (e === _.PLAY)
      return window.addEventListener("visibilitychange", r), () => {
        window.removeEventListener("visibilitychange", r);
      };
  }, [e]);
}
function FR() {
  const {
    onEvent: e,
    url: t,
    debug: r,
    tag: n,
    changeCamera: i = !0,
    setTag: M,
    cameraId: o,
    setUserCameraId: u,
    abortProcess: s,
    abortSessionStatus: l,
    setAbortSessionStatus: I,
    setAbortProcess: g,
    setImages: c,
    setPublicKey: D,
    setTransactionId: j,
    faceSnapshot: N,
    setCompletionStatus: d,
    setRequest: T,
    onError: y,
    rotationAngle: A,
    recordingProcess: x,
    livenessType: E,
    holdStillDuration: C,
    timeoutInterval: p,
    detectOcclusion: O
  } = Q(), w = x !== Ua.NOT_UPLOAD, z = f.useRef(null), [R, K] = f.useState(null), [P, H] = f.useState({
    videoElement: null,
    videoParams: {
      width: 0,
      height: 0
    },
    videoContainerParams: {
      width: 0,
      height: 0
    }
  }), [Se, fe] = f.useState({
    width: 0,
    height: 0,
    left: 0,
    top: 0
  }), [De, S] = f.useState({
    videoStatus: _.PREPARING,
    camera: {
      deviceId: "",
      facing: void 0,
      groupId: "",
      label: ""
    },
    sortedDevices: null
  }), [U, k] = f.useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }), {
    message: W,
    status: J,
    processingStage: Ge,
    request: ve,
    debugOutput: Be,
    prepared: he,
    initialized: It,
    images: ft,
    error: Wt,
    ovals: qr,
    step: $n,
    currSector: en,
    targetSector: ji,
    numSectors: gr,
    readiness: zM,
    publicKey: Rn,
    facePosition: Jt
  } = GR({
    videoStatusParams: De,
    videoElementParams: P,
    tag: n,
    setTag: M,
    setTransactionId: j,
    url: t,
    debug: r,
    faceSnapshot: N,
    abortProcess: s,
    recordingProcess: x,
    rotationAngle: eo ? A : void 0,
    livenessType: E,
    recordService: R,
    holdStillDuration: C,
    timeoutInterval: p,
    detectOcclusion: O
  }), fM = De.camera.facing === ur.user ? Fo["mirror-x"] : "", qs = f.useMemo(() => N || !w ? !1 : {
    debug: r == null ? void 0 : r.videoRecordingSaveVideo
  }, [r == null ? void 0 : r.videoRecordingSaveVideo, N, w]), ro = f.useCallback(() => {
    g(!0), I(Yt.CHANGE_CAMERA), e({
      action: xe.PROCESS_FINISHED,
      data: {
        status: nt.ERROR,
        reason: Sr.CHANGE_CAMERA
      }
    });
  }, [De.camera]), no = () => {
    document.hidden && (g(!0), I(Yt.APP_INACTIVE), e({
      action: xe.PROCESS_FINISHED,
      data: {
        status: nt.ERROR,
        reason: Sr.APP_INACTIVE
      }
    }));
  }, gt = f.useCallback((q) => {
    e({
      action: xe.PROCESS_FINISHED,
      data: {
        status: nt.ERROR,
        reason: q
      }
    });
  }, []);
  return f.useEffect(() => {
    if (JT(J, N, s, !1, !1) === m.ABORT_PROCESSING && l === Yt.CHANGE_CAMERA) {
      if (!De.sortedDevices) return;
      const Ct = _P(De.sortedDevices, De.camera.deviceId);
      Ct && u(Ct);
    }
  }, [J, Ge, N, l]), BR(De.videoStatus, no), f.useEffect(() => {
    const Ct = {
      [_.PERMISSION_DENIED]: m.PERMISSION_DENIED_ERROR,
      [_.UNKNOWN_ERROR]: m.UNKNOWN_ERROR,
      [_.NO_CAMERA]: m.NO_CAMERA_ERROR,
      [_.INCORRECT_CAMERA_ID]: m.INCORRECT_CAMERA_ID_ERROR
    }[De.videoStatus];
    Ct && d(Ct);
  }, [De.videoStatus]), f.useEffect(() => {
    !Rn || N || D(Rn);
  }, [Rn]), f.useEffect(() => {
    if (Wt) return;
    J === Re.Timeout && (e({
      action: xe.PROCESS_FINISHED,
      data: {
        status: nt.ERROR,
        reason: Sr.TIMEOUT_ERROR
      }
    }), N || I(Yt.SESSION_TIMEOUT));
    const q = JT(J, N, s, !!(ft != null && ft.length), !!ve);
    d(q), P.videoElement && (q === m.SUCCESS && c(ft), !N && (q === m.PROCESSING_REQUEST && (g(!1), c(ft), T(ve)), (q === m.FAILED || q === m.ABORT_PROCESSING) && T(ve)));
  }, [J, Ge, N, ve, ft, P.videoElement, Wt]), f.useEffect(() => {
    if (!P.videoParams.width || Jt.x === 0 || W !== Le.FitFaceIntoOval) return;
    const q = Lg(P.videoParams.width, P.videoParams.height, P.videoContainerParams.width, P.videoContainerParams.height, Jt.width, Jt.height, Jt.x, Jt.y, Pr.contain);
    k({
      width: q.width,
      height: q.height,
      x: P.videoContainerParams.width - q.left - q.width,
      y: q.top
    });
  }, [W]), f.useEffect(() => {
    if (!qr.length || Ge > Ij.Near) return;
    const q = qr[1], Ct = Lg(P.videoParams.width, P.videoParams.height, P.videoContainerParams.width, P.videoContainerParams.height, q.axisX, q.axisY, q.center.x, q.center.y, Pr.contain);
    fe(Ct);
  }, [P, qr]), f.useEffect(() => {
    const q = z.current;
    r != null && r.faceDebugOutputCanvasFromWasm && Be && q && r$(q, P, Be);
  }, [Be, P, r == null ? void 0 : r.faceDebugOutputCanvasFromWasm]), f.useEffect(() => {
    Wt && y(Wt);
  }, [Wt]), /* @__PURE__ */ a.jsxs("div", { className: Fo.container, children: [
    /* @__PURE__ */ a.jsx(gR, { facePosition: U, readiness: zM, step: $n, numSectors: gr, currSector: en, targetSector: ji, captureFrame: Se, videoStatusParams: De, message: W, prepared: he && It, onChangeCamera: ro, showChangeCameraButton: i, faceSnapshot: N, children: he ? /* @__PURE__ */ a.jsx(L$, { onVideoSizeChange: H, onVideoStatusChange: S, mode: ur.user, resolution: Vr ? Qa.HD : Qa.FULL_HD, onFailStatus: gt, cameraId: o, onRecordService: K, videoRecord: qs }) : null }),
    (r == null ? void 0 : r.faceDebugOutputCanvasFromWasm) && /* @__PURE__ */ a.jsx("div", { className: Fo.translateY, children: /* @__PURE__ */ a.jsx("canvas", { ref: z, className: "".concat(Fo["debug-canvas"], " ").concat(fM), width: P.videoContainerParams.width, height: P.videoContainerParams.height }) })
  ] });
}
const WR = "_container_e810x_1", JR = "_spinner_e810x_15", XR = "_spin_e810x_15", o2 = {
  container: WR,
  spinner: JR,
  spin: XR
};
function KR() {
  return /* @__PURE__ */ a.jsx("div", { className: o2.container, children: /* @__PURE__ */ a.jsx("div", { className: o2.spinner }) });
}
function u2(e) {
  let {
    title: t
  } = e;
  return /* @__PURE__ */ a.jsxs("div", { className: Qr["process-message"], children: [
    /* @__PURE__ */ a.jsx(KR, {}),
    /* @__PURE__ */ a.jsx("span", { className: Qr.message, children: t })
  ] });
}
const qR = "_text_g40yf_15", eH = "_title_g40yf_19", tH = "_subtitle_g40yf_31", rH = "_icons_g40yf_41", jt = {
  "retry-screen": "_retry-screen_g40yf_1",
  text: qR,
  title: eH,
  subtitle: tH,
  icons: rH,
  "icon-item": "_icon-item_g40yf_49",
  "icon-subtitle": "_icon-subtitle_g40yf_74",
  "icon-bg": "_icon-bg_g40yf_116",
  "no-smile": "_no-smile_g40yf_125",
  "no-glare": "_no-glare_g40yf_128"
};
function nH(e) {
  var t, r;
  let {
    errorCode: n,
    onReset: i
  } = e;
  const {
    translate: M
  } = Ii.useLocalize();
  return /* @__PURE__ */ a.jsxs("div", { className: jt["retry-screen"], children: [
    /* @__PURE__ */ a.jsxs("div", { className: jt.text, children: [
      /* @__PURE__ */ a.jsx("p", { "data-e2e": "retry-msg-title", className: jt.title, children: M("letsTryAgainTitle") }),
      /* @__PURE__ */ a.jsx("p", { className: jt.subtitle, children: M("followGuidelinesText") })
    ] }),
    /* @__PURE__ */ a.jsxs("div", { className: jt.icons, children: [
      ((t = u1[n]) === null || t === void 0 ? void 0 : t.type) !== 1 && /* @__PURE__ */ a.jsxs("div", { className: jt["icon-item"], children: [
        /* @__PURE__ */ a.jsx("div", { className: "".concat(jt["icon-bg"], " ").concat(jt["no-smile"]) }),
        /* @__PURE__ */ a.jsx("p", { className: jt["icon-subtitle"], children: M("noMaskSunglassesHeaddress") })
      ] }),
      ((r = u1[n]) === null || r === void 0 ? void 0 : r.type) !== 2 && /* @__PURE__ */ a.jsxs("div", { className: jt["icon-item"], children: [
        /* @__PURE__ */ a.jsx("div", { className: "".concat(jt["icon-bg"], " ").concat(jt["no-glare"]) }),
        /* @__PURE__ */ a.jsx("p", { className: jt["icon-subtitle"], children: M("ambientLighting") })
      ] })
    ] }),
    /* @__PURE__ */ a.jsx(J4, { onClick: i, children: M("retryButtonText") })
  ] });
}
const Pj = f.memo(() => {
  const {
    finishScreen: e = !0,
    abortProcess: t,
    completionStatus: r,
    response: n,
    faceSnapshot: i,
    cameraId: M,
    decreaseRetryCount: o,
    onRestart: u,
    onEvent: s,
    retryCount: l
  } = Q(), {
    translate: I
  } = Ii.useLocalize(), g = f.useCallback(() => {
    s({
      action: xe.PRESS_RETRY_BUTTON,
      data: null
    }), i || o(), u();
  }, [l]);
  if (r === m.INSTRUCTION && !t) {
    const c = I("getReady");
    return /* @__PURE__ */ a.jsx(N$, { title: I("selfieTime"), subtitle: c, btnText: I("goButton") });
  }
  return r === m.CAPTURING || t ? /* @__PURE__ */ a.jsx(FR, {}) : r === m.PROCESSING_REQUEST ? /* @__PURE__ */ a.jsx(u2, { title: I("processing") }) : r === m.SUCCESS && e ? /* @__PURE__ */ a.jsx(vt, { type: "verified", title: "" }) : r === m.INCORRECT_CAMERA_ID_ERROR ? /* @__PURE__ */ a.jsx(vt, { type: "camera-logo", title: "".concat(I("incorrectCameraId"), ' "').concat(M, '"'), subtitle: I("checkCameraId") }) : r === m.PERMISSION_DENIED_ERROR ? /* @__PURE__ */ a.jsx(vt, { type: "camera-logo", title: I("noCameraPermission"), subtitle: I("allowAccessToCamera") }) : r === m.NO_CAMERA_ERROR ? /* @__PURE__ */ a.jsx(vt, { type: "error", title: I("noCameraAvailable"), subtitle: I("checkCameraConnection"), iconColor: "#DC4343" }) : r === m.WASM_DEFAULT_ERROR ? /* @__PURE__ */ a.jsx(vt, { type: "error", title: I("error"), subtitle: I("somethingWentWrong") }) : r === m.NOT_SUPPORTED_ERROR ? /* @__PURE__ */ a.jsx(vt, { type: "error", title: I("versionNotSupported"), subtitle: I("updateBrowser") }) : r === m.HTTP_NOT_SUPPORTED ? /* @__PURE__ */ a.jsx(vt, { type: "error", title: I("error"), subtitle: I("httpNotSupported") }) : r === m.WEBSERVICE_NOT_COMPATIBLE ? /* @__PURE__ */ a.jsx(vt, { onReset: g, type: "error", title: I("error"), subtitle: I("webServerNotCompatible") }) : r === m.UNKNOWN_ERROR ? /* @__PURE__ */ a.jsx(vt, { onReset: g, type: "error", title: I("error"), subtitle: I("somethingWentWrong") }) : r === m.RESTART || r === m.ABORT_PROCESSING ? /* @__PURE__ */ a.jsx(u2, {}) : e ? n.code === s1 ? /* @__PURE__ */ a.jsx(vt, { type: "error", title: I("somethingWentWrong"), errorCode: s1 }) : /* @__PURE__ */ a.jsx(nH, { errorCode: n.code, onReset: g }) : /* @__PURE__ */ a.jsx(vt, { title: I("processCompleted"), type: "warning" });
});
Pj.displayName = "ScreenManager";
function iH(e) {
  let {
    direction: t
  } = e;
  const {
    images: r,
    onEvent: n,
    startScreen: i = !0,
    abortSessionStatus: M,
    setAbortProcess: o,
    setAbortSessionStatus: u,
    completionStatus: s,
    setCompletionStatus: l,
    onRestart: I,
    onRotateDevice: g,
    onError: c
  } = Q(), {
    orientation: D,
    isLandscape: j
  } = X4(), N = f.useRef(!0), d = f.useCallback(() => {
    n({
      action: xe.CLOSE,
      data: null
    });
  }, []);
  return f.useEffect(() => {
    yx && c(new oi("HTTP_NOT_SUPPORTED")), !i && l(m.CAPTURING);
  }, []), f.useEffect(() => {
    s === m.SUCCESS && n({
      action: xe.PROCESS_FINISHED,
      data: {
        status: nt.OK,
        response: {
          capture: r
        }
      }
    }), jx(s, M) && s === m.ABORT_PROCESSING && (I(ka && j), o(!1), u(null));
  }, [s]), f.useEffect(() => {
    if (!Vr) return;
    const T = ka && j;
    if (N.current) {
      N.current = !1, T && l(m.RESTART);
      return;
    }
    g(T, yd);
  }, [D, j]), /* @__PURE__ */ a.jsx(gx, { onError: c, supportedBrowserVersions: e5, children: /* @__PURE__ */ a.jsx(n5, { onClose: d, direction: t, children: /* @__PURE__ */ a.jsx(Pj, {}) }) });
}
const MH = lx(Ix)(iH), dx = "*,*:before,*:after{box-sizing:border-box}._window_10mzy_7{width:640px;height:360px;position:relative;background:#fff;overflow:hidden;box-shadow:0 2px 4px #00000026;color:#fff;-webkit-backface-visibility:hidden;-moz-backface-visibility:hidden;-webkit-transform:translate3d(0,0,0);-moz-transform:translate3d(0,0,0);font-family:var(--font-family);font-size:var(--font-size);margin:0 auto;border-radius:16px}._windowRotate_10mzy_26{width:360px!important;height:640px!important}._window_10mzy_7[data-direction=rtl]{direction:rtl}._window_10mzy_7[data-direction=ltr]{direction:ltr}._window_10mzy_7[data-device=mobile]{width:360px;height:640px}._header_10mzy_44{position:absolute;top:0;right:0;display:flex;justify-content:flex-end;padding:16px}div[data-direction=rtl] ._header_10mzy_44{left:0}div[data-direction=ltr] ._header_10mzy_44{right:0}._header_10mzy_44 button,._footer_10mzy_61 button{display:flex;justify-content:center;align-items:center;border:none;padding:0;margin:0;text-decoration:none;background:none;cursor:pointer;text-align:center;transition:background .25s ease-in-out,transform .15s ease;appearance:none}._footer_10mzy_61{position:absolute;bottom:0;padding:0 16px 13px;display:flex;align-items:center}div[data-device=mobile] ._footer_10mzy_61{left:50%;transform:translate(-50%)}div[data-direction=rtl]:not([data-device=mobile]) ._footer_10mzy_61{right:0}div[data-direction=ltr]:not([data-device=mobile]) ._footer_10mzy_61{left:0}._ads_10mzy_97{display:flex;align-items:center}._ads_10mzy_97 span{font-size:10px;line-height:24px;color:#8c8c8c}._ads_10mzy_97 ._pipe_10mzy_108{margin:0 6px;opacity:.3;height:18px;width:1px;background-color:#8c8c8c}@media (max-width: 360px){._window_10mzy_7[data-device=mobile]{width:100%}}@media (max-height: 640px){._window_10mzy_7[data-device=mobile]{height:100%}}@media (max-width: 360px) and (max-height: 640px){._window_10mzy_7[data-device=mobile]{border-radius:0}}@media (max-width: 640px){._window_10mzy_7[data-device=desktop]{width:100%;height:100%;border-radius:0}}", xx = '._instruction-window_wzfb4_1{display:flex;height:100%;align-items:center;justify-content:center;flex-direction:column;padding:24px 16px}div[data-device=mobile] ._instruction-window_wzfb4_1{justify-content:center;padding:4em 1em}._text_wzfb4_15{display:flex;flex-direction:column;align-items:center;text-align:center;color:#000;margin-bottom:4px}div[data-device=mobile] ._text_wzfb4_15{margin-bottom:0}._title_wzfb4_28{margin-top:14px;margin-bottom:34px;font-size:1.563em;font-weight:600;color:#000;line-height:1}div[data-device=mobile] ._title_wzfb4_28{margin-top:0;font-size:2.125em;margin-bottom:55px}._subtitle_wzfb4_43{font-size:1.063em;font-weight:600;text-align:center;color:#262626;line-height:1.1}div[data-device=mobile] ._subtitle_wzfb4_43{font-size:1.375em}._container_wzfb4_55{display:flex;flex-direction:column;width:280px;height:100%;align-items:center}div[data-locale=en] ._container_wzfb4_55{width:13.375em;min-width:214px}div[data-locale=es] ._container_wzfb4_55{width:19.375em;min-width:285px}div[data-locale=de] ._container_wzfb4_55{width:13.938em;min-width:223px}div[data-locale=fr] ._container_wzfb4_55{width:17.813em;min-width:285px}div[data-device=mobile] ._container_wzfb4_55{justify-content:center;width:280px}._icon-block_wzfb4_88{display:flex;align-items:center;color:#000;font-size:.875em;margin-bottom:1px;letter-spacing:.4px}div[data-direction=ltr] ._icon-block_wzfb4_88{text-align:left}div[data-device=mobile] ._icon-block_wzfb4_88{font-size:1.125em;letter-spacing:0;margin-bottom:5px}div[data-device=mobile][data-locale=en] ._icon-block_wzfb4_88{padding-right:10px}._icon-container_wzfb4_111{display:flex;flex-direction:column;margin-bottom:25px}div[data-device=mobile] ._icon-container_wzfb4_111{margin-bottom:45px;margin-top:8px;padding-left:12px}._icon_wzfb4_88{margin-right:9px;flex:0 0 43px;height:43px;background-repeat:no-repeat;background-position:center center;background-size:contain}._illumination_wzfb4_132{background-image:var(--onboarding-screen-illumination)}._no-accessories_wzfb4_136{background-image:var(--onboarding-screen-accessories)}._camera-on-eye_wzfb4_140{background-image:var(--onboarding-screen-camera-level)}div[data-device=mobile] ._icon_wzfb4_88{margin-right:8px;flex:0 0 50px;height:50px}._instruction-window_wzfb4_1 button{position:relative;width:100%;height:50px;overflow:hidden;font-size:1.375em;font-weight:700;background:var(--onboarding-screen-start-button-background);color:var(--onboarding-screen-start-button-title)}._instruction-window_wzfb4_1 button:hover{background:var(--onboarding-screen-start-button-background-hover);color:var(--onboarding-screen-start-button-title-hover)}._instruction-window_wzfb4_1 button:after{transform:translate(-120%);content:"";position:absolute;width:120%;height:100%;left:0;top:0;z-index:1;background:linear-gradient(269.72deg,#fff0 -4.26%,#ffffff38 47.3%,#fff0 105.48%);animation:_buttonAnimation_wzfb4_1 5.5s forwards}@keyframes _buttonAnimation_wzfb4_1{0%{transform:translate(-120%)}25%{transform:translate(120%)}26%{transform:translate(120%);opacity:0}27%{transform:translate(-120%);opacity:0}28%{transform:translate(-120%);opacity:1}40%{transform:translate(-120%);opacity:1}65%{transform:translate(120%);opacity:1}66%{transform:translate(120%);opacity:0}67%{transform:translate(-120%);opacity:0}68%{transform:translate(-120%);opacity:1}75%{transform:translate(-120%);opacity:1}to{transform:translate(120%);opacity:1}}', Ex = "._container_ctl1v_1{display:flex;width:100%;height:100%;position:relative;color:#fff}button:focus{outline:none}._debug-canvas_ctl1v_14{position:absolute;top:0;left:0}._mirror-x_ctl1v_20{transform:scaleX(-1)}._translateY_ctl1v_24{position:absolute;top:0;left:0;width:100%;height:100%;transform:translateY(-30px)}div[data-device=mobile] ._translateY_ctl1v_24{transform:translateY(-25%)}", zx = "._process-message_1n8va_1{display:flex;height:100%;flex-direction:column;align-items:center;justify-content:center}._process-message_1n8va_1 ._message_1n8va_9{display:block;padding-top:.875em;font-size:.875em;font-weight:400;line-height:1.43em;color:#444}._info-message_1n8va_18{display:flex;height:100%;flex-direction:column;align-items:center;justify-content:center;padding:0 1.5em}._text-container_1n8va_27{display:flex;flex-direction:column;align-items:center;max-width:350px;word-break:break-word}._text-container_1n8va_27>svg{margin-bottom:1.12em}._info-message_1n8va_18 ._title_1n8va_39{margin:0 0 .3em;font-size:1.25em;font-weight:700;line-height:1.4em;color:#262626;text-align:center}._info-message_1n8va_18 ._subtitle_1n8va_48{margin:0 0 .2em;font-style:normal;font-size:1em;font-weight:400;line-height:1.375em;color:#262626;text-align:center}._info-message_1n8va_18 ._errorCode_1n8va_58{margin:0 0 1.15em;font-style:normal;font-size:.9em;font-weight:400;line-height:1.375em;color:#262626;text-align:center;opacity:.7}._button_1n8va_69{margin-top:1em}._done_1n8va_73{width:86px;height:86px;background-image:var(--success-screen-image);background-repeat:no-repeat;background-size:contain;background-position:center center}", fx = '._message-container_1dlmk_2{display:inline-block;padding:.595em .87em;font-style:normal;font-weight:400;color:var(--camera-screen-front-hint-label-text);background:var(--camera-screen-front-hint-label-background);line-height:1em;border-radius:16px}._container_1dlmk_14{position:relative;height:100%;width:100%}._container_1dlmk_14:after{content:"";position:absolute;bottom:-5px;left:0;width:100%;height:10px;background:#fff}._translateY_1dlmk_31{transform:translateY(-30px)}div[data-device=mobile] ._translateY_1dlmk_31{transform:translateY(-25%)}._videoContainer_1dlmk_39{width:100%;height:100%;overflow:hidden}._videoContainerRotation_1dlmk_44{--rotatedWidth: 640px;--rotatedHeight: 360px;width:var(--rotatedWidth);height:var(--rotatedHeight);transform-origin:50% 50%}._videoContainerRotation-90-rev_1dlmk_52{transform:rotate(90deg) translateY(calc(var(--rotatedWidth) / 2 - var(--rotatedHeight) / 2)) translate(calc(var(--rotatedWidth) / 2 - var(--rotatedHeight) / 2))}._videoContainerRotation-90_1dlmk_52{transform:rotate(-90deg) translateY(calc(var(--rotatedHeight) / 2 - var(--rotatedWidth) / 2)) translate(calc(var(--rotatedHeight) / 2 - var(--rotatedWidth) / 2))}._videoContainerRotation-180_1dlmk_60{transform:rotate(-180deg)}._videoContainerBlur_1dlmk_64{display:flex;flex:1;width:100%;height:100%;transition:filter .3s linear}._backgroundSvg_1dlmk_72{position:absolute;top:0;left:0;height:100%;width:100%}._hide_1dlmk_80{opacity:0}._frame_1dlmk_84{stroke-dasharray:100;animation:_dash_1dlmk_1 10s linear infinite;animation-direction:reverse}._done_1dlmk_90{animation:_pulse_1dlmk_1 1s infinite ease-in-out}@keyframes _pulse_1dlmk_1{0%{opacity:.3}50%{opacity:1}to{opacity:.3}}._hintArrowAnimation_1dlmk_106{animation:_pulseHintArrow_1dlmk_1 1s infinite ease-in-out}@keyframes _pulseHintArrow_1dlmk_1{0%{opacity:.3;transform:translate(20px)}50%{opacity:1;transform:translate(25px)}to{opacity:.3;transform:translate(20px)}}._primaryMessage_1dlmk_125{position:absolute;bottom:8%;width:100%;text-align:center;font-size:1.125em;z-index:1}._secondaryMessage_1dlmk_134{position:absolute;bottom:-7px;padding:.2em;width:100%;text-align:center;font-size:1em;transition:.5s ease;transform:translateZ(0);z-index:1}._centreMessage_1dlmk_146{bottom:50%;transform:translateY(50%)}div[data-device=mobile] ._secondaryMessage_1dlmk_134{transition-delay:.1s;transform:translateZ(0) translateY(0);padding:3em 1em;font-size:1.25em}div[data-device=mobile] ._centreMessage_1dlmk_146{bottom:-7px;transform:translateY(-150px)}._functionalButtons_1dlmk_163{position:absolute;bottom:0;padding:20px;display:flex;align-items:flex-end;justify-content:flex-end;transform:translateY(30px);z-index:1}div[data-device=mobile] ._functionalButtons_1dlmk_163{transform:translateY(120px)}div[data-direction=rtl] ._functionalButtons_1dlmk_163{left:0}div[data-direction=ltr] ._functionalButtons_1dlmk_163{right:0}._functionalButtons_1dlmk_163 button:not(:disabled):hover{transform:scale(1.1)}._functionalButtons_1dlmk_163 button{display:flex;justify-content:center;align-items:center;border:none;padding:0;margin:0;text-decoration:none;background:none;cursor:pointer;text-align:center;transition:transform .15s ease}._functionalButtons_1dlmk_163 button:disabled{opacity:.5}._backgroundSvg_1dlmk_72 ellipse{transition:rx .5s,ry .5s}._targetSector_1dlmk_212{--sector-rotate: rotate(0deg);transform:var(--sector-rotate)}._currentSector_1dlmk_217{opacity:.8;transition:opacity .5s}._backgroundSvg_1dlmk_72._firstStepAnimation_1dlmk_222 ._targetSector_1dlmk_212{animation:_targetSectorFirstStepAnimation_1dlmk_1 .4s forwards}._backgroundSvg_1dlmk_72._firstStepAnimation_1dlmk_222 ._currentSector_1dlmk_217{animation:_currentSectorFirstStepAnimation_1dlmk_1 .4s forwards}._backgroundSvg_1dlmk_72._firstStepAnimation_1dlmk_222 ellipse{transform-origin:50% 50%;animation:_ellipseFirstStepAnimation_1dlmk_1 .2s forwards}@keyframes _ellipseFirstStepAnimation_1dlmk_1{0%{transform:scale(1)}50%{transform:scale(.8)}to{transform:scale(1)}}._face-hint_1dlmk_247{--from-left: 0;--from-top: 0}._face-hint-container_1dlmk_252{position:absolute;display:flex;justify-content:center;align-items:center;top:0;left:0;width:100%;height:100%;transition:opacity .5s}._face-hint-round_1dlmk_264{position:relative;overflow:hidden;display:flex;justify-content:center;align-items:center;transition:.8s}._face-hint-target_1dlmk_273{background-repeat:no-repeat;background-position:0 0;background-size:100%;animation:_spriteAnimation_1dlmk_1 .4s steps(7) forwards}._face-hint-animation-9_1dlmk_280{animation:_spriteAnimation_1dlmk_1 1s steps(12) forwards}._face-hint-animation-2_1dlmk_285{animation:_spriteAnimation_1dlmk_1 .4s steps(7) forwards reverse}._face-hint-animation-3_1dlmk_290{animation:_moveCloser_1dlmk_1 1s forwards}._face-hint-animation-4_1dlmk_295{animation:_moveAway_1dlmk_1 1s forwards}._face-hint-animation-1_1dlmk_300{animation:_fitYourFace_1dlmk_1 1s forwards}@keyframes _fitYourFace_1dlmk_1{0%{top:var(--from-top);left:var(--from-left)}30%{top:var(--from-top);left:var(--from-left)}to{top:0;left:0}}@keyframes _moveCloser_1dlmk_1{0%{transform:scale(.5)}to{transform:scale(1)}}@keyframes _moveAway_1dlmk_1{0%{transform:scale(1.4)}to{transform:scale(1)}}@keyframes _targetSectorFirstStepAnimation_1dlmk_1{0%{opacity:0}80%{opacity:0}to{opacity:1}}@keyframes _currentSectorFirstStepAnimation_1dlmk_1{0%{visibility:hidden}80%{visibility:hidden}to{visibility:visible}}@keyframes _spriteAnimation_1dlmk_1{0%{background-position:0 0}to{background-position:0 100%}}', Cx = "._container_1hyic_1{display:flex;flex:1}._video_1hyic_6{background-color:#fff;width:100%;height:100%;object-fit:contain}", Lx = "._button_eou6w_1{display:inline-flex;align-items:center;justify-content:center;border:none;margin:0;padding:0;background:var(--onboarding-screen-start-button-background);cursor:pointer;text-align:center;text-decoration:none;font-family:var(--font-family);font-size:1em;font-weight:400;color:var(--onboarding-screen-start-button-title);appearance:none;height:42px;flex-shrink:0;width:180px;border-radius:20px;transition:background .25s ease-in-out,transform .15s ease}._button_eou6w_1:hover{background:var(--onboarding-screen-start-button-background-hover);color:var(--onboarding-screen-start-button-title-hover)}._button_eou6w_1:active{background:var(--onboarding-screen-start-button-background)}", Ox = '._container_e810x_1{height:50px;width:50px}@keyframes _spin_e810x_15{0%{transform:rotate(0)}to{transform:rotate(360deg)}}._spinner_e810x_15{position:relative;width:50px;height:50px;clip:rect(22px,44px,44px,0);animation:_spin_e810x_15 1.5s cubic-bezier(.77,0,.175,1) infinite}._spinner_e810x_15:before,._spinner_e810x_15:after{content:"";display:block;position:absolute;inset:0;margin:auto;height:44px;width:44px;border-radius:50%}._spinner_e810x_15:before{border:3px solid transparent;border-top:3px solid var(--processing-screen-progress);animation:_spin_e810x_15 1.5s cubic-bezier(.77,0,.175,1) infinite}._spinner_e810x_15:after{border:3px solid rgba(49,49,49,.1)}', px = "._retry-screen_g40yf_1{display:flex;height:100%;flex-direction:column;align-items:center;justify-content:space-between;padding:1em}div[data-device=mobile] ._retry-screen_g40yf_1{justify-content:center;padding:4em 1em 6em}._text_g40yf_15{text-align:center}._text_g40yf_15 ._title_g40yf_19{margin:0 0 .4em;font-size:1.25em;font-weight:700;line-height:1.4em;color:#262626}div[data-device=mobile] ._text_g40yf_15 ._title_g40yf_19{line-height:1.25em}._text_g40yf_15 ._subtitle_g40yf_31{margin:0 0 16px;font-style:normal;font-size:.875em;font-weight:400;line-height:1.25em;color:#262626;opacity:.7}._retry-screen_g40yf_1 ._icons_g40yf_41{display:flex}div[data-device=mobile] ._icons_g40yf_41{flex-direction:column}._icons_g40yf_41 ._icon-item_g40yf_49{display:flex;flex-direction:column;align-items:center}._icons_g40yf_41 ._icon-item_g40yf_49+._icon-item_g40yf_49{margin-left:2em;margin-right:0}div[data-direction=rtl] ._icons_g40yf_41 ._icon-item_g40yf_49+._icon-item_g40yf_49{margin-left:0;margin-right:2em}div[data-device=mobile] ._icons_g40yf_41 ._icon-item_g40yf_49+._icon-item_g40yf_49{margin-left:0;margin-right:0}._icon-item_g40yf_49>svg{margin-bottom:.7em}._icon-subtitle_g40yf_74{font-size:.8em;line-height:1.43em;color:#262626;margin:0 0 1.15em;font-style:normal;font-weight:400;text-align:center}._icon-item_g40yf_49>p{word-break:break-word;text-align:center;max-width:280px}div[data-device=mobile] ._icon-item_g40yf_49>p{max-width:300px}div[data-device=mobile] ._icon-subtitle_g40yf_74{font-size:.8125em}._retry-screen_g40yf_1 button{color:var(--retry-screen-retry-button-title);background:var(--retry-screen-retry-button-background)}._retry-screen_g40yf_1 button:hover{color:var(--retry-screen-retry-button-title-hover);background:var(--retry-screen-retry-button-background-hover)}div[data-device=mobile] ._retry-screen_g40yf_1 button{position:absolute;width:calc(100% - 32px);bottom:55px;left:16px}._icon-bg_g40yf_116{width:140px;height:100px;background-repeat:no-repeat;background-position:center center;background-size:contain;margin-bottom:5px}._no-smile_g40yf_125{background-image:var(--retry-screen-person-image)}._no-glare_g40yf_128{background-image:var(--retry-screen-environment-image)}@media (max-width: 400px){div[data-device=mobile] ._retry-screen_g40yf_1{padding:3em 1em 5.5em}div[data-device=mobile] ._retry-screen_g40yf_1 button{bottom:45px}}@media (max-width: 360px){div[data-device=mobile] ._retry-screen_g40yf_1 ._icons_g40yf_41 svg{width:100%}}";
var ht = /* @__PURE__ */ ((e) => (e.url = "url", e.debug = "debug", e.locale = "locale", e.copyright = "copyright", e.cameraId = "camera-id", e.changeCamera = "change-camera", e.startScreen = "start-screen", e.deviceOrientation = "device-orientation", e.closeDisabled = "close-disabled", e.finishScreen = "finish-screen", e))(ht || {}), xr = /* @__PURE__ */ ((e) => (e.locale = "locale", e.copyright = "copyright", e.cameraId = "camera-id", e.changeCamera = "change-camera", e.startScreen = "start-screen", e.closeDisabled = "close-disabled", e.finishScreen = "finish-screen", e))(xr || {});
const aH = "Подготовка камеры...", oH = "Камера недоступна!", uH = "Не двигайтесь", sH = "Обработка...", lH = "Смотрите прямо", cH = "Подвиньтесь ближе", IH = "Отодвиньтесь подальше", gH = "Повторить", jH = "Давайте попробуем снова", NH = "Но убедитесь, пожалуйста, что:", DH = "Разрешите доступ к камере", yH = "Что-то пошло не так", TH = "Подготовка сервиса...", AH = "Разрешите доступ к камере и перезагрузите эту страницу для продолжения.", dH = "Ошибка!", xH = "Повторите попытку", EH = "Отсутствует камера", zH = "Проверьте подключение камеры и попробуйте снова.", fH = "Освещение не должно быть слишком ярким/тусклым, на лице не должно быть теней и бликов", CH = "Выражение лица должно быть нейтральным (без улыбки, рот закрыт, глаза открыты). Снимите маску, солнцезащитные очки, головной убор", LH = "Версия вашего браузера не поддерживается", OH = "Обновите версию вашего браузера", pH = "Только портретная ориентация", SH = "Поверните устройство в портретный режим", vH = "Ошибка лицензии", hH = "Лицензия не найдена или недействительна", mH = "Убедитесь, что на экране присутствует только одно лицо.", wH = "Камера с заданным ID не найдена.", kH = "Проверьте корректность заданного ID камеры.", UH = "Немного поверните голову", QH = "Время для селфи!", YH = "Расположите лицо по центру, поверните голову", bH = "Расположите лицо по центру", PH = "Начать", $H = "Разместите лицо по центру", RH = "Код ошибки:", HH = "Хорошее освещение.", VH = "Камера на уровне глаз.", _H = "Никаких аксессуаров: очков, маски, шляпы и т.д.", ZH = "Приготовьтесь", GH = "Процесс завершен", BH = "HTTPS не используется", FH = "Веб-сервис несовместим", WH = "Удалите предметы, закрывающие лицо", JH = {
  preparingCamera: aH,
  noCameraPermission: oH,
  holdSteady: uH,
  processing: sH,
  lookStraight: lH,
  moveCloser: cH,
  moveAway: IH,
  retryButtonText: gH,
  letsTryAgainTitle: jH,
  followGuidelinesText: NH,
  allowAccessCamera: DH,
  somethingWentWrong: yH,
  preparingService: TH,
  allowAccessToCamera: AH,
  error: dH,
  tryAgain: xH,
  noCameraAvailable: EH,
  checkCameraConnection: zH,
  ambientLighting: fH,
  noMaskSunglassesHeaddress: CH,
  versionNotSupported: LH,
  updateBrowser: OH,
  onlyPortraitOrientation: pH,
  turnDeviceIntoPortrait: SH,
  licenseError: vH,
  licenseExpired: hH,
  showOnlyOneFace: mH,
  incorrectCameraId: wH,
  checkCameraId: kH,
  turnHead: UH,
  selfieTime: QH,
  centerFaceTurnHead: YH,
  centerFace: bH,
  goButton: PH,
  fitYourFace: $H,
  errorCode: RH,
  illumination: HH,
  cameraLevel: VH,
  noAccessories: _H,
  getReady: ZH,
  processCompleted: GH,
  httpNotSupported: BH,
  webServerNotCompatible: FH,
  removeOcclusion: WH
}, XH = "Preparing the camera...", KH = "Camera unavailable!", qH = "Hold steady", eV = "Processing...", tV = "Look straight", rV = "Move closer", nV = "Move away", iV = "Retry", MV = "Let’s try that again", aV = "But please follow these guidelines:", oV = "Allow access to the camera", uV = "Something went wrong", sV = "Preparing the service...", lV = "Allow access to the camera and reload this page to continue.", cV = "Error!", IV = "Try again", gV = "No camera available", jV = "Check the camera connection and try again.", NV = "Ambient lighting is not too bright or too dark and there are no shadows or glare on your face", DV = "Neutral facial expression (no smiling, eyes open and mouth closed), no mask, sunglasses or headwear", yV = "Your browser version is not supported", TV = "Update your browser version", AV = "Portrait orientation only", dV = "Please turn your device into portrait mode", xV = "A license error has occurred", EV = "The license cannot be found or has expired", zV = "Make sure there is only one face on the screen.", fV = "No camera with the specified ID found.", CV = "Check if the specified camera ID is correct.", LV = "Turn your head a bit", OV = "Selfie time!", pV = "Center your face, turn your head", SV = "Center your face", vV = "Go", hV = "Center your face", mV = "Error code:", wV = "Good illumination.", kV = "Camera at eye level.", UV = "No accessories: glasses, mask, hat, etc.", QV = "Get ready", YV = "Process completed", bV = "HTTPS not used", PV = "Web Service not compatible", $V = "Remove items covering your face", RV = {
  preparingCamera: XH,
  noCameraPermission: KH,
  holdSteady: qH,
  processing: eV,
  lookStraight: tV,
  moveCloser: rV,
  moveAway: nV,
  retryButtonText: iV,
  letsTryAgainTitle: MV,
  followGuidelinesText: aV,
  allowAccessCamera: oV,
  somethingWentWrong: uV,
  preparingService: sV,
  allowAccessToCamera: lV,
  error: cV,
  tryAgain: IV,
  noCameraAvailable: gV,
  checkCameraConnection: jV,
  ambientLighting: NV,
  noMaskSunglassesHeaddress: DV,
  versionNotSupported: yV,
  updateBrowser: TV,
  onlyPortraitOrientation: AV,
  turnDeviceIntoPortrait: dV,
  licenseError: xV,
  licenseExpired: EV,
  showOnlyOneFace: zV,
  incorrectCameraId: fV,
  checkCameraId: CV,
  turnHead: LV,
  selfieTime: OV,
  centerFaceTurnHead: pV,
  centerFace: SV,
  goButton: vV,
  fitYourFace: hV,
  errorCode: mV,
  illumination: wV,
  cameraLevel: kV,
  noAccessories: UV,
  getReady: QV,
  processCompleted: YV,
  httpNotSupported: bV,
  webServerNotCompatible: PV,
  removeOcclusion: $V
}, HV = "Kamera wird vorbereitet...", VV = "Kamera nicht verfügbar", _V = "Nicht bewegen", ZV = "Bearbeitung...", GV = "Geradeaus schauen", BV = "Näher an die Kamera", FV = "Weiter von der Kamera", WV = "Wiederholung", JV = "Nochmal wiederholen", XV = "Aber bitte folgen Sie den Anweisungen:", KV = "Erlauben Sie den Zugriff auf die Kamera", qV = "Etwas ist schief gelaufen", e_ = "Service wird vorbereitet...", t_ = "Erlauben Sie den Zugriff auf die Kamera und laden Sie diese Seite neu, um fortzufahren.", r_ = "Fehler!", n_ = "Erneut versuchen", i_ = "Keine Kamera vorhanden", M_ = "Überprüfen Sie die Kameraverbindung und versuchen Sie es erneut.", a_ = "Die Umgebungsbeleuchtung ist weder zu hell noch zu dunkel, und es gibt keine Schatten oder Blendungen auf Ihrem Gesicht.", o_ = "Neutraler Gesichtsausdruck (kein Lächeln, Augen offen und Mund geschlossen), keine Maske, Sonnenbrille oder Kopfbedeckung", u_ = "Ihre Browserversion wird nicht unterstützt", s_ = "Aktualisieren Sie Ihre Browserversion", l_ = "Nur im Hochformat", c_ = "Bitte drehen Sie Ihr Gerät in den Hochformatmodus", I_ = "Es ist ein Lizenzfehler aufgetreten", g_ = "Die Lizenz kann nicht gefunden werden oder ist abgelaufen", j_ = "Stellen Sie sicher, dass nur ein Gesicht auf dem Bildschirm zu sehen ist.", N_ = "Keine Kamera mit angegebener ID gefunden", D_ = "Prüfen Sie, ob die angegebene Kamera-ID korrekt ist", y_ = "Kopf ein wenig drehen", T_ = "Zeit für ein Selfie!", A_ = "Das Gesicht zentrieren, den Kopf drehen", d_ = "Zentrieren Sie Ihr Gesicht", x_ = "Weiter", E_ = "Zentrieren Sie Ihr Gesicht", z_ = "Fehlercode:", f_ = "Gute Beleuchtung.", C_ = "Kamera auf Augenhöhe.", L_ = "Keine Accessoires: Brille, Maske, Hut, etc.", O_ = "Bereit machen", p_ = "Prozess abgeschlossen", S_ = "HTTPS nicht verwendet", v_ = "Webdienst nicht kompatibel", h_ = "Entfernen Sie Gegenstände, die Ihr Gesicht bedecken", m_ = {
  preparingCamera: HV,
  noCameraPermission: VV,
  holdSteady: _V,
  processing: ZV,
  lookStraight: GV,
  moveCloser: BV,
  moveAway: FV,
  retryButtonText: WV,
  letsTryAgainTitle: JV,
  followGuidelinesText: XV,
  allowAccessCamera: KV,
  somethingWentWrong: qV,
  preparingService: e_,
  allowAccessToCamera: t_,
  error: r_,
  tryAgain: n_,
  noCameraAvailable: i_,
  checkCameraConnection: M_,
  ambientLighting: a_,
  noMaskSunglassesHeaddress: o_,
  versionNotSupported: u_,
  updateBrowser: s_,
  onlyPortraitOrientation: l_,
  turnDeviceIntoPortrait: c_,
  licenseError: I_,
  licenseExpired: g_,
  showOnlyOneFace: j_,
  incorrectCameraId: N_,
  checkCameraId: D_,
  turnHead: y_,
  selfieTime: T_,
  centerFaceTurnHead: A_,
  centerFace: d_,
  goButton: x_,
  fitYourFace: E_,
  errorCode: z_,
  illumination: f_,
  cameraLevel: C_,
  noAccessories: L_,
  getReady: O_,
  processCompleted: p_,
  httpNotSupported: S_,
  webServerNotCompatible: v_,
  removeOcclusion: h_
}, w_ = "Przygotowywanie kamery...", k_ = "Kamera niedostępna", U_ = "Nie ruszaj się", Q_ = "Przetwarzanie...", Y_ = "Patrz prosto", b_ = "Przysuń się bliżej", P_ = "Odsuń się dalej", $_ = "Powtórz", R_ = "Spróbujmy jeszcze raz", H_ = "Jednak upewnij się, że:", V_ = "Zezwól na dostęp do aparatu", __ = "Coś poszło nie tak", Z_ = "Przygotowanie serwisu...", G_ = "Zezwól na dostęp do aparatu i odśwież tę stronę, aby kontynuować.", B_ = "Błąd!", F_ = "Powtórz próbę", W_ = "Brak aparatu", J_ = "Sprawdź, czy aparat jest włączony i spróbuj ponownie.", X_ = "Oświetlenie nie powinno być zbyt silne/słabe, na twarzy nie powinno być cieni i odblasków", K_ = "Wyraz twarzy powinien być neutralny (bez uśmiechu, usta zamknięte, oczy otwarte). Zdejmij maskę, okulary przeciwsłoneczne, nakrycie głowy", q_ = "Twoja wersja przeglądarki nie jest obsługiwana", eZ = "Zaktualizuj wersję przeglądarki", tZ = "Tylko orientacja portretowa", rZ = "Ustaw urządzenie w orientacji portretowej", nZ = "Błąd licencji", iZ = "Licencja nie została znaleziona lub jest nieważna", MZ = "Upewnij się, że na ekranie znajduje się tylko jedna twarz", aZ = "Nie znaleziono kamery o podanym ID", oZ = "Sprawdź, czy podane ID kamery jest prawidłowe", uZ = "Obróć trochę głowę", sZ = "Czas na selfie!", lZ = "Umieść twarz pośrodku, obróć głowę", cZ = "Umieść twarz pośrodku", IZ = "Rozpocznij", gZ = "Umieść twarz pośrodku", jZ = "Kod błędu:", NZ = "Dobre oświetlenie.", DZ = "Aparat na wysokości oczu.", yZ = "Bez akcesoriów: okularów, masek, kapeluszy itd.", TZ = "Przygotuj się", AZ = "Proces został zakończony", dZ = "HTTPS nie jest wykorzystywany", xZ = "Usługa sieciowa jest niekompatybilna", EZ = "Usuń przedmioty zasłaniające twarz", zZ = {
  preparingCamera: w_,
  noCameraPermission: k_,
  holdSteady: U_,
  processing: Q_,
  lookStraight: Y_,
  moveCloser: b_,
  moveAway: P_,
  retryButtonText: $_,
  letsTryAgainTitle: R_,
  followGuidelinesText: H_,
  allowAccessCamera: V_,
  somethingWentWrong: __,
  preparingService: Z_,
  allowAccessToCamera: G_,
  error: B_,
  tryAgain: F_,
  noCameraAvailable: W_,
  checkCameraConnection: J_,
  ambientLighting: X_,
  noMaskSunglassesHeaddress: K_,
  versionNotSupported: q_,
  updateBrowser: eZ,
  onlyPortraitOrientation: tZ,
  turnDeviceIntoPortrait: rZ,
  licenseError: nZ,
  licenseExpired: iZ,
  showOnlyOneFace: MZ,
  incorrectCameraId: aZ,
  checkCameraId: oZ,
  turnHead: uZ,
  selfieTime: sZ,
  centerFaceTurnHead: lZ,
  centerFace: cZ,
  goButton: IZ,
  fitYourFace: gZ,
  errorCode: jZ,
  illumination: NZ,
  cameraLevel: DZ,
  noAccessories: yZ,
  getReady: TZ,
  processCompleted: AZ,
  httpNotSupported: dZ,
  webServerNotCompatible: xZ,
  removeOcclusion: EZ
}, fZ = "Preparazione della fotocamera in corso...", CZ = "Fotocamera non disponibile", LZ = "Stai fermo", OZ = "Elaborazione...", pZ = "Guarda dritto", SZ = "Avvicinati", vZ = "Allontanati", hZ = "Riprova", mZ = "Prova a ripeterlo un'altra volta", wZ = "Ma per favore segui queste linee guida:", kZ = "Consenti l'accesso alla fotocamera", UZ = "Qualcosa è andato storto", QZ = "Preparazione del servizio...", YZ = "Consenti l'accesso alla fotocamera e ricarica questa pagina per continuare.", bZ = "Errore!", PZ = "Prova di nuovo", $Z = "Non c'è la fotocamera", RZ = "Controlla la connessione della fotocamera e riprova.", HZ = "L'illuminazione ambientale non è né troppo chiara né troppo scura e non ci sono ombre o riflessi sul viso", VZ = "Espressione facciale neutra (nessun sorriso, occhi aperti e bocca chiusa), nessuna mascherina, occhiali da sole o cappello", _Z = "La versione del tuo browser non è supportata", ZZ = "Aggiorna la versione del browser", GZ = "Solo orientamento verticale", BZ = "Gira il tuo dispositivo in modalità verticale", FZ = "Si è verificato un errore di licenza", WZ = "La licenza non è stata trovata o è scaduta", JZ = "Assicurati che ci sia solo un viso sullo schermo", XZ = "Nessuna telecamera trovata con l'ID specificato", KZ = "Verifica se l'ID specificato della telecamera è corretto", qZ = "Volta leggermente la testa", eG = "È l’ora del selfie!", tG = "Centra il viso, gira la testa", rG = "Centra il viso", nG = "Vai", iG = "Centra il viso", MG = "Codice errato:", aG = "Illuminazione buona.", oG = "Fotocamera all'altezza degli occhi.", uG = "Nessun accessorio: occhiali, maschera, cappello, ecc.", sG = "Prepariamoci", lG = "Processo completato", cG = "HTTPS non utilizzato", IG = "Servizio Web non compatibile", gG = "Rimuovi gli oggetti che ti coprono il viso", jG = {
  preparingCamera: fZ,
  noCameraPermission: CZ,
  holdSteady: LZ,
  processing: OZ,
  lookStraight: pZ,
  moveCloser: SZ,
  moveAway: vZ,
  retryButtonText: hZ,
  letsTryAgainTitle: mZ,
  followGuidelinesText: wZ,
  allowAccessCamera: kZ,
  somethingWentWrong: UZ,
  preparingService: QZ,
  allowAccessToCamera: YZ,
  error: bZ,
  tryAgain: PZ,
  noCameraAvailable: $Z,
  checkCameraConnection: RZ,
  ambientLighting: HZ,
  noMaskSunglassesHeaddress: VZ,
  versionNotSupported: _Z,
  updateBrowser: ZZ,
  onlyPortraitOrientation: GZ,
  turnDeviceIntoPortrait: BZ,
  licenseError: FZ,
  licenseExpired: WZ,
  showOnlyOneFace: JZ,
  incorrectCameraId: XZ,
  checkCameraId: KZ,
  turnHead: qZ,
  selfieTime: eG,
  centerFaceTurnHead: tG,
  centerFace: rG,
  goButton: nG,
  fitYourFace: iG,
  errorCode: MG,
  illumination: aG,
  cameraLevel: oG,
  noAccessories: uG,
  getReady: sG,
  processCompleted: lG,
  httpNotSupported: cG,
  webServerNotCompatible: IG,
  removeOcclusion: gG
}, NG = "A kamera előkészítése...", DG = "Nem érhető el kamera", yG = "Tartsa mozdulatlanul", TG = "Feldolgozás...", AG = "Nézzen egyenesen", dG = "Vigye közelebb", xG = "Vigye távolabb", EG = "Újra", zG = "Próbáljuk meg újra", fG = "De kérjük, kövesse a következő utasításokat:", CG = "Hozzáférés engedélyezése kamerához", LG = "Valami félresikerült", OG = "Szolgáltatás előkészítése…", pG = "Hozzáférés engedélyezése a kamerához és az oldal újratöltése a folytatáshoz.", SG = "Hiba!", vG = "Próbálja újra", hG = "Nincs kamera", mG = "Ellnőrizze a kamerát és próbálja újra.", wG = "A környezeti fények nem elég világosak vagy túl sötétek és nincsenek árnyékok, illetve fényvisszaverődés az arcán", kG = "Semleges arckifejezés (mosoly nélkül, nyitott szemmel és csukott szájjal), maszk, napszemüveg vagy fejfedő nélkül", UG = "Nem támogatott a böngésző verziója", QG = "A böngésző frissítse szükséges", YG = "Csak álló tájolás", bG = "Kérjük, fordítsa készülékét álló (arckép) helyzetbe", PG = "Engedélyezési hiba merült fel", $G = "Nem található vagy lejárt az engedély", RG = "Győződjön meg róla, hogy csak egy arc van a képen", HG = "Nem található ilyen azonosítójú kamera", VG = "Ellenőrizze, hogy helyes-e a kamera azonosítója", _G = "Kissé fordítsa el a fejét", ZG = "Szelfizzünk!", GG = "Állítsa középre az arcát, fordítsa el a fejét", BG = "Állítsa középre az arcát", FG = "Kezdjük!", WG = "Állítsa középre az arcát", JG = "Hibakód:", XG = "Jó megvilágítás.", KG = "Kamera a szem vonalában.", qG = "Nincs az arcon kiegészítő: szemüveg, maszk, kalap stb.", eB = "Készüljön fel!", tB = "Befejeződött a folyamat", rB = "HTTPS nincs használatban", nB = "Nem kompatibilis webes szolgáltatás", iB = "Távolítsa el az arcát elfedő dolgokat", MB = {
  preparingCamera: NG,
  noCameraPermission: DG,
  holdSteady: yG,
  processing: TG,
  lookStraight: AG,
  moveCloser: dG,
  moveAway: xG,
  retryButtonText: EG,
  letsTryAgainTitle: zG,
  followGuidelinesText: fG,
  allowAccessCamera: CG,
  somethingWentWrong: LG,
  preparingService: OG,
  allowAccessToCamera: pG,
  error: SG,
  tryAgain: vG,
  noCameraAvailable: hG,
  checkCameraConnection: mG,
  ambientLighting: wG,
  noMaskSunglassesHeaddress: kG,
  versionNotSupported: UG,
  updateBrowser: QG,
  onlyPortraitOrientation: YG,
  turnDeviceIntoPortrait: bG,
  licenseError: PG,
  licenseExpired: $G,
  showOnlyOneFace: RG,
  incorrectCameraId: HG,
  checkCameraId: VG,
  turnHead: _G,
  selfieTime: ZG,
  centerFaceTurnHead: GG,
  centerFace: BG,
  goButton: FG,
  fitYourFace: WG,
  errorCode: JG,
  illumination: XG,
  cameraLevel: KG,
  noAccessories: qG,
  getReady: eB,
  processCompleted: tB,
  httpNotSupported: rB,
  webServerNotCompatible: nB,
  removeOcclusion: iB
}, aB = "正在准备相机", oB = "相机不可用", uB = "持稳", sB = "处理中...", lB = "直看", cB = "靠近点", IB = "移开", gB = "重试", jB = "再试一次", NB = "但请遵循以下准则：", DB = "允许访问相机", yB = "出了问题", TB = "正在准备服务...", AB = "允许访问相机并重新加载此页面以继续。", dB = "错误！", xB = "再试一次", EB = "没有相机", zB = "检查相机的连接，再试一次。", fB = "环境照明不是太亮或太暗，脸上没有阴影或眩光", CB = "中性的面部表情（不笑，睁眼闭嘴），不戴面具、太阳镜或头饰", LB = "不支持您的浏览器版本", OB = "更新您的浏览器版本", pB = "只供肖像方向使用", SB = "请将您的设备转为纵向模式", vB = "发生许可证错误", hB = "无法找到许可证或已过期", mB = "确保屏幕上只有一张脸", wB = "未找到具有指定 ID 的像机", kB = "检查指定的相机ID是否正确", UB = "稍微转过头", QB = "自拍时间！", YB = "把脸居中，转过头", bB = "把脸居中", PB = "开始", $B = "把脸居中", RB = "错误代码：", HB = "良好的照明。", VB = "摄像头在视线水平。", _B = "无配饰：眼镜、口罩、帽子等。", ZB = "准备", GB = "流程完成", BB = "未使用 HTTPS", FB = "网络服务不兼容", WB = "取下遮住脸部的物品", JB = {
  preparingCamera: aB,
  noCameraPermission: oB,
  holdSteady: uB,
  processing: sB,
  lookStraight: lB,
  moveCloser: cB,
  moveAway: IB,
  retryButtonText: gB,
  letsTryAgainTitle: jB,
  followGuidelinesText: NB,
  allowAccessCamera: DB,
  somethingWentWrong: yB,
  preparingService: TB,
  allowAccessToCamera: AB,
  error: dB,
  tryAgain: xB,
  noCameraAvailable: EB,
  checkCameraConnection: zB,
  ambientLighting: fB,
  noMaskSunglassesHeaddress: CB,
  versionNotSupported: LB,
  updateBrowser: OB,
  onlyPortraitOrientation: pB,
  turnDeviceIntoPortrait: SB,
  licenseError: vB,
  licenseExpired: hB,
  showOnlyOneFace: mB,
  incorrectCameraId: wB,
  checkCameraId: kB,
  turnHead: UB,
  selfieTime: QB,
  centerFaceTurnHead: YB,
  centerFace: bB,
  goButton: PB,
  fitYourFace: $B,
  errorCode: RB,
  illumination: HB,
  cameraLevel: VB,
  noAccessories: _B,
  getReady: ZB,
  processCompleted: GB,
  httpNotSupported: BB,
  webServerNotCompatible: FB,
  removeOcclusion: WB
}, XB = "Príprava fotoaparátu...", KB = "Fotoaparát je nedostupný", qB = "A nehýbte sa", eF = "Spracováva sa...", tF = "Pozerajte priamo", rF = "Posuňte bližšie", nF = "Posuňte ďalej", iF = "Znova", MF = "Skúsme to znova", aF = "Postupujte však podľa týchto pokynov:", oF = "Povoliť prístup k fotoaparátu", uF = "Niečo sa pokazilo", sF = "Pripravuje sa služba...", lF = "Ak chcete pokračovať, povoľte prístup k fotoaparátu a znova načítajte túto stránku.", cF = "Chyba!", IF = "Skúste to znova", gF = "Žiadny fotoaparát", jF = "Skontrolujte pripojenie fotoaparátu a skúste to znova.", NF = "Okolité osvetlenie nie je príliš jasné ani príliš tmavé a na vašej tvári nie sú žiadne tiene ani odlesky", DF = "Neutrálny výraz tváre (žiadny úsmev, otvorené oči a zatvorené ústa), žiadna maska, slnečné okuliare ani pokrývka hlavy", yF = "Verzia vášho prehliadača nie je podporovaná", TF = "Aktualizujte verziu prehliadača", AF = "Len orientácia na výšku", dF = "Otočte zariadenie do režimu na výšku", xF = "Vyskytla sa chyba licencie", EF = "Licenciu nie je možné nájsť, prípadne už nie je platná", zF = "Zaistite, aby bola na obrazovke iba jedna tvár", fF = "Nenašiel sa žiadny fotoaparát s určeným ID", CF = "Skontrolujte, či je určené ID fotoaparátu správne", LF = "Trochu otočte hlavu", OF = "Čas na selfie!", pF = "Vycentrujte tvár, otočte hlavu", SF = "Vycentrujte tvár", vF = "Poďme", hF = "Vycentrujte tvár", mF = "Kód chyby:", wF = "Dobré osvetlenie.", kF = "Fotoaparát vo výške očí.", UF = "Žiadne doplnky: okuliare, maska, klobúk atď.", QF = "Pripravte sa", YF = "Spracovanie dokončené", bF = "HTPPS nepoužité", PF = "Webová služba nekompatibilná", $F = "Odstráňte veci zakrývajúce tvár", RF = {
  preparingCamera: XB,
  noCameraPermission: KB,
  holdSteady: qB,
  processing: eF,
  lookStraight: tF,
  moveCloser: rF,
  moveAway: nF,
  retryButtonText: iF,
  letsTryAgainTitle: MF,
  followGuidelinesText: aF,
  allowAccessCamera: oF,
  somethingWentWrong: uF,
  preparingService: sF,
  allowAccessToCamera: lF,
  error: cF,
  tryAgain: IF,
  noCameraAvailable: gF,
  checkCameraConnection: jF,
  ambientLighting: NF,
  noMaskSunglassesHeaddress: DF,
  versionNotSupported: yF,
  updateBrowser: TF,
  onlyPortraitOrientation: AF,
  turnDeviceIntoPortrait: dF,
  licenseError: xF,
  licenseExpired: EF,
  showOnlyOneFace: zF,
  incorrectCameraId: fF,
  checkCameraId: CF,
  turnHead: LF,
  selfieTime: OF,
  centerFaceTurnHead: pF,
  centerFace: SF,
  goButton: vF,
  fitYourFace: hF,
  errorCode: mF,
  illumination: wF,
  cameraLevel: kF,
  noAccessories: UF,
  getReady: QF,
  processCompleted: YF,
  httpNotSupported: bF,
  webServerNotCompatible: PF,
  removeOcclusion: $F
}, HF = "Підготовка камери...", VF = "Камера недоступна", _F = "Не рухайтеся", ZF = "Обробка...", GF = "Дивіться прямо", BF = "Підсуньтеся ближче", FF = "Відсуньтеся подалі", WF = "Повторити", JF = "Давайте спробуємо знову", XF = "Але переконайтеся, будь ласка, що:", KF = "Дозвольте доступ до камери", qF = "Щось пішло не так", eW = "Підготовка сервісу...", tW = "Дозвольте доступ до камери і перезавантажте цю сторінку, щоб продовжити.", rW = "Помилка!", nW = "Спробуйте ще раз", iW = "Камера відсутня", MW = "Перевірте підключення камери і спробуйте знову.", aW = "Освітлення не повинно бути занадто яскравим/тьмяним, на обличчі не повинно бути тіней і відблисків", oW = "Вираз обличчя має бути нейтральним (без посмішки, рот закритий, очі відкриті). Зніміть маску, сонцезахисні окуляри, головний убір", uW = "Версія вашого браузера не підтримується", sW = "Оновіть версію вашого браузера", lW = "Лише портретна орієнтація", cW = "Поверніть пристрій у портретний режим", IW = "Помилка ліцензії", gW = "Ліцензію не знайдено або вона не є дійсною", jW = "Переконайтеся, що на екрані є лише одна особа", NW = "Камеру з заданим ID не знайдено", DW = "Перевірте правильність заданого ID камери", yW = "Трохи поверніть голову", TW = "Час для селфі!", AW = "Розташуйте обличчя в центрі, поверніть голову", dW = "Розташуйте обличчя в центрі", xW = "Розпочати", EW = "Розташуйте обличчя в центрі", zW = "Код помилки:", fW = "Гарне освітлення.", CW = "Камера на рівні очей.", LW = "Жодних аксесуарів: окулярів, маски, капелюха і т.д.", OW = "Приготуйтеся", pW = "Процес завершено", SW = "HTTPS не використовується", vW = "Веб-сервіс є несумісним", hW = "Видаліть предмети, що закривають обличчя", mW = {
  preparingCamera: HF,
  noCameraPermission: VF,
  holdSteady: _F,
  processing: ZF,
  lookStraight: GF,
  moveCloser: BF,
  moveAway: FF,
  retryButtonText: WF,
  letsTryAgainTitle: JF,
  followGuidelinesText: XF,
  allowAccessCamera: KF,
  somethingWentWrong: qF,
  preparingService: eW,
  allowAccessToCamera: tW,
  error: rW,
  tryAgain: nW,
  noCameraAvailable: iW,
  checkCameraConnection: MW,
  ambientLighting: aW,
  noMaskSunglassesHeaddress: oW,
  versionNotSupported: uW,
  updateBrowser: sW,
  onlyPortraitOrientation: lW,
  turnDeviceIntoPortrait: cW,
  licenseError: IW,
  licenseExpired: gW,
  showOnlyOneFace: jW,
  incorrectCameraId: NW,
  checkCameraId: DW,
  turnHead: yW,
  selfieTime: TW,
  centerFaceTurnHead: AW,
  centerFace: dW,
  goButton: xW,
  fitYourFace: EW,
  errorCode: zW,
  illumination: fW,
  cameraLevel: CW,
  noAccessories: LW,
  getReady: OW,
  processCompleted: pW,
  httpNotSupported: SW,
  webServerNotCompatible: vW,
  removeOcclusion: hW
}, wW = "Caméra en préparation...", kW = "Caméra indisponible", UW = "Ne bougez plus", QW = "Analyse...", YW = "Regardez la caméra", bW = "Rapprochez", PW = "Eloignez", $W = "Réessayez", RW = "Essayez à nouveau", HW = "Veuillez suivre les instructions:", VW = "Autoriser l'accès à la caméra", _W = "Anomalie", ZW = "Préparation...", GW = "Autoriser l'accès à la caméra, et recharger cette page pour continuer.", BW = "Erreur!", FW = "Réessayer", WW = "Caméra introuvable", JW = "Vérifier la connexion à la caméra et réessayer.", XW = "La lumière ambiante ne doit pas être trop faible ou trop forte, et il ne doit pas y avoir d'ombres ou de reflets sur votre visage", KW = "Expression neutre (pas de sourire, yeux ouverts et bouche fermée), pas de masque, lunettes de soleil, ou couvre-chef", qW = "Version de navigateur non compatible", eJ = "Veuillez mettre à jour votre navigateur", tJ = "Orientation portrait seulement", rJ = "Veuillez tourner votre mobile en mode portrait", nJ = "Erreur de licence", iJ = "License introuvable ou expirée", MJ = "Assurez-vous qu'un seul visage apparaît à l'écran", aJ = "Aucune caméra ayant l'ID spécifié", oJ = "Vérifier que l'ID de caméra spécifié est correct", uJ = "Tournez légèrement la tête", sJ = "Démarrage du selfie!", lJ = "Centrez votre visage, tournez la tête", cJ = "Centrez votre visage", IJ = "Lancer", gJ = "Centrez votre visage", jJ = "Code d'erreur:", NJ = "Illumination correcte.", DJ = "Camera à hauteur des yeux.", yJ = "Pas d'accessoires: lunettes, masque, chapeau, casquette, etc.", TJ = "Prêt", AJ = "Traitement termin", dJ = "HTTPS non utilis", xJ = "Web Service non compatible", EJ = "Dégager le visage de toute obstruction", zJ = {
  preparingCamera: wW,
  noCameraPermission: kW,
  holdSteady: UW,
  processing: QW,
  lookStraight: YW,
  moveCloser: bW,
  moveAway: PW,
  retryButtonText: $W,
  letsTryAgainTitle: RW,
  followGuidelinesText: HW,
  allowAccessCamera: VW,
  somethingWentWrong: _W,
  preparingService: ZW,
  allowAccessToCamera: GW,
  error: BW,
  tryAgain: FW,
  noCameraAvailable: WW,
  checkCameraConnection: JW,
  ambientLighting: XW,
  noMaskSunglassesHeaddress: KW,
  versionNotSupported: qW,
  updateBrowser: eJ,
  onlyPortraitOrientation: tJ,
  turnDeviceIntoPortrait: rJ,
  licenseError: nJ,
  licenseExpired: iJ,
  showOnlyOneFace: MJ,
  incorrectCameraId: aJ,
  checkCameraId: oJ,
  turnHead: uJ,
  selfieTime: sJ,
  centerFaceTurnHead: lJ,
  centerFace: cJ,
  goButton: IJ,
  fitYourFace: gJ,
  errorCode: jJ,
  illumination: NJ,
  cameraLevel: DJ,
  noAccessories: yJ,
  getReady: TJ,
  processCompleted: AJ,
  httpNotSupported: dJ,
  webServerNotCompatible: xJ,
  removeOcclusion: EJ
}, fJ = "Preparando la cámara...", CJ = "Cámara no disponible", LJ = "Quédese quieto", OJ = "Procesamiento...", pJ = "Mire hacia adelante", SJ = "Acérquese", vJ = "Aléjese", hJ = "Reintentar", mJ = "Inténtelo de nuevo", wJ = "Por favor, asegúrese de que:", kJ = "Permita el acceso a la cámara", UJ = "Algo salió mal", QJ = "Preparando el servicio...", YJ = "Permita el acceso a la cámara y recargue esta página para continuar.", bJ = "¡Error!", PJ = "Inténtelo de nuevo", $J = "No hay cámara disponible", RJ = "Compruebe la conexión de la cámara y vuelva a intentarlo.", HJ = "La iluminación ambiental no debe ser ni demasiado brillante ni demasiado oscura y no debe haber sombras ni brillos en el rostro.", VJ = "La expresión facial debe ser neutra (sin sonrisa, con los ojos abiertos y la boca cerrada), sin máscara, gafas de sol o prendas en la cabeza.", _J = "La versión de su navegador no es compatible", ZJ = "Actualice la versión de su navegador", GJ = "Sólo orientación vertical", BJ = "Por favor, gire su dispositivo al modo vertical", FJ = "Se ha producido un error de licencia", WJ = "La licencia no se encuentra o ha expirado", JJ = "Asegúrese de que solo hay un rostro en la pantalla", XJ = "La cámara con el identificador especificado no encontrada", KJ = "Compruebe si el identificador especificado de la cámara es correcto", qJ = "Gire un poco la cabeza", eX = "¡Hora de hacer un selfie!", tX = "Centre su rostro, gire la cabeza", rX = "Centre su rostro", nX = "Empezar", iX = "Centre su rostro", MX = "Сódigo de error:", aX = "Buena iluminación.", oX = "Cámara al nivel de los ojos.", uX = "Sin accesorios: gafas, máscara, sombrero, etc.", sX = "Prepárese", lX = "Proceso completado", cX = "HTTPS no utilizado", IX = "Servicio Web no compatible", gX = "Remueva los objetos que cubren su rostro", jX = {
  preparingCamera: fJ,
  noCameraPermission: CJ,
  holdSteady: LJ,
  processing: OJ,
  lookStraight: pJ,
  moveCloser: SJ,
  moveAway: vJ,
  retryButtonText: hJ,
  letsTryAgainTitle: mJ,
  followGuidelinesText: wJ,
  allowAccessCamera: kJ,
  somethingWentWrong: UJ,
  preparingService: QJ,
  allowAccessToCamera: YJ,
  error: bJ,
  tryAgain: PJ,
  noCameraAvailable: $J,
  checkCameraConnection: RJ,
  ambientLighting: HJ,
  noMaskSunglassesHeaddress: VJ,
  versionNotSupported: _J,
  updateBrowser: ZJ,
  onlyPortraitOrientation: GJ,
  turnDeviceIntoPortrait: BJ,
  licenseError: FJ,
  licenseExpired: WJ,
  showOnlyOneFace: JJ,
  incorrectCameraId: XJ,
  checkCameraId: KJ,
  turnHead: qJ,
  selfieTime: eX,
  centerFaceTurnHead: tX,
  centerFace: rX,
  goButton: nX,
  fitYourFace: iX,
  errorCode: MX,
  illumination: aX,
  cameraLevel: oX,
  noAccessories: uX,
  getReady: sX,
  processCompleted: lX,
  httpNotSupported: cX,
  webServerNotCompatible: IX,
  removeOcclusion: gX
}, NX = "Preparando a câmara...", DX = "Camera não disponivel", yX = "Mantenha-se imóvel", TX = "A processar...", AX = "Olhe diretamente", dX = "Aproxime-se", xX = "Afaste-se", EX = "Tente outra vez", zX = "Vamos tentar de novo", fX = "Mas, siga estas orientações:", CX = "Permita o acesso à câmara", LX = "Algo correu mal", OX = "Preparando o serviço...", pX = "Permita o acesso à câmara e volte a carregar esta página para continuar.", SX = "Erro!", vX = "Tente outra vez", hX = "Não há câmara", mX = "Verifique a ligação da câmara e tente novamente.", wX = "A iluminação ambiente não é demasiado brilhante ou demasiado escura e não há sombras ou clarões no seu rosto", kX = "Expressão facial neutra (sem sorrisos, olhos abertos e boca fechada), sem máscara, óculos de sol ou touca", UX = "A versão do seu navegador não é compatível", QX = "Atualize a versão do seu navegador", YX = "Orientação de retrato apenas", bX = "Por favor, coloque seu dispositivo no modo retrato", PX = "Ocorreu um erro de licença", $X = "A licença não pode ser encontrada ou expirou", RX = "Verifique se há apenas um rosto na tela", HX = "Não foi encontrada nenhuma câmara com o ID especificado", VX = "Verifique se a ID da câmara especificada está correta", _X = "Vire um pouco a cabeça", ZX = "Hora da selfie!", GX = "Centralize o seu rosto, vire a cabeça", BX = "Centralize o seu rosto", FX = "Vamos", WX = "Centralize o seu rosto", JX = "Código de erro:", XX = "Boa iluminação.", KX = "Câmara ao nível dos olhos.", qX = "Sem acessórios: óculos, máscara, chapéu, etc.", eK = "Comece", tK = "Processo concluído", rK = "HTTPS não utilizado", nK = "Serviço web não compatível", iK = "Retire os objetos que cobrem o rosto", MK = {
  preparingCamera: NX,
  noCameraPermission: DX,
  holdSteady: yX,
  processing: TX,
  lookStraight: AX,
  moveCloser: dX,
  moveAway: xX,
  retryButtonText: EX,
  letsTryAgainTitle: zX,
  followGuidelinesText: fX,
  allowAccessCamera: CX,
  somethingWentWrong: LX,
  preparingService: OX,
  allowAccessToCamera: pX,
  error: SX,
  tryAgain: vX,
  noCameraAvailable: hX,
  checkCameraConnection: mX,
  ambientLighting: wX,
  noMaskSunglassesHeaddress: kX,
  versionNotSupported: UX,
  updateBrowser: QX,
  onlyPortraitOrientation: YX,
  turnDeviceIntoPortrait: bX,
  licenseError: PX,
  licenseExpired: $X,
  showOnlyOneFace: RX,
  incorrectCameraId: HX,
  checkCameraId: VX,
  turnHead: _X,
  selfieTime: ZX,
  centerFaceTurnHead: GX,
  centerFace: BX,
  goButton: FX,
  fitYourFace: WX,
  errorCode: JX,
  illumination: XX,
  cameraLevel: KX,
  noAccessories: qX,
  getReady: eK,
  processCompleted: tK,
  httpNotSupported: rK,
  webServerNotCompatible: nK,
  removeOcclusion: iK
}, aK = "تحضير الكاميرا...", oK = "الكاميرا  غير متاحة!", uK = "ابق ثابتًا", sK = "جاري المعالجة...", lK = "أنظر الى الأمام", cK = "إقترب أكثر", IK = "إبتعد", gK = "أعاد المحاكمة", jK = "دعونا نحاول ذلك مرة أخرى", NK = "لكن يرجى اتباع هذه الإرشادات:", DK = "اسمح بالوصول إلى الكاميرا", yK = "شيء سار على نحو خاطئ", TK = "تجهيز الخدمة...", AK = "اسمح بالوصول إلى الكاميرا وأعد تحميل هذه الصفحة للمتابعة.", dK = "خطأ!", xK = "حاول مرة أخرى", EK = "الكاميرا غير موجودة", zK = "تحقق من اتصال الكاميرا وحاول مرة أخرى.", fK = "يجب ألا تكون الإضاءة المحيطة ساطعة جدًا أو مظلمة للغاية، ويتعين التأكد من عدم وجود ظلال أو وهج على وجهك", CK = "يجب أن تكون تعبيرات وجه محايدة (بدون ابتسامة، العيون مفتوحة والفم مغلق)، بدون قناع أو نظارات شمسية أو عمرة للرأس", LK = "إصدار المتصفح الخاص بك غير مدعوم", OK = "يرجى تحديث إصدار متصفحك", pK = "اتجاه عمودي فقط", SK = "يرجى تحويل جهازك إلى الوضع العمودي", vK = "حدث خطأ في الترخيص", hK = "لا يتم العثور على الترخيص أو انتهت صلاحيته", mK = "تأكد من وجود وجه واحد فقط على الشاشة", wK = "لا يتم العثور على الكاميرا ذات المعرّف المحدد", kK = "تحقق مما إذا كان معرف الكاميرا المحدد صحيحًا.", UK = "حرك رأسك قليلا", QK = "وقت السيلفي!", YK = "مركز وجهك، أدر رأسك", bK = "مركز وجهك", PK = "لنبدأ", $K = "مركز وجهك", RK = "رمز الخطأ:", HK = "إضاءة جيدة.", VK = "الكاميرا على مستوى العينين.", _K = "لا توجد زينات: نظارات، قناع، قبعة وما إلى ذلك", ZK = "استعد", GK = "اكتملت العملية", BK = "HTTPS غير مستخدم", FK = "خدمة الويب غير متوافقة", WK = "أزل العناصر التي تغطي وجهك", JK = {
  preparingCamera: aK,
  noCameraPermission: oK,
  holdSteady: uK,
  processing: sK,
  lookStraight: lK,
  moveCloser: cK,
  moveAway: IK,
  retryButtonText: gK,
  letsTryAgainTitle: jK,
  followGuidelinesText: NK,
  allowAccessCamera: DK,
  somethingWentWrong: yK,
  preparingService: TK,
  allowAccessToCamera: AK,
  error: dK,
  tryAgain: xK,
  noCameraAvailable: EK,
  checkCameraConnection: zK,
  ambientLighting: fK,
  noMaskSunglassesHeaddress: CK,
  versionNotSupported: LK,
  updateBrowser: OK,
  onlyPortraitOrientation: pK,
  turnDeviceIntoPortrait: SK,
  licenseError: vK,
  licenseExpired: hK,
  showOnlyOneFace: mK,
  incorrectCameraId: wK,
  checkCameraId: kK,
  turnHead: UK,
  selfieTime: QK,
  centerFaceTurnHead: YK,
  centerFace: bK,
  goButton: PK,
  fitYourFace: $K,
  errorCode: RK,
  illumination: HK,
  cameraLevel: VK,
  noAccessories: _K,
  getReady: ZK,
  processCompleted: GK,
  httpNotSupported: BK,
  webServerNotCompatible: FK,
  removeOcclusion: WK
}, XK = "De camera aan het voorbereiden...", KK = "Camera onbeschikbaar", qK = "Blijf stil", eq = "Bezig met verwerken...", tq = "Kijk recht vooruit", rq = "Kom dichter", nq = "Ga verder weg", iq = "Probeer opnieuw", Mq = "Laten we dat nog eens proberen", aq = "Maar volg deze richtlijnen:", oq = "Sta toegang tot de camera toe", uq = "Er ging iets fout", sq = "Voorbereiding van de dienst...", lq = "Sta toegang to de camera toe en laad de pagina opnieuw om door te gaan.", cq = "Fout!", Iq = "Probeer opnieuw", gq = "Er is geen camera", jq = "Controleer de cameraverbinding en probeer het opnieuw.", Nq = "Het omgevingslicht is niet te fel of te donker en er zijn geen schaduwen of schitteringen op uw gezicht", Dq = "Neutrale gelaatsuitdrukking (niet glimlachen, ogen open en mond dicht), geen masker, zonnebril of hoofddeksel", yq = "Uw browserversie wordt niet ondersteund", Tq = "Update uw browserversie", Aq = "Alleen portretstand", dq = "Zet uw toestel in portretstand", xq = "Er is een licentiefout opgetreden", Eq = "De licentie kan niet gevonden worden of is verlopen", zq = "Zorg ervoor dat er maar één gezicht op het scherm staat", fq = "Geen camera met de opgegeven ID gevonden", Cq = "Controleren of de opgegeven camera-ID juist is", Lq = "Draai uw hoofd een beetje", Oq = "Tijd voor een selfie!", pq = "Centreer uw gezicht, draai uw hoofd", Sq = "Centreer uw gezicht", vq = "Ga van start", hq = "Centreer uw gezicht", mq = "Foutcode:", wq = "Goede belichting", kq = "Camera op oogzicht", Uq = "Geen accessoires: bril, masker, hoed, enz.", Qq = "Maak u klaar", Yq = "Proces voltooid", bq = "HTTPS niet gebruikt", Pq = "Webservice niet compatibel", $q = "Verwijder items die uw gezicht bedekken", Rq = {
  preparingCamera: XK,
  noCameraPermission: KK,
  holdSteady: qK,
  processing: eq,
  lookStraight: tq,
  moveCloser: rq,
  moveAway: nq,
  retryButtonText: iq,
  letsTryAgainTitle: Mq,
  followGuidelinesText: aq,
  allowAccessCamera: oq,
  somethingWentWrong: uq,
  preparingService: sq,
  allowAccessToCamera: lq,
  error: cq,
  tryAgain: Iq,
  noCameraAvailable: gq,
  checkCameraConnection: jq,
  ambientLighting: Nq,
  noMaskSunglassesHeaddress: Dq,
  versionNotSupported: yq,
  updateBrowser: Tq,
  onlyPortraitOrientation: Aq,
  turnDeviceIntoPortrait: dq,
  licenseError: xq,
  licenseExpired: Eq,
  showOnlyOneFace: zq,
  incorrectCameraId: fq,
  checkCameraId: Cq,
  turnHead: Lq,
  selfieTime: Oq,
  centerFaceTurnHead: pq,
  centerFace: Sq,
  goButton: vq,
  fitYourFace: hq,
  errorCode: mq,
  illumination: wq,
  cameraLevel: kq,
  noAccessories: Uq,
  getReady: Qq,
  processCompleted: Yq,
  httpNotSupported: bq,
  webServerNotCompatible: Pq,
  removeOcclusion: $q
}, Hq = "Menyiapkan kamera...", Vq = "Kamera tidak tersedia", _q = "Diam tidak bergerak", Zq = "Memproses...", Gq = "Lihat ke depan", Bq = "Geser mendekat", Fq = "Geser menjauh", Wq = "Coba lagi", Jq = "Mari kita coba lagi", Xq = "Tetapi, harap ikuti panduan ini:", Kq = "Izinkan akses ke kamera", qq = "Terjadi kesalahan", eee = "Menyiapkan layanan", tee = "Izinkan akses ke kamera dan muat ulang halaman ini untuk melanjutkan.", ree = "Kesalahan!", nee = "Coba lagi", iee = "Tidak ada kamera", Mee = "Periksa koneksi kamera dan coba lagi", aee = "Cahaya sekitar tidak terlalu terang dan terlalu gelap dan tidak ada bayangan atau pantulan cahaya pada wajah Anda", oee = "Ekspresi wajah netral (tidak tersenyum, mata terbuka, dan mulut tertutup), tidak menggunakan masker, kacamata, dan penutup kepala", uee = "Versi browser Anda tidak didukung", see = "Perbarui versi browser Anda", lee = "Hanya orientasi potret", cee = "Silakan putar perangkat Anda ke mode potret", Iee = "Terjadi kesalahan lisensi", gee = "Lisensi tidak dapat ditemukan atau telah habis masa berlakunya", jee = "Pastikan hanya ada satu wajah di layar", Nee = "Tidak ditemukan kamera dengan ID yang disebutkan", Dee = "Periksa apakah ID kamera yang disebutkan benar", yee = "Tengokkan sedikit kepala Anda", Tee = "Waktu swafoto!", Aee = "Pusatkan wajah Anda, tengokkan kepala Anda", dee = "Pusatkan wajah Anda", xee = "Mulai", Eee = "Pusatkan wajah Anda", zee = "Kode kesalahan:", fee = "Ilmuniasi bagus.", Cee = "Kamera di level mata.", Lee = "Tanpa aksesori: kacamata, masker, topi, dll.", Oee = "Bersiap", pee = "Proses selesai", See = "HTTPS tidak digunakan", vee = "Layanan Web tidak kompatibel", hee = "Hapus item yang menutupi wajah Anda", mee = {
  preparingCamera: Hq,
  noCameraPermission: Vq,
  holdSteady: _q,
  processing: Zq,
  lookStraight: Gq,
  moveCloser: Bq,
  moveAway: Fq,
  retryButtonText: Wq,
  letsTryAgainTitle: Jq,
  followGuidelinesText: Xq,
  allowAccessCamera: Kq,
  somethingWentWrong: qq,
  preparingService: eee,
  allowAccessToCamera: tee,
  error: ree,
  tryAgain: nee,
  noCameraAvailable: iee,
  checkCameraConnection: Mee,
  ambientLighting: aee,
  noMaskSunglassesHeaddress: oee,
  versionNotSupported: uee,
  updateBrowser: see,
  onlyPortraitOrientation: lee,
  turnDeviceIntoPortrait: cee,
  licenseError: Iee,
  licenseExpired: gee,
  showOnlyOneFace: jee,
  incorrectCameraId: Nee,
  checkCameraId: Dee,
  turnHead: yee,
  selfieTime: Tee,
  centerFaceTurnHead: Aee,
  centerFace: dee,
  goButton: xee,
  fitYourFace: Eee,
  errorCode: zee,
  illumination: fee,
  cameraLevel: Cee,
  noAccessories: Lee,
  getReady: Oee,
  processCompleted: pee,
  httpNotSupported: See,
  webServerNotCompatible: vee,
  removeOcclusion: hee
}, wee = "Đang chuẩn bị camera...", kee = "Camera không có sẵn", Uee = "Giữ yên", Qee = "Đang xử lý...", Yee = "Nhìn thẳng", bee = "Di chuyển tới gần hơn", Pee = "Di chuyển ra xa hơn", $ee = "Thử lại", Ree = "Hãy thử lại", Hee = "Nhưng vui lòng làm theo các hướng dẫn này:", Vee = "Cho phép truy cập camera", _ee = "Có lỗi xảy ra", Zee = "Đang chuẩn bị dịch vụ...", Gee = "Cho phép truy cập camera và tải lại trang này để tiếp tục.", Bee = "Có lỗi!", Fee = "Thử lại", Wee = "Không có camera", Jee = "Kiểm tra kết nối camera và thử lại.", Xee = "Ánh sáng nền không quá sáng hay quá tối, khuôn mặt không có bóng hay bị lóe sáng", Kee = "Nét mặt trung tính (không cười, mắt mở, miệng khép), không đeo khẩu trang, kính râm hay mũ", qee = "Phiên bản trình duyệt của bạn không được hỗ trợ", ete = "Cập nhật phiên bản trình duyệt của bạn", tte = "Chỉ theo hướng dọc", rte = "Vui lòng bật chế độ chân dung trên thiết bị của bạn", nte = "Đã xảy ra lỗi giấy phép", ite = "Không tìm thấy giấy phép hoặc giấy phép đã hết hạn", Mte = "Đảm bảo chỉ có một khuôn mặt trên màn hình", ate = "Không tìm thấy camera nào có ID đã nêu", ote = "Kiểm tra xem ID camera đã nêu có đúng không", ute = "Xoay đầu bạn một chút", ste = "Selfie thôi!", lte = "Chỉnh khuôn mặt chính diện, xoay đầu", cte = "Chỉnh khuôn mặt chính diện", Ite = "Đi thôi", gte = "Chỉnh khuôn mặt chính diện", jte = "Mã lỗi:", Nte = "Độ sáng tốt.", Dte = "Camera ở tầm mắt.", yte = "Không phụ kiện: kính, mặt nạ, mũ, v.v.", Tte = "Sẵn sàng", Ate = "Quá trình đã hoàn tất", dte = "HTTPS không được sử dụng", xte = "Dịch vụ Web không tương thích", Ete = "Gỡ bỏ các vật che mặt của bạn", zte = {
  preparingCamera: wee,
  noCameraPermission: kee,
  holdSteady: Uee,
  processing: Qee,
  lookStraight: Yee,
  moveCloser: bee,
  moveAway: Pee,
  retryButtonText: $ee,
  letsTryAgainTitle: Ree,
  followGuidelinesText: Hee,
  allowAccessCamera: Vee,
  somethingWentWrong: _ee,
  preparingService: Zee,
  allowAccessToCamera: Gee,
  error: Bee,
  tryAgain: Fee,
  noCameraAvailable: Wee,
  checkCameraConnection: Jee,
  ambientLighting: Xee,
  noMaskSunglassesHeaddress: Kee,
  versionNotSupported: qee,
  updateBrowser: ete,
  onlyPortraitOrientation: tte,
  turnDeviceIntoPortrait: rte,
  licenseError: nte,
  licenseExpired: ite,
  showOnlyOneFace: Mte,
  incorrectCameraId: ate,
  checkCameraId: ote,
  turnHead: ute,
  selfieTime: ste,
  centerFaceTurnHead: lte,
  centerFace: cte,
  goButton: Ite,
  fitYourFace: gte,
  errorCode: jte,
  illumination: Nte,
  cameraLevel: Dte,
  noAccessories: yte,
  getReady: Tte,
  processCompleted: Ate,
  httpNotSupported: dte,
  webServerNotCompatible: xte,
  removeOcclusion: Ete
}, fte = "카메라 준비 중...", Cte = "카메라를 사용할 수 없음", Lte = "움직이지 않기", Ote = "처리 중...", pte = "앞을 똑바로 보기", Ste = "더 가까이 이동", vte = "멀리 이동", hte = "재시도", mte = "다시 시도하세요", wte = "하지만 이 가이드라인을 따르세요:", kte = "카메라에 액세스 허용", Ute = "오류가 발생했습니다", Qte = "서비스 준비 중...", Yte = "카메라에 대한 액세스를 허용하고 이 페이지를 재로드하여 계속하십시오.", bte = "오류!", Pte = "다시 시도", $te = "카메라가 없습니다", Rte = "카메라 연결을 확인하고 다시 시도하십시오.", Hte = "주변 조명이 너무 밝지도 너무 어둡지 않아서 얼굴에 그림자나 눈부심이 없습니다", Vte = "무표정(미소 없음, 눈 떠 있음 및 입을 다뭄), 마스크, 선글라스 또는 모자 없음", _te = "사용 중인 브라우저는 지원되지 않습니다", Zte = "브라우저 버전을 업데이트하십시오", Gte = "세로 방향 전용", Bte = "장치를 세로 모드로 전환하십시오", Fte = "라이선스 오류가 발생했습니다", Wte = "라이선스를 찾을 수 없거나 만료되었습니다", Jte = "화면에는 얼굴이 하나만 있어야 합니다", Xte = "지정된 ID가 있는 카메라를 찾을 수 없음", Kte = "지정된 카메라 ID가 정확한지 확인하십시오", qte = "머리를 약간 돌리세요", ere = "셀카 타임!", tre = "얼굴을 가운데로 하고, 머리를 돌리세요", rre = "얼굴을 가운데로 위치하세요", nre = "시작", ire = "얼굴을 가운데로 위치하세요", Mre = "오류 코드:", are = "조명 밝기 양호.", ore = "카메라를 눈높이에 맞추세요.", ure = "액세서리 금지: 안경, 마스크, 모자 등", sre = "준비하십시오", lre = "프로세스 완료됨", cre = "HTTPS가 사용되지 않음", Ire = "웹 서비스가 호환되지 않음", gre = "얼굴을 가리는 물건 제거하십시오", jre = {
  preparingCamera: fte,
  noCameraPermission: Cte,
  holdSteady: Lte,
  processing: Ote,
  lookStraight: pte,
  moveCloser: Ste,
  moveAway: vte,
  retryButtonText: hte,
  letsTryAgainTitle: mte,
  followGuidelinesText: wte,
  allowAccessCamera: kte,
  somethingWentWrong: Ute,
  preparingService: Qte,
  allowAccessToCamera: Yte,
  error: bte,
  tryAgain: Pte,
  noCameraAvailable: $te,
  checkCameraConnection: Rte,
  ambientLighting: Hte,
  noMaskSunglassesHeaddress: Vte,
  versionNotSupported: _te,
  updateBrowser: Zte,
  onlyPortraitOrientation: Gte,
  turnDeviceIntoPortrait: Bte,
  licenseError: Fte,
  licenseExpired: Wte,
  showOnlyOneFace: Jte,
  incorrectCameraId: Xte,
  checkCameraId: Kte,
  turnHead: qte,
  selfieTime: ere,
  centerFaceTurnHead: tre,
  centerFace: rre,
  goButton: nre,
  fitYourFace: ire,
  errorCode: Mre,
  illumination: are,
  cameraLevel: ore,
  noAccessories: ure,
  getReady: sre,
  processCompleted: lre,
  httpNotSupported: cre,
  webServerNotCompatible: Ire,
  removeOcclusion: gre
}, Nre = "Menyediakan kamera...", Dre = "Kamera tidak tersedia", yre = "Pegang dengan stabil", Tre = "Sedang diproses...", Are = "Pandang tegak", dre = "Dekatkan", xre = "Jauhkan", Ere = "Cuba lagi", zre = "Mari kita cuba lagi", fre = "Tetapi sila ikut arahan berikut:", Cre = "Benarkan akses ke kamera", Lre = "Ada masalah", Ore = "Menyediakan perkhidmatan...", pre = "Benarkan akses ke kamera dan muat semula halaman ini untuk bermula.", Sre = "Ralat!", vre = "Sila cuba lagi", hre = "Tiada kamera", mre = "Semak sambungan kamera dan cuba lagi.", wre = "Pencahayaan persekitaran tidak terlalu terang atau terlalu gelap dan tidak ada bayangan atau silau pada muka", kre = "Ekspresi wajah neutral (tidak tersenyum, mata terbuka dan mulut ditutup), tanpa topeng, cermin mata hitam atau hiasan kepala", Ure = "Versi pelayar web anda tidak disokong", Qre = "Sila kemas kini versi pelayar web anda", Yre = "Orientasi potret sahaja", bre = "Sila tetapkan peranti anda kepada mod potret", Pre = "Lalat lesen belaku", $re = "Lesen tidak dapat dicari atau telah tamat tempoh", Rre = "Sila pastikan hanya ada satu muka pada skrin", Hre = "Tiada kamera dengan ID yang ditentukan ditemui", Vre = "Sila semak sama ada ID kamera yang dinyatakan adalah betul", _re = "Pusingkan kepala anda sedikit", Zre = "Masa selfie!", Gre = "Ketengahkan muka anda, pusing kepala anda", Bre = "Ketengahkan muka anda", Fre = "Mula", Wre = "Ketengahkan muka anda", Jre = "Kod ralat:", Xre = "Pencahayaan yang baik.", Kre = "Kamera pada paras mata.", qre = "Tiada aksesori: cermin mata, topeng, topi, dll.", ene = "Bersedia", tne = "Proses selesai", rne = "HTTPS tidak digunakan", nne = "Perkhidmatan Web tidak serasi", ine = "Alihkan barang yang menutupi muka anda", Mne = {
  preparingCamera: Nre,
  noCameraPermission: Dre,
  holdSteady: yre,
  processing: Tre,
  lookStraight: Are,
  moveCloser: dre,
  moveAway: xre,
  retryButtonText: Ere,
  letsTryAgainTitle: zre,
  followGuidelinesText: fre,
  allowAccessCamera: Cre,
  somethingWentWrong: Lre,
  preparingService: Ore,
  allowAccessToCamera: pre,
  error: Sre,
  tryAgain: vre,
  noCameraAvailable: hre,
  checkCameraConnection: mre,
  ambientLighting: wre,
  noMaskSunglassesHeaddress: kre,
  versionNotSupported: Ure,
  updateBrowser: Qre,
  onlyPortraitOrientation: Yre,
  turnDeviceIntoPortrait: bre,
  licenseError: Pre,
  licenseExpired: $re,
  showOnlyOneFace: Rre,
  incorrectCameraId: Hre,
  checkCameraId: Vre,
  turnHead: _re,
  selfieTime: Zre,
  centerFaceTurnHead: Gre,
  centerFace: Bre,
  goButton: Fre,
  fitYourFace: Wre,
  errorCode: Jre,
  illumination: Xre,
  cameraLevel: Kre,
  noAccessories: qre,
  getReady: ene,
  processCompleted: tne,
  httpNotSupported: rne,
  webServerNotCompatible: nne,
  removeOcclusion: ine
}, ane = "Se pregătește camera...", one = "Camera e indisponibilă", une = "Stați nemișcat", sne = "Se procesează...", lne = "Priviți înainte", cne = "Apropiați-vă", Ine = "Îndepărtați-vă", gne = "Reîncercare", jne = "Să mai încercăm o dată", Nne = "Dar vă rugăm urmăriți recomandările:", Dne = "Permiteți accesul la cameră", yne = "Ceva n-a mers bine", Tne = "Pregătirea serviciului...", Ane = "Permiteți accesul la cameră și reîncărcați această pagină pentru a continua.", dne = "Eroare!", xne = "Încercați încă o dată", Ene = "Nu există cameră", zne = "Verificați conexiunea la cameră și încercați din nou.", fne = "Iluminarea ambientală să nu fie nici prea puternică, nici prea întunecată și să nu existe umbre sau străluciri pe fața dvs.", Cne = "Expresie facială neutră (fără zâmbet, ochii deschiși și gura închisă), fără mască sau ochelari de soare și fără nimic pe cap", Lne = "Versiunea browserului dvs. nu este acceptată", One = "Actualizați versiunea browserului", pne = "Doar orientarea tip portret", Sne = "Vă rugăm rotiți dispozitivul în modul portret", vne = "Am întâmpinat o eroare de licențiere", hne = "Licența nu poate fi găsită sau a expirat", mne = "Asigurați-vă că apare o singură față pe ecran", wne = "Nu a fost găsită nicio cameră cu ID-ul specificat", kne = "Verificați dacă este corect ID-ul specificat pentru cameră", Une = "Întoarceți puțin capul", Qne = "Să ne facem un selfie!", Yne = "Centrați-vă fața și întoarceți capul", bne = "Centrați-vă fața", Pne = "Start", $ne = "Centrați-vă fața", Rne = "Cod de eroare:", Hne = "Iluminare bună.", Vne = "Camera la nivelul ochilor.", _ne = "Fără accesorii: ochelari, mască, pălărie/șapcă, etc.", Zne = "Pregătiți-vă", Gne = "Proces finalizat", Bne = "Nu au fost utilizate HTTPS-uri", Fne = "Web Service nu este compatibil", Wne = "Îndepărtați elementele care vă acoperă fața", Jne = {
  preparingCamera: ane,
  noCameraPermission: one,
  holdSteady: une,
  processing: sne,
  lookStraight: lne,
  moveCloser: cne,
  moveAway: Ine,
  retryButtonText: gne,
  letsTryAgainTitle: jne,
  followGuidelinesText: Nne,
  allowAccessCamera: Dne,
  somethingWentWrong: yne,
  preparingService: Tne,
  allowAccessToCamera: Ane,
  error: dne,
  tryAgain: xne,
  noCameraAvailable: Ene,
  checkCameraConnection: zne,
  ambientLighting: fne,
  noMaskSunglassesHeaddress: Cne,
  versionNotSupported: Lne,
  updateBrowser: One,
  onlyPortraitOrientation: pne,
  turnDeviceIntoPortrait: Sne,
  licenseError: vne,
  licenseExpired: hne,
  showOnlyOneFace: mne,
  incorrectCameraId: wne,
  checkCameraId: kne,
  turnHead: Une,
  selfieTime: Qne,
  centerFaceTurnHead: Yne,
  centerFace: bne,
  goButton: Pne,
  fitYourFace: $ne,
  errorCode: Rne,
  illumination: Hne,
  cameraLevel: Vne,
  noAccessories: _ne,
  getReady: Zne,
  processCompleted: Gne,
  httpNotSupported: Bne,
  webServerNotCompatible: Fne,
  removeOcclusion: Wne
}, Xne = "Προετοιμασία της κάμερας...", Kne = "Κάμερα δεν είναι διαθέσιμη", qne = "Μείνετε σταθεροί", eie = "Επεξεργασία...", tie = "Κοιτάξτε μπροστά", rie = "Πλησιάστε", nie = "Απομακρυνθείτε", iie = "Ξαναπροσπαθήστε", Mie = "Ας το δοκιμάσουμε ξανά", aie = "Ακολουθήστε όμως αυτές τις οδηγίες:", oie = "Επιτρέψτε την πρόσβαση στην κάμερα", uie = "Κάτι πήγε στραβά", sie = "Προετοιμασία της υπηρεσίας ...", lie = "Επιτρέψτε την πρόσβαση στην κάμερα και φορτώστε ξανά αυτήν τη σελίδα για να συνεχίσετε.", cie = "Σφάλμα!", Iie = "Προσπαθήστε ξανά", gie = "Δεν υπάρχει κάμερα", jie = "Ελέγξτε τη σύνδεση της κάμερας και δοκιμάστε ξανά.", Nie = "Ο φωτισμός περιβάλλοντος δεν είναι πολύ φωτεινός ή πολύ σκοτεινός και δεν υπάρχουν σκιές ή λάμψη στο πρόσωπό σας", Die = "Ουδέτερη έκφραση του προσώπου (χωρίς χαμόγελο, ανοιχτά μάτια και κλειστό στόμα), χωρίς μάσκα, γυαλιά ηλίου ή κεφαλόδεσμο", yie = "Η έκδοση του προγράμματος περιήγησής σας δεν υποστηρίζεται", Tie = "Ανανεώστε την έκδοση του προγράμματος περιήγησής σας", Aie = "Μόνο κατακόρυφος προσανατολισμός", die = "Παρακαλούμε όπως στρέψετε τη συσκευή σας κατακόρυφα για τη λειτουργία πορτρέτου", xie = "Παρουσιάστηκε σφάλμα άδειας χρήσης", Eie = "Η άδεια χρήσης δεν μπορεί να βρεθεί ή έχει λήξει", zie = "Βεβαιωθείτε ότι υπάρχει μόνο ένα πρόσωπο στην οθόνη", fie = "Δεν βρέθηκε κάμερα με το καθορισμένο ID", Cie = "Ελέγξτε εάν το καθορισμένο ID της κάμερας είναι ορθό", Lie = "Στρίψτε λίγο το κεφάλι σας", Oie = "Ώρα για σέλφι!", pie = "Τοποθετήστε το πρόσωπό σας στο κέντρο, στρίψτε το κεφάλι σας", Sie = "Τοποθετήστε το πρόσωπό σας στο κέντρο", vie = "Πάμε", hie = "Τοποθετήστε το πρόσωπό σας στο κέντρο", mie = "Κωδικός σφάλματος:", wie = "Καλός φωτισμός.", kie = "Κάμερα στο επίπεδο των ματιών.", Uie = "Χωρίς αξεσουάρ: γυαλιά, μάσκα, καπέλο κ.α.", Qie = "Ετοιμαστείτε", Yie = "Η διαδικασία ολοκληρώθηκε", bie = "Το HTTPS δεν χρησιμοποιείται", Pie = "Η διαδικτυακή υπηρεσία δεν είναι συμβατή", $ie = "Αφαιρέστε τα αντικείμενα που καλύπτουν το πρόσωπό σας", Rie = {
  preparingCamera: Xne,
  noCameraPermission: Kne,
  holdSteady: qne,
  processing: eie,
  lookStraight: tie,
  moveCloser: rie,
  moveAway: nie,
  retryButtonText: iie,
  letsTryAgainTitle: Mie,
  followGuidelinesText: aie,
  allowAccessCamera: oie,
  somethingWentWrong: uie,
  preparingService: sie,
  allowAccessToCamera: lie,
  error: cie,
  tryAgain: Iie,
  noCameraAvailable: gie,
  checkCameraConnection: jie,
  ambientLighting: Nie,
  noMaskSunglassesHeaddress: Die,
  versionNotSupported: yie,
  updateBrowser: Tie,
  onlyPortraitOrientation: Aie,
  turnDeviceIntoPortrait: die,
  licenseError: xie,
  licenseExpired: Eie,
  showOnlyOneFace: zie,
  incorrectCameraId: fie,
  checkCameraId: Cie,
  turnHead: Lie,
  selfieTime: Oie,
  centerFaceTurnHead: pie,
  centerFace: Sie,
  goButton: vie,
  fitYourFace: hie,
  errorCode: mie,
  illumination: wie,
  cameraLevel: kie,
  noAccessories: Uie,
  getReady: Qie,
  processCompleted: Yie,
  httpNotSupported: bie,
  webServerNotCompatible: Pie,
  removeOcclusion: $ie
}, Hie = "Kamera hazırlanıyor...", Vie = "Kamera kullanılamıyor", _ie = "Sabit durun", Zie = "İşleniyor...", Gie = "Tam karşıya bakın", Bie = "Yakına gelin", Fie = "Biraz uzaklaşın", Wie = "Yeniden dene", Jie = "Yeniden deneyelim", Xie = "Lütfen bu talimatları izleyin:", Kie = "Kamera erişimine izin ver", qie = "Bir hata oluştu", eMe = "Hizmet hazırlanıyor...", tMe = "Devam etmek için kameraya erişim izni vererek bu sayfayı yeniden yükleyin.", rMe = "Hata!", nMe = "Tekrar deneyin", iMe = "Kamera yok", MMe = "Kamera bağlantısını kontrol ederek tekrar deneyin", aMe = "Ortam ışığı çok fazla ya da çok az olmamalı, yüzünüzde gölge ya da parlama olmamalıdır", oMe = "Nötr bir yüz ifadesi olmalı (gülümsemeyin, gözleriniz açık ve ağzınız kapalı olsun), maske, güneş gözlüğü, başınızda bir aksesuar olmamalıdır", uMe = "Tarayıcı sürümünüz desteklenmiyor", sMe = "Tarayıcı sürümünüzü güncelleyin", lMe = "Yalnızca dikey mod", cMe = "Lütfen cihazınızı dikey moda alın", IMe = "Bir lisans hatası oluştu", gMe = "Lisans bulunamadı veya lisansın süresi dolmuş", jMe = "Ekranda sadece tek bir yüz olduğundan emin olun", NMe = "Belirtilen kimliğe sahip kamera bulunamadı", DMe = "Belirtilen kamera kimliğini doğruluğunu kontrol edin", yMe = "Başınızı biraz çevirin", TMe = "Selfie zamanı!", AMe = "Yüzünüzü ortalayın, başınızı çevirin", dMe = "Yüzünüzü ortalayın", xMe = "Başlayın", EMe = "Yüzünüzü ortalayın", zMe = "Hata kodu:", fMe = "Aydınlatma iyi.", CMe = "Kamera göz hizasında.", LMe = "Aksesuar yok: gözlük, maske, şapka vb.", OMe = "Başlayın", pMe = "İşlem tamamlandı", SMe = "HTTPS kullanılmamış", vMe = "Web Servisi uyumlu değil", hMe = "Yüzünüzü kapatan nesneleri kaldırın", mMe = {
  preparingCamera: Hie,
  noCameraPermission: Vie,
  holdSteady: _ie,
  processing: Zie,
  lookStraight: Gie,
  moveCloser: Bie,
  moveAway: Fie,
  retryButtonText: Wie,
  letsTryAgainTitle: Jie,
  followGuidelinesText: Xie,
  allowAccessCamera: Kie,
  somethingWentWrong: qie,
  preparingService: eMe,
  allowAccessToCamera: tMe,
  error: rMe,
  tryAgain: nMe,
  noCameraAvailable: iMe,
  checkCameraConnection: MMe,
  ambientLighting: aMe,
  noMaskSunglassesHeaddress: oMe,
  versionNotSupported: uMe,
  updateBrowser: sMe,
  onlyPortraitOrientation: lMe,
  turnDeviceIntoPortrait: cMe,
  licenseError: IMe,
  licenseExpired: gMe,
  showOnlyOneFace: jMe,
  incorrectCameraId: NMe,
  checkCameraId: DMe,
  turnHead: yMe,
  selfieTime: TMe,
  centerFaceTurnHead: AMe,
  centerFace: dMe,
  goButton: xMe,
  fitYourFace: EMe,
  errorCode: zMe,
  illumination: fMe,
  cameraLevel: CMe,
  noAccessories: LMe,
  getReady: OMe,
  processCompleted: pMe,
  httpNotSupported: SMe,
  webServerNotCompatible: vMe,
  removeOcclusion: hMe
}, wMe = "カメラ準備中...", kMe = "カメラは利用できません", UMe = "動かないでください", QMe = "処理しています...", YMe = "視線を真っ直ぐにしてください", bMe = "近寄ってください", PMe = "遠ざかってください", $Me = "リトライ", RMe = "もう一度やってみましょう", HMe = "ですが以下のガイドラインに従ってください：", VMe = "カメラへのアクセスを許可", _Me = "何らかの問題が発生しました", ZMe = "サービスを準備しています...", GMe = "継続するにはカメラへのアクセスを許可し、ページを再読み込みしてください。", BMe = "エラー！", FMe = "もう一度お試しください", WMe = "カメラがありません", JMe = "カメラとの接続を確認し、もう一度お試しください。", XMe = "環境光が明るすぎでも暗すぎでもなく、顔に影やグレアがない", KMe = "自然な顔を表情(笑顔でなく、目を開き、口を閉じる)、マスクや、サングラス、または帽子なし", qMe = "ご利用のブラウザのバージョンはサポートされていません", eae = "ブラウザのバージョンを更新してください", tae = "縦方向のみ", rae = "デバイスを縦方向にしてください", nae = "ライセンスエラーが発生しました", iae = "ライセンスがみつからないか有効期限が切れています", Mae = "画面上に顔が1つしか写っていないことをご確認ください", aae = "指定されたIDを持つカメラがみつかりませんでした", oae = "指定されたカメラIDが正しいかどうかをご確認ください", uae = "頭を少し回転させてください", sae = "自撮りしましょう！", lae = "顔を中心に配置し、頭を回転させてください", cae = "顔を中心に配置してください", Iae = "実行", gae = "顔を中心に配置してください", jae = "エラーコード：", Nae = "良好な照明。", Dae = "目線の高さのカメラ。", yae = "眼鏡、マスク、帽子などのアクセサリーを付けない。", Tae = "準備してください", Aae = "プロセスが完了しました", dae = "HTTPSが使用されていません", xae = "ウェブサービスに互換性がありません", Eae = "顔を覆っているものを取り除いてください", zae = {
  preparingCamera: wMe,
  noCameraPermission: kMe,
  holdSteady: UMe,
  processing: QMe,
  lookStraight: YMe,
  moveCloser: bMe,
  moveAway: PMe,
  retryButtonText: $Me,
  letsTryAgainTitle: RMe,
  followGuidelinesText: HMe,
  allowAccessCamera: VMe,
  somethingWentWrong: _Me,
  preparingService: ZMe,
  allowAccessToCamera: GMe,
  error: BMe,
  tryAgain: FMe,
  noCameraAvailable: WMe,
  checkCameraConnection: JMe,
  ambientLighting: XMe,
  noMaskSunglassesHeaddress: KMe,
  versionNotSupported: qMe,
  updateBrowser: eae,
  onlyPortraitOrientation: tae,
  turnDeviceIntoPortrait: rae,
  licenseError: nae,
  licenseExpired: iae,
  showOnlyOneFace: Mae,
  incorrectCameraId: aae,
  checkCameraId: oae,
  turnHead: uae,
  selfieTime: sae,
  centerFaceTurnHead: lae,
  centerFace: cae,
  goButton: Iae,
  fitYourFace: gae,
  errorCode: jae,
  illumination: Nae,
  cameraLevel: Dae,
  noAccessories: yae,
  getReady: Tae,
  processCompleted: Aae,
  httpNotSupported: dae,
  webServerNotCompatible: xae,
  removeOcclusion: Eae
}, fae = "Příprava fotoaparátu...", Cae = "Fotoaparát není k dispozici", Lae = "Nehýbejte se", Oae = "Zpracovává se...", pae = "Dívejte se zpříma", Sae = "Přibližte se", vae = "Oddalte se", hae = "Zkusit znovu", mae = "Zkusme to znovu", wae = "Postupujte však podle těchto pokynů:", kae = "Povolte přístup k fotoaparátu", Uae = "Něco se pokazilo", Qae = "Služba se připravuje...", Yae = "Pro pokračování povolte přístup k fotoaparátu a znovu načtěte tuto stránku.", bae = "Chyba!", Pae = "Zkusit to znovu", $ae = "Chybí fotoaparát", Rae = "Zkontrolujte připojení k fotoaparátu a zkuste to znovu.", Hae = "Okolní osvětlení by nemělo být příliš jasné či příliš tmavé. Na obličeji by neměly být žádné stíny ani odlesky", Vae = "Mějte neutrální výraz v obličeji (bez úsměvu, mějte otevřené oči a zavřená ústa), bez roušky, slunečních brýlí či pokrývky hlavy", _ae = "Vaše verze prohlížeče není podporována", Zae = "Aktualizujte verzi prohlížeče", Gae = "Pouze orientace na výšku", Bae = "Otočte zařízení tak, aby bylo v režimu na výšku", Fae = "Došlo k chybě licence", Wae = "Licenci nelze nalézt nebo vypršela její platnost", Jae = "Ujistěte se, že je na obrazovce pouze jeden obličej", Xae = "Nebyl nalezen žádný fotoaparát se zadaným ID", Kae = "Zkontrolujte, zda je zadané ID fotoaparátu správné", qae = "Trochu pootočte hlavu", eoe = "Čas na selfie!", toe = "Vycentrujte obličej, otočte hlavu", roe = "Vycentrujte obličej", noe = "Jdeme na to", ioe = "Vycentrujte obličej", Moe = "Kód chyby:", aoe = "Dobré osvětlení.", ooe = "Fotoaparát v úrovni očí.", uoe = "Odložte všechny doplňky: brýle, roušku, klobouk atd.", soe = "Připravte se", loe = "Proces je kompletní", coe = "Nebylo použito HTTPS", Ioe = "Webová služba není kompatibilní", goe = "Odstraňte předměty, které zakrývají váš obličej", joe = {
  preparingCamera: fae,
  noCameraPermission: Cae,
  holdSteady: Lae,
  processing: Oae,
  lookStraight: pae,
  moveCloser: Sae,
  moveAway: vae,
  retryButtonText: hae,
  letsTryAgainTitle: mae,
  followGuidelinesText: wae,
  allowAccessCamera: kae,
  somethingWentWrong: Uae,
  preparingService: Qae,
  allowAccessToCamera: Yae,
  error: bae,
  tryAgain: Pae,
  noCameraAvailable: $ae,
  checkCameraConnection: Rae,
  ambientLighting: Hae,
  noMaskSunglassesHeaddress: Vae,
  versionNotSupported: _ae,
  updateBrowser: Zae,
  onlyPortraitOrientation: Gae,
  turnDeviceIntoPortrait: Bae,
  licenseError: Fae,
  licenseExpired: Wae,
  showOnlyOneFace: Jae,
  incorrectCameraId: Xae,
  checkCameraId: Kae,
  turnHead: qae,
  selfieTime: eoe,
  centerFaceTurnHead: toe,
  centerFace: roe,
  goButton: noe,
  fitYourFace: ioe,
  errorCode: Moe,
  illumination: aoe,
  cameraLevel: ooe,
  noAccessories: uoe,
  getReady: soe,
  processCompleted: loe,
  httpNotSupported: coe,
  webServerNotCompatible: Ioe,
  removeOcclusion: goe
}, Noe = "กำลังเตรียมกล้องถ่ายรูป...", Doe = "กล้องถ่ายรูปไม่พร้อมใช้งาน", yoe = "จับให้นิ่ง", Toe = "กำลังประมวลผล", Aoe = "มองตรง", doe = "เข้ามาใกล้กว่านี้", xoe = "ออกไปไกลกว่านี้", Eoe = "ลองใหม่", zoe = "มาลองกันอีกครั้ง", foe = "แต่ขอให้คุณทำตามคำแนะนำ:", Coe = "อนุญาตให้เข้าถึงกล้องถ่ายรูป", Loe = "มีบางอย่างผิดพลาด", Ooe = "กำลังเตรียมบริการ...", poe = "โปรดอนุญาตการเข้าถึงกล้องถ่ายรูป และโหลดหน้านี้ใหม่อีกครั้ง จากนั้นจึงดำเนินการต่อ", Soe = "ผิดพลาด!", voe = "ลองอีกครั้ง", hoe = "ไม่มีกล้องถ่ายรูป", moe = "ตรวจสอบการเชื่อมต่อกับกล้องถ่ายรูปแล้วลองใหม่อีกครั้ง", woe = "แสงจากสภาพแวดล้อมไม่สว่างหรือมืดเกินไป และต้องไม่มีเงา หรือแสงจ้าบนใบหน้าของคุณ", koe = "แสดงอารมณ์บนใบหน้าตามธรรมชาติ (ไม่ยิ้ม เปิดตา และปิดปาก) ไม่ใส่หน้ากาก แว่นกันแดด หรือเครื่องประดับบนศีรษะ", Uoe = "ไม่รองรับเบราว์เซอร์รุ่นที่คุณใช้งาน", Qoe = "โปรดอัปเดตรุ่นเบราว์เซอร์ของคุณ", Yoe = "แนวตั้งเท่านั้น", boe = "โปรดปรับอุปกรณ์ของคุณให้เป็นโหมดถ่ายภาพบุคคล", Poe = "มีข้อผิดพลาดเกี่ยวกับใบอนุญาต", $oe = "ไม่พบใบอนุญาติ หรือใบอนุญาตหมดอายุ", Roe = "ตรวจสอบให้แน่ใจว่ามีเพียงใบหน้าเดียวปรากฏอยู่ที่หน้าจอ", Hoe = "ไม่พบกล้องที่มี ID ที่ระบุ", Voe = "ตรวจสอบความถูกต้องของ ID กล้องที่ระบุ", _oe = "หันศีรษะเล็กน้อย", Zoe = "ได้เวลาเซลฟี่!", Goe = "จัดใบหน้าให้อยู่ศูนย์กลาง หันศีรษะ", Boe = "จัดใบหน้าให้อยู่ศูนย์กลาง", Foe = "ไป", Woe = "จัดใบหน้าให้อยู่ศูนย์กลาง", Joe = "รหัสผิดพลาด:", Xoe = "ส่องสว่างดี", Koe = "กล้องระดับสายตา", qoe = "ไม่มีอุปกรณ์เสริม: แว่นตา หน้ากาก หมวก เป็นต้น", eue = "เตรียมพร้อม", tue = "กระบวนการสมบูรณ์", rue = "ไม่ได้ใช้ HTTPS", nue = "ไม่สามารถใช้ได้กับบริการเว็บ", iue = "ถอดสิ่งของที่ปกปิดหน้าของคุณออก", Mue = {
  preparingCamera: Noe,
  noCameraPermission: Doe,
  holdSteady: yoe,
  processing: Toe,
  lookStraight: Aoe,
  moveCloser: doe,
  moveAway: xoe,
  retryButtonText: Eoe,
  letsTryAgainTitle: zoe,
  followGuidelinesText: foe,
  allowAccessCamera: Coe,
  somethingWentWrong: Loe,
  preparingService: Ooe,
  allowAccessToCamera: poe,
  error: Soe,
  tryAgain: voe,
  noCameraAvailable: hoe,
  checkCameraConnection: moe,
  ambientLighting: woe,
  noMaskSunglassesHeaddress: koe,
  versionNotSupported: Uoe,
  updateBrowser: Qoe,
  onlyPortraitOrientation: Yoe,
  turnDeviceIntoPortrait: boe,
  licenseError: Poe,
  licenseExpired: $oe,
  showOnlyOneFace: Roe,
  incorrectCameraId: Hoe,
  checkCameraId: Voe,
  turnHead: _oe,
  selfieTime: Zoe,
  centerFaceTurnHead: Goe,
  centerFace: Boe,
  goButton: Foe,
  fitYourFace: Woe,
  errorCode: Joe,
  illumination: Xoe,
  cameraLevel: Koe,
  noAccessories: qoe,
  getReady: eue,
  processCompleted: tue,
  httpNotSupported: rue,
  webServerNotCompatible: nue,
  removeOcclusion: iue
}, aue = "कैमरा तैयार करना...", oue = "कैमरा अनुपलब्ध है", uue = "स्थिर पकड़ें", sue = "प्रोसेसिंग...", lue = "सामने देखें", cue = "नजदीक आएं", Iue = "दूर जाएँ", gue = "पुनः प्रयास करें", jue = "आएं फिर से प्रयास करते हैं", Nue = "लेकिन कृपया इन निर्देशों का पालन करें:", Due = "कैमरा को ऐक्सेस करने की अनुमति दें", yue = "कुछ त्रुटि हुई", Tue = "सेवा तैयार करना...", Aue = "कैमरा को ऐक्सेस करने की अनुमति दें और जारी रखने के लिए इस पृष्ठ को पुनः लोड करें।", due = "त्रुटि!", xue = "पुनः प्रयास करें", Eue = "कोई कैमरा नहीं है", zue = "कृपया कैमरा कनेक्शन की जाँच करें और पुनः प्रयास करें।", fue = "परिवेश प्रकाश बहुत तेज या बहुत डार्क नहीं है और आपके चेहरे पर कोई छाया या चकाचौंध नहीं है", Cue = "सामान्य चेहरे की अभिव्यक्ति (मुस्कान नहीं, आंखें खुली और मुंह बंद), कोई मुखौटा, धूप का चश्मा या हेडवियर नहीं", Lue = "आपका ब्राउज़र संस्करण समर्थित नहीं है", Oue = "अपना ब्राउज़र संस्करण अपडेट करें", pue = "केवल पोर्ट्रेट ओरिएंटेशन", Sue = "कृपया अपने डिवाइस को पोर्ट्रेट मोड में बदलें", vue = "एक लाइसेंस त्रुटि हुई है", hue = "लाइसेंस नहीं मिला या समाप्त हो गया है", mue = "सुनिश्चित करें कि स्क्रीन पर केवल एक ही चेहरा हो", wue = "निर्दिष्ट ID वाला कोई कैमरा नहीं मिला", kue = "जांचें कि निर्दिष्ट कैमरा ID सही है या नहीं", Uue = "अपना सिर थोड़ा घुमाएं", Que = "सेल्फ़ी टाइम!", Yue = "अपना चेहरा बीच में करें, अपना सिर घुमाएं", bue = "अपना चेहरा बीच में करें", Pue = "ठीक है", $ue = "अपना चेहरा बीच में करें", Rue = "त्रुटि कोड:", Hue = "अच्छी रोशनी।", Vue = "कैमरा आँख के स्तर पर।", _ue = "कोई एक्सेसरीज़ नहीं: चश्मा, मास्क, टोपी, आदि।", Zue = "तैयार हो जाएं", Gue = "प्रक्रिया पूरी हुई", Bue = "HTTPS का उपयोग नहीं किया गया", Fue = "वेब सर्विस संगत नहीं है", Wue = "आपके चेहरे को ढकने वाली वस्तुओं को हटा दें", Jue = {
  preparingCamera: aue,
  noCameraPermission: oue,
  holdSteady: uue,
  processing: sue,
  lookStraight: lue,
  moveCloser: cue,
  moveAway: Iue,
  retryButtonText: gue,
  letsTryAgainTitle: jue,
  followGuidelinesText: Nue,
  allowAccessCamera: Due,
  somethingWentWrong: yue,
  preparingService: Tue,
  allowAccessToCamera: Aue,
  error: due,
  tryAgain: xue,
  noCameraAvailable: Eue,
  checkCameraConnection: zue,
  ambientLighting: fue,
  noMaskSunglassesHeaddress: Cue,
  versionNotSupported: Lue,
  updateBrowser: Oue,
  onlyPortraitOrientation: pue,
  turnDeviceIntoPortrait: Sue,
  licenseError: vue,
  licenseExpired: hue,
  showOnlyOneFace: mue,
  incorrectCameraId: wue,
  checkCameraId: kue,
  turnHead: Uue,
  selfieTime: Que,
  centerFaceTurnHead: Yue,
  centerFace: bue,
  goButton: Pue,
  fitYourFace: $ue,
  errorCode: Rue,
  illumination: Hue,
  cameraLevel: Vue,
  noAccessories: _ue,
  getReady: Zue,
  processCompleted: Gue,
  httpNotSupported: Bue,
  webServerNotCompatible: Fue,
  removeOcclusion: Wue
}, Xue = "ক্যামেরা প্রস্তুত করা হচ্ছে...", Kue = "ক্যামেরা বিদ্যমান নেই", que = "স্থির থাকুন", ese = "প্রক্রিয়া করা হচ্ছে...", tse = "সোজা তাকান", rse = "কাছে যান", nse = "দূরে যান", ise = "পুনরায় চেষ্টা করুন", Mse = "আবার চেষ্টা করে দেখুন", ase = "তবে অনুগ্রহপূর্বক নিম্নোক্ত নির্দেশনাবলী অনুসরণ করুন:", ose = "ক্যামেরা অ্যাক্সেস প্রদান করুন", use = "কিছু একটা ভুল হয়েছে", sse = "পরিষেবা প্রস্তুত করা হচ্ছে...", lse = "ক্যামেরা অ্যাক্সেস প্রদান করুন এবং চালিয়ে যেতে এই পেজটি পুনরায় লোড করুন।", cse = "ত্রুটি!", Ise = "আবার চেষ্টা করুন", gse = "কোনো ক্যামেরা নেই", jse = "ক্যামেরার সংযোগটি পরীক্ষা করে দেখুন এবং আবার চেষ্টা করুন।", Nse = "পরিবেষ্টিত আলো খুব উজ্জ্বল বা খুব অন্ধকার নয় এবং আপনার মুখে কোন ছায়া বা ঝলক নেই", Dse = "নিরপেক্ষ মুখের অভিব্যক্তি (কোন হাসি নেই, চোখ খোলা এবং মুখ বন্ধ), কোন মাস্ক, সানগ্লাস বা হেডওয়্যার নেই", yse = "আপনার ব্রাউজারের সংস্করণটি সমর্থিত নয়", Tse = "আপনার ব্রাউজারের সংস্করণ আপডেট করুন", Ase = "শুধুমাত্র পোর্ট্রেট অবস্থায়", dse = "অনুগ্রহ করে আপনার ডিভাইসটিকে পোর্ট্রেট মোডে রাখুন৷", xse = "লাইসেন্স সংক্রান্ত একটি ত্রুটি ঘটেছে", Ese = "লাইসেন্স পাওয়া যায়নি বা মেয়াদ শেষ হয়ে গেছে", zse = "স্ক্রিনে শুধুমাত্র একটি মুখ রয়েছে তা নিশ্চিত করুন", fse = "নির্দিষ্ট আইডি সহ কোনো ক্যামেরা পাওয়া যায়নি", Cse = "নির্দিষ্ট ক্যামেরা আইডি সঠিক কিনা তা পরীক্ষা করুন", Lse = "মাথাটা একটু ঘুরান", Ose = "সেলফির সময়!", pse = "আপনার মুখমন্ডল কেন্দ্রে রাখুন, আপনার মাথা ঘুরান", Sse = "আপনার মুখমন্ডল কেন্দ্রে রাখুন", vse = "শুরু করুন", hse = "আপনার মুখমন্ডল কেন্দ্রে রাখুন", mse = "ত্রুটির কোড:", wse = "ভালো আলোকসজ্জা।", kse = "চোখের উচ্চতায় ক্যামেরা।", Use = "কোনো জিনিসপত্র ব্যতীত: চশমা, মুখোশ, টুপি, ইত্যাদি", Qse = "প্রস্তুত হোন", Yse = "প্রক্রিয়া সম্পন্ন হয়েছে", bse = "HTTPS ব্যবহৃত হয়নি", Pse = "ওয়েব সার্ভিস সামঞ্জস্যপূর্ণ নয়", $se = "আপনার মুখ ঢেকে রাখা বস্তুটি সরান", Rse = {
  preparingCamera: Xue,
  noCameraPermission: Kue,
  holdSteady: que,
  processing: ese,
  lookStraight: tse,
  moveCloser: rse,
  moveAway: nse,
  retryButtonText: ise,
  letsTryAgainTitle: Mse,
  followGuidelinesText: ase,
  allowAccessCamera: ose,
  somethingWentWrong: use,
  preparingService: sse,
  allowAccessToCamera: lse,
  error: cse,
  tryAgain: Ise,
  noCameraAvailable: gse,
  checkCameraConnection: jse,
  ambientLighting: Nse,
  noMaskSunglassesHeaddress: Dse,
  versionNotSupported: yse,
  updateBrowser: Tse,
  onlyPortraitOrientation: Ase,
  turnDeviceIntoPortrait: dse,
  licenseError: xse,
  licenseExpired: Ese,
  showOnlyOneFace: zse,
  incorrectCameraId: fse,
  checkCameraId: Cse,
  turnHead: Lse,
  selfieTime: Ose,
  centerFaceTurnHead: pse,
  centerFace: Sse,
  goButton: vse,
  fitYourFace: hse,
  errorCode: mse,
  illumination: wse,
  cameraLevel: kse,
  noAccessories: Use,
  getReady: Qse,
  processCompleted: Yse,
  httpNotSupported: bse,
  webServerNotCompatible: Pse,
  removeOcclusion: $se
}, Hse = "המצלמה בהכנה...", Vse = "המצלמה לא זמינה", _se = "לא לזוז", Zse = "בעיבוד...", Gse = "להסתכל קדימה", Bse = "להתקרב", Fse = "להתרחק", Wse = "לנסות שוב", Jse = "שננסה שוב?", Xse = "יש לפעול לפי הנחיות אלה:", Kse = "עליך לאפשר גישה למצלמה", qse = "משהו השתבש", ele = "מכין את השירות...", tle = "כדי להמשיך, עליך לאפשר גישה למצלמה ולאחר מכן לטעון מחדש את הדף.", rle = "שגיאה", nle = "כדאי לנסות שוב", ile = "אין מצלמה", Mle = "יש לבדוק את החיבור למצלמה ולנסות שוב.", ale = "התאורה הסביבתית לא בהירה או כהה מדי ואין צלליות או אור בוהק על הפנים שלך", ole = "הבעה טבעית של הפנים (לא לחייך, לפקוח עיניים ולסגור את הפה), אין לעטות מסכה, משקפיים או כובע", ule = "אין תמיכה בגרסה הנוכחית של הדפדפן", sle = "יש לעדכן את גרסת הדפדפן", lle = "צילום אנכי בלבד", cle = "יש לסובב את המכשיר לצילום אנכי", Ile = "שגיאת רישיון", gle = "הרישיון לא נמצא או לא בתוקף", jle = "יש לוודא שבמסך רואים פנים של אדם אחד בלבד", Nle = "לא נמצאה מצלמה עם המזהה שצוין", Dle = "יש לבדוק אם נבחר מזהה המצלמה הנכון", yle = "יש להטות קצת את הראש", Tle = "זמן לתמונת סלפי!", Ale = "יש למקם את הפנים במרכז ולהפנות את הראש הצידה", dle = "יש למקם את הפנים במרכז", xle = "שנתחיל?", Ele = "יש למקם את הפנים במרכז", zle = "קוד שגיאה:", fle = "תאורה טובה.", Cle = "מצלמה שמוחזקת בגובה העיניים.", Lle = "בלי משקפיים, מסכה, כובע וכו'", Ole = "שנתחיל?", ple = "העיבוד הסתיים", Sle = "לא נעשה שימוש ב-HTTPS", vle = "שירות האינטרנט לא תואם", hle = "צריך להסיר את כל הפריטים שמכסים את הפנים שלך", mle = {
  preparingCamera: Hse,
  noCameraPermission: Vse,
  holdSteady: _se,
  processing: Zse,
  lookStraight: Gse,
  moveCloser: Bse,
  moveAway: Fse,
  retryButtonText: Wse,
  letsTryAgainTitle: Jse,
  followGuidelinesText: Xse,
  allowAccessCamera: Kse,
  somethingWentWrong: qse,
  preparingService: ele,
  allowAccessToCamera: tle,
  error: rle,
  tryAgain: nle,
  noCameraAvailable: ile,
  checkCameraConnection: Mle,
  ambientLighting: ale,
  noMaskSunglassesHeaddress: ole,
  versionNotSupported: ule,
  updateBrowser: sle,
  onlyPortraitOrientation: lle,
  turnDeviceIntoPortrait: cle,
  licenseError: Ile,
  licenseExpired: gle,
  showOnlyOneFace: jle,
  incorrectCameraId: Nle,
  checkCameraId: Dle,
  turnHead: yle,
  selfieTime: Tle,
  centerFaceTurnHead: Ale,
  centerFace: dle,
  goButton: xle,
  fitYourFace: Ele,
  errorCode: zle,
  illumination: fle,
  cameraLevel: Cle,
  noAccessories: Lle,
  getReady: Ole,
  processCompleted: ple,
  httpNotSupported: Sle,
  webServerNotCompatible: vle,
  removeOcclusion: hle
}, wle = "Valmistellaan kameraa...", kle = "Kamera ei käytettävissä", Ule = "Pidä vakaasti", Qle = "Käsitellään...", Yle = "Katso suoraan eteesi", ble = "Siirry lähemmäs", Ple = "Siirry kauemmas", $le = "Yritä uudelleen", Rle = "Yritetään tätä uudelleen", Hle = "Noudata näitä ohjeita:", Vle = "Salli kameran käyttö", _le = "Jokin epäonnistui", Zle = "Valmistellaan palvelua...", Gle = "Jatka sallimalla kameran käyttö ja lataamalla tämä sivu uudelleen.", Ble = "Virhe!", Fle = "Yritä uudelleen!", Wle = "Kameraa ei ole", Jle = "Tarkista kameran yhteys ja yritä uudelleen.", Xle = "Ympäristön valaistus ei ole liian kirkas tai tumma eikä kasvoissasi ole varjoja tai heijastuksia", Kle = "Neutraali ilme (älä hymyile, pidä silmät auki ja suu kiinni), ei maskia, silmälaseja tai päähinettä", qle = "Selaimesi versiota ei tueta", ece = "Päivitä selaimesi versio", tce = "Ainoastaan pystysuunta", rce = "Käännä laitteesi pystyasentoon", nce = "Järjestelmässä on havaittu lisenssivirhe", ice = "Lisenssiä ei löydy tai se on vanhentunut", Mce = "Varmista, että ainoastaan yhdet kasvot näkyvät näytössä", ace = "Kameraa, jonka tunniste on määritetty, ei löydy.", oce = "Tarkista, että määritetty kameran tunniste on oikea", uce = "Käännä päätäsi hieman", sce = "Aika ottaa selfie!", lce = "Keskitä kasvosi, käännä päätäsi", cce = "Keskitä kasvosi", Ice = "Aloita", gce = "Keskitä kasvosi", jce = "Virhekoodi:", Nce = "Hyvä valaistus.", Dce = "Kamera silmän korkeudella.", yce = "Ei asusteita: silmälaseja, maskia, hattua jne.", Tce = "Valmistaudu", Ace = "Prosessi valmis", dce = "HTTPS ei käytössä", xce = "Web-palvelu ei yhteensopiva", Ece = "Poista kasvosi peittävät esineet", zce = {
  preparingCamera: wle,
  noCameraPermission: kle,
  holdSteady: Ule,
  processing: Qle,
  lookStraight: Yle,
  moveCloser: ble,
  moveAway: Ple,
  retryButtonText: $le,
  letsTryAgainTitle: Rle,
  followGuidelinesText: Hle,
  allowAccessCamera: Vle,
  somethingWentWrong: _le,
  preparingService: Zle,
  allowAccessToCamera: Gle,
  error: Ble,
  tryAgain: Fle,
  noCameraAvailable: Wle,
  checkCameraConnection: Jle,
  ambientLighting: Xle,
  noMaskSunglassesHeaddress: Kle,
  versionNotSupported: qle,
  updateBrowser: ece,
  onlyPortraitOrientation: tce,
  turnDeviceIntoPortrait: rce,
  licenseError: nce,
  licenseExpired: ice,
  showOnlyOneFace: Mce,
  incorrectCameraId: ace,
  checkCameraId: oce,
  turnHead: uce,
  selfieTime: sce,
  centerFaceTurnHead: lce,
  centerFace: cce,
  goButton: Ice,
  fitYourFace: gce,
  errorCode: jce,
  illumination: Nce,
  cameraLevel: Dce,
  noAccessories: yce,
  getReady: Tce,
  processCompleted: Ace,
  httpNotSupported: dce,
  webServerNotCompatible: xce,
  removeOcclusion: Ece
}, fce = "Förbereder kameran...", Cce = "Kamera ej tillgänglig", Lce = "Håll stadigt", Oce = "Bearbetar...", pce = "Titta rakt fram", Sce = "Flytta närmare", vce = "Flytta längre bort", hce = "Försök igen", mce = "Vi försöker igen", wce = "Vänligen följ dessa riktlinjer:", kce = "Ge appen åtkomstbehörighet till kameran", Uce = "Ett fel inträffade", Qce = "Förbereder tjänsten...", Yce = "Ge appen åtkomstbehörighet till kameran och ladda om denna sida för att fortsätta,", bce = "Fel!", Pce = "Försök igen", $ce = "Det finns ingen kamera", Rce = "Kontrollera kameraanslutningen och försök igen.", Hce = "Omgivningsbelysningen får inte vara för ljus eller för mörk och det får varken finnas skuggor eller något sken i ansiktet", Vce = "Neutralt ansiktsuttryck (varken le eller blunda och stäng munnen), använd varken mask, munskydd, solglasögon eller mössor", _ce = "Din webbläsarversion stöds inte", Zce = "Uppdatera din webbläsarversion", Gce = "Endast porträttläge", Bce = "Vänd din enhet så att den hamnar i porträttläge", Fce = "Ett licensfel har inträffat", Wce = "Licensen går antingen inte att hitta eller så har den utgått", Jce = "Säkerställ att det endast finns ett ansikte på skärmen", Xce = "Ingen kamera med specificerat ID hittat", Kce = "Kontrollera om det angivna kamera-ID:t är korrekt", qce = "Vrid ditt huvud lite", eIe = "Dags för en selfie!", tIe = "Centrera ditt ansikte, vrid ditt huvud", rIe = "Centrera ditt ansikte", nIe = "Då börjar vi", iIe = "Centrera ditt ansikte", MIe = "Felkod:", aIe = "Bra belysning.", oIe = "Kamera i ögonhöjd.", uIe = "Inga accessoarer: glasögon, masker, mössa, etc.", sIe = "Gör dig redo", lIe = "Processen avslutad", cIe = "HTTPS används inte", IIe = "Webbtjänsten är inte kompatibel", gIe = "Avlägsna föremål som täcker ansiktet", jIe = {
  preparingCamera: fce,
  noCameraPermission: Cce,
  holdSteady: Lce,
  processing: Oce,
  lookStraight: pce,
  moveCloser: Sce,
  moveAway: vce,
  retryButtonText: hce,
  letsTryAgainTitle: mce,
  followGuidelinesText: wce,
  allowAccessCamera: kce,
  somethingWentWrong: Uce,
  preparingService: Qce,
  allowAccessToCamera: Yce,
  error: bce,
  tryAgain: Pce,
  noCameraAvailable: $ce,
  checkCameraConnection: Rce,
  ambientLighting: Hce,
  noMaskSunglassesHeaddress: Vce,
  versionNotSupported: _ce,
  updateBrowser: Zce,
  onlyPortraitOrientation: Gce,
  turnDeviceIntoPortrait: Bce,
  licenseError: Fce,
  licenseExpired: Wce,
  showOnlyOneFace: Jce,
  incorrectCameraId: Xce,
  checkCameraId: Kce,
  turnHead: qce,
  selfieTime: eIe,
  centerFaceTurnHead: tIe,
  centerFace: rIe,
  goButton: nIe,
  fitYourFace: iIe,
  errorCode: MIe,
  illumination: aIe,
  cameraLevel: oIe,
  noAccessories: uIe,
  getReady: sIe,
  processCompleted: lIe,
  httpNotSupported: cIe,
  webServerNotCompatible: IIe,
  removeOcclusion: gIe
}, NIe = "Gør kameraet klar...", DIe = "Kamera utilgængelig", yIe = "Hold den stille", TIe = "Behandler...", AIe = "Se ligeud", dIe = "Flyt tættere på", xIe = "Flyt længere væk", EIe = "Forsøg igen", zIe = "Lad os forsøge igen", fIe = "Men følg venligst disse retningslinjer:", CIe = "Tillad adgang til kamera", LIe = "Noget gik galt", OIe = "Forbereder tjeneste...", pIe = "Tillad adgang til kameraet og opdater denne side for at fortsætte.", SIe = "Fejl!", vIe = "Prøv igen", hIe = "Der er intet kamera", mIe = "Tjek kameraforbindelsen og prøv igen.", wIe = "Den omgivende belysning er ikke for lys eller mørk, og der er ingen skygger eller genskin på dit ansigt", kIe = "Neutralt ansigtsudtryk (ingen smil, åbne øjne og mund lukket), ingen maske, solbriller eller hovedbeklædning", UIe = "Din browserversion er ikke understøttet", QIe = "Opdater din browserversion", YIe = "Kun portrætvisning", bIe = "Slå venligst portrætvisning til på din enhed", PIe = "Der er opstået en fejl med licensen", $Ie = "Licensen kan ikke findes eller er udløbet", RIe = "Sørg for, der kun er et ansigt på skærmen", HIe = "Intet kamera med det specificeret ID fundet", VIe = "Tjek om det specificerede kamera-ID er korrekt", _Ie = "Vend dit hoved en smule", ZIe = "Selfie tid!", GIe = "Centrer dit ansigt, vend dit hoved", BIe = "Centrer dit ansigt", FIe = "Start", WIe = "Centrer dit ansigt", JIe = "Fejlkode:", XIe = "God belysning.", KIe = "Kamera ved øjenhøjde.", qIe = "Intet tilbehør: briller, maske, hat, osv.", ege = "Gør dig klar", tge = "Proces fuldført", rge = "HTTPS ikke brugt", nge = "Webservice ikke kompatibel", ige = "Fjern objekter der dækker over dit ansigt", Mge = {
  preparingCamera: NIe,
  noCameraPermission: DIe,
  holdSteady: yIe,
  processing: TIe,
  lookStraight: AIe,
  moveCloser: dIe,
  moveAway: xIe,
  retryButtonText: EIe,
  letsTryAgainTitle: zIe,
  followGuidelinesText: fIe,
  allowAccessCamera: CIe,
  somethingWentWrong: LIe,
  preparingService: OIe,
  allowAccessToCamera: pIe,
  error: SIe,
  tryAgain: vIe,
  noCameraAvailable: hIe,
  checkCameraConnection: mIe,
  ambientLighting: wIe,
  noMaskSunglassesHeaddress: kIe,
  versionNotSupported: UIe,
  updateBrowser: QIe,
  onlyPortraitOrientation: YIe,
  turnDeviceIntoPortrait: bIe,
  licenseError: PIe,
  licenseExpired: $Ie,
  showOnlyOneFace: RIe,
  incorrectCameraId: HIe,
  checkCameraId: VIe,
  turnHead: _Ie,
  selfieTime: ZIe,
  centerFaceTurnHead: GIe,
  centerFace: BIe,
  goButton: FIe,
  fitYourFace: WIe,
  errorCode: JIe,
  illumination: XIe,
  cameraLevel: KIe,
  noAccessories: qIe,
  getReady: ege,
  processCompleted: tge,
  httpNotSupported: rge,
  webServerNotCompatible: nge,
  removeOcclusion: ige
}, age = "Priprema kamere...", oge = "Kamera nije dostupna", uge = "Držite se mirno", sge = "Obrada...", lge = "Gledajte ravno", cge = "Priđite bliže", Ige = "Odmaknite se", gge = "Pokušajte ponovo", jge = "Pokušajmo to ponovno", Nge = "Slijedite ove smjernice:", Dge = "Dopustite pristup kameri", yge = "Nešto je pošlo po zlu", Tge = "Priprema usluge...", Age = "Dopustite pristup kameri i ponovno učitajte ovu stranicu za nastavak.", dge = "Greška!", xge = "Pokušajte ponovno", Ege = "Nema kamere", zge = "Provjerite vezu kamere i pokušajte ponovno.", fge = "Ambijentalna rasvjeta nije presvijetla ili pretamna i nema sjena ili odsjaja na vašem licu", Cge = "Neutralan izraz lica (bez osmijeha, otvorenih očiju i zatvorenih usta), bez maske, sunčanih naočala ili pokrivala za glavu", Lge = "Vaša verzija preglednika nije podržana", Oge = "Ažurirajte verziju preglednika", pge = "Samo portretna orijentacija", Sge = "Okrenite svoj uređaj u portretni način rada", vge = "Došlo je do pogreške u licenci", hge = "Licenca se ne može pronaći ili je istekla", mge = "Provjerite je li na ekranu samo jedno lice", wge = "Nije pronađena kamera s navedenim ID-om", kge = "Provjerite točnost navedenog ID-a kamere", Uge = "Okreni malo glavu", Qge = "Vrijeme je za selfie!", Yge = "Centrirajte lice, okrenite glavu", bge = "Centrirajte lice", Pge = "Započnimo", $ge = "Centrirajte lice", Rge = "Kôd greške:", Hge = "Dobro osvjetljenje.", Vge = "Kamera u visini očiju.", _ge = "Bez dodataka: naočale, maska, šešir itd.", Zge = "Pripremite se", Gge = "Proces završen", Bge = "HTTPS se ne koristi", Fge = "Web usluga nije kompatibilna", Wge = "Uklonite predmete koji vam prekrivaju lice", Jge = {
  preparingCamera: age,
  noCameraPermission: oge,
  holdSteady: uge,
  processing: sge,
  lookStraight: lge,
  moveCloser: cge,
  moveAway: Ige,
  retryButtonText: gge,
  letsTryAgainTitle: jge,
  followGuidelinesText: Nge,
  allowAccessCamera: Dge,
  somethingWentWrong: yge,
  preparingService: Tge,
  allowAccessToCamera: Age,
  error: dge,
  tryAgain: xge,
  noCameraAvailable: Ege,
  checkCameraConnection: zge,
  ambientLighting: fge,
  noMaskSunglassesHeaddress: Cge,
  versionNotSupported: Lge,
  updateBrowser: Oge,
  onlyPortraitOrientation: pge,
  turnDeviceIntoPortrait: Sge,
  licenseError: vge,
  licenseExpired: hge,
  showOnlyOneFace: mge,
  incorrectCameraId: wge,
  checkCameraId: kge,
  turnHead: Uge,
  selfieTime: Qge,
  centerFaceTurnHead: Yge,
  centerFace: bge,
  goButton: Pge,
  fitYourFace: $ge,
  errorCode: Rge,
  illumination: Hge,
  cameraLevel: Vge,
  noAccessories: _ge,
  getReady: Zge,
  processCompleted: Gge,
  httpNotSupported: Bge,
  webServerNotCompatible: Fge,
  removeOcclusion: Wge
}, Xge = "Forbereder kameraet...", Kge = "Kamera utilgjengelig", qge = "Hold stødig", e4e = "Behandler...", t4e = "Se rett frem", r4e = "Kom nærmere", n4e = "Beveg deg bort", i4e = "Prøv på nytt", M4e = "La oss prøve igjen", a4e = "Men følg disse retningslinjene:", o4e = "Gi tilgang til kameraet", u4e = "Noe gikk galt", s4e = "Forbereder tjenesten...", l4e = "Gi tilgang til kameraet og last inn denne siden på nytt for å fortsette.", c4e = "Feil!", I4e = "Prøv igjen", g4e = "Ingen kamera tilgjengelig", j4e = "Sjekk kameratilkoblingen og prøv igjen.", N4e = "Omgivende lys ikke er for sterkt eller for mørkt, og at det ikke forekommer skygge eller gjenskinn på ansiktet ditt", D4e = "Nøytralt ansiktsuttrykk (ingen smil, åpne øyne og munn lukket), ingen maske, solbriller eller hodeplagg", y4e = "Din nettleserversjon støttes ikke", T4e = "Oppdater nettleserversjonen din", A4e = "Kun stående format", d4e = "Sett enheten i portrettmodus", x4e = "Det har oppstått en lisensfeil", E4e = "Lisensen finnes ikke eller har utløpt", z4e = "Sørg for at det kun er ett ansikt på skjermen", f4e = "Kamera med den spesifikke ID-en ble ikke funnet", C4e = "Sjekk om den spesifikke kamera-ID-en er korrekt", L4e = "Snu litt på hodet", O4e = "Tid for en selfie!", p4e = "Sentrer ansiktet, snu på hodet", S4e = "Sentrer ansiktet", v4e = "Gå", h4e = "Sentrer ansiktet", m4e = "Feilkode:", w4e = "God belysning.", k4e = "Kamera i øyehøyde.", U4e = "Ingen tilbehør: briller, maske, lue osv.", Q4e = "Gjør deg klar", Y4e = "Prosess fullført", b4e = "HTTPS ikke brukt", P4e = "Webtjeneste ikke kompatibel", $4e = "Fjern gjenstander som dekker ansiktet ditt", R4e = {
  preparingCamera: Xge,
  noCameraPermission: Kge,
  holdSteady: qge,
  processing: e4e,
  lookStraight: t4e,
  moveCloser: r4e,
  moveAway: n4e,
  retryButtonText: i4e,
  letsTryAgainTitle: M4e,
  followGuidelinesText: a4e,
  allowAccessCamera: o4e,
  somethingWentWrong: u4e,
  preparingService: s4e,
  allowAccessToCamera: l4e,
  error: c4e,
  tryAgain: I4e,
  noCameraAvailable: g4e,
  checkCameraConnection: j4e,
  ambientLighting: N4e,
  noMaskSunglassesHeaddress: D4e,
  versionNotSupported: y4e,
  updateBrowser: T4e,
  onlyPortraitOrientation: A4e,
  turnDeviceIntoPortrait: d4e,
  licenseError: x4e,
  licenseExpired: E4e,
  showOnlyOneFace: z4e,
  incorrectCameraId: f4e,
  checkCameraId: C4e,
  turnHead: L4e,
  selfieTime: O4e,
  centerFaceTurnHead: p4e,
  centerFace: S4e,
  goButton: v4e,
  fitYourFace: h4e,
  errorCode: m4e,
  illumination: w4e,
  cameraLevel: k4e,
  noAccessories: U4e,
  getReady: Q4e,
  processCompleted: Y4e,
  httpNotSupported: b4e,
  webServerNotCompatible: P4e,
  removeOcclusion: $4e
}, Sx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ar: JK,
  bn: Rse,
  cs: joe,
  da: Mge,
  de: m_,
  el: Rie,
  en: RV,
  es: jX,
  fi: zce,
  fr: zJ,
  he: mle,
  hi: Jue,
  hr: Jge,
  hu: MB,
  id: mee,
  it: jG,
  ja: zae,
  ko: jre,
  ms: Mne,
  nl: Rq,
  no: R4e,
  pl: zZ,
  pt: MK,
  ro: Jne,
  ru: JH,
  sk: RF,
  sv: jIe,
  th: Mue,
  tr: mMe,
  uk: mW,
  vi: zte,
  zh: JB
}, Symbol.toStringTag, { value: "Module" }));
function s2(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Jo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? s2(Object(r), !0).forEach(function(n) {
      yu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s2(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function yu(e, t, r) {
  return (t = H4e(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function H4e(e) {
  var t = V4e(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function V4e(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const _4e = Bt.create("main"), vx = [dx, xx, Ex, zx, fx, Cx, Lx, Ox, px];
let l2 = Ks({}, vx);
class Z4e extends HTMLElement {
  constructor() {
    super(), yu(this, "_root", G4(this.attachShadow({
      mode: "open"
    }))), yu(this, "_mounted", !1), yu(this, "_translations", null);
  }
  static get observedAttributes() {
    return Object.values(xr);
  }
  onEvent(t) {
    const r = cx(B8, t);
    this.dispatchEvent(r), _4e("Component event: ".concat(JSON.stringify(r.detail)));
  }
  get version() {
    return "".concat("6.4.1506".trim());
  }
  set translations(t) {
    this._translations = t, this._mounted && this.render();
  }
  get translations() {
    return this._translations;
  }
  set settings(t) {
    if (Object.keys(t).length === 0) return;
    const r = Q.getState(), n = tM(r, t);
    t.customization && (l2 = Ks(t.customization, vx)), t.rotationAngle && typeof t.rotationAngle == "number" && (n.rotationAngle = Nx(t.rotationAngle)), t.workerPath && typeof t.workerPath == "string" && (n.workerPath = t.workerPath), n && Q.setState(n), this._mounted && this.render();
  }
  get settings() {
    const t = Object.keys(xr), r = Q.getState();
    return [...t, "customization", "workerPath"].reduce((n, i) => Jo(Jo({}, n), {}, {
      [i]: r[i]
    }), {});
  }
  attributeChangedCallback(t) {
    const r = this.getAttribute(t), n = wt(r), i = {
      [xr.locale]: () => r && Q.setState({
        locale: r
      }),
      [xr.copyright]: () => {
        Q.setState({
          copyright: n
        });
      },
      [xr.changeCamera]: () => {
        Q.setState({
          changeCamera: n
        });
      },
      [xr.cameraId]: () => r && Q.setState({
        cameraId: r
      }),
      [xr.closeDisabled]: () => {
        Q.setState({
          closeDisabled: n
        });
      },
      [xr.startScreen]: () => {
        Q.setState({
          startScreen: n
        });
      },
      [xr.finishScreen]: () => {
        Q.setState({
          finishScreen: n
        });
      }
    };
    i[t] && i[t](), this._mounted && this.render();
  }
  connectedCallback() {
    console.info("[FaceDetection] Passing parameters via attributes is deprecated. In future versions, support will be discontinued. Please use the settings");
    const t = {
      onEvent: this.onEvent.bind(this),
      url: this.getAttribute("url") || void 0,
      locale: this.getAttribute("locale") || "en",
      copyright: wt(this.getAttribute("copyright")),
      cameraId: this.getAttribute("camera-id") || void 0,
      changeCamera: wt(this.getAttribute("change-camera")),
      closeDisabled: wt(this.getAttribute("close-disabled")),
      finishScreen: wt(this.getAttribute("finish-screen"))
    };
    Q.setState(Jo({}, t)), Q.setState({
      faceSnapshot: !0
    }), this.render(), this._mounted = !0, this.onEvent({
      action: xe.ELEMENT_VISIBLE,
      data: null
    });
  }
  render() {
    this._root.render(/* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      /* @__PURE__ */ a.jsx("style", { nonce: Q.getState().nonce, children: l2 }),
      /* @__PURE__ */ a.jsx(MH, { locale: Q.getState().locale, dictionaries: Jo({}, Sx), translations: this._translations || void 0 })
    ] }));
  }
  disconnectedCallback() {
    setTimeout(() => {
      Q.getState().resetAttributes(), Q.getState().resetProps(), this._root.unmount();
    }), Bt.saveLogs();
  }
}
var G4e = B, B4e = G4e.Promise, hx = {}, c2 = mn, F4e = TypeError, W4e = function(e) {
  var t, r;
  this.promise = new e(function(n, i) {
    if (t !== void 0 || r !== void 0) throw new F4e("Bad Promise constructor");
    t = n, r = i;
  }), this.resolve = c2(t), this.reject = c2(r);
};
hx.f = function(e) {
  return new W4e(e);
};
var J4e = ct, X4e = _e, K4e = hx, q4e = function(e, t) {
  if (J4e(e), X4e(t) && t.constructor === e) return t;
  var r = K4e.f(e), n = r.resolve;
  return n(t), r.promise;
}, eje = Qe, us = B4e, tje = X, mx = Jr, wx = je, rje = A5, I2 = q4e, nje = Ir, pg = us && us.prototype, ije = !!us && tje(function() {
  pg.finally.call({ then: function() {
  } }, function() {
  });
});
eje({ target: "Promise", proto: !0, real: !0, forced: ije }, {
  finally: function(e) {
    var t = rje(this, mx("Promise")), r = wx(e);
    return this.then(
      r ? function(n) {
        return I2(t, e()).then(function() {
          return n;
        });
      } : e,
      r ? function(n) {
        return I2(t, e()).then(function() {
          throw n;
        });
      } : e
    );
  }
});
if (wx(us)) {
  var g2 = mx("Promise").prototype.finally;
  pg.finally !== g2 && nje(pg, "finally", g2, { unsafe: !0 });
}
function Mje(e) {
  let {
    direction: t
  } = e;
  const {
    setAbortProcess: r,
    setAbortSessionStatus: n,
    images: i,
    abortSessionStatus: M,
    abortProcess: o,
    transactionId: u,
    publicKey: s,
    onEvent: l,
    url: I,
    debug: g,
    headers: c,
    tag: D,
    startScreen: j = !0,
    deviceOrientation: N = !1,
    retryCount: d = -1,
    completionStatus: T,
    setCompletionStatus: y,
    onRestart: A,
    request: x,
    setResponse: E,
    onRotateDevice: C,
    onError: p
  } = Q(), {
    orientation: O,
    isLandscape: w
  } = X4(), [z, R] = f.useState(!1), K = f.useRef(!0), P = f.useCallback(() => {
    T === m.CAPTURING && u ? (r(!0), n(Yt.CLOSE_BUTTON)) : (r(!1), y(j ? m.INSTRUCTION : m.FAILED)), R(!0);
  }, [T, u]);
  return f.useEffect(() => (yx && p(new oi("HTTP_NOT_SUPPORTED")), j || y(m.CAPTURING), N && Vr && !Vi.initialized && Vi.init(g == null ? void 0 : g.deviceOrientationPlate), () => {
    Wn.abortLivenessRequest(), Vr && Vi.initialized && Vi.shutdown();
  }), []), f.useEffect(() => {
    d === 0 && (T === m.CAPTURING || T === m.INSTRUCTION) && (l({
      action: xe.RETRY_COUNTER_EXCEEDED,
      data: null
    }), y(m.RESTART));
  }, [d, T]), f.useEffect(() => {
    if (T === m.PROCESSING_REQUEST) {
      if (!x) return;
      Wn.getLivenessDetectionResult(x, {
        transactionId: u,
        backendURL: I,
        publicKey: s
      }).then((H) => {
        var Se;
        E(H), y(H.status === Re.Finished ? m.SUCCESS : m.FAILED);
        const fe = {
          code: H.code,
          metadata: H.metadata,
          status: H.status,
          transactionId: H.transactionId,
          estimatedAge: H.age && Array.isArray(H.age) && ((Se = H.age[0]) === null || Se === void 0 ? void 0 : Se.pred) || null,
          images: i,
          tag: D,
          type: H.type
        };
        l({
          action: xe.PROCESS_FINISHED,
          data: {
            status: nt.OK,
            response: fe
          }
        });
      }).catch((H) => {
        (H == null ? void 0 : H.name) !== "AbortError" && (y(m.UNKNOWN_ERROR), l({
          action: xe.PROCESS_FINISHED,
          data: {
            status: nt.ERROR,
            reason: Sr.CONNECTION_ERROR
          }
        }));
      });
    }
    jx(T, M) && x && (T === m.ABORT_PROCESSING && (A(ka && w), r(!1)), Wn.sendLivenessAbortedResult(x, {
      transactionId: u,
      backendURL: I,
      publicKey: s
    }).finally(() => {
      n(null);
    }));
  }, [T, x, I, u]), f.useEffect(() => {
    !o && z && (Wn.abortLivenessRequest(), l({
      action: xe.CLOSE,
      data: null
    }), R(!1));
  }, [z, o]), f.useEffect(() => {
    Wn.provideHeaders(c);
  }, [c]), f.useEffect(() => {
    if (!Vr) return;
    const H = ka && w;
    if (K.current) {
      K.current = !1, H && y(m.RESTART);
      return;
    }
    C(H, yd);
  }, [w, O]), /* @__PURE__ */ a.jsx(gx, { onError: p, supportedBrowserVersions: e5, children: /* @__PURE__ */ a.jsx(n5, { onClose: P, direction: t, children: /* @__PURE__ */ a.jsx(Pj, {}) }) });
}
const aje = lx(Ix)(Mje);
function j2(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Xo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? j2(Object(r), !0).forEach(function(n) {
      Tu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : j2(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Tu(e, t, r) {
  return (t = oje(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function oje(e) {
  var t = uje(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function uje(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const sje = Bt.create("main"), kx = [dx, xx, Ex, zx, fx, Cx, Lx, Ox, px];
let N2 = Ks({}, kx);
class lje extends HTMLElement {
  constructor() {
    super(), Tu(this, "_root", G4(this.attachShadow({
      mode: "open"
    }))), Tu(this, "_mounted", !1), Tu(this, "_translations", null);
  }
  static get observedAttributes() {
    return Object.values(ht);
  }
  onEvent(t) {
    const r = cx(G8, t);
    this.dispatchEvent(r), sje("Component event: ".concat(JSON.stringify(r.detail)));
  }
  attributeChangedCallback(t) {
    const r = this.getAttribute(t), n = wt(r), i = {
      [ht.locale]: () => r && Q.setState({
        locale: r
      }),
      [ht.url]: () => r && Q.setState({
        url: r
      }),
      [ht.copyright]: () => {
        Q.setState({
          copyright: n
        });
      },
      [ht.changeCamera]: () => {
        Q.setState({
          changeCamera: n
        });
      },
      [ht.cameraId]: () => r && Q.setState({
        cameraId: r
      }),
      [ht.closeDisabled]: () => {
        Q.setState({
          closeDisabled: n
        });
      },
      [ht.startScreen]: () => {
        Q.setState({
          startScreen: n
        });
      },
      [ht.finishScreen]: () => {
        Q.setState({
          finishScreen: n
        });
      },
      [ht.deviceOrientation]: () => {
        Q.setState({
          deviceOrientation: n
        });
      }
    };
    i[t] && i[t](), this._mounted && this.render();
  }
  connectedCallback() {
    console.info("[FaceLiveness] Passing parameters via attributes is deprecated. In future versions, support will be discontinued. Please use the settings");
    const t = {
      onEvent: this.onEvent.bind(this),
      url: this.getAttribute("url") || void 0,
      locale: this.getAttribute("locale") || "en",
      headers: {},
      tag: "",
      retryCount: -1,
      copyright: wt(this.getAttribute("copyright")),
      startScreen: wt(this.getAttribute("start-screen")),
      cameraId: this.getAttribute("camera-id") || void 0,
      changeCamera: wt(this.getAttribute("change-camera")),
      deviceOrientation: wt(this.getAttribute("device-orientation")),
      closeDisabled: wt(this.getAttribute("close-disabled")),
      finishScreen: wt(this.getAttribute("finish-screen"))
    };
    Q.setState(Xo({}, t)), this.render(), this._mounted = !0, this.onEvent({
      action: xe.ELEMENT_VISIBLE,
      data: null
    });
  }
  get version() {
    return "".concat("6.4.1506".trim());
  }
  set translations(t) {
    this._translations = t, this._mounted && this.render();
  }
  get translations() {
    return this._translations;
  }
  set settings(t) {
    if (Object.keys(t).length === 0) return;
    const r = Q.getState(), n = Object.assign({}, t);
    typeof n.retryCount == "number" && n.retryCount <= 0 && (n.retryCount = -1), t.rotationAngle && typeof t.rotationAngle == "number" && (n.rotationAngle = Nx(t.rotationAngle)), t.workerPath && typeof t.workerPath == "string" && (n.workerPath = t.workerPath), n.customization && (N2 = Ks(n.customization, kx));
    const i = tM(r, n);
    i && Q.setState(i), this._mounted && this.render();
  }
  get settings() {
    const t = Object.keys(ht), r = Q.getState();
    return [...t, "retryCount", "headers", "tag", "customization", "recordingProcess", "livenessType", "metadata", "workerPath"].reduce((n, i) => Xo(Xo({}, n), {}, {
      [i]: r[i]
    }), {});
  }
  render() {
    this._root.render(/* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      /* @__PURE__ */ a.jsx("style", { nonce: Q.getState().nonce, children: N2 }),
      /* @__PURE__ */ a.jsx(aje, { locale: Q.getState().locale, dictionaries: Xo({}, Sx), translations: this._translations || void 0 })
    ] }));
  }
  disconnectedCallback() {
    setTimeout(() => {
      Q.getState().resetAttributes(), Q.getState().resetProps(), this._root.unmount();
    }), Bt.saveLogs();
  }
}
function cje(e, t, r) {
  return (t = Ije(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ije(e) {
  var t = gje(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function gje(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class jje extends HTMLElement {
  constructor() {
    super(), cje(this, "_root", void 0), this._root = this.attachShadow({
      mode: "open"
    });
    const t = `
            display: block;
            position: fixed;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            overflow: auto;
            z-index: 100;
        `;
    this._root.innerHTML = `
            <style>
            *, *::before, *::after {
                box-sizing: border-box;
            }
            :host {
                `.concat(t, `;
            }
            fullscreen-container {
                `).concat(t, `;
            }
            </style>
            <slot />
        `);
  }
}
const Nje = window.customElements.get("face-capture"), Dje = window.customElements.get("face-liveness"), yje = window.customElements.get("fullscreen-container");
Nje || window.customElements.define("face-capture", Z4e);
Dje || window.customElements.define("face-liveness", lje);
yje || window.customElements.define("fullscreen-container", jje);
export {
  Z4e as FaceDetectionWebComponent,
  _s as FaceLivenessType,
  lje as FaceLivenessWebComponent,
  jje as FullScreenContainer,
  Ua as RecordingProcess
};
